/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import _ from "lodash";
import upload from "../../../src/images/candidate/upload.svg";
import uploadRecruitment from "../../../src/images/candidate/upload.svg";
import uploader from "../../../src/images/candidate/uploader.png";

import { CandidateMenu } from '../common/utils' 

import CustomField  from './CustomFields'
import {
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink,
	Row,
	Col,
	Button,
	Label,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	UncontrolledTooltip,
	Popover,
	PopoverHeader,
	PopoverBody,
} from "reactstrap";
import moment from "moment";
import {
	AvForm,
	AvField,
	AvGroup,
	AvInput,
	AvRadioGroup,
	AvRadio,
	AvFeedback,
} from "availity-reactstrap-validation";
import {
	countries,
	languages,
	CheckValue,
	VaccinationList,
	checkArray,
} from "../common/utils";
import request, { client } from "../../api/api";
import NumberFormat from "react-number-format";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
// import "react-select/dist/react-select.css";
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from "react-places-autocomplete";
import IntlTelInput from "react-intl-tel-input";
import { libphonenumber } from "react-intl-tel-input/dist/libphonenumber.js";
import "react-intl-tel-input/dist/main.css";
import invoiceclose from "../../../src/images/candidate/invoice-close.svg";
import photoRules from "../../../src/images/candidate/photo-rules.jpg";
import FileSaver from "file-saver";
import { NodeURL } from "../../api/api";
import "./profile.scss";
import pdf from "./images/document.svg";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import SignaturePad from "react-signature-canvas";
import Avatar from "react-avatar-edit";
import EditProfile from './edit-profile/index'
import Profileprovider from "./edit-profile/Editprofileprovider";
import profilereducer , {initailState} from './edit-profile/utils/profileReducer'




const cursor_pointer = { cursor: "pointer" };





class MyProfffile extends Component {
	state = {

		activeMenuTab:"",
		templateFields:[],
		// this key contain the addtion field with value and fields is required
		templateAddtionalFields:[],
		nextTabIsDisabled:true,
		// Array of object { field_name :"" , field_value:"" , field_menu :"" , field_heading:"" }
		addtionalFieldsValue:[],


		empBio: "",
		avatar: "",
		mainActiveTab:
			this.props &&
				this.props.location &&
				this.props.location.state &&
				CheckValue(this.props.location.state.mainActiveTab)
				? this.props.location.state.mainActiveTab
				: "1",
		activeTab:
			this.props &&
				this.props.location &&
				this.props.location.state &&
				CheckValue(this.props.location.state.activeTab)
				? this.props.location.state.activeTab
				: "1",
		signatureTab: "1",
		signatureText: "",
		workingTimeSignatureText: "",
		isNameChanged: "",
		previousNames: "",
		martialStatus: "",
		nationality: "",
		national_ity: [],
		workstatus: "",
		Passportdetails: "",
		documentNumber: "",
		drivingCountryOfIssue: "",
		drivingCountryOfIssue_arr: [],
		licenceExpiry: "",
		licenceClass: "",
		currentDBS: "",
		dbsCertificateNo: "",
		//  dbsisVisible  section visible for the canidate  
		dbsisVisible: false,
		drivingLicenceNumber: "",
		visaNumber: "",
		visaCountryOfIssue: "",
		locationlist: [],
		company_name: "", //bank
		accountName: "", //bank
		accountType: "", //bank
		bankName: "", //bank
		bank_ac: "", //bank
		bank_sort_code: "", //bank
		postCode: "", //bank
		bankEmail: "", //bank
		bankPhoneError: false, //bank
		bankMobileNo: {
			//bank
			number: "",
			code: "",
			dialcountry: "gb",
		},
		heartCirculatory: "", // immunisation
		diabetes: "", // immunisation
		bronchitis: "", // immunisation
		epilepsy: "", // immunisation
		asthma: "", // immunisation
		headaches: "", // immunisation
		psychiatric: "", // immunisation
		dermatitis: "", // immunisation
		backProblems: "", // immunisation
		recurrentInfections: "", // immunisation
		chickenpox: "", // immunisation
		documentType: "", // ID & RIGHT WORK
		docType: "", // Identity documents
		rightToWorkType: "", //Right to work document
		docType_info: {
			doc_type: "",
			doc_url: [],
			doc_no: "",
			country_issue: "",
			expiry_date: "",
			country_issue_arr: [],
			isvisible:true
		},
		rightToWorkType_info: {
			doc_type: "",
			doc_url: [],
			doc_no: "",
			country_issue: "",
			expiry_date: "",
			country_issue_arr: [],
			isvisible:true
		},
		default_id: "",
		default_rtw: "",
		docTypeExpiry: "", // ID & RIGHT WORK
		visaExpiry: "", // ID & RIGHT WORK
		visa_Expiry: "",
		criminalAdditionalInformation: "", // declaration-criminal
		criminalDisciplinaryAction: "", // declaration-criminal
		criminalCourt: "", // declaration-criminal
		criminalConvictions: "", // declaration-criminal
		criminalCautioned: "", // declaration-criminal
		criminaloffence: "", // declaration-criminal
		registereddisabled: "", // declaration-disable
		disableAct: "", // declaration-disable
		disableOverCome: "", // declaration-disable
		disableRegisteredDetails: "", // declaration-disable
		disableActDetails: "", // declaration-disable
		disableOverComeDetails: "", // declaration-disable
		declarationAccept: false, // declaration-APPLICATION FORM DECLARATION
		dbsAccept: "", // declaration-DBS
		indemnityAccept: "",
		dbsAcceptDate: new Date(), // declaration-DBS
		education_qualification: [],
		other_courses: [],
		documents: [],
		grades: [],
		skills: [],
		work_experience: [],
		languages: [],
		religions: [],
		professional_Body: [],
		professionalBodyExpiry: "",
		declarationAcceptDate: new Date(),
		professionalBody: "",
		pinRef: "",
		skillProvideDetails: "",
		otheremp: false,
		fileviewmodal: false,
		finalFormSubmitModal: false,
		drivelicenceyes: false,
		caraccessyes: false,
		DBSyes: false,
		IELTStestyes: false,
		postapplyfor: "",
		postapplydetails: "",
		availablestartdate: "",
		dateofMarriage: "",
		dateMovedAddress: "",
		dbsIssueDate: "",
		dbsExpirydate: "",
		title: "",
		firstname: "",
		middlename: "",
		lastname: "",
		maidenName: "",
		prefferedName: "",
		homephone: "",
		mobileno: {
			number: "",
			code: "",
			dailcountry: "gb",
		},
		email: "",
		dateofbirth: "",
		insuranceno: "",
		streetAddress: "",
		addressline2: "",
		city: "",
		state: "",
		zip: "",
		country: "",
		gender: "",
		religion: "",
		race: "",
		sexualorientation: "",
		UploadIDPhoto: "",
		visapermit: "",
		visapermittype: "",
		drivinglicence: "",
		traveldetails: "",
		drivinglicenceno: "",
		drivinglicenceisVisible:true,
		caraccess: "",
		bannedfromdriving: "",
		carinsurance: "",
		vehicledocumentsvalid: "",
		englishspoken: "",
		englishwritten: "",
		otherlanguage: [],
		IELTStest: "",
		kinprefix: "",
		kinfirstname: "",
		kinlastname: "",
		kinrelationship: "",
		kinhomephone: 0,
		kinmobileno: {
			number: "",
			code: "",
			dailcountry: "gb",
		},
		kinemail: "",
		kinstreetAddress: "",
		kinaddressline2: "",
		kincity: "",
		kinstate: "",
		kinzip: "",
		kincountry: "",
		firstchoice: "",
		secondchoice: "",
		thirdchoice: "",
		shortnotice: "",
		reduceworkflexibility: "",
		workstate: "",
		employer: "",
		position: "",
		duties: "",
		datefromto: "",
		salaryonleaving: "",
		institution: "",
		course: "",
		year: "",
		grade: "",
		UploadCV: "",
		firstrefrelationship: "",
		firstreffirstname: "",
		firstreflastname: "",
		firstrefphone: {
			number: "",
			code: "",
			dailcountry: "gb",
		},
		firstrefemail: "",
		firstrefconfirmemail: "",
		firstrefstreetAddress: "",
		firstrefcity: "",
		firstrefstate: "",
		firstrefzip: "",
		secondrefrelationship: "",
		secondreffirstname: "",
		secondreflastname: "",
		secondrefphone: {
			number: "",
			code: "",
			dailcountry: "gb",
		},
		secondrefemail: "",
		secondrefconfirmemail: "",
		secondrefstreetAddress: "",
		secondrefcity: "",
		secondrefstate: "",
		secondrefzip: "",
		thirdrefrelationship: "",
		thirdreffirstname: "",
		thirdreflastname: "",
		thirdrefphone: {
			number: "",
			code: "",
			dailcountry: "gb",
		},
		thirdrefemail: "",
		thirdrefconfirmemail: "",
		thirdrefstreetAddress: "",
		thirdrefcity: "",
		thirdrefstate: "",
		thirdrefzip: "",
		appraiserfirstname: "",
		appraiserlastname: "",
		gradeofappraiser: "",
		appraiserstreetAddress: "",
		appraisercity: "",
		appraiserstate: "",
		appraiserzip: "",
		appraiserphone: "",
		appraiserfax: "",
		appraiseremail: "",
		appraiserconfirmemail: "",
		DBS: "",
		clear: "",
		DBSdate: "",
		disclosurenumber: "",
		tunicsize: "",
		sufferedlongtermillness: "",
		leaveforneckinjury: "",
		neckinjuries: "",
		sixweeksillness: "",
		communicabledisease: "",
		medicalattention: "",
		healthdeclarationdetails: "",
		absentfromwork: "",
		statereason: "",
		GPname: "",
		GPphone: {
			code: "",
			number: "",
			dialcountry: "gb",
		},
		GPstreetAddress: "",
		GPcity: "",
		GPstate: "",
		GPzip: "",
		contactDoctor: "",
		GPhealthdetails: "",
		medicalillness: "",
		medicalillnesscaused: "",
		treatment: "",
		needanyadjustments: "",
		needanyadjustmentsnotes: "",
		livedUK: "",
		livedUKnotes: "",
		BCGvaccination: "",
		BCGvaccinationyes: false,
		BCGvaccinationdate: "",
		cough: "",
		weightloss: "",
		fever: "",
		TB: "",
		chickenpoxdate: "",
		triplevaccination: "",
		polio: "",
		tetanus: "",
		hepatitisB: "",
		proneProcedures: "",
		occupationalHealthServices: "",
		warningcriminaloffence: "",
		DBSdetails: "",
		passport: "",
		workhours: "",
		addemployer: [],
		userlist: [],
		employmenthistorylist: [],
		educationlist: [],
		personaldetails: [],
		work_mornings: false,
		work_evenings: false,
		work_afternoons: false,
		work_occasional: false,
		work_fulltime: false,
		work_parttime: false,
		work_nights: false,
		work_weekends: false,
		work_anytime: false,
		movinghandling: "",
		basiclifesupport: "",
		healthsafety: "",
		firesafety: "",
		firstaid: "",
		infectioncontrol: "",
		foodsafety: "",
		medicationadmin: "",
		safeguardingvulnerable: "",
		trainingdates: "",
		healthcare_training: "",
		diplomal3: "",
		diplomal2: "",
		personalsafetymental: "",
		intermediatelife: "",
		advancedlife: "",
		complaintshandling: "",
		handlingviolence: "",
		doolsmental: "",
		coshh: "",
		dataprotection: "",
		equalityinclusion: "",
		loneworkertraining: "",
		resuscitation: "",
		interpretation: "",
		trainindates2: "",
		mandatory_training: "",
		phoneerror: false,
		phoneerror1: false,
		phoneerror2: false,
		phoneerror3: false,
		phoneerror4: false,
		phoneerror44: false,
		form_recruitement_module: 0,
		mandatorytrainingyes: false,
		healthcaretrainingyes: false,
		needanyadjustmentsyes: false,
		livedUKyes: false,
		certificatedocs: [],
		dbsdocs: [],
		passportdocs: [],
		visadocs: [],
		drivingdocs: [],
		educationdocs: [],
		othereducationdocs: [],
		uploadProfessional: [],
		addressdocs: [],
		job_type: [],
		locations: [],
		worklist: [],
		jobtypelist: [],
		signature: "",
		workTimeSignature: "", // declaration & terms
		workTimeDate: new Date(), // declaration & terms
		acceptHealthDeclaration: false, // declaration & terms
		HealthDeclarationDate: new Date(), // declaration & terms
		acceptPersonalDeclaration: false, // declaration & terms
		PersonalDeclarationDate: new Date(), // declaration & terms
		acceptConfidentiality: false, // declaration & terms
		ConfidentialityDate: new Date(), // declaration & terms
		openWorkingTimeSignature: false, // declaration & terms
		countryOfIssue_arr: [],
		visa_country_of_issue: [],
		showModal: false,
		apply_to_all_pop: false,
		apply_to_all_pop_yes: false,
		apply_id: "",
		ask_qualifi_skip: false,
		skip_for_edu_qu: localStorage.getItem("skip_for_edu") || String(false),
		apply_to_all_pop_other: false,
		apply_to_all_pop_yes_other: false,
		apply_id_other: "",
		ask_qualifi_skip_other: false,
		skip_for_other_qu: localStorage.getItem("skip_for_other") || String(false),
		sufferedlongtermillness_notes: "",
		leaveforneckinjury_notes: "",
		neckinjuries_notes: "",
		sixweeksillness_notes: "",
		communicabledisease_notes: "",
		medicalattention_notes: "",
		medicalillness_notes: "",
		medicalillnesscaused_notes: "",
		treatment_notes: "",
		formatted_address: "",
		first_tab_up_nxt: "",
		sec_tab_up_nxt: "",
		thi_tab_up_nxt: "",
		four_tab_up_nxt: "",
		sec_main_tab_up_nxt: "",
		thi_main_tab_up_nxt: "",
		four_main_tab_up_nxt: "",
		save_as_my_current: false,
		total_percentage: "",
		remaining_percentage: "",
		review_ok_submit: false,
		mainactive_tab_1: false,
		mainactive_tab_2: false,
		mainactive_tab_3: false,
		mainactive_tab_4: false,
		mainactive_tab_5: false,
		active_tab_1: false,
		active_tab_2: false,
		active_tab_3: false,
		active_tab_4: false,
		HIV: "",
		covidVaccination_date: "",
		covidVaccination: "",
		covidVaccination_arr: [],
		showExpiryTD: false,
		showExpiryQual: [],
		emergency_contacts: [],
		showPhotoRules: false,
		qualificationCheck: false,
		joining_date: "",
		dobError: false,
		jobroleError: false,
		jobareaError: false,
		dateofstartError: false,
		mobileError: false,
		isFormErrors: false,
		skills: [],
		skill_search_data: [],
		skill_search: "",
		oninputselect_skill: false,
		language_search: "",
		language_search_data: [],
		candidateAdvice: "",
	};
	// static fields requred mapping ....  these are the state key for the inputs field ....
	#requiedStaticFieldskey = {
		"First Name":"firstname",
		"Last Name":"lastname",
		"Gender":"gender",
		"Date Of Birth":"dateofbirth",
		"Email Address":"email",
		"Mobile No":"mobileno.number",
		"What is the Earliest Date you can start work":"availablestartdate",
		"Job Role":"job_typeValue",
		"Area":"locationsValue"

	}


	closeIconTab = (e) => {
		e.preventDefault();
		return this.props.history.push({ pathname: "/profile/viewprofile" });
	};

	removeEmergencyContacts(i) {
		const emergency_contacts = [...this.state.emergency_contacts];
		emergency_contacts.splice(i, 1);
		this.setState({ emergency_contacts });
	}

	onEmergencyContactChange = (e, i) => {
		const { name, value } = e.target;
		const emergency_contacts = [...this.state.emergency_contacts];
		emergency_contacts[i] = { ...emergency_contacts[i], [name]: value };
		this.setState({ emergency_contacts });
	};

	onAddEmergencyContacts = () => {
		this.setState((prevState) => ({
			emergency_contacts: [
				...prevState.emergency_contacts,
				{
					emergency_contact_name: "",
					emergency_contact_relationship: "",
					emergency_contact_tel: "",
					emergency_contact_address: "",
				},
			],
		}));
	};

	onLanguageSearch = () => {
		request({
			url: "/employee/searchLanguages",
			method: "POST",
			data: { addedBy: "agency", name: this.state.language_search },
		}).then((res) => {
			if (res.status === 1) {
				this.setState({
					language_search_data: [...res.result].map((item, i) => {
						return { key: item.name, value: item.name };
					}),
				});
			} else if (res.status === 0) {
				toast.error(res.response);
			}
		});
	};

	onAddLanguages = (item, state) => {
		this.setState((prevState) => ({
			languages: [
				...prevState.languages,
				{ languages_title: state === null ? item.value : state },
			],
			onlanguageselect: false,
			language_search: "",
		}));
	};

	addNewLanguage = (e) => {
		e.stopPropagation();
		if (this.state.language_search === "") {
			toast.error("Please Fill to Add Language");
		} else {
			request({
				url: "/administrators/employee/addNewLanguages",
				method: "POST",
				data: { addedBy: "agency", name: this.state.language_search },
			}).then((res) => {
				if (res.status === 1) {
					toast.success("Added");
					this.onAddLanguages(null, this.state.language_search);
				} else if (res.status === 0) {
					toast.error(res.response);
				}
			});
		}
	};

	removeLanguage(i) {
		const languages = [...this.state.languages];
		languages.splice(i, 1);
		this.setState({ languages });
	}

	createLanguagesUI() {
		return this.state.languages.map((el, i) => (
			<span key={i}>
				{el.languages_title}
				<div className="uppend-abs" onClick={this.removeLanguage.bind(this, i)}>
					<i className="fa fa-minus-circle" aria-hidden="true" />
				</div>
			</span>
		));
	}

	removeSkills(i) {
		const skills = [...this.state.skills];
		skills.splice(i, 1);
		this.setState({ skills });
	}

	createSkillsUI() {
		return this.state.skills.map((el, i) => (
			<span key={i}>
				{el.skills_title}
				<div className="uppend-abs" onClick={this.removeSkills.bind(this, i)}>
					<i className="fa fa-minus-circle" aria-hidden="true" />
				</div>
			</span>
		));
	}

	onAddSkills = (item, state) => {
		this.setState((prevState) => ({
			skills: [
				...prevState.skills,
				{ skills_title: state === null ? item.value : state },
			],
			oninputselect_skill: false,
			skill_search: "",
		}));
	};

	onSkillSearch = () => {
		request({
			url: "/employee/searchSkills",
			method: "POST",
			data: { addedBy: "agency", name: this.state.skill_search },
		}).then((res) => {
			if (res.status === 1) {
				const skillData = res.result.map((item, i) => {
					return { key: item.name, value: item.name };
				});
				this.setState({ skill_search_data: skillData });
			} else if (res.status === 0) {
				toast.error(res.response);
			}
		});
	};

	createEmergencyContactsUI() {
		return this.state.emergency_contacts.map((el, i) => (
			<>
				<div className="add-next">
					<Col xs="12" md="6">
						<AvGroup>
							<Label>Name </Label>
							<AvInput
								type="text"
								name="emergency_contact_name"
								onChange={(e) => this.onEmergencyContactChange(e, i)}
								value={el.emergency_contact_name}
							/>
						</AvGroup>
					</Col>
					<Col xs="12" md="6">
						<AvGroup>
							<Label>Relationship</Label>
							<AvInput
								type="text"
								name="emergency_contact_relationship"
								onChange={(e) => this.onEmergencyContactChange(e, i)}
								value={el.emergency_contact_relationship}
								placeholder="Enter Relationship"
							/>
						</AvGroup>
					</Col>
					<Col xs="12" md="6">
						<AvGroup>
							<Label>Contact Number</Label>
							<AvInput
								type="number"
								name="emergency_contact_tel"
								onChange={(e) => this.onEmergencyContactChange(e, i)}
								value={el.emergency_contact_tel}
								placeholder="Contact Number"
							/>
						</AvGroup>
					</Col>
					<Col xs="12" md="12">
						<AvGroup>
							<Label>Address</Label>
							<PlacesAutocomplete
								value={el.emergency_contact_address}
								onChange={(e) => {
									const emergency_contacts = [...this.state.emergency_contacts];
									emergency_contacts[i] = {
										...emergency_contacts[i],
										emergency_contact_address: e,
									};
									this.setState({ emergency_contacts });
								}}
								onFocus={this.geolocate}
							>
								{({ getInputProps, suggestions, getSuggestionItemProps }) => (
									<div className="cvr-sts">
										<input
											{...getInputProps({
												placeholder: "Search Address ...",
												className: "form-control",
											})}
										/>
										<div className="autocomplete-dropdown-container absolute">
											{suggestions.map((suggestion) => {
												const className = suggestion.active
													? "suggestion-item--active"
													: "suggestion-item";
												const style = suggestion.active
													? {
														backgroundColor: "#fafafa",
														cursor: "pointer",
													}
													: {
														backgroundColor: "#ffffff",
														cursor: "pointer",
													};
												return (
													<div
														{...getSuggestionItemProps(suggestion, {
															className,
															style,
														})}
													>
														<span>{suggestion.description}</span>
													</div>
												);
											})}
										</div>
									</div>
								)}
							</PlacesAutocomplete>
						</AvGroup>
					</Col>
					<Col xs="12" md="12">
						<button
							className="remove_btn_emp"
							value="remove"
							onClick={this.removeEmergencyContacts.bind(this, i)}
						>
							<span> x </span>
						</button>
					</Col>
				</div>
			</>
		));
	}

	handleChange_n_addr = (address) => {
		this.setState({ formatted_address: address });
	};

	validateFile(value, ctx, input, cb) {
		if (!value || value === "") {
			cb(false);
		} else {
			cb(true);
		}
		return;
	}

	handleSelect_n_addr = (address) => {
		this.setState({ formatted_address: address });
		geocodeByAddress(address)
			.then((results) => {
				const res_addressmap_strt_no = results[0].address_components.find(
					(item) => {
						return item.types[0] === "street_number";
					}
				);
				this.setState({
					line1:
						res_addressmap_strt_no && res_addressmap_strt_no.long_name
							? res_addressmap_strt_no.long_name
							: "",
				});
				const res_addressmap_route = results[0].address_components.find(
					(item) => {
						return item.types[0] === "route";
					}
				);
				this.setState({
					line2:
						res_addressmap_route && res_addressmap_route.long_name
							? res_addressmap_route.long_name
							: "",
				});
				const res_addressmap_postalTown = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_town";
					}
				);
				this.setState({
					city:
						res_addressmap_postalTown && res_addressmap_postalTown.long_name
							? res_addressmap_postalTown.long_name
							: "",
				});
				const res_addressmap_adLvl1 = results[0].address_components.find(
					(item) => {
						return item.types[0] === "administrative_area_level_1";
					}
				);
				this.setState({
					state:
						res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
							? res_addressmap_adLvl1.long_name
							: "",
				});
				const res_addressmap_country = results[0].address_components.find(
					(item) => {
						return item.types[0] === "country";
					}
				);
				this.setState({
					country:
						res_addressmap_country && res_addressmap_country.long_name
							? res_addressmap_country.long_name
							: "",
				});
				const res_addressmap_zip = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_code";
					}
				);
				this.setState({
					zipcode:
						res_addressmap_zip && res_addressmap_zip.long_name
							? res_addressmap_zip.long_name
							: "",
				});
				getLatLng(results[0]).then((latlong) => {
					this.setState({ lat: latlong.lat });
					this.setState({ lon: latlong.lng });
				});
			})
			.catch((error) => console.error("Error", error));
	};

	handleChange_per_det = (address) => {
		this.setState({ streetAddress: address });
	};

	handleSelect_per_det = (address) => {
		this.setState({ streetAddress: address });
		geocodeByAddress(address)
			.then((results) => {
				const res_addressmap_route = results[0].address_components.find(
					(item) => {
						return item.types[0] === "route";
					}
				);
				this.setState({
					addressline2:
						res_addressmap_route && res_addressmap_route.long_name
							? res_addressmap_route.long_name
							: "",
				});
				const res_addressmap_postalTown = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_town";
					}
				);
				this.setState({
					city:
						res_addressmap_postalTown && res_addressmap_postalTown.long_name
							? res_addressmap_postalTown.long_name
							: "",
				});
				const res_addressmap_adLvl1 = results[0].address_components.find(
					(item) => {
						return item.types[0] === "administrative_area_level_1";
					}
				);
				this.setState({
					state:
						res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
							? res_addressmap_adLvl1.long_name
							: "",
				});
				const res_addressmap_country = results[0].address_components.find(
					(item) => {
						return item.types[0] === "country";
					}
				);
				this.setState({
					country:
						res_addressmap_country && res_addressmap_country.long_name
							? res_addressmap_country.long_name
							: "",
				});
				const res_addressmap_zip = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_code";
					}
				);
				this.setState({
					zip:
						res_addressmap_zip && res_addressmap_zip.long_name
							? res_addressmap_zip.long_name
							: "",
				});
			})
			.catch((error) => console.error("Error", error));
	};

	handleChange_kin_addr = (address) => {
		this.setState({ kinstreetAddress: address });
	};

	handleSelect_kin_addr = (address) => {
		this.setState({ kinstreetAddress: address });
		geocodeByAddress(address)
			.then((results) => {
				const res_addressmap_route = results[0].address_components.find(
					(item) => {
						return item.types[0] === "route";
					}
				);
				this.setState({
					kinaddressline2:
						res_addressmap_route && res_addressmap_route.long_name
							? res_addressmap_route.long_name
							: "",
				});
				const res_addressmap_postalTown = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_town";
					}
				);
				this.setState({
					kincity:
						res_addressmap_postalTown && res_addressmap_postalTown.long_name
							? res_addressmap_postalTown.long_name
							: "",
				});
				const res_addressmap_adLvl1 = results[0].address_components.find(
					(item) => {
						return item.types[0] === "administrative_area_level_1";
					}
				);
				this.setState({
					kinstate:
						res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
							? res_addressmap_adLvl1.long_name
							: "",
				});
				const res_addressmap_country = results[0].address_components.find(
					(item) => {
						return item.types[0] === "country";
					}
				);
				this.setState({
					kincountry:
						res_addressmap_country && res_addressmap_country.long_name
							? res_addressmap_country.long_name
							: "",
				});
				const res_addressmap_zip = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_code";
					}
				);
				this.setState({
					kinzip:
						res_addressmap_zip && res_addressmap_zip.long_name
							? res_addressmap_zip.long_name
							: "",
				});
			})
			.catch((error) => console.error("Error", error));
	};

	change_toggle = (e, name) => {
		this.setState({ [name]: e.target.checked ? true : false });
		if (e.target.checked) {
			this.setState({
				kinstreetAddress: this.state.streetAddress,
				kinaddressline2: this.state.addressline2,
				kincity: this.state.city,
				kinstate: this.state.state,
				kinzip: this.state.zip,
				kincountry: this.state.country,
			});
		} else {
			this.setState({
				kinstreetAddress: "",
				kinaddressline2: "",
				kincity: "",
				kinstate: "",
				kinzip: "",
				kincountry: "",
			});
		}
	};

	handleChange_ref_addr_1 = (address) => {
		this.setState({ firstrefstreetAddress: address });
	};

	handleSelect_ref_addr1 = (address) => {
		this.setState({ firstrefstreetAddress: address });
		geocodeByAddress(address)
			.then((results) => {
				const res_addressmap_postalTown = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_town";
					}
				);
				this.setState({
					firstrefcity:
						res_addressmap_postalTown && res_addressmap_postalTown.long_name
							? res_addressmap_postalTown.long_name
							: "",
				});
				const res_addressmap_adLvl1 = results[0].address_components.find(
					(item) => {
						return item.types[0] === "administrative_area_level_1";
					}
				);
				this.setState({
					firstrefstate:
						res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
							? res_addressmap_adLvl1.long_name
							: "",
				});
				const res_addressmap_zip = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_code";
					}
				);
				this.setState({
					firstrefzip:
						res_addressmap_zip && res_addressmap_zip.long_name
							? res_addressmap_zip.long_name
							: "",
				});
			})
			.catch((error) => console.error("Error", error));
	};

	handleChange_ref_addr_2 = (address) => {
		this.setState({ secondrefstreetAddress: address });
	};

	handleSelect_ref_addr_2 = (address) => {
		this.setState({ secondrefstreetAddress: address });
		geocodeByAddress(address)
			.then((results) => {
				const res_addressmap_postalTown = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_town";
					}
				);
				this.setState({
					secondrefcity:
						res_addressmap_postalTown && res_addressmap_postalTown.long_name
							? res_addressmap_postalTown.long_name
							: "",
				});
				const res_addressmap_adLvl1 = results[0].address_components.find(
					(item) => {
						return item.types[0] === "administrative_area_level_1";
					}
				);
				this.setState({
					secondrefstate:
						res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
							? res_addressmap_adLvl1.long_name
							: "",
				});
				const res_addressmap_zip = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_code";
					}
				);
				this.setState({
					secondrefzip:
						res_addressmap_zip && res_addressmap_zip.long_name
							? res_addressmap_zip.long_name
							: "",
				});
			})
			.catch((error) => console.error("Error", error));
	};

	handleChange_ref_addr_3 = (address) => {
		this.setState({ thirdrefstreetAddress: address });
	};

	handleSelect_ref_addr_3 = (address) => {
		this.setState({ thirdrefstreetAddress: address });
		geocodeByAddress(address)
			.then((results) => {
				const res_addressmap_postalTown = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_town";
					}
				);
				this.setState({
					thirdrefcity:
						res_addressmap_postalTown && res_addressmap_postalTown.long_name
							? res_addressmap_postalTown.long_name
							: "",
				});
				const res_addressmap_adLvl1 = results[0].address_components.find(
					(item) => {
						return item.types[0] === "administrative_area_level_1";
					}
				);
				this.setState({
					thirdrefstate:
						res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
							? res_addressmap_adLvl1.long_name
							: "",
				});
				const res_addressmap_zip = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_code";
					}
				);
				this.setState({
					thirdrefzip:
						res_addressmap_zip && res_addressmap_zip.long_name
							? res_addressmap_zip.long_name
							: "",
				});
			})
			.catch((error) => console.error("Error", error));
	};

	handleChange_gp_addr = (address) => {
		this.setState({ GPstreetAddress: address });
	};

	handleSelect_gp_addr = (address) => {
		this.setState({ GPstreetAddress: address });
		geocodeByAddress(address)
			.then((results) => {
				const res_addressmap_postalTown = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_town";
					}
				);
				this.setState({
					GPcity:
						res_addressmap_postalTown && res_addressmap_postalTown.long_name
							? res_addressmap_postalTown.long_name
							: "",
				});
				const res_addressmap_adLvl1 = results[0].address_components.find(
					(item) => {
						return item.types[0] === "administrative_area_level_1";
					}
				);
				this.setState({
					GPstate:
						res_addressmap_adLvl1 && res_addressmap_adLvl1.long_name
							? res_addressmap_adLvl1.long_name
							: "",
				});
				const res_addressmap_zip = results[0].address_components.find(
					(item) => {
						return item.types[0] === "postal_code";
					}
				);
				this.setState({
					GPzip:
						res_addressmap_zip && res_addressmap_zip.long_name
							? res_addressmap_zip.long_name
							: "",
				});
			})
			.catch((error) => console.error("Error", error));
	};
	getCandidateAdvice = () => {
		request({
			url: "/candidate/recruitment_advice",
			method: "POST",
		}).then((results) => {
			// console.log(results);
			this.setState({ candidateAdvice: results.result.candidateAdvice });
		}).catch((error) => console.error("Error", error));
	};



	//  to get the template fields ....  /candidate/onlineform_template
	getTemplateFields = async () => { 
		request({
			url: "/candidate/onlineform_template",
			method: "POST",
		}).then((results = {}) => {
			// console.log(results , "from the candidate template form .....");
			let staticFields = Array.isArray(results.response && results.response.staticFields) ? results.response.staticFields : [],
				addtionalFields = Array.isArray(results.response && results.response.addtionalFields) ? results.response.addtionalFields  : [];
			this.setState({ templateFields: staticFields , templateAddtionalFields:addtionalFields   });
		}).catch((error) => console.error("Error", error));
		// this.setState(()=>({templateFields:dummyFields}))
	}

	componentDidMount(name) {
		// const token = this.props.token_role;
		// if (
		//     !token ||
		//     (token && (!token.username || token.role !== "employee"))
		// ) {
		//     return this.props.history.replace("/employeelogin");
		// }
		this.setState({ propreview: null, avatar: "" });
		this.getEmployeeData(name);
		this.getCandidateAdvice();
		this.getTemplateFields().then(()=>{

			// let nextTabIsDisabled = this.menuRequiredFieldsAreNotEmpty();
			// 	nextTabIsDisabled = !(nextTabIsDisabled.addtionalFields && nextTabIsDisabled.staticFields)
			// 	this.setState({nextTabIsDisabled})
		})
	}

	review_ok_toggle = (e, name) => {
		if(String(name) === "") return this.setState({ review_ok_submit: !this.state.review_ok_submit });
		if (name && String(name).length > 0 && String(name) === "settab") {
			this.setState({ mainActiveTab: "1", activeTab: "1" });
			window.scrollTo(0, 0);
		}
		toast.success(
			"Thank you, your profile/application has been submitted, we will be in touch soon"
		);
		this.setState({ review_ok_submit: !this.state.review_ok_submit });
		this.props.history.push("/profile/viewprofile");
	};

	getEmployeeData = (name) => {
		request({
			url: "/employee/profile",
			method: "POST",
		}).then((res) => {
			if (res.status === 1) {
				if (String(name).length > 0 && String(name) === "signature") {
					this.setState({
						total_percentage:
							res.response &&
								res.response.result &&
								res.response.result.total_percentage
								? res.response.result.total_percentage
								: 0,
						remaining_percentage:
							res.response &&
								res.response.result &&
								res.response.result.remaining_percentage
								? res.response.result.remaining_percentage
								: 0,
					});
					if (
						res.response &&
						res.response.result &&
						res.response.result.total_percentage &&
						// res.response.result.total_percentage <= 99
						res.response.result.total_percentage <= 95
					) {
						this.setState({ review_ok_submit: !this.state.review_ok_submit });
					}
				} else {
					this.setState({
						total_percentage:
							res.response &&
								res.response.result &&
								res.response.result.total_percentage
								? res.response.result.total_percentage
								: 0,
						remaining_percentage:
							res.response &&
								res.response.result &&
								res.response.result.remaining_percentage
								? res.response.result.remaining_percentage
								: 0,
					});
				}
				const emp_reg_address = res.response.result.address || {};
				const res_result = res.response.result ? res.response.result : {};
				const form_data = res.response.result.onlineform
					? res.response.result.onlineform
					: {};
				const form_recruitement_module = res.response.result.onlineform
					? res.response.result.onlineform.recruitment_module
					: {};
				const form_personaldetails =
					res.response.result.onlineform &&
						res.response.result.onlineform.personaldetails
						? res.response.result.onlineform.personaldetails
						: {};
				const form_driving =
					res.response.result.onlineform &&
						res.response.result.onlineform.drivingdetails
						? res.response.result.onlineform.drivingdetails
						: {};
				const form_aboutwork =
					res.response.result.onlineform &&
						res.response.result.onlineform.aboutyourwork
						? res.response.result.onlineform.aboutyourwork.abletowork
						: {};
				const form_aboutmywork =
					res.response.result.onlineform &&
						res.response.result.onlineform.aboutyourwork
						? res.response.result.onlineform.aboutyourwork
						: {};
				const form_kin =
					res.response.result.onlineform &&
						res.response.result.onlineform.nextofkindetails
						? res.response.result.onlineform.nextofkindetails
						: {};
				const form_gp =
					res.response.result.onlineform &&
						res.response.result.onlineform.gpdetails
						? res.response.result.onlineform.gpdetails
						: {};
				const form_status =
					res.response.result.onlineform &&
						res.response.result.onlineform.form_status
						? res.response.result.onlineform.form_status
						: 0;
				const bankDetails = res.response.result.bank_details
					? res.response.result.bank_details
					: {};
				const locations = res.response.result
					? res.response.result.locations
					: [];
				const job_types = res.response.result
					? res.response.result.job_type
					: [];
				if (
					res.response &&
					res.response.result &&
					res.response.result.save_as_my_current
				) {
					document.getElementById(`save_as_my_current`).checked = true;
				}
				request({
					url: "/employee/agencydetails",
					method: "POST",
				}).then((res) => {
					if (res.status === 1) {
						this.setState({
							// worklist: res.response.result[0].locations || {},
							// jobtypelist: res.response.result[0].jobtypes || {},
							company_name: res.response.result[0].company_name || "",
						});
						if (
							res.response &&
							res.response.result.length > 0 &&
							Array.isArray(res.response.result) &&
							res.response.result[0].locations &&
							res.response.result[0].locations.length > 0 &&
							Array.isArray(res.response.result[0].jobtypes)
						) {
							const worklist = res.response.result[0].locations.map(
								(emp, key) => ({
									value: emp._id,
									label: emp.name,
								})
							);
							let locationsValue = worklist.filter((item) => {
								return locations.includes(item.value);
							});
							this.setState({
								worklist,
								locations: locationsValue,
								locationsValue,
							});
						}
						if (
							res.response &&
							res.response.result.length > 0 &&
							Array.isArray(res.response.result) &&
							res.response.result[0].jobtypes &&
							res.response.result[0].jobtypes.length > 0 &&
							Array.isArray(res.response.result[0].jobtypes)
						) {
							const jobtypelist = res.response.result[0].jobtypes.map(
								(emp, key) => ({
									value: emp._id,
									label: emp.name,
								})
							);
							let job_typeValue = jobtypelist.filter((item) => {
								return job_types.includes(item.value);
							});

							this.setState({
								jobtypelist,
								job_type: job_typeValue,
								job_typeValue,
							});
						}
					}
				});

				this.setState({
					empBio:
						res_result && CheckValue(res_result.empBio)
							? res_result.empBio
							: "",
					joining_date:
						res_result.joining_date && CheckValue(res_result.joining_date)
							? res_result.joining_date
							: "",
					covidVaccination:
						res.response &&
							res.response.result &&
							res.response.result.covidVaccination &&
							CheckValue(res.response.result.covidVaccination)
							? res.response.result.covidVaccination
							: "",
					covidVaccination_date:
						res.response &&
							res.response.result &&
							res.response.result.covidVaccination_date &&
							CheckValue(res.response.result.covidVaccination_date)
							? res.response.result.covidVaccination_date
							: "",
					covidVaccination_arr:
						res.response &&
							res.response.result &&
							res.response.result.covidVaccination &&
							CheckValue(res.response.result.covidVaccination)
							? VaccinationList.filter(
								(e) =>
									String(e.value) ===
									String(res.response.result.covidVaccination)
							)
							: [],
					save_as_my_current:
						res.response &&
							res.response.result &&
							res.response.result.save_as_my_current
							? res.response.result.save_as_my_current
							: false,
					signature:
						res.response.result && res.response.result.signature
							? res.response.result.signature
							: "",
					workTimeSignature:
						form_data && form_data.worktimedirectives
							? form_data.worktimedirectives.signature
							: "",
					workTimeDate:
						form_data && form_data.worktimedirectives
							? form_data.worktimedirectives.date === ""
								? new Date()
								: form_data.worktimedirectives.date
							: new Date(),
					acceptHealthDeclaration:
						form_data && form_data.healthDeclarationTerms
							? form_data.healthDeclarationTerms.acceptHealthDeclaration
							: "",
					HealthDeclarationDate:
						form_data && form_data.healthDeclarationTerms
							? form_data.healthDeclarationTerms.date === ""
								? new Date()
								: form_data.healthDeclarationTerms.date
							: new Date(),
					acceptPersonalDeclaration:
						form_data && form_data.personalDeclarationTerms
							? form_data.personalDeclarationTerms.acceptPersonalDeclaration
							: "",
					PersonalDeclarationDate:
						form_data && form_data.personalDeclarationTerms
							? form_data.personalDeclarationTerms.date === ""
								? new Date()
								: form_data.personalDeclarationTerms.date
							: new Date(),
					acceptConfidentiality:
						form_data && form_data.confidentialityTerms
							? form_data.confidentialityTerms.acceptConfidentiality
							: "",
					ConfidentialityDate:
						form_data && form_data.confidentialityTerms
							? form_data.confidentialityTerms.date === ""
								? new Date()
								: form_data.confidentialityTerms.date
							: new Date(),
					// driving details
					drivinglicence: form_driving.drivinglicence || "",
					// driving details
					drivinglicenceno:
						res.response.result &&
							res.response.result.drivers_licence &&
							res.response.result.drivers_licence.licence_number
							? res.response.result.drivers_licence.licence_number
							: "",
					// driving details
					drivinglicenceisVisible: res.response.result &&
							res.response.result.drivers_licence &&
							res.response.result.drivers_licence.licenceisVisible
							? res.response.result.drivers_licence.licenceisVisible
							: false,
					licenceExpiry:
						res.response.result &&
							res.response.result.drivers_licence &&
							res.response.result.drivers_licence.licence_expiry
							? res.response.result.drivers_licence.licence_expiry
							: "", // driving details
					licenceClass:
						res.response.result &&
							res.response.result.drivers_licence &&
							res.response.result.drivers_licence.licence_class
							? res.response.result.drivers_licence.licence_class
							: "",
					job_type:
						res.response.result.job_type &&
							Array.isArray(res.response.result.job_type) &&
							res.response.result.job_type.length > 0
							? res.response.result.job_type
							: [],
					locations:
						res.response.result.locations &&
							Array.isArray(res.response.result.locations) &&
							res.response.result.locations.length > 0
							? res.response.result.locations
							: [],
					dateofMarriage:
						form_personaldetails &&
							form_personaldetails.dateofMarriage &&
							CheckValue(form_personaldetails.dateofMarriage)
							? form_personaldetails.dateofMarriage
							: null,
					addtionalFieldsValue:form_data.addtionalFields,
				});
				if (
					res.response.result &&
					res.response.result.drivers_licence &&
					res.response.result.drivers_licence.country_of_issue
				) {
					let drivingCountryOfIssue_arr = countries.filter((item) => {
						if (
							item &&
							(String(item.value) ===
								String(res.response.result.drivers_licence.country_of_issue) ||
								String(item.label) ===
								String(res.response.result.drivers_licence.country_of_issue))
						) {
							return item;
						}
					});
					this.setState({
						drivingCountryOfIssue_arr,
						drivingCountryOfIssue:
							res.response.result.drivers_licence.country_of_issue,
					});
				}
				if (
					form_personaldetails &&
					form_personaldetails.nationality &&
					countries &&
					countries.length > 0
				) {
					let national_ity = countries.filter((item) => {
						if (
							item &&
							(String(item.value) ===
								String(form_personaldetails.nationality) ||
								String(item.label) === String(form_personaldetails.nationality))
						) {
							return item;
						}
					});
					this.setState({ national_ity });
				}
				if (
					form_data &&
					form_data.righttowork &&
					form_data.righttowork.countryOfIssue &&
					countries &&
					countries.length > 0
				) {
					let countryOfIssue_arr = countries.filter((item) => {
						if (
							item &&
							(String(item.value) ===
								String(form_data.righttowork.countryOfIssue) ||
								String(item.label) ===
								String(form_data.righttowork.countryOfIssue))
						) {
							return item;
						}
					});
					this.setState({
						countryOfIssue_arr,
						countryOfIssue: form_data.righttowork.countryOfIssue,
					});
				}
				this.setState({
					visaNumber:
						res.response.result &&
							res.response.result.visa_info &&
							res.response.result.visa_info.visa_number
							? res.response.result.visa_info.visa_number
							: "",
					visaCountryOfIssue:
						res.response.result &&
							res.response.result.visa_info &&
							res.response.result.visa_info.country_of_issue
							? res.response.result.visa_info.country_of_issue
							: "",
					visaExpiry:
						res.response.result &&
							res.response.result.visa_info &&
							res.response.result.visa_info.visa_expiry
							? res.response.result.visa_info.visa_expiry
							: "",
				});
				if (
					res.response.result &&
					res.response.result.visa_info &&
					res.response.result.visa_info.country_of_issue
				) {
					let visa_country_of_issue = countries.filter((item) => {
						if (
							item &&
							(String(item.value) ===
								String(res.response.result.visa_info.country_of_issue) ||
								String(item.label) ===
								String(res.response.result.visa_info.country_of_issue))
						) {
							return item;
						}
					});
					this.setState({
						visa_country_of_issue,
						visaCountryOfIssue: res.response.result.visa_info.country_of_issue,
					});
				}
				if (form_recruitement_module) {
					this.checkandupdate();
					if (form_data) {
						this.setState(
							{
								declarationAccept:
									form_data.declaration &&
									form_data.declaration.declarationAccept, // declaration
								declarationAcceptDate:
									form_data && form_data.declaration
										? form_data.declaration.declarationAcceptDate === ""
											? new Date()
											: form_data.declaration.declarationAcceptDate
										: new Date(), // declaration
								registereddisabled:
									form_data.disable_act &&
									form_data.disable_act.registereddisabled, // declaration-disable
								disableAct:
									form_data.disable_act && form_data.disable_act.disableAct, // declaration-disable
								disableOverCome:
									form_data.disable_act &&
									form_data.disable_act.disableOverCome, // declaration-disable
								disableRegisteredDetails:
									form_data.disable_act &&
									form_data.disable_act.disableRegisteredDetails, // declaration-disable
								disableActDetails:
									form_data.disable_act &&
									form_data.disable_act.disableActDetails, // declaration-disable
								disableOverComeDetails:
									form_data.disable_act &&
									form_data.disable_act.disableOverComeDetails,
								criminalAdditionalInformation:
									form_data.criminal_records &&
									form_data.criminal_records.criminalAdditionalInformation, // declaration-criminal
								dbsAccept:
									form_data.dbsDeclaration && form_data.dbsDeclaration.dbsAccept
										? form_data.dbsDeclaration.dbsAccept
										: "", // declaration-criminal
								indemnityAccept: form_data.id_indemnity_verification
									? form_data.id_indemnity_verification
									: "", // id and indemnity
								dbsAcceptDate:
									form_data.dbsDeclaration && form_data.dbsDeclaration.date
										? form_data.dbsDeclaration.date
										: new Date(), // declaration-criminal
								criminalDisciplinaryAction:
									form_data.criminal_records &&
									form_data.criminal_records.criminalDisciplinaryAction, // declaration-criminal
								criminalCourt:
									form_data.criminal_records &&
									form_data.criminal_records.criminalCourt, // declaration-criminal
								criminalConvictions:
									form_data.criminal_records &&
									form_data.criminal_records.criminalConvictions, // declaration-criminal
								criminalCautioned:
									form_data.criminal_records &&
									form_data.criminal_records.criminalCautioned, // declaration-criminal
								criminaloffence:
									form_data.criminal_records &&
									form_data.criminal_records.criminaloffence,

								documentType:
									form_data.righttowork && form_data.righttowork.documentType
										? form_data.righttowork.documentType
										: "",
								docType:
									form_data.docType ? form_data.docType : "",
								rightToWorkType:
									form_data.rightToWorkType ? form_data.rightToWorkType : "",
								default_id:
									form_data.docType ? form_data.docType : "",
								default_rtw:
									form_data.rightToWorkType ? form_data.rightToWorkType : "",
								docType_info:
									form_data.docType_info ? form_data.docType_info : this.state.docType_info,
								rightToWorkType_info:
									form_data.rightToWorkType_info ? form_data.rightToWorkType_info : this.state.rightToWorkType_info,
								passportdocs:
									form_data.uploadpassport &&
										form_data.uploadpassport.length > 0
										? form_data.uploadpassport
										: [],
								visadocs:
									form_data.uploadvisa && form_data.uploadvisa.length > 0
										? form_data.uploadvisa
										: [],
								drivingdocs:
									form_data.uploaddriving && form_data.uploaddriving.length > 0
										? form_data.uploaddriving
										: [],
								educationdocs:
									form_data.uploadeducationcertificate &&
										form_data.uploadeducationcertificate.length > 0
										? form_data.uploadeducationcertificate
										: [],
								othereducationdocs:
									form_data.uploadothereducationcertificate &&
										form_data.uploadothereducationcertificate.length > 0
										? form_data.uploadothereducationcertificate
										: [],
								// passport details
								passport:
									form_data.righttowork && form_data.righttowork.passport
										? form_data.righttowork.passport
										: "",
								Passportdetails:
									form_data.righttowork && form_data.righttowork.Passportdetails
										? form_data.righttowork.Passportdetails
										: "",
								documentNumber:
									form_data.righttowork && form_data.righttowork.documentNumber
										? form_data.righttowork.documentNumber
										: "",
								countryOfIssue:
									form_data.righttowork && form_data.righttowork.countryOfIssue
										? form_data.righttowork.countryOfIssue
										: "",
								docTypeExpiry:
									form_data.righttowork && form_data.righttowork.docTypeExpiry
										? form_data.righttowork.docTypeExpiry
										: "",
								documents: res.response.result.documents || [], //documents
								work_experience: res.response.result.work_exp || [], //Skills and Work history
								skills: res.response.result.skills || [], //Skills and Work history
								languages: res.response.result.languages || [], //Skills and Work history
								skillProvideDetails: form_data.skillProvideDetails, //Skills and Work history
								education_qualification:
									res.response.result.education_qualification || [], //employment and education
								other_courses: res.response.result.other_courses || [], //employment and education
								professional_Body:
									form_data &&
										form_data.professional_Body &&
										Array.isArray(form_data.professional_Body) &&
										form_data.professional_Body.length > 0
										? form_data.professional_Body
										: [],
								professionalBodyExpiry:
									form_data.professionalBody &&
									form_data.professionalBody.professionalBodyExpiry, //employment and education
								professionalBody:
									form_data.professionalBody &&
									form_data.professionalBody.professionalBody, //employment and education
								pinRef:
									form_data.professionalBody &&
									form_data.professionalBody.pinRef, //employment and education
								accountName: bankDetails.accountName, //bank
								accountType: bankDetails.accountType, //bank
								bankName: bankDetails.bankName, //bank
								bank_ac: bankDetails.bank_ac_name, //bank
								bank_sort_code: bankDetails.bank_sort_code, //bank
								postCode: bankDetails.postCode, //bank
								bankEmail: bankDetails.bankEmail, //bank
								// bankMobileNo: {//bank
								//     number: "",
								//     code: "",
								//     dialcountry: ""
								// },
								bankMobileNo: {
									//bank
									number:
										bankDetails &&
											bankDetails.bank_number &&
											bankDetails.bank_number.number
											? bankDetails.bank_number.number
											: "",
									code:
										bankDetails &&
											bankDetails.bank_number &&
											bankDetails.bank_number.code
											? bankDetails.bank_number.code
											: "",
									dialcountry:
										bankDetails &&
											bankDetails.bank_number &&
											bankDetails.bank_number.dailcountry
											? bankDetails.bank_number.dailcountry
											: "gb",
								},
								form_recruitement_module,
								// activeTab: form_status > 0 ? "5" : "1",
								postapplyfor: res.response.result.job_type,
								postapplydetails: form_data.postapplydetails,
								title: form_personaldetails.title,
								dateMovedAddress: form_personaldetails.dateMovedAddress,
								firstname: res.response.result.name,
								middlename: form_personaldetails.middlename,
								prefferedName: form_personaldetails.prefferedName,
								maidenName: form_personaldetails.maidenName,
								isNameChanged: form_personaldetails.isNameChanged,
								previousNames: form_personaldetails.previousName,
								lastname: res.response.result.surname,
								homephone: form_personaldetails.homephone || "",
								mobileno: {
									number:
										form_personaldetails &&
											form_personaldetails.mobileno &&
											form_personaldetails.mobileno.number &&
											CheckValue(form_personaldetails.mobileno.number)
											? form_personaldetails.mobileno.number
											: res.response.result &&
												res.response.result.phone &&
												res.response.result.phone.number
												? res.response.result.phone.number
												: "",
									code:
										form_personaldetails &&
											form_personaldetails.mobileno &&
											form_personaldetails.mobileno.code &&
											CheckValue(form_personaldetails.mobileno.code)
											? form_personaldetails.mobileno.code
											: res.response.result &&
												res.response.result.phone &&
												res.response.result.phone.code
												? res.response.result.phone.code
												: "",
									dailcountry:
										form_personaldetails &&
											form_personaldetails.mobileno &&
											form_personaldetails.mobileno.dialcountry &&
											CheckValue(form_personaldetails.mobileno.dialcountry)
											? form_personaldetails.mobileno.dialcountry
											: res.response.result &&
												res.response.result.phone &&
												res.response.result.phone.dailcountry
												? res.response.result.phone.dailcountry
												: "gb",
								},
								email: res.response.result.email,
								dateofbirth: form_personaldetails.dateofbirth,
								insuranceno: form_personaldetails.insuranceno,
								martialStatus: form_personaldetails.martialStatus,
								nationality: form_personaldetails.nationality,
								workstatus: form_data.workstatus,
								currentDBS: form_personaldetails.iscurrentDBS,
								dbsIssueDate: form_personaldetails.dbsIssueDate
									? form_personaldetails.dbsIssueDate
									: this.state.dbsIssueDate,
								dbsExpirydate: CheckValue(form_personaldetails.dbsExpirydate)
									? form_personaldetails.dbsExpirydate
									: "",
								dbsCertificateNo: form_personaldetails.dbsCertificateNo,
								dbsisVisible: form_personaldetails.dbsisVisible ,
								// streetAddress: form_personaldetails.address && form_personaldetails.address.streetAddress,
								// addressline2: form_personaldetails.address && form_personaldetails.address.addressline2,
								// city: form_personaldetails.address && form_personaldetails.address.city,
								// state: form_personaldetails.address && form_personaldetails.address.state,
								// zip: form_personaldetails.address && form_personaldetails.address.zip,
								// country: form_personaldetails.address && form_personaldetails.address.country,

								streetAddress:
									form_personaldetails.address &&
										form_personaldetails.address.streetAddress
										? form_personaldetails.address.streetAddress
										: "",
								addressline2:
									form_personaldetails.address &&
										form_personaldetails.address.addressline2
										? form_personaldetails.address.addressline2
										: "",
								city:
									form_personaldetails.address &&
										form_personaldetails.address.city
										? form_personaldetails.address.city
										: "",
								state:
									form_personaldetails.address &&
										form_personaldetails.address.state
										? form_personaldetails.address.state
										: "",
								zip:
									form_personaldetails.address &&
										form_personaldetails.address.zip
										? form_personaldetails.address.zip
										: "",
								country:
									form_personaldetails.address &&
										form_personaldetails.address.country
										? form_personaldetails.address.country
										: "",

								gender: form_personaldetails.gender,
								religion: form_personaldetails.religion,
								race: form_personaldetails.race,
								sexualorientation: form_personaldetails.sexualorientation,
								UploadIDPhoto: form_data.UploadIDPhoto,
								UploadIDName:
									form_data.UploadIDPhoto &&
									form_data.UploadIDPhoto.substr(24, 30),
								visapermit:
									form_data.employmenteligibility &&
									form_data.employmenteligibility.visapermit,
								visapermittype:
									form_data.employmenteligibility &&
									form_data.employmenteligibility.visapermittype,
								traveldetails: form_driving.traveldetails || "",
								caraccess: form_driving.caraccess || "",
								bannedfromdriving: form_driving.bannedfromdriving || "",
								carinsurance: form_driving.carinsurance || "",
								drivingPhotoID: form_driving.drivingPhotoID || "",
								UploadCV: form_data.UploadCV && form_data.UploadCV,
								UploadCVName:
									form_data.UploadCV && form_data.UploadCV.substr(24, 30),
								vehicledocumentsvalid: form_driving.vehicledocumentsvalid,
								englishspoken:
									(form_data.langauages &&
										form_data.langauages.englishspoken) ||
									"",
								englishwritten:
									(form_data.langauages &&
										form_data.langauages.englishwritten) ||
									"",
								otherlanguage:
									form_data.langauages &&
										form_data.langauages.otherlanguage &&
										Array.isArray(form_data.langauages.otherlanguage)
										? form_data.langauages.otherlanguage
										: [],

								IELTStest:
									(form_data.langauages && form_data.langauages.IELTStest) ||
									"",
								work_mornings:
									String(form_aboutwork.work_mornings) === String("true")
										? true
										: false,
								work_evenings:
									String(form_aboutwork.work_evenings) === String("true")
										? true
										: false,
								work_afternoons:
									String(form_aboutwork.work_afternoons) === String("true")
										? true
										: false,
								work_occasional:
									String(form_aboutwork.work_occasional) === String("true")
										? true
										: false,
								work_fulltime:
									String(form_aboutwork.work_fulltime) === String("true")
										? true
										: false,
								work_parttime:
									String(form_aboutwork.work_parttime) === String("true")
										? true
										: false,
								work_nights:
									String(form_aboutwork.work_nights) === String("true")
										? true
										: false,
								work_weekends:
									String(form_aboutwork.work_weekends) === String("true")
										? true
										: false,
								work_anytime:
									String(form_aboutwork.work_anytime) === String("true")
										? true
										: false,
								availablestartdate: form_aboutmywork.availablestartdate
									? form_aboutmywork.availablestartdate
									: "",

								kinprefix: form_kin.kinprefix,
								kinfirstname:
									form_kin.kinfirstname === "undefined"
										? ""
										: form_kin.kinfirstname,
								kinlastname:
									form_kin.kinlastname === "undefined"
										? ""
										: form_kin.kinlastname,
								kinrelationship:
									form_kin.kinrelationship === "undefined"
										? ""
										: form_kin.kinrelationship,
								kinhomephone:
									form_kin.kinhomephone === "undefined"
										? 0
										: form_kin.kinhomephone,
								kinmobileno: form_kin.kinmobileno || {
									number: "",
									code: "",
									dailcountry: "gb",
								},
								kinemail: form_kin.kinemail || "",
								kinstreetAddress:
									(form_kin.Address && form_kin.Address.kinstreetAddress) || "",
								kinaddressline2:
									(form_kin.Address && form_kin.Address.kinaddressline2) || "",
								kincity: (form_kin.Address && form_kin.Address.kincity) || "",
								kinstate: (form_kin.Address && form_kin.Address.kinstate) || "",
								kinzip: (form_kin.Address && form_kin.Address.kinzip) || "",
								kincountry:
									(form_kin.Address && form_kin.Address.kincountry) || "",
								firstchoice:
									form_data.aboutyourwork &&
									form_data.aboutyourwork.firstchoice,
								secondchoice:
									form_data.aboutyourwork &&
									form_data.aboutyourwork.secondchoice,
								thirdchoice:
									form_data.aboutyourwork &&
									form_data.aboutyourwork.thirdchoice,
								shortnotice:
									form_data.aboutyourwork &&
									form_data.aboutyourwork.shortnotice,
								reduceworkflexibility:
									form_data.aboutyourwork &&
									form_data.aboutyourwork.reduceworkflexibility,
								workstate:
									form_data.aboutyourwork &&
										form_data.aboutyourwork.workstate === "undefined"
										? ""
										: form_data.aboutyourwork &&
										form_data.aboutyourwork.workstate,
								employmenthistorylist:
									form_data.employmenthistory === "undefined" ||
										form_data.employmenthistory === null
										? []
										: form_data.employmenthistory,
								educationlist:
									form_data.education === "undefined" ||
										form_data.education === null
										? []
										: form_data.education,
								firstrefrelationship:
									form_data.reference1 &&
										form_data.reference1.firstrefrelationship === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.firstrefrelationship,
								firstreffirstname:
									form_data.reference1 &&
										form_data.reference1.firstreffirstname === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.firstreffirstname,
								firstreflastname:
									form_data.reference1 &&
										form_data.reference1.firstreflastname === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.firstreflastname,
								firstrefphone: (form_data.reference1 &&
									form_data.reference1.firstrefphone) || {
									number: "",
									code: "",
									dailcountry: "gb",
								},
								firstrefemail:
									form_data.reference1 &&
										form_data.reference1.firstrefemail === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.firstrefemail,
								firstrefconfirmemail:
									form_data.reference1 &&
										form_data.reference1.firstrefconfirmemail === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.firstrefconfirmemail,
								firstrefstreetAddress:
									form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefstreetAddress ===
										"undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefstreetAddress,
								firstrefcity:
									form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefcity === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefcity,
								firstrefstate:
									form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefstate === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefstate,
								firstrefzip:
									form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefzip === "undefined"
										? ""
										: form_data.reference1 &&
										form_data.reference1.Address &&
										form_data.reference1.Address.firstrefzip,
								secondrefrelationship:
									form_data.reference2 &&
										form_data.reference2.secondrefrelationship === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.secondrefrelationship,
								secondreffirstname:
									form_data.reference2 &&
										form_data.reference2.secondreffirstname === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.secondreffirstname,
								secondreflastname:
									form_data.reference2 &&
										form_data.reference2.secondreflastname === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.secondreflastname,
								secondrefphone: (form_data.reference2 &&
									form_data.reference2.secondrefphone) || {
									number: "",
									code: "",
									dailcountry: "gb",
								},
								secondrefemail:
									form_data.reference2 &&
										form_data.reference2.secondrefemail === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.secondrefemail,
								secondrefconfirmemail:
									form_data.reference2 &&
										form_data.reference2.secondrefconfirmemail === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.secondrefconfirmemail,
								secondrefstreetAddress:
									form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefstreetAddress ===
										"undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefstreetAddress,
								secondrefcity:
									form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefcity === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefcity,
								secondrefstate:
									form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefstate === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefstate,
								secondrefzip:
									form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefzip === "undefined"
										? ""
										: form_data.reference2 &&
										form_data.reference2.Address &&
										form_data.reference2.Address.secondrefzip,
								thirdrefrelationship:
									form_data.reference3 &&
										form_data.reference3.thirdrefrelationship === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.thirdrefrelationship,
								thirdreffirstname:
									form_data.reference3 &&
										form_data.reference3.thirdreffirstname === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.thirdreffirstname,
								thirdreflastname:
									form_data.reference3 &&
										form_data.reference3.thirdreflastname === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.thirdreflastname,
								thirdrefphone: (form_data.reference3 &&
									form_data.reference3.thirdrefphone) || {
									number: "",
									code: "",
									dailcountry: "gb",
								},
								thirdrefemail:
									form_data.reference3 &&
										form_data.reference3.thirdrefemail === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.thirdrefemail,
								thirdrefconfirmemail:
									form_data.reference3 &&
										form_data.reference3.thirdrefconfirmemail === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.thirdrefconfirmemail,
								thirdrefstreetAddress:
									form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefstreetAddress ===
										"undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefstreetAddress,
								thirdrefcity:
									form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefcity === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefcity,
								thirdrefstate:
									form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefstate === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefstate,
								thirdrefzip:
									form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefzip === "undefined"
										? ""
										: form_data.reference3 &&
										form_data.reference3.Address &&
										form_data.reference3.Address.thirdrefzip,
								mandatory_training: form_data.mandatory_training,
								movinghandling: form_data.movinghandling,
								basiclifesupport: form_data.basiclifesupport,
								healthsafety: form_data.healthsafety,
								firesafety: form_data.firesafety,
								firstaid: form_data.firstaid,
								infectioncontrol: form_data.infectioncontrol,
								foodsafety: form_data.foodsafety,
								medicationadmin: form_data.medicationadmin,
								safeguardingvulnerable: form_data.safeguardingvulnerable,
								trainingdates: form_data.trainingdates,
								healthcare_training: form_data.healthcare_training,
								diplomal3: form_data.diplomal3,
								diplomal2: form_data.diplomal2,
								personalsafetymental: form_data.personalsafetymental,
								intermediatelife: form_data.intermediatelife,
								advancedlife: form_data.advancedlife,
								complaintshandling: form_data.complaintshandling,
								handlingviolence: form_data.handlingviolence,
								doolsmental: form_data.doolsmental,
								coshh: form_data.coshh,
								dataprotection: form_data.dataprotection,
								equalityinclusion: form_data.equalityinclusion,
								loneworkertraining: form_data.loneworkertraining,
								resuscitation: form_data.resuscitation,
								interpretation: form_data.interpretation,
								trainindates2: form_data.trainindates2,
								sufferedlongtermillness:
									form_data.healthdeclaration &&
									form_data.healthdeclaration.sufferedlongtermillness,
								leaveforneckinjury:
									form_data.healthdeclaration &&
									form_data.healthdeclaration.leaveforneckinjury,
								neckinjuries:
									form_data.healthdeclaration &&
									form_data.healthdeclaration.neckinjuries,
								sixweeksillness:
									form_data.healthdeclaration &&
									form_data.healthdeclaration.sixweeksillness,
								communicabledisease:
									form_data.healthdeclaration &&
									form_data.healthdeclaration.communicabledisease,
								medicalattention:
									form_data.healthdeclaration &&
									form_data.healthdeclaration.medicalattention,
								healthdeclarationdetails:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.healthdeclarationdetails ===
										"undefined"
										? ""
										: form_data.healthdeclaration &&
										form_data.healthdeclaration.healthdeclarationdetails,
								// registereddisabled:
								//     form_data.healthdeclaration &&
								//     form_data.healthdeclaration.registereddisabled,
								absentfromwork:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.absentfromwork === "undefined"
										? 0
										: form_data.healthdeclaration &&
										form_data.healthdeclaration.absentfromwork,
								statereason:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.statereason === "undefined"
										? ""
										: form_data.healthdeclaration &&
										form_data.healthdeclaration.statereason,
								GPname: form_gp.GPname === "undefined" ? "" : form_gp.GPname,
								GPphone:
									form_gp &&
										form_gp.GPphone &&
										form_gp.GPphone.number &&
										form_gp.GPphone.number.length > 0
										? form_gp.GPphone
										: {
											number: "",
											code: "",
											dailcountry: "gb",
										},
								GPstreetAddress:
									form_gp.gpaddress &&
										form_gp.gpaddress.GPstreetAddress === "undefined"
										? ""
										: form_gp.gpaddress && form_gp.gpaddress.GPstreetAddress,
								GPcity:
									form_gp.gpaddress && form_gp.gpaddress.GPcity === "undefined"
										? ""
										: form_gp.gpaddress && form_gp.gpaddress.GPcity,
								GPstate:
									form_gp.gpaddress && form_gp.gpaddress.GPstate === "undefined"
										? ""
										: form_gp.gpaddress && form_gp.gpaddress.GPstate,
								GPzip:
									form_gp.gpaddress && form_gp.gpaddress.GPzip === "undefined"
										? ""
										: form_gp.gpaddress && form_gp.gpaddress.GPzip,
								contactDoctor:
									form_gp.gpaddress && form_gp.gpaddress.contactDoctor,
								GPhealthdetails:
									form_gp.gpaddress && form_gp.gpaddress.GPhealthdetails,
								medicalillness:
									form_data.medicalhistory &&
									form_data.medicalhistory.medicalillness,
								medicalillnesscaused:
									form_data.medicalhistory &&
									form_data.medicalhistory.medicalillnesscaused,
								treatment:
									form_data.medicalhistory &&
									form_data.medicalhistory.treatment,
								needanyadjustments:
									form_data.medicalhistory &&
									form_data.medicalhistory.needanyadjustments,
								needanyadjustmentsnotes:
									form_data.medicalhistory &&
									form_data.medicalhistory.needanyadjustmentsnotes,
								livedUK:
									form_data.tuberculosis && form_data.tuberculosis.livedUK,
								livedUKnotes:
									form_data.tuberculosis && form_data.tuberculosis.livedUKnotes,
								BCGvaccination:
									form_data.tuberculosis &&
									form_data.tuberculosis.BCGvaccination,
								BCGvaccinationyes:
									form_data.tuberculosis &&
									form_data.tuberculosis.BCGvaccination === "yes",
								BCGvaccinationdate:
									form_data.tuberculosis &&
									form_data.tuberculosis.BCGvaccinationdate,
								cough: form_data.tuberculosis && form_data.tuberculosis.cough,
								weightloss:
									form_data.tuberculosis && form_data.tuberculosis.weightloss,
								fever: form_data.tuberculosis && form_data.tuberculosis.fever,
								TB: form_data.tuberculosis && form_data.tuberculosis.TB,
								chickenpox:
									form_data.chickenpoxorshingles &&
									form_data.chickenpoxorshingles.chickenpox,
								chickenpoxyes:
									form_data.chickenpoxorshingles &&
									form_data.chickenpoxorshingles.chickenpox === "yes",
								chickenpoxdate:
									form_data.chickenpoxorshingles &&
									form_data.chickenpoxorshingles.chickenpoxdate,
								triplevaccination:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.triplevaccination,
								polio:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.polio,
								heartCirculatory:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.heartCirculatory,
								diabetes:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.diabetes,
								bronchitis:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.bronchitis,
								epilepsy:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.epilepsy,
								asthma:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.asthma,
								headaches:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.headaches,
								psychiatric:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.psychiatric,
								dermatitis:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.dermatitis,
								backProblems:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.backProblems,
								recurrentInfections:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.recurrentInfections,
								hepatitis:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.hepatitis,
								chickenpox:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.chickenpox,
								varicella:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.varicella,
								tuberculosis:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.tuberculosis,
								heaf:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.heaf,
								rubella:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.rubella,
								poliomyelitis:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.poliomyelitis,
								HIV:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.HIV,
								typhoid:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.typhoid,
								tetanus:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.tetanus,
								hepatitisB:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.hepatitisB,
								proneProcedures:
									form_data.immunisationhistory &&
									form_data.immunisationhistory.proneProcedures,
								occupationalHealthServices:
									form_data.declaration &&
									form_data.declaration.occupationalHealthServices,
								// criminaloffence:
								//     form_data.declaration &&
								//     form_data.declaration.criminaloffence,
								warningcriminaloffence:
									form_data.declaration &&
									form_data.declaration.warningcriminaloffence,
								DBSdetails:
									form_data.declaration && form_data.declaration.DBSdetails,
								passport:
									form_data.righttowork && form_data.righttowork.passport,
								workhours:
									form_data.worktimedirectives &&
									form_data.worktimedirectives.workhours,
								form_status: form_status,
								// uploadcertificate: form_data.uploadcertificate && form_data.uploadcertificate,
								// uploadcertificateName: form_data.uploadcertificate && form_data.uploadcertificate.substr(24, 30),
								// uploadaddress: form_data.uploadaddress && form_data.uploadaddress,
								// uploadaddressName: form_data.uploadaddress && form_data.uploadaddress.substr(24, 30),
								// uploadpassport: form_data.uploadpassport && form_data.uploadpassport,
								// uploadpassportName: form_data.uploadpassport && form_data.uploadpassport.substr(24, 30),
								// uploaddbs: form_data.uploaddbs && form_data.uploaddbs,
								final_verify_status: form_data.final_verify_status,
								// uploaddbsName: form_data.uploaddbs && form_data.uploaddbs.substr(24, 30),
								caraccessyes: form_driving.caraccess === "yes",
								IELTStestyes:
									form_data.langauages &&
									form_data.langauages.IELTStest === "yes",
								mandatorytrainingyes: form_data.mandatory_training === "yes",
								healthcaretrainingyes: form_data.healthcare_training === "yes",
								needanyadjustmentsyes:
									form_data.medicalhistory &&
									form_data.medicalhistory.needanyadjustments === "yes",
								livedUKyes:
									form_data.tuberculosis &&
									form_data.tuberculosis.livedUK === "no",
								certificatedocs:
									form_data.uploadcertificate &&
										form_data.uploadcertificate.length > 0
										? form_data.uploadcertificate
										: [],
								addressdocs:
									form_data.uploadaddress && form_data.uploadaddress.length > 0
										? form_data.uploadaddress
										: [],
								dbsdocs:
									form_data.uploaddbs && form_data.uploaddbs.length > 0
										? form_data.uploaddbs
										: [],
								otherdocs:
									form_data.uploadothers && form_data.uploadothers.length > 0
										? form_data.uploadothers
										: [],
								uploadProfessional:
									form_data &&
										form_data.uploadProfessional &&
										checkArray(form_data.uploadProfessional)
										? form_data.uploadProfessional
										: [],
								sufferedlongtermillness_notes:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.sufferedlongtermillness_notes
										? form_data.healthdeclaration.sufferedlongtermillness_notes
										: "",
								leaveforneckinjury_notes:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.leaveforneckinjury_notes
										? form_data.healthdeclaration.leaveforneckinjury_notes
										: "",
								neckinjuries_notes:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.neckinjuries_notes
										? form_data.healthdeclaration.neckinjuries_notes
										: "",
								sixweeksillness_notes:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.sixweeksillness_notes
										? form_data.healthdeclaration.sixweeksillness_notes
										: "",
								communicabledisease_notes:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.communicabledisease_notes
										? form_data.healthdeclaration.communicabledisease_notes
										: "",
								medicalattention_notes:
									form_data.healthdeclaration &&
										form_data.healthdeclaration.medicalattention_notes
										? form_data.healthdeclaration.medicalattention_notes
										: "",
								medicalillness_notes:
									form_data.medicalhistory &&
										form_data.medicalhistory.medicalillness_notes
										? form_data.medicalhistory.medicalillness_notes
										: "",
								medicalillnesscaused_notes:
									form_data.medicalhistory &&
										form_data.medicalhistory.medicalillnesscaused_notes
										? form_data.medicalhistory.medicalillnesscaused_notes
										: "",
								treatment_notes:
									form_data.medicalhistory &&
										form_data.medicalhistory.treatment_notes
										? form_data.medicalhistory &&
										form_data.medicalhistory.treatment_notes
										: "",
								emergency_contacts:
									res_result &&
										res_result.emergency_contacts &&
										Array.isArray(res_result.emergency_contacts)
										? res_result.emergency_contacts
										: [],
							},
							() => {
								this.state.documents.map((el, i) => {
									const docExpiryName = `document_expiry_${i}`;
									let checkVal =
										this.state.documents.filter((o) => {
											return o[docExpiryName] === true;
										}).length > 0
											? true
											: false;
									this.setState({ showExpiryTD: checkVal });
								});

								let { dbsIssueDate = "", dbsExpirydate = "" } = this.state;
								if (CheckValue(dbsIssueDate) && !CheckValue(dbsExpirydate)) {
									dbsExpirydate = new Date(
										new Date(dbsIssueDate).setFullYear(
											new Date(dbsIssueDate).getFullYear() + 1
										)
									);
									this.setState({ dbsExpirydate });
								}
								this.check_other_documents();

								if (
									this.state.education_qualification &&
									this.state.education_qualification.length > 0
								) {
									this.state.education_qualification.map((item, i) => {
										const education_qualification = [
											...this.state.education_qualification,
										];
										if (
											item.qualification_date_expiry !== "" &&
											item.qualification_date_expiry !== undefined &&
											item.qualification_date_expiry !== null
										) {
											this.state.education_qualification[i] = {
												...education_qualification[i],
												qualificationCheck: true,
											};
											this.setState(education_qualification);
										} else {
											this.state.education_qualification[i] = {
												...education_qualification[i],
												qualificationCheck: false,
											};
											this.setState(education_qualification);
										}
									});
								}
							}
						);
						if (
							form_data &&
							form_data.docType_info &&
							form_data.docType_info.country_issue &&
							form_data.docType_info.country_issue.length > 0
						) {
							let country_issue_arr = countries.filter((item) => {
								if (
									item &&
									(String(item.value) ===
										String(form_data.docType_info.country_issue) ||
										String(item.label) === String(form_data.docType_info.country_issue))
								) {
									return item;
								}
							});
							this.setState({ docType_info: { ...this.state.docType_info, country_issue_arr: country_issue_arr } });
						}
						if (
							form_data &&
							form_data.rightToWorkType_info &&
							form_data.rightToWorkType_info.country_issue &&
							form_data.rightToWorkType_info.country_issue.length > 0
						) {
							let country_issue_arr = countries.filter((item) => {
								if (
									item &&
									(String(item.value) ===
										String(form_data.rightToWorkType_info.country_issue) ||
										String(item.label) === String(form_data.rightToWorkType_info.country_issue))
								) {
									return item;
								}
							});
							this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, country_issue_arr: country_issue_arr } });
						}
					}
				} else {
					return this.props.history.replace("/dashboard/default");
				}
			} else if (res.status === 0) {
				toast.error(res.response);
			}
		});
	};

	check_other_documents = () => {
		let {
			other_courses = [],
			educationdocs: uploadothereducationcertificate = [],
			education_qualification = [],
			othereducationdocs: uploadeducationcertificate = [],
			professional_Body = [],
			uploadProfessional = [],
		} = this.state;
		if (other_courses && other_courses.length > 0) {
			other_courses.map((item) => {
				let { filePath = "", fileName = "", _id = "" } = item;
				let obj = {};
				obj = item;
				obj["fileName"] = CheckValue(fileName)
					? fileName
					: [...uploadothereducationcertificate].filter(
						(e) =>
							CheckValue(_id) &&
							CheckValue(e.courseID) &&
							String(e.courseID) === String(_id)
					).length > 0
						? [...uploadothereducationcertificate].filter(
							(e) =>
								CheckValue(_id) &&
								CheckValue(e.courseID) &&
								String(e.courseID) === String(_id)
						)[0].name
						: "";
				obj["filePath"] = CheckValue(filePath)
					? filePath
					: [...uploadothereducationcertificate].filter(
						(e) =>
							CheckValue(_id) &&
							CheckValue(e.courseID) &&
							String(e.courseID) === String(_id)
					).length > 0
						? [...uploadothereducationcertificate].filter(
							(e) =>
								CheckValue(_id) &&
								CheckValue(e.courseID) &&
								String(e.courseID) === String(_id)
						)[0].path
						: "";
				return obj;
			});
			this.setState({ other_courses });
		}
		if (education_qualification.length > 0) {
			education_qualification.map((item) => {
				let { filePath = "", fileName = "", _id = "" } = item;
				let obj = {};
				obj = item;
				obj["fileName"] = CheckValue(fileName)
					? fileName
					: [...uploadeducationcertificate].filter(
						(e) =>
							CheckValue(_id) &&
							CheckValue(e.courseID) &&
							String(e.courseID) === String(_id)
					).length > 0
						? [...uploadeducationcertificate].filter(
							(e) =>
								CheckValue(_id) &&
								CheckValue(e.courseID) &&
								String(e.courseID) === String(_id)
						)[0].name
						: "";
				obj["filePath"] = CheckValue(filePath)
					? filePath
					: [...uploadeducationcertificate].filter(
						(e) =>
							CheckValue(_id) &&
							CheckValue(e.courseID) &&
							String(e.courseID) === String(_id)
					).length > 0
						? [...uploadeducationcertificate].filter(
							(e) =>
								CheckValue(_id) &&
								CheckValue(e.courseID) &&
								String(e.courseID) === String(_id)
						)[0].path
						: "";
				return obj;
			});
			this.setState({ education_qualification });
		}
		if (professional_Body.length > 0) {
			professional_Body.map((item) => {
				let { filePath = "", fileName = "", _id = "" } = item;
				let obj = {};
				obj = item;
				obj["fileName"] = CheckValue(fileName)
					? fileName
					: [...uploadProfessional].filter(
						(e) =>
							CheckValue(_id) &&
							CheckValue(e.courseID) &&
							String(e.courseID) === String(_id)
					).length > 0
						? [...uploadProfessional].filter(
							(e) =>
								CheckValue(_id) &&
								CheckValue(e.courseID) &&
								String(e.courseID) === String(_id)
						)[0].name
						: "";
				obj["filePath"] = CheckValue(filePath)
					? filePath
					: [...uploadProfessional].filter(
						(e) =>
							CheckValue(_id) &&
							CheckValue(e.courseID) &&
							String(e.courseID) === String(_id)
					).length > 0
						? [...uploadProfessional].filter(
							(e) =>
								CheckValue(_id) &&
								CheckValue(e.courseID) &&
								String(e.courseID) === String(_id)
						)[0].path
						: "";
				return obj;
			});
			this.setState({ professional_Body });
		}
	};

	checkandupdate = () => {
		let { jobtypelist, job_type, locations, worklist } = this.state;
		if (
			jobtypelist &&
			jobtypelist.length > 0 &&
			job_type &&
			job_type.length > 0
		) {
			let new_job = jobtypelist.filter((item) => {
				if (item && item.value && job_type.includes(String(item.value))) {
					return item;
				}
			});
			this.setState({ job_type: new_job });
		}
		if (worklist && worklist.length > 0 && locations && locations.length > 0) {
			let new_loc = worklist.filter((item) => {
				if (item && item.value && locations.includes(String(item.value))) {
					return item;
				}
			});
			this.setState({ locations: new_loc });
		}
	};

	addmploymenthistory = () => {
		if (
			this.state.employer === "" ||
			this.state.position === "" ||
			this.state.duties === "" ||
			this.state.start_date === "" ||
			this.state.end_date === "" ||
			this.state.salaryonleaving === ""
		) {
			toast.error(
				"Please complete the required information before you proceed"
			);
		} else {
			const value = {
				employer: this.state.employer,
				position: this.state.position,
				duties: this.state.duties,
				start_date: this.state.start_date,
				end_date: this.state.end_date,
				salaryonleaving: this.state.salaryonleaving,
			};
			this.setState({
				employmenthistorylist: this.state.employmenthistorylist.concat([value]),
				employer: "",
				position: "",
				duties: "",
				start_date: "",
				end_date: "",
				salaryonleaving: "",
			});
		}
	};

	removeemploymenthistory = (value) => {
		const arr = this.state.employmenthistorylist.filter(
			(list, i) => i !== value
		);
		this.setState({ employmenthistorylist: arr });
	};

	addeducationlist = () => {
		if (
			this.state.institution === "" ||
			this.state.year === "" ||
			this.state.course === "" ||
			this.state.grade === ""
		) {
			toast.error(
				"Please complete the required information before you proceed"
			);
		} else {
			const value = {
				year: this.state.year,
				institution: this.state.institution,
				course: this.state.course,
				grade: this.state.grade,
			};
			this.setState({
				educationlist: this.state.educationlist.concat([value]),
				institution: "",
				year: "",
				course: "",
				grade: "",
			});
		}
	};
	removeeducationlist = (value) => {
		const arr = this.state.educationlist.filter((list, i) => i !== value);
		this.setState({ educationlist: arr });
	};
	otheremp = (value) => {
		if (value === "other") {
			this.setState({
				otheremp: true,
			});
		} else {
			this.setState({
				otheremp: false,
			});
		}
	};
	drivelicenceyes = (yes, e) => {
		if (yes === "yes") {
			this.setState({
				drivelicenceyes: true,
				drivinglicence: "yes",
			});
		} else {
			this.setState({
				drivelicenceyes: false,
				drivinglicence: "no",
			});
		}
	};
	caraccessyes = (yes) => {
		if (yes === "yes") {
			this.setState({
				caraccessyes: true,
			});
		} else {
			this.setState({
				caraccessyes: false,
			});
		}
	};
	DBSyes = (yes) => {
		if (yes === "yes") {
			this.setState({
				DBSyes: true,
			});
		} else {
			this.setState({
				DBSyes: false,
			});
		}
	};
	IELTStestyes = (yes) => {
		if (yes === "yes") {
			this.setState({
				IELTStestyes: true,
			});
		} else {
			this.setState({
				IELTStestyes: false,
			});
		}
	};

	toggle = (tab) => {
		if (this.state.activeTab !== tab) {
			this.setState({ 
				activeTab: tab,
			});
			window.scrollTo(0, 0);
		}
	};

	mainToggle = (tab) => {
		if (this.state.mainActiveTab !== tab) {
			this.setState({
				mainActiveTab: tab,
			});
		}
	};
	signatureToggle = (tab) => {
		if (this.state.signatureTab !== tab) {
			this.setState({
				signatureTab: tab,
			});
		}
	};

	onChange = (e) => {
		// console.log(e.target.name , e.target.value , "form the onchange...")
		this.setState({ [e.target.name]: e.target.value });
	};
	docTypeChangeHandler = (e) => {
		if (this.state.default_id === e.target.value) {
			this.getEmployeeData();
		}
		this.setState({ docType: e.target.value, docType_info: { ...this.state.docType_info, doc_type: e.target.value, doc_no: "", expiry_date: "", country_issue_arr: [], country_issue: "" } })
	}
	docTypeChangeHandler2 = (e) => {
		if (this.state.default_rtw === e.target.value) {
			this.getEmployeeData();
		}
		this.setState({ rightToWorkType: e.target.value, rightToWorkType_info: { ...this.state.rightToWorkType_info, doc_type: e.target.value, doc_no: "", doc_url: [], expiry_date: "", country_issue_arr: [], country_issue: "" } })
	}
	onInsuranceChange = (e) => {
		this.setState({ [e.target.name]: e.target.value, isFormErrors: false });
	};
	onCheckedChange = (e) => {
		e.persist();
		this.setState({ [e.target.name]: String(e.target.checked) });
	};

	DBSChange = (date) => {
		this.setState({
			DBSdate: date,
		});
	};
	dateChange = (date) => {
		this.setState({
			dateofbirth: date,
		});
	};

	onClose = () => {
		this.setState({ propreview: null });
	};
	onCrop = (propreview) => {
		function base64ImageToBlob(propreview) {
			// extract content type and base64 payload from original string
			const pos = propreview.indexOf(";base64,");
			const type = propreview.substring(5, pos);
			const b64 = propreview.substr(pos + 8);
			// decode base64
			const imageContent = atob(b64);
			// create an ArrayBuffer and a view (as unsigned 8-bit)
			const buffer = new ArrayBuffer(imageContent.length);
			const view = new Uint8Array(buffer);
			// fill the view, using the decoded base64
			for (let n = 0; n < imageContent.length; n++) {
				view[n] = imageContent.charCodeAt(n);
			}
			// convert ArrayBuffer to Blob
			const blob = new Blob([buffer], { type: type });
			return blob;
		}
		const dataURItoBlob = base64ImageToBlob(propreview);
		this.setState({ propreview, avatar: dataURItoBlob });
	};

	fileChangedHandler = (evt) => {
		if (evt) {
			const file_data = evt.target.files[0];
			if (file_data.size < 5242880) {
				// this.setState({
				//     UploadIDPhoto: file_data,
				//     UploadIDfile: URL.createObjectURL(file_data),
				//     UploadIDName: file_data.name,
				// });
				let data = new FormData();
				data.append("UploadIDPhoto", file_data);
				request({
					url: "/employee/update/UploadIDPhoto",
					method: "POST",
					data,
				})
					.then((res) => {
						if (res && +res.status === 1) {
							toast.success(res.response);
							this.setState({ UploadIDPhoto: res.avatar });
							// this.componentDidMount();
						} else {
							toast.info(res.response);
						}
					})
					.catch((err) => {
						// console.log(`err`, err);
						toast.error("Something went wrong");
					});
			} else {
				toast.error("Maximum upload size is 5MB");
			}
		}
	};
	uploadCV = (evt) => {
		evt.persist();
		if (evt) {
			const file_data = evt.target.files[0];
			if (file_data.size < 5242880) {
				this.setState({
					UploadCV: file_data,
					UploadCVfile: URL.createObjectURL(file_data),
					UploadCVName: file_data.name,
				});
				this.files_api(file_data || null, "UploadCV");
			} else {
				toast.error("Maximum upload size is 5MB");
			}
		}
	};
	uploadDocs = (evt, place) => {
		evt.persist();
		if (evt) {
			const file_data = evt.target.files[0];
			// const file_split = file_data.type.split("/");
			// if (file_split[1] === "pdf") {
			//   toast.error("PDF not supported");
			// }
			if (file_data.size < 5242880) {
				this.files_api(file_data || null, place);
			} else {
				toast.error("Maximum upload size is 5MB");
			}
		}
	};
	deleteDocs = (e, fileid, filepath, filefor) => {
		e.preventDefault();
		let toastId = "employee_files_delete_form_01";
		toastId = toast.info("Please Wait......", { autoClose: false });
		request({
			url: "/employees/apply-online-form/delete-files",
			method: "POST",
			data: { filefor, fileid, filepath },
		}).then((res) => {
			if (res.status === 1) {
				toast.update(toastId, {
					render: res.response,
					type: toast.TYPE.SUCCESS,
					autoClose: 2500,
				});
				// this.componentDidMount();
				if (String(filefor) === "passport") {
					this.setState({ passportdocs: res.avatar });
				}
				if (String(filefor) === "visa") {
					this.setState({ visadocs: res.avatar });
				}
				if (String(filefor) === "driving") {
					this.setState({ drivingdocs: res.avatar });
				}
				if (String(filefor) === "dbs") {
					this.setState({ dbsdocs: res.avatar });
				}
				if (String(filefor) === "education") {
					this.setState({ educationdocs: res.avatar });
				}
				if (String(filefor) === "othereducation") {
					this.setState({ othereducationdocs: res.avatar });
				}
			} else if (res.status === 0) {
				toast.update(toastId, {
					render: res.response,
					type: toast.TYPE.ERROR,
					autoClose: 2500,
				});
			}
		});
	};

	/* uploadCertificate = evt => {
		this.setState({
		  uploadcertificate: evt.target.files[0],
		  uploadcertificatefile: URL.createObjectURL(evt.target.files[0]),
		  uploadcertificateName1: evt.target.files[0].name,
		  certificatedocs: evt.target.files[0] ? [evt.target.files[0], ...this.state.certificatedocs] : null
		});
	  };
	   
	  };*/
	englishSpoken = (e) => {
		e.persist();
		this.setState({
			englishspoken: e.target.value,
		});
	};
	englishWritten = (e) => {
		e.persist();
		this.setState({
			englishwritten: e.target.value,
		});
	};
	mandatorytraining = (yes) => {
		if (yes === "yes") {
			this.setState({
				mandatorytrainingyes: true,
			});
		} else {
			this.setState({
				mandatorytrainingyes: false,
			});
		}
	};
	healthcaretraining = (yes) => {
		if (yes === "yes") {
			this.setState({
				healthcaretrainingyes: true,
			});
		} else {
			this.setState({
				healthcaretrainingyes: false,
			});
		}
	};
	needanyadjustments = (yes) => {
		if (yes === "yes") {
			this.setState({
				needanyadjustmentsyes: true,
			});
		} else {
			this.setState({
				needanyadjustmentsyes: false,
			});
		}
	};
	livedUK = (no) => {
		if (no === "no") {
			this.setState({
				livedUKyes: true,
			});
		} else {
			this.setState({
				livedUKyes: false,
			});
		}
	};
	BCGvaccination = (yes) => {
		if (yes === "yes") {
			this.setState({
				BCGvaccinationyes: true,
			});
		} else {
			this.setState({
				BCGvaccinationyes: false,
			});
		}
	};
	chickenpox = (yes) => {
		if (yes === "yes") {
			this.setState({
				chickenpoxyes: true,
			});
		} else {
			this.setState({
				chickenpoxyes: false,
			});
		}
	};

	update_1st_tab = (name) => {
		this.setState({ first_tab_up_nxt: name });
	};
	onFormPersonalDetails = (event, errors, values) => {
		if (this.state.first_tab_up_nxt === "next") {
			if (this.state.dateofbirth === "" || this.state.dateofbirth === null) {
				this.setState({ dobError: true, isFormErrors: true });
			}
			if (this.state.mobileno.number === "") {
				this.setState({ mobileError: true, isFormErrors: true });
			}
			if (checkArray(this.state.job_type) && this.state.job_type.length === 0) {
				this.setState({ jobroleError: true, isFormErrors: true });
			}
			if (
				checkArray(this.state.locations) &&
				this.state.locations.length === 0
			) {
				this.setState({ jobareaError: true, isFormErrors: true });
			}
			if (
				this.state.availablestartdate === "" ||
				this.state.availablestartdate === null ||
				this.state.availablestartdate === "null"
			) {
				this.setState({ dateofstartError: true, isFormErrors: true });
			}
			// if (this.state.insuranceno === "" || this.state.insuranceno === null) {
			// 	this.setState({ isFormErrors: true });
			// }
		}

		if (
			this.state.first_tab_up_nxt === "next" &&
			((errors && errors.length > 0) || this.state.isFormErrors)
		) {
			// console.log({errors} , "errors from the personal details...")
			toast.error(
				"Please complete the required information before you proceed 3"
			);
		} else {
			if (this.state.activeTab === "1") {

				let nextTabIsDisabled = this.menuRequiredFieldsAreNotEmpty();
				    nextTabIsDisabled = !(nextTabIsDisabled.addtionalFields && nextTabIsDisabled.staticFields);
					this.setState({nextTabIsDisabled})
				// let check_email =
				// 	values.email &&
				// 		String(values.email) !== String(undefined) &&
				// 		values.email.length > 0
				// 		? values.email
				// 		: this.state.email &&
				// 			String(this.state.email) !== String(undefined) &&
				// 			this.state.email.length > 0
				// 			? this.state.email
				// 			: false;
				// if (!check_email) {
				// 	return toast.info("Email is required");
				// }

				const data = new FormData();
				data.append("forpage", 1);
				// data.append("postapplydetails", values.postapplydetails);
				/* Personal details 1 */
				data.append(
					"personaldetails[title]",
					this.state.title &&
						String(this.state.title) !== String(undefined) &&
						this.state.title.length > 0
						? this.state.title
						: values.title &&
							String(values.title) !== String(undefined) &&
							values.title.length > 0
							? values.title
							: ""
				);
				data.append(
					"personaldetails[firstname]",
					this.state.firstname &&
						String(this.state.firstname) !== String(undefined) &&
						this.state.firstname.length > 0
						? this.state.firstname
						: values.firstname &&
							String(values.firstname) !== String(undefined) &&
							values.firstname.length > 0
							? values.firstname
							: ""
				);
				data.append(
					"personaldetails[prefferedName]",
					this.state.prefferedName &&
						String(this.state.prefferedName) !== String(undefined) &&
						this.state.prefferedName.length > 0
						? this.state.prefferedName
						: values.prefferedName &&
							String(values.prefferedName) !== String(undefined) &&
							values.prefferedName.length > 0
							? values.prefferedName
							: ""
				);
				data.append(
					"personaldetails[middlename]",
					this.state.middlename &&
						String(this.state.middlename) !== String(undefined) &&
						this.state.middlename.length > 0
						? this.state.middlename
						: values.middlename &&
							String(values.middlename) !== String(undefined) &&
							values.middlename.length > 0
							? values.middlename
							: ""
				);
				data.append(
					"personaldetails[lastname]",
					this.state.lastname &&
						String(this.state.lastname) !== String(undefined) &&
						this.state.lastname.length > 0
						? this.state.lastname
						: values.lastname &&
							String(values.lastname) !== String(undefined) &&
							values.lastname.length > 0
							? values.lastname
							: ""
				);
				data.append(
					"personaldetails[maidenName]",
					this.state.maidenName &&
						String(this.state.maidenName) !== String(undefined) &&
						this.state.maidenName.length > 0
						? this.state.maidenName
						: values.maidenName &&
							String(values.maidenName) !== String(undefined) &&
							values.maidenName.length > 0
							? values.maidenName
							: ""
				);
				data.append(
					"personaldetails[isNameChanged]",
					this.state.isNameChanged &&
						String(this.state.isNameChanged) !== String(undefined) &&
						this.state.isNameChanged.length > 0
						? this.state.isNameChanged
						: values.isNameChanged &&
							String(values.isNameChanged) !== String(undefined) &&
							values.isNameChanged.length > 0
							? values.isNameChanged
							: ""
				);
				data.append(
					"personaldetails[previousName]",
					this.state.previousNames &&
						String(this.state.previousNames) !== String(undefined) &&
						this.state.previousNames.length > 0
						? this.state.previousNames
						: values.previousNames &&
							String(values.previousNames) !== String(undefined) &&
							values.previousNames.length > 0
							? values.previousNames
							: ""
				);
				data.append(
					"personaldetails[gender]",
					this.state.gender &&
						String(this.state.gender) !== String(undefined) &&
						this.state.gender.length > 0
						? this.state.gender
						: values.gender &&
							String(values.gender) !== String(undefined) &&
							values.gender.length > 0
							? values.gender
							: ""
				);
				data.append(
					"UploadIDPhoto",
					this.state.UploadIDPhoto &&
						String(this.state.UploadIDPhoto) !== String(undefined) &&
						this.state.UploadIDPhoto.length > 0
						? this.state.UploadIDPhoto
						: values.UploadIDPhoto &&
							String(values.UploadIDPhoto) !== String(undefined) &&
							values.UploadIDPhoto.length > 0
							? values.UploadIDPhoto
							: ""
				);
				data.append(
					"docType",
					this.state.docType &&
						String(this.state.docType) !== String(undefined) &&
						this.state.docType.length > 0
						? this.state.docType
						: values.docType &&
							String(values.docType) !== String(undefined) &&
							values.docType.length > 0
							? values.docType
							: ""
				);
				data.append(
					"docType_info[doc_type]",
					this.state.docType_info &&
						this.state.docType_info.doc_type &&
						String(this.state.docType_info.doc_type) !== String(undefined) &&
						this.state.docType_info.doc_type.length > 0
						? this.state.docType_info.doc_type
						: ""
				);
				data.append(
					"docType_info[doc_url]",
					this.state.docType_info &&
						this.state.docType_info.doc_url &&
						String(this.state.docType_info.doc_url) !== String(undefined) &&
						this.state.docType_info.doc_url.length > 0
						? this.state.docType_info.doc_url
						: ""
				);
				data.append(
					"docType_info[doc_no]",
					this.state.docType_info &&
						this.state.docType_info.doc_no &&
						String(this.state.docType_info.doc_no) !== String(undefined) &&
						this.state.docType_info.doc_no.length > 0
						? this.state.docType_info.doc_no
						: ""
				);
				data.append(
					"docType_info[country_issue]",
					this.state.docType_info &&
						this.state.docType_info.country_issue &&
						String(this.state.docType_info.country_issue) !== String(undefined) &&
						this.state.docType_info.country_issue.length > 0
						? this.state.docType_info.country_issue
						: ""
				);
				data.append(
					"docType_info[expiry_date]",
					this.state.docType_info &&
						this.state.docType_info.expiry_date
						? this.state.docType_info.expiry_date
						: ""
				);
				data.append(
					"rightToWorkType",
					this.state.rightToWorkType &&
						String(this.state.rightToWorkType) !== String(undefined) &&
						this.state.rightToWorkType.length > 0
						? this.state.rightToWorkType
						: values.rightToWorkType &&
							String(values.rightToWorkType) !== String(undefined) &&
							values.rightToWorkType.length > 0
							? values.rightToWorkType
							: ""
				);
				data.append(
					"rightToWorkType_info[doc_type]",
					this.state.rightToWorkType_info &&
						this.state.rightToWorkType_info.doc_type &&
						String(this.state.rightToWorkType_info.doc_type) !== String(undefined) &&
						this.state.rightToWorkType_info.doc_type.length > 0
						? this.state.rightToWorkType_info.doc_type
						: ""
				);
				data.append(
					"rightToWorkType_info[doc_url]",
					this.state.rightToWorkType_info &&
						this.state.rightToWorkType_info.doc_url &&
						String(this.state.rightToWorkType_info.doc_url) !== String(undefined) &&
						this.state.rightToWorkType_info.doc_url.length > 0
						? this.state.rightToWorkType_info.doc_url
						: ""
				);
				data.append(
					"rightToWorkType_info[doc_no]",
					this.state.rightToWorkType_info &&
						this.state.rightToWorkType_info.doc_no &&
						String(this.state.rightToWorkType_info.doc_no) !== String(undefined) &&
						this.state.rightToWorkType_info.doc_no.length > 0
						? this.state.rightToWorkType_info.doc_no
						: ""
				);
				data.append(
					"rightToWorkType_info[country_issue]",
					this.state.rightToWorkType_info &&
						this.state.rightToWorkType_info.country_issue &&
						String(this.state.rightToWorkType_info.country_issue) !== String(undefined) &&
						this.state.rightToWorkType_info.country_issue.length > 0
						? this.state.rightToWorkType_info.country_issue
						: ""
				);
				data.append(
					"rightToWorkType_info[expiry_date]",
					this.state.rightToWorkType_info &&
						this.state.rightToWorkType_info.expiry_date
						? this.state.rightToWorkType_info.expiry_date
						: ""
				);
				data.append("avatar", this.state.avatar || "");
				data.append("joining_date", this.state.joining_date || "");
				/* Personal details 1 */

				/* Personal details 2 */
				data.append(
					"personaldetails[dateofbirth]",
					this.state.dateofbirth &&
						String(this.state.dateofbirth).length > 0 &&
						String(this.state.dateofbirth) !== String(null)
						? this.state.dateofbirth
						: ""
				);
				data.append(
					"personaldetails[martialStatus]",
					this.state.martialStatus &&
						String(this.state.martialStatus) !== String(undefined) &&
						this.state.martialStatus.length > 0
						? this.state.martialStatus
						: values.martialStatus &&
							String(values.martialStatus) !== String(undefined) &&
							values.martialStatus.length > 0
							? values.martialStatus
							: ""
				);
				data.append(
					"personaldetails[dateofMarriage]",
					this.state.dateofMarriage &&
						String(this.state.dateofMarriage) !== String(undefined) &&
						String(this.state.dateofMarriage).length > 0
						? this.state.dateofMarriage
						: values.dateofMarriage &&
							String(values.dateofMarriage) !== String(undefined) &&
							values.dateofMarriage.length > 0
							? values.dateofMarriage
							: ""
				);
				data.append(
					"personaldetails[nationality]",
					this.state.nationality &&
						String(this.state.nationality) !== String(undefined) &&
						this.state.nationality.length > 0
						? this.state.nationality
						: values.nationality &&
							String(values.nationality) !== String(undefined) &&
							values.nationality.length > 0
							? values.nationality
							: ""
				);
				data.append(
					"personaldetails[religion]",
					this.state.religion &&
						String(this.state.religion) !== String(undefined) &&
						this.state.religion.length > 0
						? this.state.religion
						: values.religion &&
							String(values.religion) !== String(undefined) &&
							values.religion.length > 0
							? values.religion
							: ""
				);
				/* Personal details 2 */

				/* CONTACT AND ADDRESS DETAILS */
				data.append(
					"personaldetails[email]",
					values.email &&
						String(values.email) !== String(undefined) &&
						values.email.length > 0
						? values.email
						: this.state.email &&
							String(this.state.email) !== String(undefined) &&
							this.state.email.length > 0
							? this.state.email
							: ""
				);
				data.append(
					"personaldetails[mobileno][number]",
					this.state.mobileno &&
						this.state.mobileno.number &&
						String(this.state.mobileno.number) !== String(undefined) &&
						this.state.mobileno.number.length > 0
						? this.state.mobileno.number
						: values.mobileno &&
							values.mobileno.number &&
							String(values.mobileno.number) !== String(undefined) &&
							values.mobileno.number.length > 0
							? values.mobileno.number
							: ""
				);
				data.append(
					"personaldetails[mobileno][code]",
					this.state.mobileno &&
						this.state.mobileno.code &&
						String(this.state.mobileno.code) !== String(undefined) &&
						this.state.mobileno.code.length > 0
						? this.state.mobileno.code
						: values.mobileno &&
							values.mobileno.code &&
							String(values.mobileno.code) !== String(undefined) &&
							values.mobileno.code.length > 0
							? values.mobileno.code
							: ""
				);
				data.append(
					"personaldetails[mobileno][dialcountry]",
					this.state.mobileno &&
						this.state.mobileno.dialcountry &&
						String(this.state.mobileno.dialcountry) !== String(undefined) &&
						this.state.mobileno.dialcountry.length > 0
						? this.state.mobileno.dialcountry
						: values.mobileno &&
							values.mobileno.dialcountry &&
							String(values.mobileno.dialcountry) !== String(undefined) &&
							values.mobileno.dialcountry.length > 0
							? values.mobileno.dialcountry
							: ""
				);
				data.append(
					"personaldetails[homephone]",
					values.homephone &&
						String(values.homephone) !== String(undefined) &&
						values.homephone.length > 0
						? values.homephone
						: this.state.homephone &&
							String(this.state.homephone) !== String(undefined) &&
							this.state.homephone.length > 0
							? this.state.homephone
							: ""
				);
				data.append(
					"personaldetails[address][streetAddress]",
					this.state.streetAddress &&
						String(this.state.streetAddress) !== String(undefined) &&
						this.state.streetAddress.length > 0
						? this.state.streetAddress
						: values.streetAddress &&
							String(values.streetAddress) !== String(undefined) &&
							values.streetAddress.length > 0
							? values.streetAddress
							: ""
				);
				data.append(
					"personaldetails[address][addressline2]",
					this.state.addressline2 &&
						String(this.state.addressline2) !== String(undefined) &&
						this.state.addressline2.length > 0
						? this.state.addressline2
						: values.addressline2 &&
							String(values.addressline2) !== String(undefined) &&
							values.addressline2.length > 0
							? values.addressline2
							: ""
				);
				data.append(
					"personaldetails[address][city]",
					this.state.city &&
						String(this.state.city) !== String(undefined) &&
						this.state.city.length > 0
						? this.state.city
						: values.city &&
							String(values.city) !== String(undefined) &&
							values.city.length > 0
							? values.city
							: ""
				);
				data.append(
					"personaldetails[address][state]",
					this.state.state &&
						String(this.state.state) !== String(undefined) &&
						this.state.state.length > 0
						? this.state.state
						: values.state &&
							String(values.state) !== String(undefined) &&
							values.state.length > 0
							? values.state
							: ""
				);
				data.append(
					"personaldetails[address][zip]",
					this.state.zip &&
						String(this.state.zip) !== String(undefined) &&
						this.state.zip.length > 0
						? this.state.zip
						: values.zip &&
							String(values.zip) !== String(undefined) &&
							values.zip.length > 0
							? values.zip
							: ""
				);
				data.append(
					"personaldetails[address][country]",
					this.state.country &&
						String(this.state.country) !== String(undefined) &&
						this.state.country.length > 0
						? this.state.country
						: values.country &&
							String(values.country) !== String(undefined) &&
							values.country.length > 0
							? values.country
							: ""
				);
				data.append(
					"personaldetails[address][label]",
					this.state.label &&
						String(this.state.label) !== String(undefined) &&
						this.state.label.length > 0
						? this.state.label
						: values.label &&
							String(values.label) !== String(undefined) &&
							values.label.length > 0
							? values.label
							: ""
				);
				data.append(
					"personaldetails[address][title]",
					this.state.title &&
						String(this.state.title) !== String(undefined) &&
						this.state.title.length > 0
						? this.state.title
						: values.title &&
							String(values.title) !== String(undefined) &&
							values.title.length > 0
							? values.title
							: ""
				);
				data.append(
					"personaldetails[dateMovedAddress]",
					this.state.dateMovedAddress
				);
				/* CONTACT AND ADDRESS DETAILS */

				/* WORK & PERSONAL DETAILS */
				data.append(
					"postapplyfor",
					values.postapplyfor &&
						String(values.postapplyfor) !== String(undefined) &&
						values.postapplyfor.length > 0
						? values.postapplyfor
						: this.state.postapplyfor &&
							String(this.state.postapplyfor) !== String(undefined) &&
							this.state.postapplyfor.length > 0
							? this.state.postapplyfor
							: ""
				);
				data.append(
					"workstatus",
					this.state.workstatus &&
						this.state.workstatus.length > 0 &&
						String(this.state.workstatus) !== String(undefined)
						? this.state.workstatus
						: values.workstatus &&
							values.workstatus.length > 0 &&
							String(values.workstatus) !== String(undefined)
							? values.workstatus
							: ""
				);

				data.append("job_type", JSON.stringify(this.state.job_type));
				data.append("locations", JSON.stringify(this.state.locations));

				/* WORK & PERSONAL DETAILS */

				/* General Availability */
				data.append(
					"aboutyourwork[availablestartdate]",
					this.state.availablestartdate
				);
				data.append(
					"aboutyourwork[abletowork][work_mornings]",
					this.state.work_mornings || values.work_mornings
				);
				data.append(
					"aboutyourwork[abletowork][work_evenings]",
					this.state.work_evenings || values.work_evenings
				);
				data.append(
					"aboutyourwork[abletowork][work_afternoons]",
					this.state.work_afternoons || values.work_afternoons
				);
				data.append(
					"aboutyourwork[abletowork][work_occasional]",
					this.state.work_occasional || values.work_occasional
				);
				data.append(
					"aboutyourwork[abletowork][work_fulltime]",
					this.state.work_fulltime || values.work_fulltime
				);
				data.append(
					"aboutyourwork[abletowork][work_parttime]",
					this.state.work_parttime || values.work_parttime
				);
				data.append(
					"aboutyourwork[abletowork][work_nights]",
					this.state.work_nights || values.work_nights
				);
				data.append(
					"aboutyourwork[abletowork][work_weekends]",
					this.state.work_weekends || values.work_weekends
				);
				data.append(
					"aboutyourwork[abletowork][work_anytime]",
					this.state.work_anytime || values.work_anytime
				);
				data.append(
					"aboutyourwork[firstchoice]",
					values.firstchoice &&
						values.firstchoice.length > 0 &&
						String(values.firstchoice) !== String(undefined)
						? values.firstchoice
						: this.state.firstchoice &&
							this.state.firstchoice.length > 0 &&
							String(this.state.firstchoice) !== String(undefined)
							? this.state.firstchoice
							: ""
				);
				data.append(
					"aboutyourwork[secondchoice]",
					values.secondchoice &&
						values.secondchoice.length > 0 &&
						String(values.secondchoice) !== String(undefined)
						? values.secondchoice
						: this.state.secondchoice &&
							this.state.secondchoice.length > 0 &&
							String(this.state.secondchoice) !== String(undefined)
							? this.state.secondchoice
							: ""
				);
				data.append(
					"aboutyourwork[thirdchoice]",
					values.thirdchoice &&
						values.thirdchoice.length > 0 &&
						String(values.thirdchoice) !== String(undefined)
						? values.thirdchoice
						: this.state.thirdchoice &&
							this.state.thirdchoice.length > 0 &&
							String(this.state.thirdchoice) !== String(undefined)
							? this.state.thirdchoice
							: ""
				);
				data.append(
					"aboutyourwork[shortnotice]",
					values.shortnotice &&
						values.shortnotice.length > 0 &&
						String(values.shortnotice) !== String(undefined)
						? values.shortnotice
						: this.state.shortnotice &&
							this.state.shortnotice.length > 0 &&
							String(this.state.shortnotice) !== String(undefined)
							? this.state.shortnotice
							: ""
				);
				data.append(
					"aboutyourwork[reduceworkflexibility]",
					values.reduceworkflexibility &&
						String(values.reduceworkflexibility) !== String(undefined) &&
						values.reduceworkflexibility.length > 0
						? values.reduceworkflexibility
						: this.state.reduceworkflexibility &&
							String(this.state.reduceworkflexibility) !== String(undefined) &&
							this.state.reduceworkflexibility.length > 0
							? this.state.reduceworkflexibility
							: ""
				);
				data.append(
					"aboutyourwork[workstate]",
					values.workstate &&
						String(values.workstate) !== String(undefined) &&
						values.workstate.length > 0
						? values.workstate
						: this.state.workstate &&
							String(this.state.workstate) !== String(undefined) &&
							this.state.workstate.length > 0
							? this.state.workstate
							: ""
				);
				/* General Availability */

				/* ID & RIGHT WORK */
				data.append(
					"righttowork[documentType]",
					this.state.documentType &&
						String(this.state.documentType) !== String(undefined) &&
						this.state.documentType.length > 0
						? this.state.documentType
						: values.documentType &&
							String(values.documentType) !== String(undefined) &&
							values.documentType.length > 0
							? values.documentType
							: ""
				);
				data.append(
					"righttowork[Passportdetails]",
					this.state.Passportdetails &&
						String(this.state.Passportdetails) !== String(undefined) &&
						this.state.Passportdetails.length > 0
						? this.state.Passportdetails
						: values.Passportdetails &&
							String(values.Passportdetails) !== String(undefined) &&
							values.Passportdetails.length > 0
							? values.Passportdetails
							: ""
				);
				data.append(
					"righttowork[documentNumber]",
					this.state.documentNumber &&
						String(this.state.documentNumber) !== String(undefined) &&
						this.state.documentNumber.length > 0
						? this.state.documentNumber
						: values.documentNumber &&
							String(values.documentNumber) !== String(undefined) &&
							values.documentNumber.length > 0
							? values.documentNumber
							: ""
				);
				data.append(
					"righttowork[countryOfIssue]",
					this.state.countryOfIssue &&
						String(this.state.countryOfIssue) !== String(undefined) &&
						this.state.countryOfIssue.length > 0
						? this.state.countryOfIssue
						: values.countryOfIssue &&
							String(values.countryOfIssue) !== String(undefined) &&
							values.countryOfIssue.length > 0
							? values.countryOfIssue
							: ""
				);
				data.append("righttowork[docTypeExpiry]", this.state.docTypeExpiry);

				// visa
				data.append(
					"visa_info[visa_number]",
					this.state.visaNumber &&
						String(this.state.visaNumber) !== String(undefined) &&
						this.state.visaNumber.length > 0
						? this.state.visaNumber
						: values.visaNumber &&
							String(values.visaNumber) !== String(undefined) &&
							values.visaNumber.length > 0
							? values.visaNumber
							: ""
				);
				data.append("visa_info[visa_expiry]", this.state.visaExpiry || "");
				data.append(
					"visa_info[country_of_issue]",
					this.state.visaCountryOfIssue &&
						String(this.state.visaCountryOfIssue) !== String(undefined) &&
						this.state.visaCountryOfIssue.length > 0
						? this.state.visaCountryOfIssue
						: values.visaCountryOfIssue &&
							String(values.visaCountryOfIssue) !== String(undefined) &&
							values.visaCountryOfIssue.length > 0
							? values.visaCountryOfIssue
							: ""
				);
				data.append(
					"personaldetails[insuranceno]",
					values.insuranceno &&
						values.insuranceno.length > 0 &&
						String(values.insuranceno) !== String(undefined)
						? values.insuranceno
						: this.state.insuranceno &&
							this.state.insuranceno.length > 0 &&
							String(this.state.insuranceno) !== String(undefined)
							? this.state.insuranceno
							: ""
				);
				/* ID & RIGHT WORK */

				/* Languages */
				data.append(
					"langauages[englishspoken]",
					this.state.englishspoken &&
						String(this.state.englishspoken) !== String(undefined) &&
						this.state.englishspoken.length > 0
						? this.state.englishspoken
						: values.englishspoken &&
							String(values.englishspoken) !== String(undefined) &&
							values.englishspoken.length > 0
							? values.englishspoken
							: ""
				);
				data.append(
					"langauages[englishwritten]",
					this.state.englishwritten &&
						String(this.state.englishwritten) !== String(undefined) &&
						this.state.englishwritten.length > 0
						? this.state.englishwritten
						: values.englishwritten &&
							String(values.englishwritten) !== String(undefined) &&
							values.englishwritten.length > 0
							? values.englishwritten
							: ""
				);
				data.append(
					"langauages[otherlanguage]",
					JSON.stringify(this.state.otherlanguage)
				);
				data.append(
					"langauages[IELTStest]",
					values.IELTStest &&
						String(values.IELTStest) !== String(undefined) &&
						values.IELTStest.length > 0
						? values.IELTStest
						: this.state.IELTStest &&
							String(this.state.IELTStest) !== String(undefined) &&
							this.state.IELTStest.length > 0
							? this.state.IELTStest
							: ""
				);
				/* Languages */

				data.append(
					"save_as_my_current",
					this.state.save_as_my_current
						? this.state.save_as_my_current
						: values.save_as_my_current
							? values.save_as_my_current
							: false
				);

				/* DRIVING DETAILS */
				data.append(
					"drivingdetails[drivinglicence]",
					this.state.drivinglicence &&
						String(this.state.drivinglicence) !== String(undefined) &&
						this.state.drivinglicence.length > 0
						? this.state.drivinglicence
						: values.drivinglicence &&
							String(values.drivinglicence) !== String(undefined) &&
							values.drivinglicence.length > 0
							? values.drivinglicence
							: ""
				);
				data.append(
					"drivingdetails[traveldetails]",
					this.state.traveldetails &&
						String(this.state.traveldetails) !== String(undefined) &&
						this.state.traveldetails.length > 0
						? this.state.traveldetails
						: values.traveldetails &&
							String(values.traveldetails) !== String(undefined) &&
							values.traveldetails.length > 0
							? values.traveldetails
							: ""
				);
				data.append(
					"drivingdetails[drivinglicenceno]",
					this.state.drivinglicenceno &&
						String(this.state.drivinglicenceno) !== String(undefined) &&
						this.state.drivinglicenceno.length > 0
						? this.state.drivinglicenceno
						: values.drivinglicenceno &&
							String(values.drivinglicenceno) !== String(undefined) &&
							values.drivinglicenceno.length > 0
							? values.drivinglicenceno
							: ""
				);
				data.append(
					"drivingdetails[caraccess]",
					this.state.caraccess &&
						String(this.state.caraccess) !== String(undefined) &&
						this.state.caraccess.length > 0
						? this.state.caraccess
						: values.caraccess &&
							String(values.caraccess) !== String(undefined) &&
							values.caraccess.length > 0
							? values.caraccess
							: ""
				);
				data.append(
					"drivingdetails[bannedfromdriving]",
					this.state.bannedfromdriving &&
						String(this.state.bannedfromdriving) !== String(undefined) &&
						this.state.bannedfromdriving.length > 0
						? this.state.bannedfromdriving
						: values.bannedfromdriving &&
							String(values.bannedfromdriving) !== String(undefined) &&
							values.bannedfromdriving.length > 0
							? values.bannedfromdriving
							: ""
				);
				data.append(
					"drivingdetails[carinsurance]",
					this.state.carinsurance &&
						String(this.state.carinsurance) !== String(undefined) &&
						this.state.carinsurance.length > 0
						? this.state.carinsurance
						: values.carinsurance &&
							String(values.carinsurance) !== String(undefined) &&
							values.carinsurance.length > 0
							? values.carinsurance
							: ""
				);
				data.append(
					"drivingdetails[vehicledocumentsvalid]",
					this.state.vehicledocumentsvalid &&
						this.state.vehicledocumentsvalid.lemgth > 0 &&
						String(this.state.vehicledocumentsvalid) !== String(undefined)
						? this.state.vehicledocumentsvalid
						: values.vehicledocumentsvalid &&
							values.vehicledocumentsvalid.lemgth > 0 &&
							String(values.vehicledocumentsvalid) !== String(undefined)
							? values.vehicledocumentsvalid
							: ""
				);

				data.append(
					"drivingdetails[drivingPhotoID]",
					values.drivingPhotoID &&
						values.drivingPhotoID.lemgth > 0 &&
						String(values.drivingPhotoID) !== String(undefined)
						? values.drivingPhotoID
						: this.state.drivingPhotoID &&
							this.state.drivingPhotoID.lemgth > 0 &&
							String(this.state.drivingPhotoID) !== String(undefined)
							? this.state.drivingPhotoID
							: ""
				);

				data.append(
					"drivers_licence[country_of_issue]",
					values.drivingCountryOfIssue &&
						String(values.drivingCountryOfIssue) !== String(undefined) &&
						values.drivingCountryOfIssue.length > 0
						? values.drivingCountryOfIssue
						: this.state.drivingCountryOfIssue &&
							String(this.state.drivingCountryOfIssue) !== String(undefined) &&
							this.state.drivingCountryOfIssue.length > 0
							? this.state.drivingCountryOfIssue
							: ""
				);
				data.append(
					"drivers_licence[licence_class]",
					this.state.licenceClass &&
						String(this.state.licenceClass) !== String(undefined) &&
						this.state.licenceClass.length > 0
						? this.state.licenceClass
						: values.licenceClass &&
							String(values.licenceClass) !== String(undefined) &&
							values.licenceClass.length > 0
							? values.licenceClass
							: ""
				);
				data.append(
					"drivers_licence[isdrivinglicence]",
					this.state.drivinglicence &&
						String(this.state.drivinglicence) !== String(undefined) &&
						this.state.drivinglicence.length > 0
						? this.state.drivinglicence
						: values.drivinglicence &&
							String(values.drivinglicence) !== String(undefined) &&
							values.drivinglicence.length > 0
							? values.drivinglicence
							: ""
				);
				data.append(
					"drivers_licence[licence_number]",
					this.state.drivinglicenceno &&
						String(this.state.drivinglicenceno) !== String(undefined) &&
						this.state.drivinglicenceno.length > 0
						? this.state.drivinglicenceno
						: values.drivinglicenceno &&
							String(values.drivinglicenceno) !== String(undefined) &&
							values.drivinglicenceno.length > 0
							? values.drivinglicenceno
							: ""
				);
				data.append(
					"drivers_licence[licence_expiry]",
					this.state.licenceExpiry
				);
				/* DRIVING DETAILS */

				// data.append("personaldetails[race]", values.race);
				// data.append("personaldetails[sexualorientation]", values.sexualorientation);
				/* DBS Details*/

				// data.append("employmenteligibility[visapermit]", values.visapermit);
				data.append(
					"nextofkindetails[kinprefix]",
					values.kinprefix &&
						values.kinprefix.lemgth > 0 &&
						String(values.kinprefix) !== String(undefined)
						? values.kinprefix
						: this.state.kinprefix &&
							this.state.kinprefix.length > 0 &&
							String(this.state.kinprefix) !== String(undefined)
							? this.state.kinprefix
							: ""
				);
				data.append(
					"nextofkindetails[kinfirstname]",
					values.kinfirstname &&
						String(values.kinfirstname) !== String(undefined) &&
						values.kinfirstname.length > 0
						? values.kinfirstname
						: this.state.kinfirstname &&
							String(this.state.kinfirstname) !== String(undefined) &&
							this.state.kinfirstname.length > 0
							? this.state.kinfirstname
							: ""
				);
				data.append(
					"nextofkindetails[kinlastname]",
					values.kinlastname &&
						String(values.kinlastname) !== String(undefined) &&
						values.kinlastname.length > 0
						? values.kinlastname
						: this.state.kinlastname &&
							String(this.state.kinlastname) !== String(undefined) &&
							this.state.kinlastname.length > 0
							? this.state.kinlastname
							: ""
				);
				data.append(
					"nextofkindetails[kinrelationship]",
					values.kinrelationship &&
						String(values.kinrelationship) !== String(undefined) &&
						values.kinrelationship.length > 0
						? values.kinrelationship
						: this.state.kinrelationship &&
							String(this.state.kinrelationship) !== String(undefined) &&
							this.state.kinrelationship.length > 0
							? this.state.kinrelationship
							: ""
				);
				data.append(
					"nextofkindetails[kinhomephone]",
					values.kinhomephone &&
						String(values.kinhomephone) !== String(undefined) &&
						values.kinhomephone.length > 0
						? values.kinhomephone
						: this.state.kinhomephone &&
							String(this.state.kinhomephone) !== String(undefined) &&
							this.state.kinhomephone.length > 0
							? this.state.kinhomephone
							: ""
				);
				data.append(
					"nextofkindetails[kinmobileno][number]",
					this.state.kinmobileno &&
						this.state.kinmobileno.number &&
						String(this.state.kinmobileno.number) !== String(undefined) &&
						this.state.kinmobileno.number.length > 0
						? this.state.kinmobileno.number
						: values.kinmobileno &&
							values.kinmobileno.number &&
							String(values.kinmobileno.number) !== String(undefined) &&
							values.kinmobileno.number.length > 0
							? values.kinmobileno.number
							: ""
				);
				data.append(
					"nextofkindetails[kinmobileno][code]",
					this.state.kinmobileno &&
						this.state.kinmobileno.code &&
						String(this.state.kinmobileno.code) !== String(undefined) &&
						this.state.kinmobileno.code.length > 0
						? this.state.kinmobileno.code
						: values.kinmobileno &&
							values.kinmobileno.code &&
							String(values.kinmobileno.code) !== String(undefined) &&
							values.kinmobileno.code.length > 0
							? values.kinmobileno.code
							: ""
				);
				data.append(
					"nextofkindetails[kinmobileno][dialcountry]",
					this.state.kinmobileno &&
						this.state.kinmobileno.dialcountry &&
						String(this.state.kinmobileno.dialcountry) !== String(undefined) &&
						this.state.kinmobileno.dialcountry.length > 0
						? this.state.kinmobileno.dialcountry
						: values.kinmobileno &&
							values.kinmobileno.dialcountry &&
							String(values.kinmobileno.dialcountry) !== String(undefined) &&
							values.kinmobileno.dialcountry.length > 0
							? values.kinmobileno.dialcountry
							: ""
				);
				data.append(
					"nextofkindetails[kinemail]",
					values.kinemail &&
						String(values.kinemail) !== String(undefined) &&
						values.kinemail.length > 0
						? values.kinemail
						: this.state.kinemail &&
							String(this.state.kinemail) !== String(undefined) &&
							this.state.kinemail.length > 0
							? this.state.kinemail
							: ""
				);
				data.append(
					"nextofkindetails[Address][kinstreetAddress]",
					values.kinstreetAddress &&
						String(values.kinstreetAddress) !== String(undefined) &&
						values.kinstreetAddress.length > 0
						? values.kinstreetAddress
						: this.state.kinstreetAddress &&
							String(this.state.kinstreetAddress) !== String(undefined) &&
							this.state.kinstreetAddress.length > 0
							? this.state.kinstreetAddress
							: ""
				);
				data.append(
					"nextofkindetails[Address][kinaddressline2]",
					values.kinaddressline2 &&
						String(values.kinaddressline2) !== String(undefined) &&
						values.kinaddressline2.length > 0
						? values.kinaddressline2
						: this.state.kinaddressline2 &&
							String(this.state.kinaddressline2) !== String(undefined) &&
							this.state.kinaddressline2.length > 0
							? this.state.kinaddressline2
							: ""
				);
				data.append(
					"nextofkindetails[Address][kincity]",
					values.kincity &&
						String(values.kincity) !== String(undefined) &&
						values.kincity.length > 0
						? values.kincity
						: this.state.kincity &&
							String(this.state.kincity) !== String(undefined) &&
							this.state.kincity.length > 0
							? this.state.kincity
							: ""
				);
				data.append(
					"nextofkindetails[Address][kinstate]",
					values.kinstate &&
						String(values.kinstate) !== String(undefined) &&
						values.kinstate.length > 0
						? values.kinstate
						: this.state.kinstate &&
							String(this.state.kinstate) !== String(undefined) &&
							this.state.kinstate.length > 0
							? this.state.kinstate
							: ""
				);
				data.append(
					"nextofkindetails[Address][kinzip]",
					values.kinzip &&
						String(values.kinzip) !== String(undefined) &&
						values.kinzip.length > 0
						? values.kinzip
						: this.state.kinzip &&
							String(this.state.kinzip) !== String(undefined) &&
							this.state.kinzip.length > 0
							? this.state.kinzip
							: ""
				);
				data.append(
					"nextofkindetails[Address][kincountry]",
					values.kincountry &&
						String(values.kincountry) !== String(undefined) &&
						values.kincountry.length > 0
						? values.kincountry
						: this.state.kincountry &&
							String(this.state.kincountry) !== String(undefined) &&
							this.state.kincountry.length > 0
							? this.state.kincountry
							: ""
				);
				data.append(
					"empBio",
					values.empBio && CheckValue(values.empBio)
						? values.empBio
						: this.state.empBio && CheckValue(this.state.empBio)
							? this.state.empBio
							: ""
				);
				/* DBS  Details*/
				data.append("personaldetails[iscurrentDBS]", this.state.currentDBS);
				data.append("personaldetails[dbsIssueDate]", this.state.dbsIssueDate);
				data.append("personaldetails[dbsExpirydate]", this.state.dbsExpirydate);
				data.append(
					"personaldetails[dbsCertificateNo]",
					this.state.dbsCertificateNo
				);


				// Template addtional fields mapping with the online form.;
				let addtionalFields = this.state.templateAddtionalFields.length ? this.state.templateAddtionalFields /*.filter((item ={}) => item.isModified) */ : [] ;
					addtionalFields = addtionalFields.map((fld , i)=>({
						field_heading:fld.field_heading.name,
						field_menu:fld.field_menu.name,
						field_value:fld.field_value,
						_id:fld._id
					}))
				data.append("addtionalFields" , JSON.stringify(addtionalFields))





				this.setState({ active_tab_1: true });
				this.save_online_form(data);
			}
		}
	};

	update_2_tab = (name) => {
		this.setState({ sec_tab_up_nxt: name });
	};

	OnFormEmploymentEducation = (event, errors, values) => {
		if (this.state.activeTab === "2") {
			const data = new FormData();
			data.append("forpage", 2);

			/* Qualifications */
			let updatedEqDocs = this.state.education_qualification
				.filter(function (item) {
					return item.qualification_course !== "";
				})
				.map(function (item) {
					return item;
				});

			data.append("educational_qualification", JSON.stringify(updatedEqDocs));

			let updatedOtherCourseDocs = this.state.other_courses
				.filter(function (item) {
					return item.other_qualification_course !== "";
				})
				.map(function (item) {
					return item;
				});

			data.append("other_courses", JSON.stringify(updatedOtherCourseDocs));
			// data.append(
			// 	"professionalBody[professionalBody]",
			// 	this.state.professionalBody &&
			// 		String(this.state.professionalBody) !== String(undefined) &&
			// 		this.state.professionalBody.length > 0
			// 		? this.state.professionalBody
			// 		: values.professionalBody &&
			// 			String(values.professionalBody) !== String(undefined) &&
			// 			values.professionalBody.length > 0
			// 			? values.professionalBody
			// 			: ""
			// );
			// data.append(
			// 	"professionalBody[pinRef]",
			// 	this.state.pinRef &&
			// 		String(this.state.pinRef) !== String(undefined) &&
			// 		this.state.pinRef.length > 0
			// 		? this.state.pinRef
			// 		: values.pinRef &&
			// 			String(values.pinRef) !== String(undefined) &&
			// 			values.pinRef.length > 0
			// 			? values.pinRef
			// 			: ""
			// );
			// data.append(
			// 	"professionalBody[professionalBodyExpiry]",
			// 	this.state.professionalBodyExpiry
			// );

			let updatedPbDocs = this.state.professional_Body
				.filter(function (item) {
					return item.professionalBody !== "";
				})
				.map(function (item) {
					return item;
				});

			data.append("professional_Body", JSON.stringify(updatedPbDocs));
			this.setState({ active_tab_2: true });
			this.save_online_form(data);
		}
	};
	update_3_tab = (name) => {
		this.setState({ thi_tab_up_nxt: name });
	};
	OnFormSkills = (event, errors, values) => {
		if (this.state.activeTab === "3") {
			const data = new FormData();
			data.append("forpage", 3);

			let updatedWorkDocs = this.state.work_experience
				.filter(function (item) {
					return item.work_title !== "";
				})
				.map(function (item) {
					return item;
				});

			data.append("work_experience", JSON.stringify(updatedWorkDocs));
			data.append(
				"skills",
				JSON.stringify(
					this.state.skills &&
						Array.isArray(this.state.skills) &&
						this.state.skills.length > 0
						? this.state.skills
						: []
				)
			);
			data.append(
				"languages",
				JSON.stringify(
					this.state.languages &&
						Array.isArray(this.state.languages) &&
						this.state.languages.length > 0
						? this.state.languages
						: []
				)
			);
			data.append(
				"emergency_contacts",
				JSON.stringify(
					this.state.emergency_contacts &&
						Array.isArray(this.state.emergency_contacts) &&
						this.state.emergency_contacts.length > 0
						? this.state.emergency_contacts
						: []
				)
			);
			// data.append("reference1[firstrefrelationship]", values.firstrefrelationship);
			// data.append("reference1[firstreffirstname]", values.firstreffirstname);
			// data.append("reference1[firstreflastname]", values.firstreflastname);
			// data.append("reference1[firstrefphone][number]", this.state.firstrefphone.number);
			// data.append("reference1[firstrefphone][code]", this.state.firstrefphone.code);
			// data.append("reference1[firstrefphone][dialcountry]", this.state.firstrefphone.dialcountry);
			// data.append("reference1[firstrefemail]", values.firstrefemail);
			// data.append("reference1[firstrefconfirmemail]", values.firstrefconfirmemail);
			// data.append("reference1[Address][firstrefstreetAddress]", values.firstrefstreetAddress);
			// data.append("reference1[Address][firstrefcity]", values.firstrefcity);
			// data.append("reference1[Address][firstrefstate]", values.firstrefstate);
			// data.append("reference1[Address][firstrefzip]", values.firstrefzip);
			// data.append("reference2[secondrefrelationship]", values.secondrefrelationship);
			// data.append("reference2[secondreffirstname]", values.secondreffirstname);
			// data.append("reference2[secondreflastname]", values.secondreflastname);
			// data.append("reference2[secondrefphone][number]", this.state.secondrefphone.number);
			// data.append("reference2[secondrefphone][code]", this.state.secondrefphone.code);
			// data.append("reference2[secondrefphone][dialcountry]", this.state.secondrefphone.dialcountry);
			// data.append("reference2[secondrefemail]", values.secondrefemail);
			// data.append("reference2[secondrefconfirmemail]", values.secondrefconfirmemail);
			// data.append("reference2[Address][secondrefstreetAddress]", values.secondrefstreetAddress);
			// data.append("reference2[Address][secondrefcity]", values.secondrefcity);
			// data.append("reference2[Address][secondrefstate]", values.secondrefstate);
			// data.append("reference2[Address][secondrefzip]", values.secondrefzip);
			// data.append("reference3[thirdrefrelationship]", values.thirdrefrelationship);
			// data.append("reference3[thirdreffirstname]", values.thirdreffirstname);
			// data.append("reference3[thirdreflastname]", values.thirdreflastname);
			// data.append("reference3[thirdrefphone][number]", this.state.thirdrefphone.number);
			// data.append("reference3[thirdrefphone][code]", this.state.thirdrefphone.code);
			// data.append("reference3[thirdrefphone][dialcountry]", this.state.thirdrefphone.dialcountry);
			// data.append("reference3[thirdrefemail]", values.thirdrefemail);
			// data.append("reference3[thirdrefconfirmemail]", values.thirdrefconfirmemail);
			// data.append("reference3[Address][thirdrefstreetAddress]", values.thirdrefstreetAddress);
			// data.append("reference3[Address][thirdrefcity]", values.thirdrefcity);
			// data.append("reference3[Address][thirdrefstate]", values.thirdrefstate);
			// data.append("reference3[Address][thirdrefzip]", values.thirdrefzip);


			data.append(
				"skillProvideDetails",
				this.state.skillProvideDetails &&
					String(this.state.skillProvideDetails) !== String(undefined) &&
					this.state.skillProvideDetails.length > 0
					? this.state.skillProvideDetails
					: values.skillProvideDetails &&
						String(values.skillProvideDetails) !== String(undefined) &&
						values.skillProvideDetails.length > 0
						? values.skillProvideDetails
						: ""
			);
			this.setState({ active_tab_3: true });
			this.save_online_form(data);
		}
	};
	update_2_main_tab = (name) => {
		this.setState({ sec_main_tab_up_nxt: name });
	};

	OnFormDocuments = (event, errors, values) => {
		event.preventDefault();
		if (this.state.mainActiveTab === "2") {
			if (this.state.documents.length >= 0) {
				const data = new FormData();
				data.append("forpage", 4);

				let updatedDocs = this.state.documents
					.filter(function (item) {
						return Object.keys(item).length !== 0 && item && item.upload_doc && item.upload_doc.length > 4;
					})
					.map(function (item) {
						return item;
					});

				data.append("documents", JSON.stringify(updatedDocs));
				this.setState({ mainactive_tab_2: true });
				this.save_online_form(data);
			} else {
				toast.error("Kindly add the documents to upload");
			}
		}
	};

	update_4_tab = (name) => {
		this.setState({ four_tab_up_nxt: name });
	};

	OnFormDeclaration = (event, errors, values) => {
		// console.log("this.state.signature", this.state.signature);
		if (
			this.state.signature.length === 0 ||
			String(this.state.signature) === String(undefined) ||
			String(this.state.signature) === String(null)
		) {
			return toast.error("Declaration Signature is required");
		}
		if (
			this.state.workTimeSignature.length === 0 ||
			String(this.state.workTimeSignature) === String(undefined) ||
			String(this.state.workTimeSignature) === String(null)
		) {
			return toast.error("Working time signature is required");
		}

		if (this.state.activeTab === "4") {
			const data = new FormData();
			data.append("forpage", 5);
			data.append(
				"medicalhistory[medicalillness]",
				values.medicalillness &&
					String(values.medicalillness) !== String(undefined) &&
					values.medicalillness.length > 0
					? values.medicalillness
					: this.state.medicalillness &&
						String(this.state.medicalillness) !== String(undefined) &&
						this.state.medicalillness.length > 0
						? this.state.medicalillness
						: ""
			);
			data.append(
				"medicalhistory[medicalillness_notes]",
				values.medicalillness_notes &&
					String(values.medicalillness_notes) !== String(undefined) &&
					values.medicalillness_notes.length > 0
					? values.medicalillness_notes
					: this.state.medicalillness_notes &&
						String(this.state.medicalillness_notes) !== String(undefined) &&
						this.state.medicalillness_notes.length > 0
						? this.state.medicalillness_notes
						: ""
			);
			data.append(
				"medicalhistory[medicalillnesscaused]",
				values.medicalillnesscaused &&
					String(values.medicalillnesscaused) !== String(undefined) &&
					values.medicalillnesscaused.length > 0
					? values.medicalillnesscaused
					: this.state.medicalillnesscaused &&
						String(this.state.medicalillnesscaused) !== String(undefined) &&
						this.state.medicalillnesscaused.length > 0
						? this.state.medicalillnesscaused
						: ""
			);
			data.append(
				"medicalhistory[medicalillnesscaused_notes]",
				values.medicalillnesscaused_notes &&
					String(values.medicalillnesscaused_notes) !== String(undefined) &&
					values.medicalillnesscaused_notes.length > 0
					? values.medicalillnesscaused_notes
					: this.state.medicalillnesscaused_notes &&
						String(this.state.medicalillnesscaused_notes) !==
						String(undefined) &&
						this.state.medicalillnesscaused_notes.length > 0
						? this.state.medicalillnesscaused_notes
						: ""
			);
			data.append(
				"medicalhistory[treatment]",
				values.treatment &&
					String(values.treatment) !== String(undefined) &&
					values.treatment.length > 0
					? values.treatment
					: this.state.treatment &&
						String(this.state.treatment) !== String(undefined) &&
						this.state.treatment.length > 0
						? this.state.treatment
						: ""
			);
			data.append(
				"medicalhistory[treatment_notes]",
				values.treatment_notes &&
					String(values.treatment_notes) !== String(undefined) &&
					values.treatment_notes.length > 0
					? values.treatment_notes
					: this.state.treatment_notes &&
						String(this.state.treatment_notes) !== String(undefined) &&
						this.state.treatment_notes.length > 0
						? this.state.treatment_notes
						: ""
			);
			data.append(
				"medicalhistory[needanyadjustments]",
				values.needanyadjustments &&
					String(values.needanyadjustments) !== String(undefined) &&
					values.needanyadjustments.length > 0
					? values.needanyadjustments
					: this.state.needanyadjustments &&
						String(this.state.needanyadjustments) !== String(undefined) &&
						this.state.needanyadjustments.length > 0
						? this.state.needanyadjustments
						: ""
			);
			data.append(
				"medicalhistory[needanyadjustmentsnotes]",
				values.needanyadjustmentsnotes &&
					String(values.needanyadjustmentsnotes) !== String(undefined) &&
					values.needanyadjustmentsnotes.length > 0
					? values.needanyadjustmentsnotes
					: this.state.needanyadjustmentsnotes &&
						String(this.state.needanyadjustmentsnotes) !== String(undefined) &&
						this.state.needanyadjustmentsnotes.length > 0
						? this.state.needanyadjustmentsnotes
						: ""
			);

			data.append(
				"tuberculosis[livedUK]",
				values.livedUK &&
					String(values.livedUK) !== String(undefined) &&
					values.livedUK.length > 0
					? values.livedUK
					: this.state.livedUK &&
						String(this.state.livedUK) !== String(undefined) &&
						this.state.livedUK.length > 0
						? this.state.livedUK
						: ""
			);
			data.append(
				"tuberculosis[livedUKnotes]",
				values.livedUKnotes &&
					String(values.livedUKnotes) !== String(undefined) &&
					values.livedUKnotes.length > 0
					? values.livedUKnotes
					: this.state.livedUKnotes &&
						String(this.state.livedUKnotes) !== String(undefined) &&
						this.state.livedUKnotes.length > 0
						? this.state.livedUKnotes
						: ""
			);
			data.append(
				"tuberculosis[BCGvaccination]",
				values.BCGvaccination &&
					String(values.BCGvaccination) !== String(undefined) &&
					values.BCGvaccination.length > 0
					? values.BCGvaccination
					: this.state.BCGvaccination &&
						String(this.state.BCGvaccination) !== String(undefined) &&
						this.state.BCGvaccination.length > 0
						? this.state.BCGvaccination
						: ""
			);
			// data.append("tuberculosis[BCGvaccinationdate]", moment(values.BCGvaccinationdate).format("DD/MM/YYYY") || "");
			data.append(
				"tuberculosis[cough]",
				values.cough &&
					String(values.cough) !== String(undefined) &&
					values.cough.length > 0
					? values.cough
					: this.state.cough &&
						String(this.state.cough) !== String(undefined) &&
						this.state.cough.length > 0
						? this.state.cough
						: ""
			);
			data.append(
				"tuberculosis[weightloss]",
				values.weightloss &&
					String(values.weightloss) !== String(undefined) &&
					values.weightloss.length > 0
					? values.weightloss
					: this.state.weightloss &&
						String(this.state.weightloss) !== String(undefined) &&
						this.state.weightloss.length > 0
						? this.state.weightloss
						: ""
			);
			data.append(
				"tuberculosis[fever]",
				values.fever &&
					String(values.fever) !== String(undefined) &&
					values.fever.length > 0
					? values.fever
					: this.state.fever &&
						String(this.state.fever) !== String(undefined) &&
						this.state.fever.length > 0
						? this.state.fever
						: ""
			);
			data.append(
				"tuberculosis[TB]",
				values.TB &&
					String(values.TB) !== String(undefined) &&
					values.TB.length > 0
					? values.TB
					: this.state.TB &&
						String(this.state.TB) !== String(undefined) &&
						this.state.TB.length > 0
						? this.state.TB
						: ""
			);

			data.append(
				"criminal_records[criminaloffence]",
				values.criminaloffence &&
					String(values.criminaloffence) !== String(undefined) &&
					values.criminaloffence.length > 0
					? values.criminaloffence
					: this.state.criminaloffence &&
						String(this.state.criminaloffence) !== String(undefined) &&
						this.state.criminaloffence.length > 0
						? this.state.criminaloffence
						: ""
			);
			data.append(
				"criminal_records[criminalCautioned]",
				values.criminalCautioned &&
					String(values.criminalCautioned) !== String(undefined) &&
					values.criminalCautioned.length > 0
					? values.criminalCautioned
					: this.state.criminalCautioned &&
						String(this.state.criminalCautioned) !== String(undefined) &&
						this.state.criminalCautioned.length > 0
						? this.state.criminalCautioned
						: ""
			);
			data.append(
				"criminal_records[criminalConvictions]",
				values.criminalConvictions &&
					String(values.criminalConvictions) !== String(undefined) &&
					values.criminalConvictions.length > 0
					? values.criminalConvictions
					: this.state.criminalConvictions &&
						String(this.state.criminalConvictions) !== String(undefined) &&
						this.state.criminalConvictions.length > 0
						? this.state.criminalConvictions
						: ""
			);
			data.append(
				"criminal_records[criminalCourt]",
				values.criminalCourt &&
					String(values.criminalCourt) !== String(undefined) &&
					values.criminalCourt.length > 0
					? values.criminalCourt
					: this.state.criminalCourt &&
						String(this.state.criminalCourt) !== String(undefined) &&
						this.state.criminalCourt.length > 0
						? this.state.criminalCourt
						: ""
			);
			data.append(
				"criminal_records[criminalDisciplinaryAction]",
				values.criminalDisciplinaryAction &&
					String(values.criminalDisciplinaryAction) !== String(undefined) &&
					values.criminalDisciplinaryAction.length > 0
					? values.criminalDisciplinaryAction
					: this.state.criminalDisciplinaryAction &&
						String(this.state.criminalDisciplinaryAction) !==
						String(undefined) &&
						this.state.criminalDisciplinaryAction.length > 0
						? this.state.criminalDisciplinaryAction
						: ""
			);
			data.append(
				"criminal_records[criminalAdditionalInformation]",
				values.criminalAdditionalInformation &&
					String(values.criminalAdditionalInformation) !== String(undefined) &&
					values.criminalAdditionalInformation.length > 0
					? values.criminalAdditionalInformation
					: this.state.criminalAdditionalInformation &&
						String(this.state.criminalAdditionalInformation) !==
						String(undefined) &&
						this.state.criminalAdditionalInformation.length > 0
						? this.state.criminalAdditionalInformation
						: ""
			);

			data.append("dbsDeclaration[dbsAccept]", this.state.dbsAccept);
			data.append("dbsDeclaration[date]", this.state.dbsAcceptDate);

			data.append("id_indemnity_verification", this.state.indemnityAccept);

			data.append(
				"disable_act[registereddisabled]",
				values.registereddisabled &&
					String(values.registereddisabled) !== String(undefined) &&
					values.registereddisabled.length > 0
					? values.registereddisabled
					: this.state.registereddisabled &&
						String(this.state.registereddisabled) !== String(undefined) &&
						this.state.registereddisabled.length > 0
						? this.state.registereddisabled
						: ""
			);
			data.append(
				"disable_act[disableRegisteredDetails]",
				values.disableRegisteredDetails &&
					String(values.disableRegisteredDetails) !== String(undefined) &&
					values.disableRegisteredDetails.length > 0
					? values.disableRegisteredDetails
					: this.state.disableRegisteredDetails &&
						String(this.state.disableRegisteredDetails) !== String(undefined) &&
						this.state.disableRegisteredDetails.length > 0
						? this.state.disableRegisteredDetails
						: ""
			);
			data.append(
				"disable_act[disableAct]",
				values.disableAct &&
					String(values.disableAct) !== String(undefined) &&
					values.disableAct.length > 0
					? values.disableAct
					: this.state.disableAct &&
						String(this.state.disableAct) !== String(undefined) &&
						this.state.disableAct.length > 0
						? this.state.disableAct
						: ""
			);
			data.append(
				"disable_act[disableActDetails]",
				values.disableActDetails &&
					String(values.disableActDetails) !== String(undefined) &&
					values.disableActDetails.length > 0
					? values.disableActDetails
					: this.state.disableActDetails &&
						String(this.state.disableActDetails) !== String(undefined) &&
						this.state.disableActDetails.length > 0
						? this.state.disableActDetails
						: ""
			);
			data.append(
				"disable_act[disableOverCome]",
				values.disableOverCome &&
					String(values.disableOverCome) !== String(undefined) &&
					values.disableOverCome.length > 0
					? values.disableOverCome
					: this.state.disableOverCome &&
						String(this.state.disableOverCome) !== String(undefined) &&
						this.state.disableOverCome.length > 0
						? this.state.disableOverCome
						: ""
			);

			data.append(
				"disable_act[disableOverComeDetails]",
				values.disableOverComeDetails &&
					String(values.disableOverComeDetails) !== String(undefined) &&
					values.disableOverComeDetails.length > 0
					? values.disableOverComeDetails
					: this.state.disableOverComeDetails &&
						String(this.state.disableOverComeDetails) !== String(undefined) &&
						this.state.disableOverComeDetails.length > 0
						? this.state.disableOverComeDetails
						: ""
			);

			data.append(
				"declaration[declarationAccept]",
				this.state.declarationAccept
			);
			data.append(
				"declaration[declarationAcceptDate]",
				this.state.declarationAcceptDate
			);
			data.append("worktimedirectives[date]", this.state.workTimeDate);
			data.append(
				"worktimedirectives[signature]",
				this.state.workTimeSignature
			);
			data.append(
				"healthDeclarationTerms[acceptHealthDeclaration]",
				this.state.acceptHealthDeclaration
			);
			data.append(
				"healthDeclarationTerms[date]",
				this.state.HealthDeclarationDate
			);
			data.append(
				"personalDeclarationTerms[acceptPersonalDeclaration]",
				this.state.acceptPersonalDeclaration
			);
			data.append(
				"personalDeclarationTerms[date]",
				this.state.PersonalDeclarationDate
			);
			data.append(
				"confidentialityTerms[acceptConfidentiality]",
				this.state.acceptConfidentiality
			);
			data.append("confidentialityTerms[date]", this.state.ConfidentialityDate);
			this.setState({ active_tab_4: true });
			this.save_online_form(data);
		}
	};

	update_4_main_tab = (name) => {
		this.setState({ four_main_tab_up_nxt: name });
	};

	onHealthDeclarationSubmit = (event, errors, values) => {
		if (this.state.mainActiveTab === "4") {
			const data = new FormData();
			data.append("forpage", 6);

			data.append(
				"healthdeclaration[sufferedlongtermillness]",
				values.sufferedlongtermillness &&
					String(values.sufferedlongtermillness) !== String(undefined) &&
					values.sufferedlongtermillness.length > 0
					? values.sufferedlongtermillness
					: this.state.sufferedlongtermillness &&
						String(this.state.sufferedlongtermillness) !== String(undefined) &&
						this.state.sufferedlongtermillness.length > 0
						? this.state.sufferedlongtermillness
						: ""
			);
			data.append(
				"healthdeclaration[sufferedlongtermillness_notes]",
				values.sufferedlongtermillness_notes &&
					String(values.sufferedlongtermillness_notes) !== String(undefined) &&
					values.sufferedlongtermillness_notes.length > 0
					? values.sufferedlongtermillness_notes
					: this.state.sufferedlongtermillness_notes &&
						String(this.state.sufferedlongtermillness_notes) !==
						String(undefined) &&
						this.state.sufferedlongtermillness_notes.length > 0
						? this.state.sufferedlongtermillness_notes
						: ""
			);
			data.append(
				"healthdeclaration[leaveforneckinjury]",
				values.leaveforneckinjury &&
					String(values.leaveforneckinjury) !== String(undefined) &&
					values.leaveforneckinjury.length > 0
					? values.leaveforneckinjury
					: this.state.leaveforneckinjury &&
						String(this.state.leaveforneckinjury) !== String(undefined) &&
						this.state.leaveforneckinjury.length > 0
						? this.state.leaveforneckinjury
						: ""
			);
			data.append(
				"healthdeclaration[leaveforneckinjury_notes]",
				values.leaveforneckinjury_notes &&
					String(values.leaveforneckinjury_notes) !== String(undefined) &&
					values.leaveforneckinjury_notes.length > 0
					? values.leaveforneckinjury_notes
					: this.state.leaveforneckinjury_notes &&
						String(this.state.leaveforneckinjury_notes) !== String(undefined) &&
						this.state.leaveforneckinjury_notes.length > 0
						? this.state.leaveforneckinjury_notes
						: ""
			);
			data.append(
				"healthdeclaration[neckinjuries]",
				values.neckinjuries &&
					String(values.neckinjuries) !== String(undefined) &&
					values.neckinjuries.length > 0
					? values.neckinjuries
					: this.state.neckinjuries &&
						String(this.state.neckinjuries) !== String(undefined) &&
						this.state.neckinjuries.length > 0
						? this.state.neckinjuries
						: ""
			);
			data.append(
				"healthdeclaration[neckinjuries_notes]",
				values.neckinjuries_notes &&
					String(values.neckinjuries_notes) !== String(undefined) &&
					values.neckinjuries_notes.length > 0
					? values.neckinjuries_notes
					: this.state.neckinjuries_notes &&
						String(this.state.neckinjuries_notes) !== String(undefined) &&
						this.state.neckinjuries_notes.length > 0
						? this.state.neckinjuries_notes
						: ""
			);
			data.append(
				"healthdeclaration[sixweeksillness]",
				values.sixweeksillness &&
					String(values.sixweeksillness) !== String(undefined) &&
					values.sixweeksillness.length > 0
					? values.sixweeksillness
					: this.state.sixweeksillness &&
						String(this.state.sixweeksillness) !== String(undefined) &&
						this.state.sixweeksillness.length > 0
						? this.state.sixweeksillness
						: ""
			);
			data.append(
				"healthdeclaration[sixweeksillness_notes]",
				values.sixweeksillness_notes &&
					String(values.sixweeksillness_notes) !== String(undefined) &&
					values.sixweeksillness_notes.length > 0
					? values.sixweeksillness_notes
					: this.state.sixweeksillness_notes &&
						String(this.state.sixweeksillness_notes) !== String(undefined) &&
						this.state.sixweeksillness_notes.length > 0
						? this.state.sixweeksillness_notes
						: ""
			);
			data.append(
				"healthdeclaration[communicabledisease]",
				values.communicabledisease &&
					String(values.communicabledisease) !== String(undefined) &&
					values.communicabledisease.length > 0
					? values.communicabledisease
					: this.state.communicabledisease &&
						String(this.state.communicabledisease) !== String(undefined) &&
						this.state.communicabledisease.length > 0
						? this.state.communicabledisease
						: ""
			);
			data.append(
				"healthdeclaration[communicabledisease_notes]",
				values.communicabledisease_notes &&
					String(values.communicabledisease_notes) !== String(undefined) &&
					values.communicabledisease_notes.length > 0
					? values.communicabledisease_notes
					: this.state.communicabledisease_notes &&
						String(this.state.communicabledisease_notes) !==
						String(undefined) &&
						this.state.communicabledisease_notes.length > 0
						? this.state.communicabledisease_notes
						: ""
			);
			data.append(
				"healthdeclaration[medicalattention]",
				values.medicalattention &&
					String(values.medicalattention) !== String(undefined) &&
					values.medicalattention.length > 0
					? values.medicalattention
					: this.state.medicalattention &&
						String(this.state.medicalattention) !== String(undefined) &&
						this.state.medicalattention.length > 0
						? this.state.medicalattention
						: ""
			);
			data.append(
				"healthdeclaration[healthdeclarationdetails]",
				this.state.healthdeclarationdetails &&
					String(this.state.healthdeclarationdetails) !== String(undefined) &&
					this.state.healthdeclarationdetails.length > 0
					? this.state.healthdeclarationdetails
					: values.healthdeclarationdetails &&
						String(values.healthdeclarationdetails) !== String(undefined) &&
						values.healthdeclarationdetails.length > 0
						? values.healthdeclarationdetails
						: ""
			);
			data.append(
				"healthdeclaration[registereddisabled]",
				values.registereddisabled &&
					String(values.registereddisabled) !== String(undefined) &&
					values.registereddisabled.length > 0
					? values.registereddisabled
					: this.state.registereddisabled &&
						String(this.state.registereddisabled) !== String(undefined) &&
						this.state.registereddisabled.length > 0
						? this.state.registereddisabled
						: ""
			);
			data.append(
				"healthdeclaration[absentfromwork]",
				this.state.absentfromwork &&
					String(this.state.absentfromwork) !== String(undefined) &&
					this.state.absentfromwork.length > 0
					? this.state.absentfromwork
					: values.absentfromwork &&
						String(values.absentfromwork) !== String(undefined) &&
						values.absentfromwork.length > 0
						? values.absentfromwork
						: ""
			);
			data.append(
				"healthdeclaration[statereason]",
				values.statereason &&
					String(values.statereason) !== String(undefined) &&
					values.statereason.length > 0
					? values.statereason
					: this.state.statereason &&
						String(this.state.statereason) !== String(undefined) &&
						this.state.statereason.length > 0
						? this.state.statereason
						: ""
			);

			data.append(
				"medicalhistory[medicalillness]",
				values.medicalillness &&
					String(values.medicalillness) !== String(undefined) &&
					values.medicalillness.length > 0
					? values.medicalillness
					: this.state.medicalillness &&
						String(this.state.medicalillness) !== String(undefined) &&
						this.state.medicalillness.length > 0
						? this.state.medicalillness
						: ""
			);
			data.append(
				"medicalhistory[medicalillness_notes]",
				values.medicalillness_notes &&
					String(values.medicalillness_notes) !== String(undefined) &&
					values.medicalillness_notes.length > 0
					? values.medicalillness_notes
					: this.state.medicalillness_notes &&
						String(this.state.medicalillness_notes) !== String(undefined) &&
						this.state.medicalillness_notes.length > 0
						? this.state.medicalillness_notes
						: ""
			);
			data.append(
				"medicalhistory[medicalillnesscaused]",
				values.medicalillnesscaused &&
					String(values.medicalillnesscaused) !== String(undefined) &&
					values.medicalillnesscaused.length > 0
					? values.medicalillnesscaused
					: this.state.medicalillnesscaused &&
						String(this.state.medicalillnesscaused) !== String(undefined) &&
						this.state.medicalillnesscaused.length > 0
						? this.state.medicalillnesscaused
						: ""
			);
			data.append(
				"medicalhistory[medicalillnesscaused_notes]",
				values.medicalillnesscaused_notes &&
					String(values.medicalillnesscaused_notes) !== String(undefined) &&
					values.medicalillnesscaused_notes.length > 0
					? values.medicalillnesscaused_notes
					: this.state.medicalillnesscaused_notes &&
						String(this.state.medicalillnesscaused_notes) !==
						String(undefined) &&
						this.state.medicalillnesscaused_notes.length > 0
						? this.state.medicalillnesscaused_notes
						: ""
			);
			data.append(
				"medicalhistory[treatment]",
				values.treatment &&
					String(values.treatment) !== String(undefined) &&
					values.treatment.length > 0
					? values.treatment
					: this.state.treatment &&
						String(this.state.treatment) !== String(undefined) &&
						this.state.treatment.length > 0
						? this.state.treatment
						: ""
			);
			data.append(
				"medicalhistory[treatment_notes]",
				values.treatment_notes &&
					String(values.treatment_notes) !== String(undefined) &&
					values.treatment_notes.length > 0
					? values.treatment_notes
					: this.state.treatment_notes &&
						String(this.state.treatment_notes) !== String(undefined) &&
						this.state.treatment_notes.length > 0
						? this.state.treatment_notes
						: ""
			);
			data.append(
				"medicalhistory[needanyadjustments]",
				values.needanyadjustments &&
					String(values.needanyadjustments) !== String(undefined) &&
					values.needanyadjustments.length > 0
					? values.needanyadjustments
					: this.state.needanyadjustments &&
						String(this.state.needanyadjustments) !== String(undefined) &&
						this.state.needanyadjustments.length > 0
						? this.state.needanyadjustments
						: ""
			);
			data.append(
				"medicalhistory[needanyadjustmentsnotes]",
				values.needanyadjustmentsnotes &&
					String(values.needanyadjustmentsnotes) !== String(undefined) &&
					values.needanyadjustmentsnotes.length > 0
					? values.needanyadjustmentsnotes
					: this.state.needanyadjustmentsnotes &&
						String(this.state.needanyadjustmentsnotes) !== String(undefined) &&
						this.state.needanyadjustmentsnotes.length > 0
						? this.state.needanyadjustmentsnotes
						: ""
			);

			data.append(
				"tuberculosis[livedUK]",
				values.livedUK &&
					String(values.livedUK) !== String(undefined) &&
					values.livedUK.length > 0
					? values.livedUK
					: this.state.livedUK &&
						String(this.state.livedUK) !== String(undefined) &&
						this.state.livedUK.length > 0
						? this.state.livedUK
						: ""
			);
			data.append(
				"tuberculosis[livedUKnotes]",
				values.livedUKnotes &&
					String(values.livedUKnotes) !== String(undefined) &&
					values.livedUKnotes.length > 0
					? values.livedUKnotes
					: this.state.livedUKnotes &&
						String(this.state.livedUKnotes) !== String(undefined) &&
						this.state.livedUKnotes.length > 0
						? this.state.livedUKnotes
						: ""
			);
			data.append(
				"tuberculosis[BCGvaccination]",
				values.BCGvaccination &&
					String(values.BCGvaccination) !== String(undefined) &&
					values.BCGvaccination.length > 0
					? values.BCGvaccination
					: this.state.BCGvaccination &&
						String(this.state.BCGvaccination) !== String(undefined) &&
						this.state.BCGvaccination.length > 0
						? this.state.BCGvaccination
						: ""
			);
			// data.append("tuberculosis[BCGvaccinationdate]", moment(values.BCGvaccinationdate).format("DD/MM/YYYY") || "");
			data.append(
				"tuberculosis[cough]",
				values.cough &&
					String(values.cough) !== String(undefined) &&
					values.cough.length > 0
					? values.cough
					: this.state.cough &&
						String(this.state.cough) !== String(undefined) &&
						this.state.cough.length > 0
						? this.state.cough
						: ""
			);
			data.append(
				"tuberculosis[weightloss]",
				values.weightloss &&
					String(values.weightloss) !== String(undefined) &&
					values.weightloss.length > 0
					? values.weightloss
					: this.state.weightloss &&
						String(this.state.weightloss) !== String(undefined) &&
						this.state.weightloss.length > 0
						? this.state.weightloss
						: ""
			);
			data.append(
				"tuberculosis[fever]",
				values.fever &&
					String(values.fever) !== String(undefined) &&
					values.fever.length > 0
					? values.fever
					: this.state.fever &&
						String(this.state.fever) !== String(undefined) &&
						this.state.fever.length > 0
						? this.state.fever
						: ""
			);
			data.append(
				"tuberculosis[TB]",
				values.TB &&
					String(values.TB) !== String(undefined) &&
					values.TB.length > 0
					? values.TB
					: this.state.TB &&
						String(this.state.TB) !== String(undefined) &&
						this.state.TB.length > 0
						? this.state.TB
						: ""
			);

			data.append(
				"immunisationhistory[polio]",
				values.polio &&
					String(values.polio) !== String(undefined) &&
					values.polio.length > 0
					? values.polio
					: this.state.polio &&
						String(this.state.polio) !== String(undefined) &&
						this.state.polio.length > 0
						? this.state.polio
						: ""
			);
			data.append(
				"immunisationhistory[tetanus]",
				values.tetanus &&
					String(values.tetanus) !== String(undefined) &&
					values.tetanus.length > 0
					? values.tetanus
					: this.state.tetanus &&
						String(this.state.tetanus) !== String(undefined) &&
						this.state.tetanus.length > 0
						? this.state.tetanus
						: ""
			);
			data.append(
				"immunisationhistory[hepatitisB]",
				values.hepatitisB &&
					String(values.hepatitisB) !== String(undefined) &&
					values.hepatitisB.length > 0
					? values.hepatitisB
					: this.state.hepatitisB &&
						String(this.state.hepatitisB) !== String(undefined) &&
						this.state.hepatitisB.length > 0
						? this.state.hepatitisB
						: ""
			);
			data.append(
				"immunisationhistory[proneProcedures]",
				values.proneProcedures &&
					String(values.proneProcedures) !== String(undefined) &&
					values.proneProcedures.length > 0
					? values.proneProcedures
					: this.state.proneProcedures &&
						String(this.state.proneProcedures) !== String(undefined) &&
						this.state.proneProcedures.length > 0
						? this.state.proneProcedures
						: ""
			);
			data.append(
				"immunisationhistory[heartCirculatory]",
				this.state.heartCirculatory &&
					String(this.state.heartCirculatory) !== String(undefined) &&
					this.state.heartCirculatory.length > 0
					? this.state.heartCirculatory
					: values.heartCirculatory &&
						String(values.heartCirculatory) !== String(undefined) &&
						values.heartCirculatory.length > 0
						? values.heartCirculatory
						: ""
			);
			data.append(
				"immunisationhistory[diabetes]",
				this.state.diabetes &&
					String(this.state.diabetes) !== String(undefined) &&
					this.state.diabetes.length > 0
					? this.state.diabetes
					: values.diabetes &&
						String(values.diabetes) !== String(undefined) &&
						values.diabetes.length > 0
						? values.diabetes
						: ""
			);
			data.append(
				"immunisationhistory[bronchitis]",
				this.state.bronchitis &&
					String(this.state.bronchitis) !== String(undefined) &&
					this.state.bronchitis.length > 0
					? this.state.bronchitis
					: values.bronchitis &&
						String(values.bronchitis) !== String(undefined) &&
						values.bronchitis.length > 0
						? values.bronchitis
						: ""
			);
			data.append(
				"immunisationhistory[epilepsy]",
				this.state.epilepsy &&
					String(this.state.epilepsy) !== String(undefined) &&
					this.state.epilepsy.length > 0
					? this.state.epilepsy
					: values.epilepsy &&
						String(values.epilepsy) !== String(undefined) &&
						values.epilepsy.length > 0
						? values.epilepsy
						: ""
			);
			data.append(
				"immunisationhistory[asthma]",
				this.state.asthma &&
					String(this.state.asthma) !== String(undefined) &&
					this.state.asthma.length > 0
					? this.state.asthma
					: values.asthma &&
						String(values.asthma) !== String(undefined) &&
						values.asthma.length > 0
						? values.asthma
						: ""
			);
			data.append(
				"immunisationhistory[headaches]",
				this.state.headaches &&
					String(this.state.headaches) !== String(undefined) &&
					this.state.headaches.length > 0
					? this.state.headaches
					: values.headaches &&
						String(values.headaches) !== String(undefined) &&
						values.headaches.length > 0
						? values.headaches
						: ""
			);
			data.append(
				"immunisationhistory[psychiatric]",
				this.state.psychiatric &&
					String(this.state.psychiatric) !== String(undefined) &&
					this.state.psychiatric.length > 0
					? this.state.psychiatric
					: values.psychiatric &&
						String(values.psychiatric) !== String(undefined) &&
						values.psychiatric.length > 0
						? values.psychiatric
						: ""
			);
			data.append(
				"immunisationhistory[dermatitis]",
				this.state.dermatitis &&
					String(this.state.dermatitis) !== String(undefined) &&
					this.state.dermatitis.length > 0
					? this.state.dermatitis
					: values.dermatitis &&
						String(values.dermatitis) !== String(undefined) &&
						values.dermatitis.length > 0
						? values.dermatitis
						: ""
			);
			data.append(
				"immunisationhistory[backProblems]",
				this.state.backProblems &&
					String(this.state.backProblems) !== String(undefined) &&
					this.state.backProblems.length > 0
					? this.state.backProblems
					: values.backProblems &&
						String(values.backProblems) !== String(undefined) &&
						values.backProblems.length > 0
						? values.backProblems
						: ""
			);
			data.append(
				"immunisationhistory[recurrentInfections]",

				this.state.recurrentInfections &&
					String(this.state.recurrentInfections) !== String(undefined) &&
					this.state.recurrentInfections.length > 0
					? this.state.recurrentInfections
					: values.recurrentInfections &&
						String(values.recurrentInfections) !== String(undefined) &&
						values.recurrentInfections.length > 0
						? values.recurrentInfections
						: ""
			);
			data.append(
				"immunisationhistory[hepatitis]",
				this.state.hepatitis &&
					String(this.state.hepatitis) !== String(undefined) &&
					this.state.hepatitis.length > 0
					? this.state.hepatitis
					: values.hepatitis &&
						String(values.hepatitis) !== String(undefined) &&
						values.hepatitis.length > 0
						? values.hepatitis
						: ""
			);
			data.append(
				"immunisationhistory[chickenpox]",
				this.state.chickenpox &&
					String(this.state.chickenpox) !== String(undefined) &&
					this.state.chickenpox.length > 0
					? this.state.chickenpox
					: values.chickenpox &&
						String(values.chickenpox) !== String(undefined) &&
						values.chickenpox.length > 0
						? values.chickenpox
						: ""
			);

			data.append(
				"immunisationhistory[varicella]",
				this.state.varicella &&
					String(this.state.varicella) !== String(undefined) &&
					this.state.varicella.length > 0
					? this.state.varicella
					: values.varicella &&
						String(values.varicella) !== String(undefined) &&
						values.varicella.length > 0
						? values.varicella
						: ""
			);
			data.append(
				"immunisationhistory[tuberculosis]",
				this.state.tuberculosis &&
					String(this.state.tuberculosis) !== String(undefined) &&
					this.state.tuberculosis.length > 0
					? this.state.tuberculosis
					: values.tuberculosis &&
						String(values.tuberculosis) !== String(undefined) &&
						values.tuberculosis.length > 0
						? values.tuberculosis
						: ""
			);
			data.append(
				"immunisationhistory[heaf]",
				this.state.heaf &&
					String(this.state.heaf) !== String(undefined) &&
					this.state.heaf.length > 0
					? this.state.heaf
					: values.heaf &&
						String(values.heaf) !== String(undefined) &&
						values.heaf.length > 0
						? values.heaf
						: ""
			);
			data.append(
				"immunisationhistory[rubella]",
				this.state.rubella &&
					String(this.state.rubella) !== String(undefined) &&
					this.state.rubella.length > 0
					? this.state.rubella
					: values.rubella &&
						String(values.rubella) !== String(undefined) &&
						values.rubella.length > 0
						? values.rubella
						: ""
			);
			data.append(
				"immunisationhistory[poliomyelitis]",

				this.state.poliomyelitis &&
					String(this.state.poliomyelitis) !== String(undefined) &&
					this.state.poliomyelitis.length > 0
					? this.state.poliomyelitis
					: values.poliomyelitis &&
						String(values.poliomyelitis) !== String(undefined) &&
						values.poliomyelitis.length > 0
						? values.poliomyelitis
						: ""
			);
			data.append(
				"immunisationhistory[HIV]",
				this.state.HIV &&
					String(this.state.HIV) !== String(undefined) &&
					this.state.HIV.length > 0
					? this.state.HIV
					: values.HIV &&
						String(values.HIV) !== String(undefined) &&
						values.HIV.length > 0
						? values.HIV
						: ""
			);
			data.append(
				"immunisationhistory[typhoid]",
				this.state.typhoid &&
					String(this.state.typhoid) !== String(undefined) &&
					this.state.typhoid.length > 0
					? this.state.typhoid
					: values.typhoid &&
						String(values.typhoid) !== String(undefined) &&
						values.typhoid.length > 0
						? values.typhoid
						: ""
			);

			data.append(
				"gpdetails[GPname]",
				values.GPname &&
					String(values.GPname) !== String(undefined) &&
					values.GPname.length > 0
					? values.GPname
					: this.state.GPname &&
						String(this.state.GPname) !== String(undefined) &&
						this.state.GPname.length > 0
						? this.state.GPname
						: ""
			);
			data.append(
				"gpdetails[GPphone][code]",
				values.GPphone &&
					values.GPphone.code &&
					String(values.GPphone.code) !== String(undefined) &&
					values.GPphone.code.length > 0
					? values.GPphone.code
					: this.state.GPphone &&
						this.state.GPphone.code &&
						String(this.state.GPphone.code) !== String(undefined) &&
						this.state.GPphone.code.length > 0
						? this.state.GPphone.code
						: ""
			);
			data.append(
				"gpdetails[GPphone][number]",
				values.GPphone &&
					values.GPphone.number &&
					String(values.GPphone.number) !== String(undefined) &&
					values.GPphone.number.length > 0
					? values.GPphone.number
					: this.state.GPphone &&
						this.state.GPphone.number &&
						String(this.state.GPphone.number) !== String(undefined) &&
						this.state.GPphone.number.length > 0
						? this.state.GPphone.number
						: ""
			);
			data.append(
				"gpdetails[GPphone][dialcountry]",
				values.GPphone &&
					values.GPphone.dialcountry &&
					String(values.GPphone.dialcountry) !== String(undefined) &&
					values.GPphone.dialcountry.length > 0
					? values.GPphone.dialcountry
					: this.state.GPphone &&
						this.state.GPphone.dialcountry &&
						String(this.state.GPphone.dialcountry) !== String(undefined) &&
						this.state.GPphone.dialcountry.length > 0
						? this.state.GPphone.dialcountry
						: "gb"
			);
			data.append(
				"gpdetails[gpaddress][GPstreetAddress]",
				values.GPstreetAddress &&
					String(values.GPstreetAddress) !== String(undefined) &&
					values.GPstreetAddress.length > 0
					? values.GPstreetAddress
					: this.state.GPstreetAddress &&
						String(this.state.GPstreetAddress) !== String(undefined) &&
						this.state.GPstreetAddress.length > 0
						? this.state.GPstreetAddress
						: ""
			);
			data.append(
				"gpdetails[gpaddress][GPcity]",
				values.GPcity &&
					String(values.GPcity) !== String(undefined) &&
					values.GPcity.length > 0
					? values.GPcity
					: this.state.GPcity &&
						String(this.state.GPcity) !== String(undefined) &&
						this.state.GPcity.length > 0
						? this.state.GPcity
						: ""
			);
			data.append(
				"gpdetails[gpaddress][GPstate]",
				values.GPstate &&
					String(values.GPstate) !== String(undefined) &&
					values.GPstate.length > 0
					? values.GPstate
					: this.state.GPstate &&
						String(this.state.GPstate) !== String(undefined) &&
						this.state.GPstate.length > 0
						? this.state.GPstate
						: ""
			);
			data.append(
				"gpdetails[gpaddress][GPzip]",
				values.GPzip &&
					String(values.GPzip) !== String(undefined) &&
					values.GPzip.length > 0
					? values.GPzip
					: this.state.GPzip &&
						String(this.state.GPzip) !== String(undefined) &&
						this.state.GPzip.length > 0
						? this.state.GPzip
						: ""
			);
			data.append(
				"covidVaccination",
				this.state.covidVaccination && CheckValue(this.state.covidVaccination)
					? this.state.covidVaccination
					: ""
			);
			data.append(
				"covidVaccination_date",
				this.state.covidVaccination_date &&
					CheckValue(this.state.covidVaccination_date)
					? this.state.covidVaccination_date
					: ""
			);
			// data.append("gpdetails[gpaddress][contactDoctor]", values.contactDoctor);
			// data.append("gpdetails[gpaddress][GPhealthdetails]", values.GPhealthdetails);
			this.setState({ mainactive_tab_4: false });
			this.save_online_form(data);
		}
	};

	OnBankFormSubmit = (event, errors, values, key) => {
		if (errors && errors.length > 0)
			return toast.error(
				"Please complete the required information before you proceed"
			);
		// if (this.state.bank_ac.length === 0) {
		// 	return toast.error("Please fill the account number");
		// }
		// if (this.state.job_type.length === 0) {
		// 	return toast.error("Job role is required");
		// }
		// if (this.state.locations.length === 0) {
		// 	return toast.error("Area is required");
		// }
		// if (this.state.signature.length === 0 || String(this.state.signature) === String(undefined) || String(this.state.signature) === String(null)) {
		// 	return toast.error("Signature is required");
		// }
		// if (this.state.workTimeSignature.length === 0 || String(this.state.workTimeSignature) === String(undefined) || String(this.state.workTimeSignature) === String(null)) {
		// 	return toast.error("Working time signature is required");
		// }
		let toastId = "employee_save_online_form_01";
		toastId = toast.info("Please Wait......", { autoClose: true });

		this.setState({ mainactive_tab_5: true });
		request({
			url: "/candidate/update/bankdetails/recruitment",
			method: "POST",
			data: {
				accountName:
					this.state.accountName &&
						String(this.state.accountName) !== String(undefined) &&
						this.state.accountName.length > 0
						? this.state.accountName
						: values &&
							values.accountName &&
							String(values.accountName) !== String(undefined) &&
							values.accountName.length > 0
							? values.accountName
							: "",
				accountType:
					this.state.accountType &&
						String(this.state.accountType) !== String(undefined) &&
						this.state.accountType.length > 0
						? this.state.accountType
						: values &&
							values.accountType &&
							String(values.accountType) !== String(undefined) &&
							values.accountType.length > 0
							? values.accountType
							: "",
				bankName:
					this.state.bankName &&
						String(this.state.bankName) !== String(undefined) &&
						this.state.bankName.length > 0
						? this.state.bankName
						: values &&
							values.bankName &&
							String(values.bankName) !== String(undefined) &&
							values.bankName.length > 0
							? values.bankName
							: "",
				bank_ac_name:
					this.state.bank_ac &&
						String(this.state.bank_ac) !== String(undefined) &&
						this.state.bank_ac.length > 0
						? this.state.bank_ac
						: values &&
							values.bank_ac &&
							String(values.bank_ac) !== String(undefined) &&
							values.bank_ac.length > 0
							? values.bank_ac
							: "",
				bank_sort_code:
					this.state.bank_sort_code &&
						String(this.state.bank_sort_code) !== String(undefined) &&
						this.state.bank_sort_code.length > 0
						? this.state.bank_sort_code
						: values &&
							values.bank_sort_code &&
							String(values.bank_sort_code) !== String(undefined) &&
							values.bank_sort_code.length > 0
							? values.bank_sort_code
							: "",
				postCode: "",
				bankEmail: "",
				dailcountryCode: "gb",
				number: "",
				code: "",
				port: window.location.port,
				hostname: window.location.hostname,
				protocol: window.location.protocol,
			},
		}).then((res) => {
			this.setState({ mainactive_tab_5: false });
			if (res.status === 1) {
				// toast.success(res.response);
				toast.update(toastId, {
					render: "Your profile has been saved",
					type: toast.TYPE.SUCCESS,
					autoClose: 2500,
				});
				this.componentDidMount("signature");
				// this.setState({ logo_loder: false });
			} else if (res.status === 0) {
				toast.error(res.response);
			}
		});
	};

	save_online_form(data) {
		// let toastId = "employee_save_online_form_01";
		// toastId = toast.info("Please Wait......", { autoClose: 2500 });
		request({
			url: "/employees/apply-online-form",
			method: "POST",
			data: data,
		}).then((res) => {
			this.setState({ active_tab_1: false });
			this.setState({ active_tab_2: false });
			this.setState({ active_tab_3: false });
			this.setState({ active_tab_4: false });
			this.setState({ mainactive_tab_2: false });
			this.setState({ mainactive_tab_4: false });
			if (res.status === 1) {
				// toast.update(toastId, { render: "Saved!", type: toast.TYPE.SUCCESS, autoClose: 2500 });
				toast.success("Saved!");
				this.componentDidMount();
				if (String(this.state.mainActiveTab) === "2") {
					if (
						this.state.sec_main_tab_up_nxt &&
						String(this.state.sec_main_tab_up_nxt) === "next"
					) {
						this.setState({ mainActiveTab: "3" });
					}
				} else if (String(this.state.mainActiveTab) === "4") {
					if (
						this.state.four_main_tab_up_nxt &&
						String(this.state.four_main_tab_up_nxt) === "next"
					) {
						this.setState({ mainActiveTab: "5" });
					}
				} else if (String(this.state.activeTab) === "4") {
					if (
						this.state.four_tab_up_nxt &&
						String(this.state.four_tab_up_nxt) === "next"
					) {
						this.setState({ mainActiveTab: "2" });
					}
				} else {
					if (String(this.state.activeTab) === "1") {
						if (this.state.first_tab_up_nxt && String(this.state.first_tab_up_nxt) === "next") {
							this.setState({
								activeTab: (Number(this.state.activeTab) + 1).toString(),
							});
						}
					} else {
						if (String(this.state.activeTab) === "2") {
							if (
								this.state.sec_tab_up_nxt &&
								String(this.state.sec_tab_up_nxt) === "next"
							) {
								this.setState({
									activeTab: (Number(this.state.activeTab) + 1).toString(),
								});
							}
						} else {
							if (String(this.state.activeTab) === "3") {
								if (
									this.state.thi_tab_up_nxt &&
									String(this.state.thi_tab_up_nxt) === "next"
								) {
									this.setState({
										activeTab: (Number(this.state.activeTab) + 1).toString(),
									});
								}
							} else {
								this.setState({
									activeTab: (Number(this.state.activeTab) + 1).toString(),
								});
							}
						}
					}
				}
				window.scrollTo(0, 0);
				this.setState({ disableonsave: false });
			} else if (res.status === 0) {
				toast.error(res.response);
				// toast.update(toastId, {
				// 	render: res.response,
				// 	type: toast.TYPE.ERROR,
				// 	autoClose: 2500,
				// });
				this.setState({ disableonsave: false });
			}
		});
	}
	senRequest = () => {
		let toastId = "submit_mail_online_Time_01";
		toastId = toast.info("Sending......", { autoClose: false });
		request({
			url: "/employees/send-online-form",
			method: "POST",
			data: { form_status: 1 },
		}).then((res) => {
			if (res.status === 1) {
				toast.update(toastId, {
					render: "Form Sent!",
					type: toast.TYPE.SUCCESS,
					autoClose: 2500,
				});
				this.componentDidMount();
			} else if (res.status === 0) {
				toast.update(toastId, {
					render: res.response,
					type: toast.TYPE.SUCCESS,
					autoClose: 2500,
				});
			}
		});
	};
	handler = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({
				phoneerror: false,
				mobileError: false,
				isFormErrors: false,
			});
		} else {
			this.setState({
				mobileError: true,
				phoneerror: true,
			});
		}
		this.setState({
			mobileno: {
				number: value,
				code: countryData.dialCode,
				dailcountry: countryData.iso2,
			},
		});
	};
	handler1 = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({
				phoneerror1: false,
			});
		} else {
			this.setState({
				phoneerror1: true,
			});
		}
		this.setState({
			kinmobileno: {
				number: value,
				code: countryData.dialCode,
				dailcountry: countryData.iso2,
			},
		});
	};
	handler2 = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({
				phoneerror2: false,
			});
		} else {
			this.setState({
				phoneerror2: true,
			});
		}
		this.setState({
			firstrefphone: {
				number: value,
				code: countryData.dialCode,
				dailcountry: countryData.iso2,
			},
		});
	};
	handler3 = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({
				phoneerror3: false,
			});
		} else {
			this.setState({
				phoneerror3: true,
			});
		}
		this.setState({
			secondrefphone: {
				number: value,
				code: countryData.dialCode,
				dailcountry: countryData.iso2,
			},
		});
	};
	handler4 = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({
				phoneerror4: false,
			});
		} else {
			this.setState({
				phoneerror4: true,
			});
		}
		this.setState({
			thirdrefphone: {
				number: value,
				code: countryData.dialCode,
				dailcountry: countryData.iso2,
			},
		});
	};
	handler3_gp = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({ phoneerror44: false });
		} else {
			this.setState({ phoneerror44: true });
		}
		this.setState({
			GPphone: {
				number: value,
				code: countryData.dialCode,
				dialcountry: countryData.iso2,
			},
		});
	};
	DownloadPDF = () => {
		let toastId = "Down_online_m_Time_01";
		client.defaults.responseType = "blob";
		toastId = toast.info("Downloading......", { autoClose: false });
		request({
			url: "/employees/onlineform/downloadpdf",
			method: "POST",
		})
			.then((res) => {
				if (res.status === 0) {
					toast.error(res.response);
				} else {
					if (res) {
						const file = new Blob([res], {
							type: "application/pdf",
						});
						const name = `${this.state.firstname}_${this.state.lastname}_Application-Form.pdf`;
						FileSaver(file, name);
						toast.update(toastId, {
							render: "Downloaded",
							type: toast.TYPE.SUCCESS,
							autoClose: 2500,
						});
						this.componentDidMount();
					}
					client.defaults.responseType = "json";
				}
			})
			.catch((error) => {
				toast.update(toastId, {
					render: error,
					type: toast.TYPE.ERROR,
					autoClose: 2500,
				});
				client.defaults.responseType = "json";
			});
	};

	FileView = (path) => {
		if (path) {
			const filepath = `${NodeURL}/${path}`;
			let fileext = path && path.split(".");
			fileext = fileext[fileext.length - 1];
			this.setState({ filepath, fileext, fileviewmodal: true });
		} else {
			this.setState({ fileviewmodal: false });
		}
	};

	apply_pop_toggle = () => {
		this.setState({ apply_to_all_pop: !this.state.apply_to_all_pop });
	};

	apply_pop_toggle_other = () => {
		this.setState({
			apply_to_all_pop_other: !this.state.apply_to_all_pop_other,
		});
	};

	onRadioNameChanged = (e) => {
		e.persist();
		this.setState({ [e.target.name]: e.target.value });
	};

	yes_qualification = () => {
		this.setState({ apply_to_all_pop_yes: !this.state.apply_to_all_pop_yes });
	};

	no_qualification = (e) => {
		e.persist();
		this.setState({ ask_qualifi_skip: !this.state.ask_qualifi_skip });
	};

	yes_qualification_other = () => {
		this.setState({
			apply_to_all_pop_yes_other: !this.state.apply_to_all_pop_yes_other,
		});
	};

	no_qualification_other = (e) => {
		e.persist();
		this.setState({
			ask_qualifi_skip_other: !this.state.ask_qualifi_skip_other,
		});
	};

	save_pop_qualification = (e) => {
		e.persist();
		let checklength = this.state.education_qualification.filter((item) => {
			if (item && item.checked) {
				return item;
			}
		});
		if (checklength.length === 0) {
			return toast.info("Please select atleast one to apply");
		}
		request({
			url: "/employee/apply/educationdocs/by/selected",
			method: "POST",
			data: {
				education_qualification: this.state.education_qualification,
				educationdocs: this.state.educationdocs,
				apply_id: this.state.apply_id,
			},
		})
			.then((res) => {
				if (res && +res.status === 1) {
					toast.success(res.response);
					this.setState({ apply_to_all_pop: !this.state.apply_to_all_pop });
					this.setState({
						apply_to_all_pop_yes: !this.state.apply_to_all_pop_yes,
					});
					this.componentDidMount();
				} else {
					toast.error(res.response);
				}
			})
			.catch((err) => {
				console.log("err is ", err);
			});
	};

	save_pop_qualification_other = (e) => {
		e.persist();
		let checklength = this.state.other_courses.filter((item) => {
			if (item && item.checked) {
				return item;
			}
		});
		if (checklength.length === 0) {
			return toast.info("Please select atleast one to apply");
		}
		request({
			url: "/employee/apply/othereducationdocs/by/selected",
			method: "POST",
			data: {
				other_courses: this.state.other_courses,
				othereducationdocs: this.state.othereducationdocs,
				apply_id: this.state.apply_id_other,
			},
		})
			.then((res) => {
				if (res && +res.status === 1) {
					toast.success(res.response);
					this.setState({
						apply_to_all_pop_other: !this.state.apply_to_all_pop_other,
					});
					this.setState({
						apply_to_all_pop_yes_other: !this.state.apply_to_all_pop_yes_other,
					});
					this.componentDidMount();
				} else {
					toast.error(res.response);
				}
			})
			.catch((err) => {
				console.log("err is ", err);
			});
	};

	backgrounddelete = (filePath = "") => {
		if (CheckValue(filePath)) {
			request({
				url: "/employee/uploaded/file/delete",
				method: "DELETE",
				data: { path: filePath },
			})
				.then((res) => {
					console.log("res", res);
				})
				.catch((err) => {
					console.log("err", err);
				});
		}
	};

	delete_Docs_normal_edu = (evt, i, filePath) => {
		evt.preventDefault();
		let { education_qualification = [] } = this.state;
		education_qualification[i] = {
			...education_qualification[i],
			fileName: "",
			filePath: "",
		};
		this.setState({ education_qualification });
		this.backgrounddelete(filePath);
	};

	delete_Docs_other_docs = (evt, i, filePath) => {
		evt.preventDefault();
		let { documents = [] } = this.state;
		documents[i] = { ...documents[i], fileName: "", upload_doc: "" };
		this.setState({ documents });
		this.backgrounddelete(filePath);
	};

	uploadotherDocs_normal_edu = (evt, index) => {
		evt.persist();
		let { education_qualification = [] } = this.state;
		if (evt && evt.target && evt.target.files) {
			const file_data = evt.target.files[0];
			const file_split = file_data.type.split("/");
			if (
				file_split[1] === "pdf" ||
				file_split[1] === "png" ||
				file_split[1] === "jpeg" ||
				file_split[1] === "jpg"
			) {
				if (file_data.size < 5242880) {
					let toastId = "employee_files_other_upload1";
					toastId = toast.info("Please Wait......", { autoClose: false });
					const data = new FormData();
					data.append("uploadfiles", file_data);
					request({
						url: "/employees/profile/upload/others",
						method: "POST",
						data,
					})
						.then((res) => {
							if (res.status === 1) {
								toast.update(toastId, {
									render: "File Saved",
									type: toast.TYPE.SUCCESS,
									autoClose: 2500,
								});
								if (
									res.response &&
									CheckValue(res.response.path) &&
									CheckValue(res.response.name)
								) {
									education_qualification[index] = {
										...education_qualification[index],
										fileName: res.response.name,
										filePath: res.response.path,
									};
									this.setState({ education_qualification });
								}
							} else if (res.status === 0) {
								toast.update(toastId, {
									render: res.response,
									type: toast.TYPE.ERROR,
									autoClose: 2500,
								});
							}
						})
						.catch((err) => {
							// console.log("/employees/profile/upload/others", err);
							toast.error("Something went wrong");
						})
						.finally(() => {
							console.log("done");
						});
				} else {
					toast.error("Maximum upload size is 5MB");
				}
			} else {
				toast.error("File Format not supported");
			}
		}
	};

	/* Qualifications */
	createQualificationsUI() {
		return this.state.education_qualification.map((el, i) => (
			<tr key={i}>
				<td>
					<AvGroup>
						<AvInput
							placeholder="Nursing"
							type="text"
							name="qualification_course"
							onChange={(e) => this.onEducationalChange(e, i)}
							value={el.qualification_course}
						/>
					</AvGroup>
				</td>
				<td>
					<AvGroup>
						<AvInput
							type="text"
							name="qualification_level"
							placeholder="Degree"
							onChange={(e) => this.onEducationalChange(e, i)}
							value={el.qualification_level}
						/>
					</AvGroup>
				</td>
				<td>
					<AvGroup>
						<AvInput
							type="text"
							name="qualification_title"
							placeholder="BA Hons"
							onChange={(e) => this.onEducationalChange(e, i)}
							value={el.qualification_title}
						/>
					</AvGroup>
				</td>
				<td>
					<Datetime
						name="qualification_date"
						dateFormat="DD-MM-YYYY"
						timeFormat={false}
						closeOnSelect={true}
						value={
							el.qualification_date === "" ||
								String(el.qualification_date) === String(undefined) ||
								String(el.qualification_date) === String(null) ||
								String(el.qualification_date) === String("Invalid date")
								? ""
								: moment(el.qualification_date).format("DD-MM-YYYY")
						}
						inputProps={{ placeholder: "Select Date" }}
						// isValidDate={current => current.isBefore(moment('').subtract(18, "years"))}
						onChange={(e) => {
							if (e._isValid) {
								const education_qualification = [
									...this.state.education_qualification,
								];
								education_qualification[i] = {
									...education_qualification[i],
									qualification_date: e,
								};
								this.setState({ education_qualification });
							} else if (!e) {
								const education_qualification = [
									...this.state.education_qualification,
								];
								education_qualification[i] = {
									...education_qualification[i],
									qualification_date: null,
								};
								this.setState({ education_qualification });
							} else {
								const education_qualification = [
									...this.state.education_qualification,
								];
								education_qualification[i] = {
									...education_qualification[i],
									qualification_date: null,
								};
								this.setState({ education_qualification });
							}
						}}
					/>
				</td>

				<td style={{ width: "150px" }}>
					<Row className="expiry-container">
						<Col lg={"1"}>
							<div className="expiry_checkbox">
								<input
									type="checkbox"
									name="document_expiry"
									// value={el.document_expiry}
									className="doc_details"
									checked={el.qualificationCheck ? true : false}
									onChange={(e) => {
										e.persist();
										const { name, checked } = e.target;
										const education_qualification = [
											...this.state.education_qualification,
										];
										if (checked) {
											this.state.education_qualification[i] = {
												...education_qualification[i],
												qualificationCheck: true,
											};
											this.setState(education_qualification);
										} else {
											this.state.education_qualification[i] = {
												...education_qualification[i],
												qualificationCheck: false,
												qualification_date_expiry: null,
											};
											this.setState(education_qualification);
										}
									}}
								/>
							</div>
						</Col>
						<Col lg={"11"}>
							{el.qualificationCheck && (
								<div className="expiry_box">
									<Datetime
										name="qualification_date_expiry"
										dateFormat="DD-MM-YYYY"
										timeFormat={false}
										closeOnSelect={true}
										value={
											CheckValue(el.qualification_date_expiry)
												? moment(el.qualification_date_expiry).format(
													"DD-MM-YYYY"
												)
												: ""
										}
										inputProps={{ placeholder: "Select Date" }}
										// isValidDate={current => current.isBefore(moment('').subtract(18, "years"))}
										onChange={(e) => {
											if (e._isValid) {
												const education_qualification = [
													...this.state.education_qualification,
												];
												education_qualification[i] = {
													...education_qualification[i],
													qualification_date_expiry: e,
												};
												this.setState({ education_qualification });
											} else if (!e) {
												const education_qualification = [
													...this.state.education_qualification,
												];
												education_qualification[i] = {
													...education_qualification[i],
													qualification_date_expiry: null,
												};
												this.setState({ education_qualification });
											} else {
												const education_qualification = [
													...this.state.education_qualification,
												];
												education_qualification[i] = {
													...education_qualification[i],
													qualification_date_expiry: null,
												};
												this.setState({ education_qualification });
											}
										}}
									/>
								</div>
							)}
						</Col>
					</Row>
				</td>
				<td>
					{CheckValue(el.filePath) ? (
						<p className="down-uploads">
							<UncontrolledTooltip
								placement="bottom"
								target={`uploadeducation${i}`}
							>
								View Document{" "}
							</UncontrolledTooltip>
							<img
								style={{ cursor: "pointer" }}
								src={pdf}
								alt="pdf"
								id={`uploadeducation${i}`}
								onClick={(e) => {
									e.preventDefault();
									this.FileView(el.filePath);
								}}
							/>
							<button
								type="button"
								className="trash-bttn"
								onClick={(e) => this.delete_Docs_normal_edu(e, i, el.filePath)}
							>
								<i className="fa fa-trash-o" aria-hidden="true"></i>
							</button>
						</p>
					) : (
						<p className="upper-uploads">
							<span>
								<img src={upload} alt="upload" />
								<input
									style={{ cursor: "pointer" }}
									type="file"
									name="upload_doc"
									accept="application/pdf,.pdf,image/*"
									onChange={(e) => this.uploadotherDocs_normal_edu(e, i)}
								/>
							</span>
						</p>
					)}
				</td>
				<td>
					<button
						className="remove_btn_emp"
						style={{ cursor: "pointer" }}
						title="remove"
						onClick={(e) => this.removeClick(e, i, el._id)}
					>
						x
					</button>
				</td>
			</tr>
		));
	}
	onEducationalChange = (e, i) => {
		const { name, value } = e.target;
		const education_qualification = [...this.state.education_qualification];
		education_qualification[i] = {
			...education_qualification[i],
			[name]: value,
		};
		this.setState({ education_qualification });
	};

	onAddFormEducation = () => {
		this.setState((prevState) => ({
			education_qualification: [
				...prevState.education_qualification,
				{
					qualification_course: "",
					qualification_level: "",
					qualification_title: "",
					qualification_date: "",
					qualification_date_expiry: "",
					fileName: "",
					filePath: "",
				},
			],
		}));
	};

	removeClick(evt, i, id) {
		evt.preventDefault();
		if (id) {
			request({
				url: "/candidate/form/deleteEducationData",
				method: "POST",
				data: { edu_id: id },
			}).then((res) => {
				if (res.status === 1) {
					toast.success("Removed");
					this.componentDidMount();
					this.setState({ activeTab: "2" });
				} else if (res.status === 0) {
					toast.error("Error in File");
				}
			});
		} else {
			const education_qualification = [...this.state.education_qualification];
			education_qualification.splice(i, 1);
			this.setState({ education_qualification });
		}
	}

	delete_Docs = (evt, i, filePath) => {
		evt.preventDefault();
		let { other_courses = [] } = this.state;
		other_courses[i] = { ...other_courses[i], fileName: "", filePath: "" };
		this.setState({ other_courses });
		this.backgrounddelete(filePath);
	};

	uploadotherDocs = (evt, index) => {
		evt.persist();
		let { other_courses = [] } = this.state;
		if (evt && evt.target && evt.target.files) {
			const file_data = evt.target.files[0];
			const file_split = file_data.type.split("/");
			if (
				file_split[1] === "pdf" ||
				file_split[1] === "png" ||
				file_split[1] === "jpeg" ||
				file_split[1] === "jpg"
			) {
				if (file_data.size < 5242880) {
					let toastId = "employee_files_other_upload1";
					toastId = toast.info("Please Wait......", { autoClose: false });
					const data = new FormData();
					data.append("uploadfiles", file_data);
					request({
						url: "/employees/profile/upload/others",
						method: "POST",
						data,
					})
						.then((res) => {
							if (res.status === 1) {
								toast.update(toastId, {
									render: "File Saved",
									type: toast.TYPE.SUCCESS,
									autoClose: 2500,
								});
								if (
									res.response &&
									CheckValue(res.response.path) &&
									CheckValue(res.response.name)
								) {
									other_courses[index] = {
										...other_courses[index],
										fileName: res.response.name,
										filePath: res.response.path,
									};
									this.setState({ other_courses });
								}
							} else if (res.status === 0) {
								toast.update(toastId, {
									render: res.response,
									type: toast.TYPE.ERROR,
									autoClose: 2500,
								});
							}
						})
						.catch((err) => {
							console.log("/employees/profile/upload/others", err);
							toast.error("Something went wrong");
						})
						.finally(() => {
							console.log("done");
						});
				} else {
					toast.error("Maximum upload size is 5MB");
				}
			} else {
				toast.error("File Format not supported");
			}
		}
	};

	createOtherCoursesUI() {
		return this.state.other_courses.map((el, i) => (
			<tr key={i}>
				<td>
					<AvGroup>
						<AvInput
							placeholder="Course"
							type="text"
							name="other_qualification_course"
							onChange={(e) => this.onOtherEducationalChange(e, i)}
							value={el.other_qualification_course}
						/>
					</AvGroup>
				</td>
				<td>
					<AvGroup>
						<AvInput
							type="text"
							name="other_qualification_level"
							onChange={(e) => this.onOtherEducationalChange(e, i)}
							value={el.other_qualification_level}
						/>
					</AvGroup>
				</td>
				<td>
					<AvGroup>
						<AvInput
							type="text"
							name="other_qualification_title"
							onChange={(e) => this.onOtherEducationalChange(e, i)}
							value={el.other_qualification_title}
						/>
					</AvGroup>
				</td>
				<td>
					<Datetime
						name="other_qualification_date"
						dateFormat="DD-MM-YYYY"
						timeFormat={false}
						closeOnSelect={true}
						value={
							el.other_qualification_date === "" ||
								String(el.other_qualification_date) === String(undefined) ||
								String(el.other_qualification_date) === String(null) ||
								String(el.other_qualification_date) === String("Invalid date")
								? ""
								: moment(el.other_qualification_date).format("DD-MM-YYYY")
						}
						inputProps={{ placeholder: "Select Date" }}
						// isValidDate={current => current.isBefore(moment('').subtract(18, "years"))}
						onChange={(e) => {
							if (e._isValid) {
								const other_courses = [...this.state.other_courses];
								other_courses[i] = {
									...other_courses[i],
									other_qualification_date: e,
								};
								this.setState({ other_courses });
							} else if (!e) {
								const other_courses = [...this.state.other_courses];
								other_courses[i] = {
									...other_courses[i],
									other_qualification_date: null,
								};
								this.setState({ other_courses });
							} else {
								const other_courses = [...this.state.other_courses];
								other_courses[i] = {
									...other_courses[i],
									other_qualification_date: null,
								};
								this.setState({ other_courses });
							}
						}}
					/>
				</td>
				<td>
					<Datetime
						name="other_qualification_date_expiry"
						dateFormat="DD-MM-YYYY"
						timeFormat={false}
						closeOnSelect={true}
						value={
							CheckValue(el.other_qualification_date_expiry)
								? moment(el.other_qualification_date_expiry).format(
									"DD-MM-YYYY"
								)
								: ""
						}
						inputProps={{ placeholder: "Select Date" }}
						onChange={(e) => {
							if (e._isValid) {
								const other_courses = [...this.state.other_courses];
								other_courses[i] = {
									...other_courses[i],
									other_qualification_date_expiry: e,
								};
								this.setState({ other_courses });
							} else if (!e) {
								const other_courses = [...this.state.other_courses];
								other_courses[i] = {
									...other_courses[i],
									other_qualification_date_expiry: null,
								};
								this.setState({ other_courses });
							} else {
								const other_courses = [...this.state.other_courses];
								other_courses[i] = {
									...other_courses[i],
									other_qualification_date_expiry: null,
								};
								this.setState({ other_courses });
							}
						}}
					/>
				</td>
				<td>
					{CheckValue(el.filePath) ? (
						<p className="down-uploads">
							<UncontrolledTooltip
								placement="bottom"
								target={`uploadeducation${i}`}
							>
								View Document{" "}
							</UncontrolledTooltip>
							<img
								src={pdf}
								alt="pdf"
								id={`uploadeducation${i}`}
								onClick={(e) => {
									e.preventDefault();
									this.FileView(el.filePath);
								}}
							/>
							<button
								type="button"
								className="trash-bttn"
								onClick={(e) => this.delete_Docs(e, i, el.filePath)}
							>
								<i className="fa fa-trash-o" aria-hidden="true"></i>
							</button>
						</p>
					) : (
						<p className="upper-uploads">
							<span>
								<img src={uploadRecruitment} alt="uploadRecruitment" />
								<input
									type="file"
									name="upload_doc"
									accept="application/pdf,.pdf,image/*"
									onChange={(e) => this.uploadotherDocs(e, i)}
								/>
							</span>
						</p>
					)}
				</td>
				<td>
					<button
						className="remove_btn_emp"
						style={{ cursor: "pointer" }}
						title="remove"
						onClick={(e) => this.removeOtherCourses(e, i, el._id)}
					>
						x
					</button>
				</td>
			</tr>
		));
	}

	professional_body_change_d = (e, i) => {
		const { name, value } = e.target;
		const professional_Body = [...this.state.professional_Body];
		professional_Body[i] = { ...professional_Body[i], [name]: value };
		this.setState({ professional_Body });
	};

	delete_pbm = (evt, i, filePath) => {
		evt.preventDefault();
		let { professional_Body = [] } = this.state;
		professional_Body[i] = {
			...professional_Body[i],
			fileName: "",
			filePath: "",
		};
		this.setState({ professional_Body });
		this.backgrounddelete(filePath);
	};

	uploadother_pbm = (evt, index) => {
		evt.persist();
		let { professional_Body = [] } = this.state;
		if (evt && evt.target && evt.target.files) {
			const file_data = evt.target.files[0];
			const file_split = file_data.type.split("/");
			if (
				file_split[1] === "pdf" ||
				file_split[1] === "png" ||
				file_split[1] === "jpeg" ||
				file_split[1] === "jpg"
			) {
				if (file_data.size < 5242880) {
					let toastId = "employee_files_other_upload1";
					toastId = toast.info("Please Wait......", { autoClose: false });
					const data = new FormData();
					data.append("uploadfiles", file_data);
					request({
						url: "/employees/profile/upload/others",
						method: "POST",
						data,
					})
						.then((res) => {
							if (res.status === 1) {
								toast.update(toastId, {
									render: "File Saved",
									type: toast.TYPE.SUCCESS,
									autoClose: 2500,
								});
								if (
									res.response &&
									CheckValue(res.response.path) &&
									CheckValue(res.response.name)
								) {
									professional_Body[index] = {
										...professional_Body[index],
										fileName: res.response.name,
										filePath: res.response.path,
									};
									this.setState({ professional_Body });
								}
							} else if (res.status === 0) {
								toast.update(toastId, {
									render: res.response,
									type: toast.TYPE.ERROR,
									autoClose: 2500,
								});
							}
						})
						.catch((err) => {
							console.log("/employees/profile/upload/others", err);
							toast.error("Something went wrong");
						})
						.finally(() => {
							console.log("done");
						});
				} else {
					toast.error("Maximum upload size is 5MB");
				}
			} else {
				toast.error("File Format not supported");
			}
		}
	};

	create_professional_body() {
		return this.state.professional_Body.map((el, i) => (
			<tr key={i}>
				<td>
					<AvGroup>
						<AvInput
							placeholder="NMC/HCPC/GMC"
							type="text"
							name="professionalBody"
							onChange={(e) => this.professional_body_change_d(e, i)}
							value={el.professionalBody}
						/>
					</AvGroup>
				</td>
				<td>
					<AvGroup>
						<AvInput
							type="text"
							name="pinRef"
							placeholder="99A9999A"
							onChange={(e) => this.professional_body_change_d(e, i)}
							value={el.pinRef}
						/>
					</AvGroup>
				</td>
				<td>
					<Datetime
						name="professionalBodyExpiry"
						dateFormat="DD-MM-YYYY"
						timeFormat={false}
						closeOnSelect={true}
						value={
							el.professionalBodyExpiry === "" ||
								String(el.professionalBodyExpiry) === String(undefined) ||
								String(el.professionalBodyExpiry) === String(null) ||
								String(el.professionalBodyExpiry) === String("Invalid date")
								? ""
								: moment(el.professionalBodyExpiry).format("DD-MM-YYYY")
						}
						inputProps={{ placeholder: "Select Date" }}
						onChange={(e) => {
							if (e._isValid) {
								const professional_Body = [...this.state.professional_Body];
								professional_Body[i] = {
									...professional_Body[i],
									professionalBodyExpiry: e,
								};
								this.setState({ professional_Body });
							} else if (!e) {
								const professional_Body = [...this.state.professional_Body];
								professional_Body[i] = {
									...professional_Body[i],
									professionalBodyExpiry: null,
								};
								this.setState({ professional_Body });
							} else {
								const professional_Body = [...this.state.professional_Body];
								professional_Body[i] = {
									...professional_Body[i],
									professionalBodyExpiry: null,
								};
								this.setState({ professional_Body });
							}
						}}
					/>
				</td>
				<td>
					{CheckValue(el.filePath) ? (
						<p className="down-uploads">
							<UncontrolledTooltip
								placement="bottom"
								target={`uploadeducation${i}`}
							>
								View Document{" "}
							</UncontrolledTooltip>
							<img
								src={pdf}
								alt="pdf"
								id={`uploadeducation${i}`}
								onClick={(e) => {
									e.preventDefault();
									this.FileView(el.filePath);
								}}
							/>
							<button
								type="button"
								className="trash-bttn"
								onClick={(e) => this.delete_pbm(e, i, el.filePath)}
							>
								<i className="fa fa-trash-o" aria-hidden="true"></i>
							</button>
						</p>
					) : (
						<p className="upper-uploads">
							<span>
								<img src={uploadRecruitment} alt="uploadRecruitment" />
								<input
									type="file"
									name="upload_doc"
									accept="application/pdf,.pdf,image/*"
									onChange={(e) => this.uploadother_pbm(e, i)}
								/>
							</span>
						</p>
					)}
				</td>
				<td>
					<button
						className="remove_btn_emp"
						style={{ cursor: "pointer" }}
						title="remove"
						onClick={(e) => this.remove_professional_body(e, i, el._id)}
					>
						x
					</button>
				</td>
			</tr>
		));
	}

	remove_professional_body(evt, i, id) {
		evt.preventDefault();
		if (id) {
			request({
				url: "/candidate/form/delete/professional_body",
				method: "POST",
				data: { _id: id },
			}).then((res) => {
				if (res.status === 1) {
					toast.success("Removed");
					this.componentDidMount();
					this.setState({ activeTab: "2" });
				} else if (res.status === 0) {
					toast.error("Error in File");
				}
			});
		} else {
			const professional_Body = [...this.state.professional_Body];
			professional_Body.splice(i, 1);
			this.setState({ professional_Body });
		}
	}

	onOtherEducationalChange = (e, i) => {
		const { name, value } = e.target;
		const other_courses = [...this.state.other_courses];
		other_courses[i] = { ...other_courses[i], [name]: value };
		this.setState({ other_courses });
	};
	onAddOtherEducation = () => {
		this.setState((prevState) => ({
			other_courses: [
				...prevState.other_courses,
				{
					other_qualification_course: "",
					other_qualification_level: "",
					other_qualification_title: "",
					other_qualification_date: "",
					other_qualification_date_expiry: "",
					fileName: "",
					filePath: "",
				},
			],
		}));
	};

	add_professional_body = () => {
		this.setState((prevState) => ({
			professional_Body: [
				...prevState.professional_Body,
				{
					professionalBody: "",
					pinRef: "",
					professionalBodyExpiry: "",
					fileName: "",
					filePath: "",
				},
			],
		}));
	};

	removeOtherCourses(evt, i, id) {
		evt.preventDefault();
		if (id) {
			request({
				url: "/candidate/form/deleteOtherEducationData",
				method: "POST",
				data: { othr_edu_id: id },
			}).then((res) => {
				if (res.status === 1) {
					toast.success("Removed");
					this.componentDidMount();
					this.setState({ activeTab: "2" });
				} else if (res.status === 0) {
					toast.error("Error in File");
				}
			});
		} else {
			const other_courses = [...this.state.other_courses];
			other_courses.splice(i, 1);
			this.setState({ other_courses });
		}
	}
	/* Qualifications END */

	/* Skills and Work History */
	createWorkExperienceUI() {
		return this.state.work_experience.map((el, i) => (
			<tr key={i}>
				<td>
					<AvField
						name="work_title"
						type="text"
						// label="Work Title"
						onChange={(e) => this.onWorkExperienceChange(e, i)}
						value={el.work_title}
					/>
				</td>
				<td>
					<AvField
						name="employer"
						type="text"
						// label="Work Title"
						onChange={(e) => this.onWorkExperienceChange(e, i)}
						value={el.employer}
					/>
				</td>
				<td>
					<Datetime
						name="work_from_date"
						dateFormat="DD-MM-YYYY"
						timeFormat={false}
						closeOnSelect={true}
						value={
							el.work_from_date === "" ||
								String(el.work_from_date) === String(undefined) ||
								String(el.work_from_date) === String(null) ||
								String(el.work_from_date) === String("Invalid date")
								? ""
								: moment(el.work_from_date).format("DD-MM-YYYY")
						}
						inputProps={{
							placeholder: "Select Date",
						}}
						// isValidDate={current => current.isBefore(moment('').subtract(18, "years"))}
						onChange={(e) => {
							if (e._isValid) {
								// console.log("e",e)

								const work_experience = [...this.state.work_experience];
								work_experience[i] = {
									...work_experience[i],
									work_from_date: e,
								};
								this.setState({ work_experience });
							} else if (!e) {
								const work_experience = [...this.state.work_experience];
								work_experience[i] = {
									...work_experience[i],
									work_from_date: null,
								};
								this.setState({ work_experience });
							} else {
								const work_experience = [...this.state.work_experience];
								work_experience[i] = {
									...work_experience[i],
									work_from_date: null,
								};
								this.setState({ work_experience });
							}
						}}
					/>
				</td>
				<td>
					<Datetime
						name="work_to_date"
						dateFormat="DD-MM-YYYY"
						timeFormat={false}
						closeOnSelect={true}
						value={
							el.work_to_date === "" ||
								String(el.work_from_date) === String(undefined) ||
								String(el.work_from_date) === String(null) ||
								String(el.work_from_date) === String("Invalid date")
								? ""
								: moment(el.work_to_date).format("DD-MM-YYYY")
						}
						inputProps={{
							placeholder: "Select Date",
						}}
						// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
						onChange={(e) => {
							if (e._isValid) {
								// console.log("e",e)

								const work_experience = [...this.state.work_experience];
								work_experience[i] = {
									...work_experience[i],
									work_to_date: e,
								};
								this.setState({ work_experience });
							} else if (!e) {
								const work_experience = [...this.state.work_experience];
								work_experience[i] = {
									...work_experience[i],
									work_to_date: null,
								};
								this.setState({ work_experience });
							} else {
								const work_experience = [...this.state.work_experience];
								work_experience[i] = {
									...work_experience[i],
									work_to_date: null,
								};
								this.setState({ work_experience });
							}
						}}
					/>
				</td>
				<td>
					<button
						className="remove_btn_emp"
						value="remove"
						onClick={(e) => this.removeWorkExperience(e, i)}
					>
						<i className="fa fa-times" aria-hidden="true"></i>
					</button>
				</td>
			</tr>
		));
	}

	onWorkExperienceChange = (e, i) => {
		const { name, value } = e.target;
		const work_experience = [...this.state.work_experience];
		work_experience[i] = { ...work_experience[i], [name]: value };
		this.setState({ work_experience });
	};

	onAddWorkExperience = () => {
		this.setState((prevState) => ({
			work_experience: [
				...prevState.work_experience,
				{
					work_title: "",
					employer: "",
					work_from_date: "",
					work_to_date: "",
				},
			],
		}));
	};

	removeWorkExperience(evt, i) {
		evt.preventDefault();
		const work_experience = [...this.state.work_experience];
		work_experience.splice(i, 1);
		this.setState({ work_experience });
	}
	/* Skills and Work History */

	uploadImportantDocuments = (
		evt,
		document,
		educationCourse,
		educationCourseID
	) => {
		evt.persist();
		if (evt) {
			const file_data = evt.target.files[0];
			const file_split = file_data.type.split("/");
			if (
				file_split[1] === "pdf" ||
				file_split[1] === "png" ||
				file_split[1] === "jpeg" ||
				file_split[1] === "jpg"
			) {
				if (file_data.size < 5242880) {
					this.files_api(
						file_data || null,
						document,
						educationCourse,
						educationCourseID
					);
				} else {
					toast.error("Maximum upload size is 5MB");
				}
			} else {
				toast.error("File Format not supported");
			}
		}
	};
	files_api(uploadfiles, filefor, educationCourse, educationCourseID) {
		let toastId = "employee_files_save_form_01";
		toastId = toast.info("Please Wait......", { autoClose: false });
		const data = new FormData();
		data.append("filefor", filefor);
		data.append("uploadfiles", uploadfiles);
		data.append("educationCourse", educationCourse);
		data.append("educationCourseID", educationCourseID);
		request({
			url: "/employees/apply-online-form/save-files",
			method: "POST",
			data,
		}).then((res) => {
			if (res.status === 1) {
				toast.update(toastId, {
					render: res.response,
					type: toast.TYPE.SUCCESS,
					autoClose: 2500,
				});
				if (String(filefor) === "passport") {
					this.setState({ passportdocs: res.avatar });
				}
				if (String(filefor) === "visa") {
					this.setState({ visadocs: res.avatar });
				}
				if (String(filefor) === "driving") {
					this.setState({ drivingdocs: res.avatar });
				}
				if (String(filefor) === "education") {
					this.setState({ educationdocs: res.avatar });
				}
				if (String(filefor) === "othereducation") {
					this.setState({ othereducationdocs: res.avatar });
				}
				if(String(filefor) === "dbs") {
					this.setState({ dbsdocs: res.avatar})
				}
				// this.componentDidMount();
				if (
					String(this.state.skip_for_edu_qu) === String(false) &&
					String(filefor) === "education" &&
					this.state.education_qualification &&
					this.state.education_qualification.length > 1
				) {
					this.setState({
						apply_to_all_pop: true,
						apply_id: educationCourseID,
					});
				}
				if (
					String(this.state.skip_for_other_qu) === String(false) &&
					String(filefor) === "othereducation" &&
					this.state.other_courses &&
					this.state.other_courses.length > 1
				) {
					this.setState({
						apply_to_all_pop_other: true,
						apply_id_other: educationCourseID,
					});
				}
			} else if (res.status === 0) {
				toast.update(toastId, {
					render: res.response,
					type: toast.TYPE.ERROR,
					autoClose: 2500,
				});
			}
		});
	}

	checking_name = (evt, id) => {
		let value = evt.target.checked;
		this.state.education_qualification
			.filter((item, index) => {
				if (String(id) === String(item._id)) {
					return item;
				}
			})
			.map((item, index) => {
				let obj = {};
				obj = item;
				obj.checked = value;
				return obj;
			});
	};

	checking_name_other = (evt, id) => {
		let value = evt.target.checked;
		this.state.other_courses
			.filter((item, index) => {
				if (String(id) === String(item._id)) {
					return item;
				}
			})
			.map((item, index) => {
				let obj = {};
				obj = item;
				obj.checked = value;
				return obj;
			});
	};

	question_popup = () => {
		return (
			<>
				{this.state.education_qualification
					.filter((item, index) => {
						if (String(this.state.apply_id) !== String(item._id)) {
							return item;
						}
					})
					.map((item, index) => {
						return (
							<div key={index}>
								<Row>
									<Col className="che-box">
										<input
											type="checkbox"
											name={`checked${index}`}
											onChange={(e) => this.checking_name(e, item._id)}
										/>{" "}
										{item.qualification_course}{" "}
									</Col>
								</Row>
							</div>
						);
					})}
			</>
		);
	};

	question_popup_other = () => {
		return (
			<>
				{this.state.other_courses
					.filter((item, index) => {
						if (String(this.state.apply_id_other) !== String(item._id)) {
							return item;
						}
					})
					.map((item, index) => {
						return (
							<div key={index}>
								<Row>
									<Col className="che-box">
										<input
											type="checkbox"
											name={`checked${index}`}
											onChange={(e) => this.checking_name_other(e, item._id)}
										/>{" "}
										{item.other_qualification_course}{" "}
									</Col>
								</Row>
							</div>
						);
					})}
			</>
		);
	};

	check_skip = (evt) => {
		let value = evt.target.checked;
		this.setState({ skip_for_edu_qu: String(value) });
	};

	skip_popup = () => {
		return (
			<>
				<div>
					<Row>
						<Col className="che-box">
							<input
								type="checkbox"
								name={`skip_for_edu_qu`}
								onChange={(e) => this.check_skip(e)}
							/>{" "}
							Skip{" "}
						</Col>
					</Row>
				</div>
			</>
		);
	};

	yes_skip_qualification = () => {
		let { skip_for_edu_qu } = this.state;
		if (String(skip_for_edu_qu) === String(true)) {
			console.log("true", skip_for_edu_qu);
		} else {
			if (String(skip_for_edu_qu) === String(false)) {
				console.log("false", skip_for_edu_qu);
			} else {
				return toast.info("Select Skip for this process");
			}
		}
		localStorage.setItem("skip_for_edu", String(skip_for_edu_qu));
		this.setState({ apply_to_all_pop: !this.state.apply_to_all_pop });
	};

	check_skip_other = (evt) => {
		let value = evt.target.checked;
		this.setState({ skip_for_other_qu: String(value) });
	};

	skip_popup_other = () => {
		return (
			<>
				<div>
					<Row>
						<Col className="che-box">
							<input
								type="checkbox"
								name={`skip_for_other_qu`}
								onChange={(e) => this.check_skip_other(e)}
							/>{" "}
							Skip{" "}
						</Col>
					</Row>
				</div>
			</>
		);
	};

	yes_skip_qualification_other = () => {
		let { skip_for_other_qu } = this.state;
		if (String(skip_for_other_qu) === String(true)) {
			console.log("true", skip_for_other_qu);
		} else {
			if (String(skip_for_other_qu) === String(false)) {
				console.log("false", skip_for_other_qu);
			} else {
				return toast.info("Select Skip for this process");
			}
		}
		localStorage.setItem("skip_for_other", String(skip_for_other_qu));
		this.setState({
			apply_to_all_pop_other: !this.state.apply_to_all_pop_other,
		});
	};

	createPassportUploadUI() {
		return (
			<>
				<tr>
					<td>
						<AvGroup className="upload-abs">
							<div className="upload-gals">
								<img src={upload} alt="images" />
							</div>
							<AvInput
								encType="multipart/form-data"
								type="file"
								name="upload_doc"
								accept="application/pdf,.pdf,image/*"
								onChange={(e) => this.uploadImportantDocuments(e, "passport")}
							/>

							{/* <p className="file-output"> sdsdd </p> */}
						</AvGroup>
					</td>
				</tr>
			</>
		);
	}
	createDrivingUploadUI() {
		return (
			<>
				<tr>
					<td>
						<AvGroup className="upload-abs">
							<div className="upload-gals">
								<img src={upload} alt="images" />
							</div>
							<AvInput
								encType="multipart/form-data"
								type="file"
								title="upload"
								name="upload_doc"
								accept="application/pdf,.pdf,image/*"
								onChange={(e) => this.uploadImportantDocuments(e, "driving")}
							/>
							{/* <p className="file-output"> sdsdd </p> */}
						</AvGroup>
					</td>
				</tr>
			</>
		);
	}

	createDBSUploadUI() {
		return (
			<>
				<tr>
					<td>
						<AvGroup className="upload-abs">
							<div className="upload-gals">
								<img src={upload} alt="images" />
							</div>
							<AvInput
								encType="multipart/form-data"
								type="file"
								title="upload"
								name="upload_doc"
								accept="application/pdf,.pdf,image/*"
								onChange={(e) => this.uploadImportantDocuments(e, "dbs")}
							/>
							{/* <p className="file-output"> sdsdd </p> */}
						</AvGroup>
					</td>
				</tr>
			</>
		);
	}

	createVisaUploadUI() {
		return (
			<>
				<tr>
					<td>
						<AvGroup className="upload-abs">
							<div className="upload-gals">
								<img src={upload} alt="images" />
							</div>
							<AvInput
								encType="multipart/form-data"
								type="file"
								name="upload_doc"
								accept="application/pdf,.pdf,image/*"
								onChange={(e) => this.uploadImportantDocuments(e, "visa")}
							/>
							{/* <p className="file-output"> sdsdd </p> */}
						</AvGroup>
					</td>
				</tr>
			</>
		);
	}
	createQualificationUploadUI() {
		return this.state.education_qualification.map((el, i) => (
			<>
				<tr key={i}>
					<td>
						<label>{el.qualification_course}</label>
					</td>

					<td>
						{/* <Input type="file" name="document_upload" id="documentupload" /> */}
						<AvGroup className="upload-abs">
							<div className="upload-gals">
								<img src={upload} alt="images" />
							</div>
							<AvInput
								encType="multipart/form-data"
								type="file"
								name="upload_doc"
								accept="application/pdf,.pdf,image/*"
								onChange={(e) =>
									this.uploadImportantDocuments(
										e,
										"education",
										el.qualification_course,
										el._id
									)
								}
							/>
							{/* <p className="file-output"> sdsdd </p> */}
						</AvGroup>
					</td>
					<td>
						{this.state &&
							this.state.educationdocs &&
							this.state.educationdocs.length > 0 &&
							this.state.educationdocs.map((list, i) =>
								el._id === list.courseID ? (
									<>
										<div className="documentlist">
											<span>
												<button
													className="trash-bttn"
													onClick={(e) =>
														this.deleteDocs(e, list._id, list.path, "education")
													}
												>
													<span>
														<i
															className="fa fa-trash-o"
															style={{
																fontSize: 16,
																color: "#e4566e",
																cursor: "pointer",
															}}
															aria-hidden="true"
														/>
													</span>
												</button>
											</span>
											<img
												src={pdf}
												className="fileviewimg"
												style={{ cursor: "pointer" }}
												alt="files"
												onClick={() => this.FileView(list.path)}
											/>
											<span className="documents-name">
												{list && list.name}{" "}
											</span>
										</div>
									</>
								) : null
							)}
					</td>
				</tr>
			</>
		));
	}
	createOtherQualificationUploadUI() {
		return this.state.other_courses.map((el, i) => (
			<>
				<tr key={i}>
					<td>
						<label>{el.other_qualification_course}</label>
					</td>

					<td>
						{/* <Input type="file" name="document_upload" id="documentupload" /> */}
						<AvGroup className="upload-abs">
							<div className="upload-gals">
								<img src={upload} alt="images" />
							</div>
							<AvInput
								encType="multipart/form-data"
								type="file"
								name="upload_doc"
								accept="application/pdf,.pdf,image/*"
								onChange={(e) =>
									this.uploadImportantDocuments(
										e,
										"othereducation",
										el.other_qualification_course,
										el._id
									)
								}
							/>
							{/* <p className="file-output"> sdsdd </p> */}
						</AvGroup>
					</td>
					<td>
						<div className="list-spaces">
							{this.state &&
								this.state.othereducationdocs &&
								this.state.othereducationdocs.length > 0 &&
								this.state.othereducationdocs.map((list, i) =>
									el._id === list.courseID ? (
										<>
											<div className="documentlist">
												<span>
													<button
														className="trash-bttn"
														onClick={(e) =>
															this.deleteDocs(
																e,
																list._id,
																list.path,
																"othereducation"
															)
														}
													>
														<span>
															<i
																className="fa fa-trash-o"
																style={{
																	fontSize: 16,
																	color: "#e4566e",
																	cursor: "pointer",
																}}
																aria-hidden="true"
															/>
														</span>
													</button>
												</span>
												<img
													src={pdf}
													className="fileviewimg"
													style={{ cursor: "pointer" }}
													alt="files"
													onClick={() => this.FileView(list.path)}
												/>
												<span className="documents-name">
													{list && list.name}{" "}
												</span>
											</div>
										</>
									) : null
								)}
						</div>
					</td>
				</tr>
			</>
		));
	}
	/* Documents */
	createDocumentsUI() {
		return (
			<>
				<thead>
					<tr>
						<th className="col-lg-4">Document Title/Name</th>
						<th className="col-lg-4">Is there an expiry date?</th>
						<th className="col-lg-3">Upload</th>
						<th className="col-lg-1"></th>
					</tr>
				</thead>
				<tbody>
					{this.state.documents.map((el, i) => {
						// const docExpiry = _.get(this.state.documents, `${i}.document_expiry_${i}`, false);
						// const docExpiryDate = _.get(this.state.documents, `${i}.document_expiry_date_${i}`, "");
						// const docDate = `document_expiry_date`;
						// const docUpload = `other_doc`;
						// const docExpiryName = `document_expiry`;
						return (
							<tr key={i}>
								<td style={{ width: "250px" }}>
									<AvGroup>
										<AvInput
											type="text"
											name="document_title"
											onChange={(e) => this.onChangeDocuments(e, i)}
											value={
												el[`document_title_${i}`]
													? el[`document_title_${i}`]
													: el.document_title
											}
										/>
										{/* <AvFeedback>Doc title is required!</AvFeedback> */}
									</AvGroup>
								</td>
								<td style={{ width: "150px" }}>
									<Row className="expiry-container">
										<Col lg={"1"}>
											<div className="expiry_checkbox">
												<input
													type="checkbox"
													name="document_expiry"
													className="doc_details"
													checked={
														el[`document_expiry_${i}`] || el.document_expiry
															? true
															: false
													}
													onChange={(e) => {
														e.persist();
														const { name, checked } = e.target;
														const documents = [...this.state.documents];
														documents[i] = { ...documents[i], [name]: checked };
														this.setState({ documents });
														// this.setState({ documents }, () => {
														// 	let checkVal = (this.state.documents.filter((o) => { return o[docExpiryName] === true })).length > 0 ? true : false;
														// 	this.setState({ showExpiryTD: checkVal });
														// });
													}}
												/>
											</div>
										</Col>
										<Col lg={"11"}>
											{el[`document_expiry_${i}`] || el.document_expiry ? (
												<div className="expiry_box">
													<td style={{ width: "250px" }}>
														<Datetime
															name="document_expiry_date"
															dateFormat="DD-MM-YYYY"
															timeFormat={false}
															closeOnSelect={true}
															value={
																el[`document_expiry_date_${i}`] !== undefined &&
																	el[`document_expiry_date_${i}`] !== ""
																	? moment(
																		el[`document_expiry_date_${i}`]
																	).format("DD-MM-YYYY")
																	: el.document_expiry_date !== undefined &&
																		el.document_expiry_date !== ""
																		? moment(el.document_expiry_date).format(
																			"DD-MM-YYYY"
																		)
																		: ""
															}
															inputProps={{ placeholder: "Select Date" }}
															onChange={(e) => {
																if (e._isValid) {
																	const documents = [...this.state.documents];
																	documents[i] = {
																		...documents[i],
																		document_expiry_date: e,
																	};
																	this.setState({ documents });
																} else if (!e) {
																	const documents = [...this.state.documents];
																	documents[i] = {
																		...documents[i],
																		document_expiry_date: null,
																	};
																	this.setState({ documents });
																} else {
																	const documents = [...this.state.documents];
																	documents[i] = {
																		...documents[i],
																		document_expiry_date: null,
																	};
																	this.setState({ documents });
																}
															}}
														/>
													</td>
												</div>
											) : null}
										</Col>
									</Row>
								</td>

								<td>
									{CheckValue(el.upload_doc) ? (
										<p className="down-uploads">
											<UncontrolledTooltip
												placement="bottom"
												target={`otherdocs${i}`}
											>
												View Document{" "}
											</UncontrolledTooltip>
											<img
												style={{ cursor: "pointer" }}
												src={pdf}
												alt="pdf"
												id={`otherdocs${i}`}
												onClick={(e) => {
													e.preventDefault();
													this.FileView(el.upload_doc);
												}}
											/>
											<button
												id={`otherdocs${i}`}
												type="button"
												className="trash-bttn"
												onClick={(e) => {
													e.preventDefault();
													this.setState({
														openPopover: {
															isOpen: true,
															matchedid: el.upload_doc,
														},
													});
												}}
											>
												<i className="fa fa-trash-o" aria-hidden="true"></i>
											</button>
											{this.state.openPopover &&
												this.state.openPopover.isOpen === true &&
												String(
													this.state.openPopover.matchedid ===
													String(el.upload_doc)
												) ? (
												<Popover
													toggle={(e) => this.popoverToggle(e)}
													placement="right"
													isOpen={
														this.state.openPopover.isOpen &&
														this.state.openPopover.matchedid === el.upload_doc
													}
													target={`otherdocs${i}`}
												>
													<PopoverHeader>Confirmation</PopoverHeader>
													<PopoverBody>
														<h6>Are You Sure, You Want To Delete ?</h6>
														<button
															type="button"
															title="Yes"
															className="btn btn-danger ml-4"
															color="success"
															onClick={(e) => {
																e.preventDefault();
																this.delete_Docs_other_docs(
																	e,
																	i,
																	el.upload_doc
																);
															}}
														>
															Yes
														</button>
														<button
															type="button"
															title="No"
															className="btn btn-secondary ml-4"
															color="secondary"
															onClick={(e) => {
																e.preventDefault();
																this.setState({
																	openPopover: { isOpen: false, matchedid: "" },
																});
															}}
														>
															No
														</button>
													</PopoverBody>
												</Popover>
											) : null}
										</p>
									) : (
										<p className="upper-uploads">
											<span>
												<img src={uploadRecruitment} alt="uploadRecruitment" />
												<input
													style={{ cursor: "pointer" }}
													type="file"
													name="upload_doc"
													accept="application/pdf,.pdf,image/*"
													onChange={(e) => this.uploadDocsArray(e, i)}
												/>
											</span>
										</p>
									)}
								</td>
								<td>
									<button
										className="remove-tabs"
										// style={style_in}
										title="remove"
										onClick={(e) => {
											this.removeDocuments(e, i);
										}}
									>
										<i className="fa fa-times" aria-hidden="true"></i>
									</button>
								</td>
							</tr>
						);
					})}
				</tbody>
			</>
		);
	}

	onAddDocuments = () => {
		this.setState((prevState) => ({ documents: [...prevState.documents, {}] }));
	};

	onChangeDocuments = (e, i) => {
		e.persist();
		const { name, value } = e.target;
		const documents = [...this.state.documents];
		documents[i] = { ...documents[i], [name]: value };
		this.setState({ documents });
	};

	uploadDocsArray = (evt, i) => {
		evt.persist();
		if (evt) {
			const file_data = evt.target.files[0];
			const file_split = file_data.type.split("/");
			if (
				file_split[1] !== "exe" &&
				file_split[1] !== "zip" &&
				file_split[1] !== "rar"
			) {
				if (file_data.size < 5242880) {
					const data = new FormData();
					data.append("upload_doc", file_data);
					request({
						url: "/candidate/form/addFilestoLocalDB",
						method: "POST",
						data,
					}).then((res) => {
						const documents = [...this.state.documents];
						documents[i] = { ...documents[i], upload_doc: res.file_path };
						this.setState({ documents });
					});
				} else {
					toast.error("Maximum upload size is 5MB");
					this.setState({ upload_doc: undefined });
				}
			} else {
				toast.error("File Format not supported");
				this.setState({ upload_doc: null });
			}
		}
	};

	removeDocuments(evt, i) {
		evt.preventDefault();
		evt.stopPropagation();
		const documents = [...this.state.documents];
		documents.splice(i, 1);
		this.setState({ documents });
	}
	/* Documents */

	bankPhoneHandler = (status, value, countryData, number, id) => {
		if (status === true) {
			this.setState({
				bankPhoneError: false,
			});
		} else {
			this.setState({
				bankPhoneError: true,
			});
		}
		this.setState({
			bankMobileNo: {
				number: value,
				code: countryData.dialCode,
				dialcountry: countryData.iso2,
			},
		});
	};

	locationsselect = (value) => {
		if (value && Array.isArray(value) && value.length > 0) {
			this.setState({
				locations: value,
				locationsValue: value,
				jobareaError: false,
				isFormErrors: false,
			});
		} else {
			this.setState({ locations: [], locationsValue: [], jobareaError: true });
		}
	};
	jobtypeselect = (value) => {
		if (value && Array.isArray(value) && value.length > 0) {
			this.setState({
				job_type: value,
				job_typeValue: value,
				jobroleError: false,
				isFormErrors: false,
			});
		} else {
			this.setState({ job_type: [], job_typeValue: [], jobroleError: true });
		}
	};

	clear = () => {
		this.sigPad.clear();
	};

	openModal = (e) => {
		e.preventDefault();
		this.setState({ showModal: true });
	};
	workingTimeSignatureModal = (e) => {
		e.preventDefault();
		this.setState({
			openWorkingTimeSignature: !this.state.openWorkingTimeSignature,
		});
	};

	toggleModal = () => {
		this.setState({ showModal: !this.state.showModal });
	};
	saveTextSignature = () => {
		if (this.state.job_type.length === 0) {
			return toast.error("Job role is required");
		}
		if (this.state.locations.length === 0) {
			return toast.error("Area is required");
		}
		const data = new FormData();
		data.append("signatureText", this.state.signatureText);
		data.append("for", "text");
		data.append("port", window.location.port);
		data.append("hostname", window.location.hostname);
		data.append("protocol", window.location.protocol);
		data.append(
			"medicalhistory[medicalillness]",
			this.state.medicalillness &&
				String(this.state.medicalillness) !== String(undefined) &&
				this.state.medicalillness.length > 0
				? this.state.medicalillness
				: ""
		);
		data.append(
			"medicalhistory[medicalillness_notes]",
			this.state.medicalillness_notes &&
				String(this.state.medicalillness_notes) !== String(undefined) &&
				this.state.medicalillness_notes.length > 0
				? this.state.medicalillness_notes
				: ""
		);
		data.append(
			"medicalhistory[medicalillnesscaused]",
			this.state.medicalillnesscaused &&
				String(this.state.medicalillnesscaused) !== String(undefined) &&
				this.state.medicalillnesscaused.length > 0
				? this.state.medicalillnesscaused
				: ""
		);
		data.append(
			"medicalhistory[medicalillnesscaused_notes]",
			this.state.medicalillnesscaused_notes &&
				String(this.state.medicalillnesscaused_notes) !== String(undefined) &&
				this.state.medicalillnesscaused_notes.length > 0
				? this.state.medicalillnesscaused_notes
				: ""
		);
		data.append(
			"medicalhistory[treatment]",
			this.state.treatment &&
				String(this.state.treatment) !== String(undefined) &&
				this.state.treatment.length > 0
				? this.state.treatment
				: ""
		);
		data.append(
			"medicalhistory[treatment_notes]",
			this.state.treatment_notes &&
				String(this.state.treatment_notes) !== String(undefined) &&
				this.state.treatment_notes.length > 0
				? this.state.treatment_notes
				: ""
		);
		data.append(
			"medicalhistory[needanyadjustments]",
			this.state.needanyadjustments &&
				String(this.state.needanyadjustments) !== String(undefined) &&
				this.state.needanyadjustments.length > 0
				? this.state.needanyadjustments
				: ""
		);
		data.append(
			"medicalhistory[needanyadjustmentsnotes]",
			this.state.needanyadjustmentsnotes &&
				String(this.state.needanyadjustmentsnotes) !== String(undefined) &&
				this.state.needanyadjustmentsnotes.length > 0
				? this.state.needanyadjustmentsnotes
				: ""
		);

		data.append(
			"tuberculosis[livedUK]",
			this.state.livedUK &&
				String(this.state.livedUK) !== String(undefined) &&
				this.state.livedUK.length > 0
				? this.state.livedUK
				: ""
		);
		data.append(
			"tuberculosis[livedUKnotes]",
			this.state.livedUKnotes &&
				String(this.state.livedUKnotes) !== String(undefined) &&
				this.state.livedUKnotes.length > 0
				? this.state.livedUKnotes
				: ""
		);
		data.append(
			"tuberculosis[BCGvaccination]",
			this.state.BCGvaccination &&
				String(this.state.BCGvaccination) !== String(undefined) &&
				this.state.BCGvaccination.length > 0
				? this.state.BCGvaccination
				: ""
		);
		data.append(
			"tuberculosis[cough]",
			this.state.cough &&
				String(this.state.cough) !== String(undefined) &&
				this.state.cough.length > 0
				? this.state.cough
				: ""
		);
		data.append(
			"tuberculosis[weightloss]",
			this.state.weightloss &&
				String(this.state.weightloss) !== String(undefined) &&
				this.state.weightloss.length > 0
				? this.state.weightloss
				: ""
		);
		data.append(
			"tuberculosis[fever]",
			this.state.fever &&
				String(this.state.fever) !== String(undefined) &&
				this.state.fever.length > 0
				? this.state.fever
				: ""
		);
		data.append(
			"tuberculosis[TB]",
			this.state.TB &&
				String(this.state.TB) !== String(undefined) &&
				this.state.TB.length > 0
				? this.state.TB
				: ""
		);

		data.append(
			"criminal_records[criminaloffence]",
			this.state.criminaloffence &&
				String(this.state.criminaloffence) !== String(undefined) &&
				this.state.criminaloffence.length > 0
				? this.state.criminaloffence
				: ""
		);
		data.append(
			"criminal_records[criminalCautioned]",
			this.state.criminalCautioned &&
				String(this.state.criminalCautioned) !== String(undefined) &&
				this.state.criminalCautioned.length > 0
				? this.state.criminalCautioned
				: ""
		);
		data.append(
			"criminal_records[criminalConvictions]",
			this.state.criminalConvictions &&
				String(this.state.criminalConvictions) !== String(undefined) &&
				this.state.criminalConvictions.length > 0
				? this.state.criminalConvictions
				: ""
		);
		data.append(
			"criminal_records[criminalCourt]",
			this.state.criminalCourt &&
				String(this.state.criminalCourt) !== String(undefined) &&
				this.state.criminalCourt.length > 0
				? this.state.criminalCourt
				: ""
		);
		data.append(
			"criminal_records[criminalDisciplinaryAction]",
			this.state.criminalDisciplinaryAction &&
				String(this.state.criminalDisciplinaryAction) !== String(undefined) &&
				this.state.criminalDisciplinaryAction.length > 0
				? this.state.criminalDisciplinaryAction
				: ""
		);
		data.append(
			"criminal_records[criminalAdditionalInformation]",
			this.state.criminalAdditionalInformation &&
				String(this.state.criminalAdditionalInformation) !==
				String(undefined) &&
				this.state.criminalAdditionalInformation.length > 0
				? this.state.criminalAdditionalInformation
				: ""
		);

		data.append("dbsDeclaration[dbsAccept]", this.state.dbsAccept);
		data.append("dbsDeclaration[date]", this.state.dbsAcceptDate);

		data.append("id_indemnity_verification", this.state.indemnityAccept);

		data.append(
			"disable_act[registereddisabled]",
			this.state.registereddisabled &&
				String(this.state.registereddisabled) !== String(undefined) &&
				this.state.registereddisabled.length > 0
				? this.state.registereddisabled
				: ""
		);
		data.append(
			"disable_act[disableRegisteredDetails]",
			this.state.disableRegisteredDetails &&
				String(this.state.disableRegisteredDetails) !== String(undefined) &&
				this.state.disableRegisteredDetails.length > 0
				? this.state.disableRegisteredDetails
				: ""
		);
		data.append(
			"disable_act[disableAct]",
			this.state.disableAct &&
				String(this.state.disableAct) !== String(undefined) &&
				this.state.disableAct.length > 0
				? this.state.disableAct
				: ""
		);
		data.append(
			"disable_act[disableActDetails]",
			this.state.disableActDetails &&
				String(this.state.disableActDetails) !== String(undefined) &&
				this.state.disableActDetails.length > 0
				? this.state.disableActDetails
				: ""
		);
		data.append(
			"disable_act[disableOverCome]",
			this.state.disableOverCome &&
				String(this.state.disableOverCome) !== String(undefined) &&
				this.state.disableOverCome.length > 0
				? this.state.disableOverCome
				: ""
		);

		data.append(
			"disable_act[disableOverComeDetails]",
			this.state.disableOverComeDetails &&
				String(this.state.disableOverComeDetails) !== String(undefined) &&
				this.state.disableOverComeDetails.length > 0
				? this.state.disableOverComeDetails
				: ""
		);

		data.append(
			"declaration[declarationAccept]",
			this.state.declarationAccept || ""
		);
		data.append(
			"declaration[declarationAcceptDate]",
			this.state.declarationAcceptDate || ""
		);
		data.append("worktimedirectives[date]", this.state.workTimeDate || "");
		data.append(
			"worktimedirectives[signature]",
			this.state.workTimeSignature || ""
		);
		data.append(
			"healthDeclarationTerms[acceptHealthDeclaration]",
			this.state.acceptHealthDeclaration || ""
		);
		data.append(
			"healthDeclarationTerms[date]",
			this.state.HealthDeclarationDate || ""
		);
		data.append(
			"personalDeclarationTerms[acceptPersonalDeclaration]",
			this.state.acceptPersonalDeclaration || ""
		);
		data.append(
			"personalDeclarationTerms[date]",
			this.state.PersonalDeclarationDate || ""
		);
		data.append(
			"confidentialityTerms[acceptConfidentiality]",
			this.state.acceptConfidentiality || ""
		);
		data.append(
			"confidentialityTerms[date]",
			this.state.ConfidentialityDate || ""
		);

		request({
			url: "/employee/update/signature",
			method: "post",
			data,
		})
			.then((res) => {
				if (res && +res.status === 1) {
					// toast.success(res.response);
					// this.componentDidMount("signature");
					this.setState({
						showModal: !this.state.showModal,
						signatureText: "",
					});
				} else {
					toast.info(res.response);
				}
			})
			.catch((err) => {
				toast.error("Something Went wrong");
				console.log("err", err);
			});
	};

	trim = () => {
		if (this.sigPad.isEmpty() === false) {
			let image = this.sigPad.getTrimmedCanvas().toDataURL("image/png");
			fetch(image)
				.then((res) => res.blob())
				.then((blob) => {
					const file = new File([blob], "png", { type: "image/png" });
					const data = new FormData();
					data.append("signature", file);
					data.append("port", window.location.port);
					data.append("hostname", window.location.hostname);
					data.append("protocol", window.location.protocol);

					data.append(
						"medicalhistory[medicalillness]",
						this.state.medicalillness &&
							String(this.state.medicalillness) !== String(undefined) &&
							this.state.medicalillness.length > 0
							? this.state.medicalillness
							: ""
					);
					data.append(
						"medicalhistory[medicalillness_notes]",
						this.state.medicalillness_notes &&
							String(this.state.medicalillness_notes) !== String(undefined) &&
							this.state.medicalillness_notes.length > 0
							? this.state.medicalillness_notes
							: ""
					);
					data.append(
						"medicalhistory[medicalillnesscaused]",
						this.state.medicalillnesscaused &&
							String(this.state.medicalillnesscaused) !== String(undefined) &&
							this.state.medicalillnesscaused.length > 0
							? this.state.medicalillnesscaused
							: ""
					);
					data.append(
						"medicalhistory[medicalillnesscaused_notes]",
						this.state.medicalillnesscaused_notes &&
							String(this.state.medicalillnesscaused_notes) !==
							String(undefined) &&
							this.state.medicalillnesscaused_notes.length > 0
							? this.state.medicalillnesscaused_notes
							: ""
					);
					data.append(
						"medicalhistory[treatment]",
						this.state.treatment &&
							String(this.state.treatment) !== String(undefined) &&
							this.state.treatment.length > 0
							? this.state.treatment
							: ""
					);
					data.append(
						"medicalhistory[treatment_notes]",
						this.state.treatment_notes &&
							String(this.state.treatment_notes) !== String(undefined) &&
							this.state.treatment_notes.length > 0
							? this.state.treatment_notes
							: ""
					);
					data.append(
						"medicalhistory[needanyadjustments]",
						this.state.needanyadjustments &&
							String(this.state.needanyadjustments) !== String(undefined) &&
							this.state.needanyadjustments.length > 0
							? this.state.needanyadjustments
							: ""
					);
					data.append(
						"medicalhistory[needanyadjustmentsnotes]",
						this.state.needanyadjustmentsnotes &&
							String(this.state.needanyadjustmentsnotes) !==
							String(undefined) &&
							this.state.needanyadjustmentsnotes.length > 0
							? this.state.needanyadjustmentsnotes
							: ""
					);

					data.append(
						"tuberculosis[livedUK]",
						this.state.livedUK &&
							String(this.state.livedUK) !== String(undefined) &&
							this.state.livedUK.length > 0
							? this.state.livedUK
							: ""
					);
					data.append(
						"tuberculosis[livedUKnotes]",
						this.state.livedUKnotes &&
							String(this.state.livedUKnotes) !== String(undefined) &&
							this.state.livedUKnotes.length > 0
							? this.state.livedUKnotes
							: ""
					);
					data.append(
						"tuberculosis[BCGvaccination]",
						this.state.BCGvaccination &&
							String(this.state.BCGvaccination) !== String(undefined) &&
							this.state.BCGvaccination.length > 0
							? this.state.BCGvaccination
							: ""
					);
					data.append(
						"tuberculosis[cough]",
						this.state.cough &&
							String(this.state.cough) !== String(undefined) &&
							this.state.cough.length > 0
							? this.state.cough
							: ""
					);
					data.append(
						"tuberculosis[weightloss]",
						this.state.weightloss &&
							String(this.state.weightloss) !== String(undefined) &&
							this.state.weightloss.length > 0
							? this.state.weightloss
							: ""
					);
					data.append(
						"tuberculosis[fever]",
						this.state.fever &&
							String(this.state.fever) !== String(undefined) &&
							this.state.fever.length > 0
							? this.state.fever
							: ""
					);
					data.append(
						"tuberculosis[TB]",
						this.state.TB &&
							String(this.state.TB) !== String(undefined) &&
							this.state.TB.length > 0
							? this.state.TB
							: ""
					);

					data.append(
						"criminal_records[criminaloffence]",
						this.state.criminaloffence &&
							String(this.state.criminaloffence) !== String(undefined) &&
							this.state.criminaloffence.length > 0
							? this.state.criminaloffence
							: ""
					);
					data.append(
						"criminal_records[criminalCautioned]",
						this.state.criminalCautioned &&
							String(this.state.criminalCautioned) !== String(undefined) &&
							this.state.criminalCautioned.length > 0
							? this.state.criminalCautioned
							: ""
					);
					data.append(
						"criminal_records[criminalConvictions]",
						this.state.criminalConvictions &&
							String(this.state.criminalConvictions) !== String(undefined) &&
							this.state.criminalConvictions.length > 0
							? this.state.criminalConvictions
							: ""
					);
					data.append(
						"criminal_records[criminalCourt]",
						this.state.criminalCourt &&
							String(this.state.criminalCourt) !== String(undefined) &&
							this.state.criminalCourt.length > 0
							? this.state.criminalCourt
							: ""
					);
					data.append(
						"criminal_records[criminalDisciplinaryAction]",
						this.state.criminalDisciplinaryAction &&
							String(this.state.criminalDisciplinaryAction) !==
							String(undefined) &&
							this.state.criminalDisciplinaryAction.length > 0
							? this.state.criminalDisciplinaryAction
							: ""
					);
					data.append(
						"criminal_records[criminalAdditionalInformation]",
						this.state.criminalAdditionalInformation &&
							String(this.state.criminalAdditionalInformation) !==
							String(undefined) &&
							this.state.criminalAdditionalInformation.length > 0
							? this.state.criminalAdditionalInformation
							: ""
					);

					data.append("dbsDeclaration[dbsAccept]", this.state.dbsAccept);
					data.append("dbsDeclaration[date]", this.state.dbsAcceptDate);

					data.append("id_indemnity_verification", this.state.indemnityAccept);

					data.append(
						"disable_act[registereddisabled]",
						this.state.registereddisabled &&
							String(this.state.registereddisabled) !== String(undefined) &&
							this.state.registereddisabled.length > 0
							? this.state.registereddisabled
							: ""
					);
					data.append(
						"disable_act[disableRegisteredDetails]",
						this.state.disableRegisteredDetails &&
							String(this.state.disableRegisteredDetails) !==
							String(undefined) &&
							this.state.disableRegisteredDetails.length > 0
							? this.state.disableRegisteredDetails
							: ""
					);
					data.append(
						"disable_act[disableAct]",
						this.state.disableAct &&
							String(this.state.disableAct) !== String(undefined) &&
							this.state.disableAct.length > 0
							? this.state.disableAct
							: ""
					);
					data.append(
						"disable_act[disableActDetails]",
						this.state.disableActDetails &&
							String(this.state.disableActDetails) !== String(undefined) &&
							this.state.disableActDetails.length > 0
							? this.state.disableActDetails
							: ""
					);
					data.append(
						"disable_act[disableOverCome]",
						this.state.disableOverCome &&
							String(this.state.disableOverCome) !== String(undefined) &&
							this.state.disableOverCome.length > 0
							? this.state.disableOverCome
							: ""
					);

					data.append(
						"disable_act[disableOverComeDetails]",
						this.state.disableOverComeDetails &&
							String(this.state.disableOverComeDetails) !== String(undefined) &&
							this.state.disableOverComeDetails.length > 0
							? this.state.disableOverComeDetails
							: ""
					);

					data.append(
						"declaration[declarationAccept]",
						this.state.declarationAccept || ""
					);
					data.append(
						"declaration[declarationAcceptDate]",
						this.state.declarationAcceptDate || ""
					);
					data.append(
						"worktimedirectives[date]",
						this.state.workTimeDate || ""
					);
					data.append(
						"worktimedirectives[signature]",
						this.state.workTimeSignature || ""
					);
					data.append(
						"healthDeclarationTerms[acceptHealthDeclaration]",
						this.state.acceptHealthDeclaration || ""
					);
					data.append(
						"healthDeclarationTerms[date]",
						this.state.HealthDeclarationDate || ""
					);
					data.append(
						"personalDeclarationTerms[acceptPersonalDeclaration]",
						this.state.acceptPersonalDeclaration || ""
					);
					data.append(
						"personalDeclarationTerms[date]",
						this.state.PersonalDeclarationDate || ""
					);
					data.append(
						"confidentialityTerms[acceptConfidentiality]",
						this.state.acceptConfidentiality || ""
					);
					data.append(
						"confidentialityTerms[date]",
						this.state.ConfidentialityDate || ""
					);

					if (this.state.job_type.length === 0) {
						return toast.error("Job role is required");
					}
					if (this.state.locations.length === 0) {
						return toast.error("Area is required");
					}
					request({
						url: "/employee/update/signature",
						method: "post",
						data,
					})
						.then((res) => {
							if (res && +res.status === 1) {
								// toast.success(res.response);
								// this.componentDidMount("signature");
								this.setState({ signature: res.signature });
								this.setState({ showModal: !this.state.showModal });
							} else {
								toast.info(res.response);
							}
						})
						.catch((err) => {
							toast.error("Something Went wrong");
							console.log("err", err);
						});
				});
		} else {
			toast.error("Signature is required field.");
		}
	};
	saveWorkingTimeSignature = () => {
		if (this.sigPad.isEmpty() === false) {
			let image = this.sigPad.getTrimmedCanvas().toDataURL("image/png");
			fetch(image)
				.then((res) => res.blob())
				.then((blob) => {
					const file = new File([blob], "png", { type: "image/png" });
					const data = new FormData();
					data.append("signature", file);
					if (this.state.job_type.length === 0) {
						return toast.error("Job role is required");
					}
					if (this.state.locations.length === 0) {
						return toast.error("Area is required");
					}
					request({
						url: "/employee/update/worktime/signature",
						method: "post",
						data,
					})
						.then((res) => {
							if (res && +res.status === 1) {
								toast.success(res.response);
								// this.componentDidMount();
								this.setState({ workTimeSignature: res.workTimeSignature });
								this.setState({
									openWorkingTimeSignature:
										!this.state.openWorkingTimeSignature,
								});
							} else {
								toast.info(res.response);
							}
						})
						.catch((err) => {
							toast.error("Something Went wrong");
							console.log("err", err);
						});
				});
		} else {
			toast.error("Signature is required field.");
		}
	};
	saveWorkingTextSignature = () => {
		if (this.state.job_type.length === 0) {
			return toast.error("Job role is required");
		}
		if (this.state.locations.length === 0) {
			return toast.error("Area is required");
		}
		request({
			url: "/employee/update/worktime/signature",
			method: "post",
			data: {
				workingTimeSignatureText: this.state.workingTimeSignatureText,
				for: "text",
			},
		})
			.then((res) => {
				if (res && +res.status === 1) {
					toast.success(res.response);
					this.setState({ workTimeSignature: res.workingTimeSignatureText });
					// this.componentDidMount();
					this.setState({
						openWorkingTimeSignature: !this.state.openWorkingTimeSignature,
						workingTimeSignatureText: "",
					});
				} else {
					toast.info(res.response);
				}
			})
			.catch((err) => {
				toast.error("Something Went wrong");
				console.log("err", err);
			});
	};

	FileDownloader = (filepath, name) => {
		let toastId = "downloadfiles0101";
		toastId = toast.info("Please Wait......", { autoClose: false });
		if (filepath) {
			const file = NodeURL + "/" + filepath;
			FileSaver.saveAs(file, name);
			toast.update(toastId, {
				render: "File Downloaded!",
				type: toast.TYPE.SUCCESS,
				autoClose: 2500,
			});
		} else {
			toast.update(toastId, {
				render: "Unable to Download",
				type: toast.TYPE.ERROR,
				autoClose: 2500,
			});
		}
	};

	onSelectbank = (e) => {
		e.preventDefault();
		this.setState({ accountType: e.target.value });
	};

	onSelectChange = (e) => {
		e.preventDefault();
		this.setState({ [e.target.name]: e.target.value });
	};

	onSelectModuleChange = (value) => {
		if (value && value.value) {
			this.setState({
				nationality: value.value,
				national_ity: Array.of(value),
			});
		} else {
			this.setState({ nationality: "", national_ity: [] });
		}
	};

	vaccinationHistoryChange = (value) => {
		if (value && value.value) {
			this.setState({
				covidVaccination: value.value,
				covidVaccination_arr: Array.of(value),
			});
		} else {
			this.setState({ covidVaccination: "", covidVaccination_arr: [] });
		}
	};

	onSelectModule_Change = (value) => {
		if (value && value.value) {
			this.setState({ drivingCountryOfIssue: value.value });
		} else {
			this.setState({ drivingCountryOfIssue: "" });
		}
	};

	previous = (evt) => {
		evt.preventDefault();
		evt.stopPropagation();
		window.scrollTo(0, 0);
		let { mainActiveTab, activeTab } = this.state;
		if (mainActiveTab >= 2) {
			mainActiveTab = Number(mainActiveTab) - 1;
			this.setState({ mainActiveTab: String(mainActiveTab) });
		} else {
			activeTab = Number(activeTab) - 1;
			this.setState({ activeTab: String(activeTab) });
		}
	};

	next = (evt) => {
		evt.preventDefault();
		evt.stopPropagation();
		let { mainActiveTab, activeTab } = this.state;
		window.scrollTo(0, 0);

		if (activeTab >= 5) {
			mainActiveTab = Number(mainActiveTab) + 1;
			this.setState({ mainActiveTab: String(mainActiveTab) });
		} else {
			activeTab = Number(activeTab) + 1;
			this.setState({ activeTab: String(activeTab) });
		}
	};

	update_3_main_tab = (name) => {
		this.setState({ thi_main_tab_up_nxt: name });
	};

	reference_submiit = (evt) => {
		let { mainActiveTab, job_type, locations } = this.state;
		if (job_type.length === 0) {
			return toast.error("Job role is required");
		}
		if (locations.length === 0) {
			return toast.error("Area is required");
		}
		if (
			!this.state.firstreffirstname ||
			this.state.firstreffirstname.length === 0
		) {
			return toast.error("Reference 1 First Name is required");
		}
		if (
			!this.state.firstreflastname ||
			this.state.firstreflastname.length === 0
		) {
			return toast.error("Reference 1 Last Name is required");
		}
		if (!this.state.firstrefemail || this.state.firstrefemail.length === 0) {
			return toast.error("Reference 1 Email is required");
		}
		if (
			String(this.state.firstrefconfirmemail) !==
			String(this.state.firstrefemail)
		) {
			return toast.error("Reference 1 Email & Confirm Email should be same");
		}
		if (
			!this.state.secondreffirstname ||
			this.state.secondreffirstname.length === 0
		) {
			return toast.error("Reference 2 First Name is required");
		}
		if (
			!this.state.secondreflastname ||
			this.state.secondreflastname.length === 0
		) {
			return toast.error("Reference 2 Last Name is required");
		}
		if (!this.state.secondrefemail || this.state.secondrefemail.length === 0) {
			return toast.error("Reference 2 Email is required");
		}
		if (
			String(this.state.secondrefconfirmemail) !==
			String(this.state.secondrefemail)
		) {
			return toast.error("Reference 2 Email & Confirm Email should be same");
		}
		let toastId = "employee_save_online_form_01";
		toastId = toast.info("Please Wait......", { autoClose: false });
		evt.preventDefault();
		evt.stopPropagation();
		const data = new FormData();
		data.append(
			"reference1[firstrefrelationship]",
			this.state.firstrefrelationship
		);
		data.append("reference1[firstreffirstname]", this.state.firstreffirstname);
		data.append("reference1[firstreflastname]", this.state.firstreflastname);
		data.append(
			"reference1[firstrefphone][number]",
			this.state.firstrefphone.number
		);
		data.append(
			"reference1[firstrefphone][code]",
			this.state.firstrefphone.code
		);
		data.append(
			"reference1[firstrefphone][dialcountry]",
			this.state.firstrefphone.dialcountry
		);
		data.append("reference1[firstrefemail]", this.state.firstrefemail);
		data.append(
			"reference1[firstrefconfirmemail]",
			this.state.firstrefconfirmemail
		);
		data.append(
			"reference1[Address][firstrefstreetAddress]",
			this.state.firstrefstreetAddress
		);
		data.append("reference1[Address][firstrefcity]", this.state.firstrefcity);
		data.append("reference1[Address][firstrefstate]", this.state.firstrefstate);
		data.append("reference1[Address][firstrefzip]", this.state.firstrefzip);
		data.append(
			"reference2[secondrefrelationship]",
			this.state.secondrefrelationship
		);
		data.append(
			"reference2[secondreffirstname]",
			this.state.secondreffirstname
		);
		data.append("reference2[secondreflastname]", this.state.secondreflastname);
		data.append(
			"reference2[secondrefphone][number]",
			this.state.secondrefphone.number
		);
		data.append(
			"reference2[secondrefphone][code]",
			this.state.secondrefphone.code
		);
		data.append(
			"reference2[secondrefphone][dialcountry]",
			this.state.secondrefphone.dialcountry
		);
		data.append("reference2[secondrefemail]", this.state.secondrefemail);
		data.append(
			"reference2[secondrefconfirmemail]",
			this.state.secondrefconfirmemail
		);
		data.append(
			"reference2[Address][secondrefstreetAddress]",
			this.state.secondrefstreetAddress
		);
		data.append("reference2[Address][secondrefcity]", this.state.secondrefcity);
		data.append(
			"reference2[Address][secondrefstate]",
			this.state.secondrefstate
		);
		data.append("reference2[Address][secondrefzip]", this.state.secondrefzip);
		data.append(
			"reference3[thirdrefrelationship]",
			this.state.thirdrefrelationship
		);
		data.append(
			"reference3[thirdreffirstname]",
			this.state.thirdreffirstname
		);
		data.append("reference3[thirdreflastname]", this.state.thirdreflastname);
		data.append(
			"reference3[thirdrefphone][number]",
			this.state.thirdrefphone.number
		);
		data.append(
			"reference3[thirdrefphone][code]",
			this.state.thirdrefphone.code
		);
		data.append(
			"reference3[thirdrefphone][dialcountry]",
			this.state.thirdrefphone.dialcountry
		);
		data.append("reference3[thirdrefemail]", this.state.thirdrefemail);
		data.append(
			"reference3[thirdrefconfirmemail]",
			this.state.thirdrefconfirmemail
		);
		data.append(
			"reference3[Address][thirdrefstreetAddress]",
			this.state.thirdrefstreetAddress
		);
		data.append("reference3[Address][thirdrefcity]", this.state.thirdrefcity);
		data.append(
			"reference3[Address][thirdrefstate]",
			this.state.thirdrefstate
		);
		data.append("reference3[Address][thirdrefzip]", this.state.thirdrefzip);
		data.append("port", window.location.port);
		data.append("hostname", window.location.hostname);
		data.append("protocol", window.location.protocol);
		this.setState({ mainactive_tab_3: true });
		request({
			url: "/employees/apply-online-form/reference/save",
			method: "POST",
			data: data,
		}).then((res) => {
			this.setState({ mainactive_tab_3: false });
			if (res && +res.status === 1) {
				toast.update(toastId, {
					render: "Saved!",
					type: toast.TYPE.SUCCESS,
					autoClose: 250,
				});
				this.componentDidMount();
				window.scrollTo(0, 0);
				if (
					this.state.thi_main_tab_up_nxt &&
					String(this.state.thi_main_tab_up_nxt) === "next"
				) {
					mainActiveTab = Number(mainActiveTab) + 1;
					this.setState({ mainActiveTab: String(mainActiveTab) });
				}
				this.setState({ disableonsave: false });
			} else if (res && +res.status === 0) {
				toast.update(toastId, {
					render: res.response,
					type: toast.TYPE.ERROR,
					autoClose: 2500,
				});
				this.setState({ disableonsave: false });
			}
		}).catch((err) => {
			console.log(`err is ${err}`);
		});
	};

	onSelectDrivingCountryOfIssue = (value) => {
		if (value) {
			this.setState({
				drivingCountryOfIssue: value.value,
				drivingCountryOfIssue_arr: Array.of(value),
			});
		} else {
			this.setState({
				drivingCountryOfIssue: "",
				drivingCountryOfIssue_arr: [],
			});
		}
	};

	onSelectModule_Change = (value) => {
		if (value && value.value) {
			this.setState({
				drivingCountryOfIssue: value.value,
				drivingCountryOfIssue_arr: Array.of(value),
			});
		} else {
			this.setState({
				drivingCountryOfIssue: "",
				drivingCountryOfIssue_arr: [],
			});
		}
	};

	onSelect_Module_Change = (value) => {
		if (value && value.value) {
			this.setState({
				countryOfIssue: value.value,
				countryOfIssue_arr: Array.of(value),
			});
		} else {
			this.setState({ countryOfIssue: "", countryOfIssue_arr: [] });
		}
	};
	docCountryIssueHandler = (value) => {
		if (value && value.value) {
			if (value.value === "United Kingdom") {
				this.setState({
					rightToWorkType: "", rightToWorkType_info: {
						doc_type: "",
						doc_url: "",
						doc_no: "",
						country_issue: "",
						expiry_date: "",
						country_issue_arr: []
					}
				})
			}
			// console.log({ doc: this.state.docType_info })
			this.setState({ docType_info: { ...this.state.docType_info, country_issue: value.value, country_issue_arr: Array.of(value) } });
		} else {
			this.setState({ docType_info: { ...this.state.docType_info, country_issue: "", country_issue_arr: [] } });
		}
	};
	docCountryIssueHandler2 = (value) => {
		if (value && value.value) {
			this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, country_issue: value.value, country_issue_arr: Array.of(value) } });
		} else {
			this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, country_issue: "", country_issue_arr: [] } });
		}
	};
	languages_change_arr = (value) => {
		if (value && value.length > 0) {
			this.setState({ otherlanguage: value });
		} else {
			this.setState({ otherlanguage: [] });
		}
	};

	onSelectVisaCountryOfIssue = (value) => {
		if (value && value.value) {
			this.setState({
				visaCountryOfIssue: value.value,
				visa_country_of_issue: Array.of(value),
			});
		} else {
			this.setState({ visaCountryOfIssue: "", visa_country_of_issue: [] });
		}
	};
	acceptHealthDeclaration = (e) => {
		e.persist();
		this.setState({
			acceptHealthDeclaration: e.target.checked,
		});
	};
	acceptPersonalDeclaration = (e) => {
		e.persist();
		this.setState({
			acceptPersonalDeclaration: e.target.checked,
		});
	};
	acceptConfidentiality = (e) => {
		e.persist();
		this.setState({
			acceptConfidentiality: e.target.checked,
		});
	};
	dbsAccept = (e) => {
		e.persist();
		this.setState({
			dbsAccept: e.target.checked,
		});
	};
	indemnityAccept = (e) => {
		e.persist();
		this.setState({
			indemnityAccept: e.target.checked,
		});
	};
	declarationAccept = (e) => {
		e.persist();
		this.setState({
			declarationAccept: e.target.checked,
		});
	};

	fileChangedHandler1 = (evt) => {
		this.setState({
			avatar: evt.target.files[0],
			propreview: URL.createObjectURL(evt.target.files[0]),
		});
	};
	uploadIDDoc = (evt) => {
		evt.persist();
		if (evt) {
			const file_data = evt.target.files[0];
			const file_split = file_data.type.split("/");
			if (
				file_split[1] !== "exe" &&
				file_split[1] !== "zip" &&
				file_split[1] !== "rar"
			) {
				if (file_data.size < 5242880) {
					// console.log({ file_data });
					const data = new FormData();
					data.append("upload_doc", file_data);
					request({
						url: "/candidate/form/addFilestoLocalDB",
						method: "POST",
						data,
					}).then((res) => {
						let doc_url = Array.isArray(this.state.docType_info.doc_url) ? [...this.state.docType_info.doc_url ,res.file_path ] : this.state.docType_info.doc_url;
						this.setState({ docType_info: { ...this.state.docType_info, doc_url } });
					});
				} else {
					toast.error("Maximum upload size is 5MB");
					let doc_url = Array.isArray(this.state.docType_info.doc_url) ? this.state.docType_info.doc_url : [];
					this.setState({ docType_info: { ...this.state.docType_info, doc_url  } });
				}
			} else {
				toast.error("File Format not supported");
				let doc_url = Array.isArray(this.state.docType_info.doc_url) ? this.state.docType_info.doc_url : [];
				this.setState({ docType_info: { ...this.state.docType_info, doc_url } });
			}
		}
	};
	delete_DocType_doc = (event, filepath) => {
		event.preventDefault();
		this.setState({ docType_info: { ...this.state.docType_info, doc_url: "" } });
		this.backgrounddelete(filepath);
	}
	uploadIDDoc2 = (evt) => {
		evt.persist();
		if (evt) {
			const file_data = evt.target.files[0];
			const file_split = file_data.type.split("/");
			if (
				file_split[1] !== "exe" &&
				file_split[1] !== "zip" &&
				file_split[1] !== "rar"
			) {
				if (file_data.size < 5242880) {
					console.log({ file_data });
					const data = new FormData();
					data.append("upload_doc", file_data);
					request({
						url: "/candidate/form/addFilestoLocalDB",
						method: "POST",
						data,
					}).then((res) => {
						this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, doc_url: res.file_path } });
					});
				} else {
					toast.error("Maximum upload size is 5MB");
					this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, doc_url: undefined } });
				}
			} else {
				toast.error("File Format not supported");
				this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, doc_url: null } });
			}
		}
	};
	delete_DocType_doc2 = (event, filepath) => {
		event.preventDefault();
		this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, doc_url: "" } });
		this.backgrounddelete(filepath);
	}

	handleOnlineFormChange = (e ={} , fields = {}) =>{
		let value = (e && e.target && e.target.value) || "";
			if(fields && fields._id){
				this.setState((prev)=>({
					templateAddtionalFields:prev.templateAddtionalFields.map((fld ={})=>{
						if(fld._id === fields._id ){
							fld.field_value = value;
							fld.isModified = true;
						}
						return fld;
					}),

				}))
			}
	}


	menuHeadingIsVisible = (menu = '') => (head = '' , field_name = '' , staticFields = true) => {
		let Fields = (staticFields) ? this.state.templateFields : this.state.templateAddtionalFields
		let predicate = field_name
		? (item={})=>(item.field_menu.name === menu && item.field_heading.name === head && item.field_name === field_name) 
		: (item={})=>(item.field_menu.name === menu && item.field_heading.name === head);
		let terms = Fields.find(predicate);
			return terms;
	}

	/**
	 * 
	 * @param {string} menu 
	 * @param {string} heading 
	 * @returns {Array}
	 */
	addtionalFieldsFilterByHeading = (menu = "Your Personal Details" , heading = '') =>{
		let addtionalFields = this.state.templateAddtionalFields
		/**
		 * @type {Array<{}>}
		 */
		let fields = Array.isArray(addtionalFields) && addtionalFields.length ? addtionalFields : [],
			filterPredicate = (item = {})=>(item.field_menu && item.field_menu.name === menu && item.field_heading && item.field_heading.name === heading )
			return fields.filter(filterPredicate)
	}


	menuRequiredFieldsAreNotEmpty = (menu = 'Your Personal Details') =>{
		let filterByRequired = (item = {})=>item.field_menu && item.field_menu.name === menu && item.field_required;
		let staticFields = this.state.templateFields.filter(filterByRequired).map((item = {})=>{
			let key = this.#requiedStaticFieldskey[item.field_name];
			let value = _.get(this.state ,key , '' );
				value = Array.isArray(value) ? value.length : value
			return Boolean(value)
		}).every(Boolean),
			addtionalFields = this.state.templateAddtionalFields.filter(filterByRequired).map((item ={})=>Boolean(Array.isArray(item.field_value) ? item.field_value.length : item.field_value)).every(Boolean);
		return {
			staticFields,
			addtionalFields
		}
	}


	render() {
		const { mainActiveTab, activeTab, signatureTab, title } = this.state;

		const yourPersonalDetailsIsVisible = this.menuHeadingIsVisible("Your Personal Details");
		const declarationAndTermIsVisible = this.menuHeadingIsVisible("Declaration & Terms");
		const skillsAndWorkHistoryIsVisible = this.menuHeadingIsVisible("Skills & Work History");
		const employmentAndEducation = this.menuHeadingIsVisible("Employment & Education");

		const {
			jobtypelist,
			worklist,
			form_status,
			final_verify_status,
			filepath,
			fileext,
			mobileno,
		} = this.state || {};
		const externalCloseBtn = (
			<button
				className="close fileview_close"
				onClick={() => this.FileView("")}
			>
				<i className="fa fa-close fa-4x btn btn-success" aria-hidden="true" />
			</button>
		);
		// console.log(this.state.docType_info.expiry_date, this.state.rightToWorkType_info.expiry_date, this.state.joining_date)
		return (
			<div className="candidate-main">
				<Fragment>
					<Breadcrumb title="Edit Profile" parent="Profile" />
					<div className="mar-top"></div>
					<div className="card main-space">
						<div className="cancel-cls">
							<button
								type="button"
								className="back-pages"
								onClick={(e) => this.closeIconTab(e)}
							>
								<img src={invoiceclose} alt="invoice-close" />
							</button>
						</div>
						<div className="editing-candidates">
							<div className="col-sm-12 col-xs-12">
								<Nav tabs className="nav-pills nav-info horz-tab">
									<NavItem className="nav nav-tabs" id="myTab" role="tablist">
										<NavLink
											className={mainActiveTab === "1" ? "active" : ""}
											onClick={() => this.mainToggle("1")}
										>
											Profile
										</NavLink>
									</NavItem>
									<NavItem className="nav nav-tabs" id="myTab" role="tablist">
										<NavLink
											className={mainActiveTab === "2" ? "active" : ""}
											onClick={() => this.mainToggle("2")}
										>
											Documents
										</NavLink>
									</NavItem>
									<NavItem className="nav nav-tabs" id="myTab" role="tablist">
										<NavLink
											className={mainActiveTab === "3" ? "active" : ""}
											onClick={() => this.mainToggle("3")}
										>
											References
										</NavLink>
									</NavItem>
									<NavItem className="nav nav-tabs" id="myTab" role="tablist">
										<NavLink
											className={mainActiveTab === "4" ? "active" : ""}
											onClick={() => this.mainToggle("4")}
										>
											Health Questionnaire
										</NavLink>
									</NavItem>
									<NavItem className="nav nav-tabs" id="myTab" role="tablist">
										<NavLink
											className={mainActiveTab === "5" ? "active" : ""}
											onClick={() => this.mainToggle("5")}
										>
											Payment Details
										</NavLink>
									</NavItem>
								</Nav>
							</div>
							<div className="col-sm-12 col-xs-12">
								<TabContent
									activeTab={mainActiveTab}
									className="myspace-functions"
								>
									<TabPane tabId="1">
										<div className="tab-block">
											<Nav
												tabs
												className="vertical-tabset nav-pills nav-primary"
											>
												<NavItem
													className="nav nav-tabs"
													id="myTab"
													role="tablist"
												>
													<NavLink
														className={activeTab === "1" ? "active" : ""}
														onClick={() => this.toggle("1")}
													>
														Your Personal Details
													</NavLink>
												</NavItem>


											{
												employmentAndEducation("Professional Body Memberships") || employmentAndEducation("Training & Other Courses (Mandatory Training)") || employmentAndEducation("Qualifications") ?
												<NavItem
													className="nav nav-tabs"
													id="myTab"
													role="tablist"
												>
													<NavLink
														className={activeTab === "2" ? "active" : ""}
														onClick={() => this.toggle("2")}
														disabled={this.state.nextTabIsDisabled}
													>
														Employment & Education
													</NavLink>

												</NavItem>
												: <></>

											}


												<NavItem
													className="nav nav-tabs"
													id="myTab"
													role="tablist"
												>
													<NavLink
														className={activeTab === "3" ? "active" : ""}
														onClick={() => this.toggle("3")}
														disabled={this.state.nextTabIsDisabled}
													>
														Skills & Work History
													</NavLink>
												</NavItem>

												<NavItem
													className="nav nav-tabs"
													id="myTab"
													role="tablist"
												>
													<NavLink
														className={activeTab === "4" ? "active" : ""}
														disabled={this.state.nextTabIsDisabled}
														onClick={() => this.toggle("4")}
													>
														Declaration & Terms
													</NavLink>
												</NavItem>
											</Nav>
											<TabContent activeTab={activeTab}>
												<TabPane tabId="1">
													<div className="col-lg-12 edit-list-box">
														<AvForm
															className="card"
															onSubmit={this.onFormPersonalDetails}
														>
															{
															( yourPersonalDetailsIsVisible("Personal Details 1") || yourPersonalDetailsIsVisible("Personal Details 1" , undefined , false) )  && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		Personal Details 1
																	</h4>
																</div>
																<div className="card-body">
																	<div className="row">

																		{/* Title */}
																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Title") &&
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="select"
																				name="title"
																				label="Title"
																				placeholder="Select Title"
																				onChange={this.onChange}
																				value={this.state.title}
																			>
																				<option>Please Select</option>
																				<option value="mr">Mr.</option>
																				<option value="mrs">Mrs.</option>
																				<option value="miss">Miss.</option>
																				<option value="ms">Ms.</option>
																				<option value="dr">Dr.</option>
																				<option value="prof">Prof.</option>
																				<option value="rev">Rev.</option>
																			</AvField>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"First Name") &&
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label>
																				First Name{" "}
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<AvField
																				type="text"
																				// label="First Name"
																				name="firstname"
																				placeholder="Enter First Name"
																				onChange={this.onChange}
																				value={this.state.firstname}
																				errorMessage="Required"
																				required
																			/>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Preferred Name") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Preferred Name"
																				name="prefferedName"
																				placeholder="Enter Preferred Name"
																				onChange={this.onChange}
																				value={this.state.prefferedName}
																			/>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Middle Name") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Middle Name"
																				name="middlename"
																				placeholder="Enter Middle Name"
																				onChange={this.onChange}
																				value={this.state.middlename}
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Last Name") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label>
																				Last Name{" "}
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<AvField
																				type="text"
																				// label="Last Name"
																				name="lastname"
																				placeholder="Enter Last Name"
																				onChange={this.onChange}
																				value={this.state.lastname}
																				errorMessage="Required"
																				required
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Maiden Name") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Maiden Name"
																				name="maidenName"
																				placeholder="Enter Maiden Name"
																				onChange={this.onChange}
																				value={this.state.maidenName}
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Have you ever changed your name ?") && 
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				label="Have you ever changed your name?"
																				name="isNameChanged"
																				value={this.state.isNameChanged}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Gender") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label>
																				Gender{" "}
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<AvField
																				type="select"
																				name="gender"
																				// label="Gender"
																				placeholder="Select Gender"
																				onChange={this.onChange}
																				value={this.state.gender}
																				errorMessage="Required"
																				required
																			>
																				<option value="">Please Select</option>
																				<option value="female">Female</option>
																				<option value="male">Male</option>
																				<option value="agenda">Agender</option>
																			</AvField>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"Date Joined") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<div className="form-group">
																				<label>Date Joined</label>
																				<Datetime
																					dateFormat="DD-MM-YYYY"
																					timeFormat={false}
																					closeOnSelect={true}
																					value={
																						this.state.joining_date === "" ||
																							String(this.state.joining_date) ===
																							String(null) ||
																							String(this.state.joining_date) ===
																							String(undefined) ||
																							String(this.state.joining_date) ===
																							String("Invalid date")
																							? ""
																							: moment(
																								this.state.joining_date
																							).format("DD-MM-YYYY")
																					}
																					inputProps={{
																						placeholder: "Select Date",
																					}}
																					// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
																					onChange={(e) => {
																						if (e._isValid) {
																							this.setState({
																								joining_date: e,
																							});
																						} else if (!e) {
																							this.setState({
																								joining_date: null,
																							});
																						} else {
																							this.setState({
																								joining_date: null,
																							});
																						}
																					}}
																				/>
																			</div>
																		</Col>
																		}

																		{
																			this.addtionalFieldsFilterByHeading("Your Personal Details" ,'Personal Details 1').map((item)=>{
																				const TYPE = (item && item.field_type && item.field_type.toUpperCase()) || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				let field_value = (this.state.addtionalFieldsValue.find(fld => fld._id === item._id) || {}).field_value;
																				    field_value = item.field_value || field_value;
																					item.field_value = field_value;
																				// console.log({item})
																				return <Field key={item._id} {...item} onChange={this.handleOnlineFormChange} />
																			})
																		}
																		{
																			yourPersonalDetailsIsVisible("Personal Details 1") && 
																		<Col
																			xs="12"
																			md="7"
																			className="position-relative"
																		>
																			{/* <Label for="exampleCustomFileBrowser">
																				Upload Photo
																			</Label> */}
																			<div className="cropper-files">
																				<div className="right-uploads">
																					<div className="checks-uploaders">
																						<input
																							type="file"
																							onChange={(e) =>
																								this.fileChangedHandler1(e)
																							}
																							accept="image/*"
																						/>
																						<img src={uploader} />
																						<p>Click to Upload Photo</p>
																						<h6>or</h6>
																						<p>Drag & Drop</p>
																					</div>
																					{/* <div className="company-uplaoder">
																						<Avatar width={350} height={180} imageWidth={350} onCrop={this.onCrop} onClose={this.onClose} />
																					</div> */}
																				</div>
																				{/* <CustomInput
																				type="file"
																				className="hiding-files"
																				id="exampleCustomFileBrowser"
																				name="UploadIDPhoto"
																				onChange={this.fileChangedHandler}
																				label={
																					this.state.UploadIDName
																						? this.state.UploadIDName
																						: "Upload  Image"
																				}
																				encType="multipart/form-data"
																			/> */}
																				<p className="help-block">
																					<small>
																						<i>
																							<a
																								class="rules-lines"
																								onClick={() =>
																									this.setState({
																										showPhotoRules: true,
																									})
																								}
																							>
																								Rules for photos
																							</a>
																						</i>
																					</small>
																				</p>
																			</div>
																		</Col>
																		}


																		{this.state.propreview ? (
																			<Col xs="6" md="5">
																				<img
																					width="130px"
																					height="130px"
																					src={this.state.propreview}
																					alt="Preview"
																				/>{" "}
																			</Col>
																		) : null}
																		{String(this.state.UploadIDPhoto).length ===
																			0 ||
																			String(this.state.UploadIDPhoto) ===
																			String(undefined) ||
																			String(this.state.UploadIDPhoto) ===
																			String(null) ? null : (
																			<Col xs="6" md="3">
																				<img
																					width="130px"
																					height="130px"
																					src={
																						NodeURL +
																						"/" +
																						this.state.UploadIDPhoto
																					}
																					alt="Profile"
																				/>
																			</Col>
																		)}

																		{/* {this.state.UploadIDPhoto && (
                                                                <Col xs="12" md="12">
                                                                    <Button color="success" className="mt-2" onClick={() => this.FileDownloader(this.state.UploadIDPhoto, "IDphoto.jpg")}>
                                                                        Download
                                                             </Button>
                                                                </Col>
                                                            )} */}
																{
																			yourPersonalDetailsIsVisible("Personal Details 1" ,"About Me") && 
																		<Col
																			xs="12"
																			md="6"
																			className="position-relative mt-3"
																		>
																			<AvField
																				type="textarea"
																				name="empBio"
																				label="About Me"
																				placeholder={this.state.candidateAdvice}
																				onChange={this.onChange}
																				id="textareamybio"
																				value={
																					this.state.empBio &&
																						CheckValue(this.state.empBio)
																						? this.state.empBio
																						: ""
																				}
																			></AvField>
																		</Col>
																}


																	</div>
																</div>
															</div>
															}



															{
															(yourPersonalDetailsIsVisible("Personal Details 2") ||  yourPersonalDetailsIsVisible("Personal Details 1" , undefined , false)  ) && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		Personal Details 2
																	</h4>
																</div>
																<div className="card-body">
																	<div className="row">

																		{
																			yourPersonalDetailsIsVisible("Personal Details 2" ,"Date Of Birth") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			{/* <label>Date Of Birth</label> */}
																			<Label>
																				Date Of Birth{" "}
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<Datetime
																				className={
																					this.state.dobError ? "red-box" : ""
																				}
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				value={
																					this.state.dateofbirth === "" ||
																						String(this.state.dateofbirth) ===
																						String(null) ||
																						String(this.state.dateofbirth) ===
																						String(undefined) ||
																						String(this.state.dateofbirth) ===
																						String("Invalid date")
																						? ""
																						: moment(
																							this.state.dateofbirth
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																					required: true,
																				}}
																				isValidDate={(current) =>
																					current.isBefore(
																						moment(new Date()).subtract(
																							16,
																							"years"
																						)
																					)
																				}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							dateofbirth: e,
																							dobError: false,
																							isFormErrors: false,
																						});
																					} else if (!e) {
																						this.setState({
																							dateofbirth: null,
																							dobError: true,
																						});
																					} else {
																						this.setState({
																							dateofbirth: null,
																							dobError: true,
																						});
																					}
																				}}
																				onBlur={() => {
																					this.state.dateofbirth === "" ||
																						this.state.dateofbirth === null
																						? this.setState({ dobError: true })
																						: this.setState({
																							dobError: false,
																						});
																				}}
																			/>
																			{this.state.dobError ? (
																				<span className="custom-text-danger">
																					Required
																				</span>
																			) : null}
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("Personal Details 2" ,"Marital Status") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="select"
																				name="martialStatus"
																				label="Marital Status"
																				placeholder="Marital Status"
																				onChange={(e) => {
																					this.onSelectChange(e);
																				}}
																				value={this.state.martialStatus}
																			>
																				<option>Please Select</option>
																				<option value="Single">Single</option>
																				<option value="Married">Married</option>
																				<option value="Divorced">
																					Divorced
																				</option>
																				<option value="Widowed">Widowed</option>
																			</AvField>
																		</Col>
																		}
																		{this.state.martialStatus === "Married" ? (
																			<Col
																				xs="12"
																				md="4"
																				className="position-relative"
																			>
																				<label>Date Of Marriage</label>
																				<Datetime
																					dateFormat="DD-MM-YYYY"
																					timeFormat={false}
																					closeOnSelect={true}
																					value={
																						this.state.dateofMarriage === "" ||
																							String(
																								this.state.dateofMarriage
																							) !== String(undefined) ||
																							String(
																								this.state.dateofMarriage
																							) !== String(null) ||
																							String(
																								this.state.dateofMarriage
																							) !== String("Invalid date")
																							? moment(
																								this.state.dateofMarriage
																							).format("DD-MM-YYYY")
																							: ""
																					}
																					inputProps={{
																						placeholder: "Select Date",
																					}}
																					// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
																					onChange={(e) => {
																						if (e._isValid) {
																							this.setState({
																								dateofMarriage: e,
																							});
																						} else if (!e) {
																							this.setState({
																								dateofMarriage: null,
																							});
																						} else {
																							this.setState({
																								dateofMarriage: null,
																							});
																						}
																					}}
																				/>
																			</Col>
																		) : null}


																		{
																			yourPersonalDetailsIsVisible("Personal Details 2" ,"National Insurance No") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label>
																				National Insurance No{" "}
																				
																			</Label>
																			<AvField
																				type="text"
																				// label="National Insurance No"
																				name="insuranceno"
																				placeholder="Enter Insurance No"
																				// errorMessage="Required"
																				// required
																				onChange={this.onInsuranceChange}
																				value={this.state.insuranceno}
																			/>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("Personal Details 2" ,"Nationality") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<label>Nationality</label>
																			<Select
																				name="countries"
																				isClearable={true}
																				isSearchable={true}
																				options={countries}
																				value={this.state.national_ity}
																				onChange={this.onSelectModuleChange}
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("Personal Details 2" ,"Religion") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="select"
																				name="religion"
																				label="Religion"
																				placeholder="Select Religion.."
																				onChange={this.onChange}
																				value={this.state.religion}
																			>
																				<option>Please Select</option>
																				<option value="bhudist">Bhudist</option>
																				<option value="christian">
																					Christian
																				</option>
																				<option value="jewish">Jewish</option>
																				<option value="hindu">Hindu</option>
																				<option value="muslim">Muslim</option>
																				<option value="sikh">Sikh</option>
																				<option value="other">Other</option>
																			</AvField>
																		</Col>
																		}

																		{
																			this.addtionalFieldsFilterByHeading("Your Personal Details" ,'Personal Details 2').map((item)=>{
																				const TYPE = (item && item.field_type && item.field_type.toUpperCase()) || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				let field_value = (this.state.addtionalFieldsValue.find(fld => fld._id === item._id) || {}).field_value;
																				    field_value = item.field_value || field_value;
																					item.field_value = field_value;
																				// console.log({item})
																				return <Field key={item._id} {...item} onChange={this.handleOnlineFormChange} />
																			})
																		}

																	</div>
																</div>
															</div>
															}

															{
															(yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS") || yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS", undefined , false) ) && 
															<div className="section-divder">
															<div className="card-header">
																<h4 className="card-title mb-0">
																	CONTACT AND ADDRESS DETAILS
																</h4>
															</div>
																<div className="card-body">
																	<div className="row">

																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "Email Address") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label>
																				Email Address
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<AvField
																				type="email"
																				// label="Email"
																				name="email"
																				placeholder="Enter Email Address"
																				onChange={this.onChange}
																				value={this.state.email}
																				errorMessage="Required"
																				required
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "Mobile No") && 	
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label
																				className={
																					this.state.phoneerror
																						? "error-color"
																						: null
																				}
																			>
																				Mobile No:
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<IntlTelInput
																				placeholder=""
																				style={{ width: "100%" }}
																				defaultCountry={
																					this.state.mobileno.dailcountry
																				}
																				utilsScript={libphonenumber}
																				css={
																					this.state.phoneerror ||
																						this.state.mobileError
																						? [
																							"intl-tel-input",
																							"form-control",
																							"error-color",
																							"red-box",
																						]
																						: ["intl-tel-input", "form-control"]
																				}
																				onPhoneNumberChange={this.handler}
																				value={this.state.mobileno.number}
																				required
																			/>
																			{this.state.mobileError ||
																				this.state.phoneerror ? (
																				<span className="custom-text-danger">
																					Required
																				</span>
																			) : null}
																			{/* <AvField type="number" label="Mobile No" name="mobileno" placeholder="Enter Mobile Number" onChange={this.onChange} value={this.state.mobileno} required /> */}
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "Home Phone") && 	
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="number"
																				label="Home Phone"
																				name="homephone"
																				placeholder="Enter Phone number"
																				onChange={this.onChange}
																				value={this.state.homephone}
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "House/Flat/Building") && 	
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<div className="form-group">
																				<Label>House/Flat/Building</Label>
																				<PlacesAutocomplete
																					value={this.state.streetAddress}
																					onChange={this.handleChange_per_det}
																					onSelect={this.handleSelect_per_det}
																					onFocus={this.geolocate}
																				>
																					{({
																						getInputProps,
																						suggestions,
																						getSuggestionItemProps,
																					}) => (
																						<div>
																							<input
																								{...getInputProps({
																									placeholder: "Search Places",
																									className:
																										"form-control serach-place",
																								})}
																							/>
																							<div className="autocomplete-dropdown-container absolute">
																								{suggestions.map(
																									(suggestion) => {
																										const className =
																											suggestion.active
																												? "suggestion-item--active"
																												: "suggestion-item";
																										// inline style for demonstration purpose
																										const style =
																											suggestion.active
																												? {
																													backgroundColor:
																														"#fafafa",
																													cursor: "pointer",
																												}
																												: {
																													backgroundColor:
																														"#ffffff",
																													cursor: "pointer",
																												};
																										return (
																											<div
																												{...getSuggestionItemProps(
																													suggestion,
																													{
																														className,
																														style,
																													}
																												)}
																											>
																												<span>
																													{
																														suggestion.description
																													}
																												</span>
																											</div>
																										);
																									}
																								)}
																							</div>
																						</div>
																					)}
																				</PlacesAutocomplete>
																			</div>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "Address Line 2") &&
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Address Line 2"
																				name="addressline2"
																				placeholder="Enter Address Line 2"
																				onChange={this.onChange}
																				value={this.state.addressline2}
																			/>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "City") &&
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="City"
																				name="city"
																				placeholder="Enter City"
																				onChange={this.onChange}
																				value={this.state.city}
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "State / Region") && 	
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="State / Region"
																				name="state"
																				placeholder="Enter State"
																				onChange={this.onChange}
																				value={this.state.state}
																			/>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "ZIP / Postal Code") && 	
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="ZIP / Postal Code"
																				name="zip"
																				placeholder="Enter ZIP / Postal Code"
																				onChange={this.onChange}
																				value={this.state.zip}
																			/>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "Country") && 																				
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Country"
																				name="country"
																				placeholder="Enter Country"
																				onChange={this.onChange}
																				value={this.state.country}
																			/>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("CONTACT AND ADDRESS DETAILS" , "Date moved to this address") && 																				
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<label>Date moved to this address</label>
																			<Datetime
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				value={
																					this.state.dateMovedAddress === "" ||
																						String(
																							this.state.dateMovedAddress
																						) === String(undefined) ||
																						String(
																							this.state.dateMovedAddress
																						) === String(null) ||
																						String(
																							this.state.dateMovedAddress
																						) === String("Invalid date")
																						? ""
																						: moment(
																							this.state.dateMovedAddress
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																				}}
																				// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							dateMovedAddress: e,
																						});
																					} else if (!e) {
																						this.setState({
																							dateMovedAddress: null,
																						});
																					} else {
																						this.setState({
																							dateMovedAddress: null,
																						});
																					}
																				}}
																			/>
																		</Col>
																		}

																		{
																			this.addtionalFieldsFilterByHeading("Your Personal Details" ,"CONTACT AND ADDRESS DETAILS").map((item)=>{
																				const TYPE = item && item.field_type && item.field_type.toUpperCase() || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				let field_value = (this.state.addtionalFieldsValue.find(fld => fld._id === item._id) || {}).field_value;
																				    field_value = item.field_value || field_value;
																					item.field_value = field_value;
																				// console.log({item})
																				return <Field key={item._id} {...item} onChange={this.handleOnlineFormChange} />
																			})
																		}

																	</div>
																</div>
															
															</div>
															}


															{
															( yourPersonalDetailsIsVisible("WORK & PERSONAL DETAILS") || yourPersonalDetailsIsVisible("WORK & PERSONAL DETAILS" , undefined , false)  ) && 														
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		WORK {"&"} PERSONAL DETAILS
																	</h4>
																</div>
																<div className="card-body">
																	<div className="row">
																		
																		{
																			yourPersonalDetailsIsVisible("WORK & PERSONAL DETAILS" ,"Job Role") && 
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<div className="form-group">
																				<Label>
																					Job Role{" "}
																					<span style={{ color: "red" }}>
																						*
																					</span>{" "}
																				</Label>

																				<Select
																					className={
																						this.state.jobroleError
																							? "red-box"
																							: ""
																					}
																					name="job_type"
																					value={this.state.job_typeValue}
																					options={jobtypelist}
																					onChange={this.jobtypeselect}
																					isMulti
																					required={true}
																				/>
																				{this.state.jobroleError ? (
																					<span className="custom-text-danger">
																						Required
																					</span>
																				) : null}
																			</div>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("WORK & PERSONAL DETAILS" ,"Area") && 																		
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<div className="form-group">
																				<Label>
																					Area{" "}
																					<span style={{ color: "red" }}>
																						*
																					</span>{" "}
																				</Label>
																				<Select
																					className={
																						this.state.jobareaError
																							? "red-box"
																							: ""
																					}
																					name="locations"
																					value={this.state.locationsValue}
																					options={worklist}
																					onChange={this.locationsselect}
																					isMulti
																					required={true}
																				/>
																				{this.state.jobareaError ? (
																					<span className="custom-text-danger">
																						Required
																					</span>
																				) : null}
																			</div>
																		</Col>
																		}

																		{/* <Col xs="12" md="4">
                                                                <AvField type="select" name="locations" label="Select Location" placeholder="Select Location.." onChange={this.onChange} value={this.state.locations} required>
                                                                    <option>Please select</option>
                                                                    {this.state.locationlist
                                                                        ? this.state.locationlist.map(list => (
                                                                            <option key={list._id} value={list._id}>
                                                                                {list.name}
                                                                            </option>
                                                                        ))
                                                                        : null}
                                                                </AvField>
                                                            </Col> */}

																		{
																			yourPersonalDetailsIsVisible("WORK & PERSONAL DETAILS" ,"Work Status") && 																		
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="select"
																				name="workstatus"
																				label="Work Status"
																				onChange={this.onChange}
																				value={this.state.workstatus}
																			>
																				<option>Please Select</option>
																				<option value="paye">PAYE</option>
																				<option value="selfemployed">
																					Self Employed
																				</option>
																				<option value="notsure">
																					Not sure
																				</option>
																			</AvField>
																		</Col>					
																		}

																		{
																			this.addtionalFieldsFilterByHeading("Your Personal Details" ,"WORK & PERSONAL DETAILS").map((item)=>{
																				const TYPE = item && item.field_type && item.field_type.toUpperCase() || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				let field_value = (this.state.addtionalFieldsValue.find(fld => fld._id === item._id) || {}).field_value;
																				    field_value = item.field_value || field_value;
																					item.field_value = field_value;
																				// console.log({item})
																				return <Field key={item._id} {...item} onChange={this.handleOnlineFormChange} />
																			})
																		}

																	</div>
																</div>
															</div>
															}


															{
															( yourPersonalDetailsIsVisible("General Availability") || yourPersonalDetailsIsVisible("General Availability" , undefined , false) ) && 														
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		General Availability
																	</h4>
																</div>
																<div className="card-body">
																	<Row>

																		{
																			yourPersonalDetailsIsVisible("General Availability" , "When are you able to work?") &&
																		<Col xs="12" md="12">
																			<label>When are you able to work?</label>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_anytime"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_anytime}
																				/>{" "}
																				Anytime
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_mornings"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_mornings}
																				/>{" "}
																				Mornings
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_evenings"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_evenings}
																				/>{" "}
																				Evenings
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_afternoons"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_afternoons}
																				/>{" "}
																				Afternoons
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_occasional"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_occasional}
																				/>{" "}
																				Occasional Weeks
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_fulltime"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_fulltime}
																				/>{" "}
																				Full Time
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_parttime"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_parttime}
																				/>{" "}
																				Part Time
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_nights"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_nights}
																				/>{" "}
																				Nights
																			</Col>
																			<Col className="che-box">
																				<AvInput
																					type="checkbox"
																					name="work_weekends"
																					onChange={this.onCheckedChange}
																					checked={this.state.work_weekends}
																				/>{" "}
																				Weekends
																			</Col>
																		</Col>
																		}


																		{
																			yourPersonalDetailsIsVisible("General Availability" , "What is the Earliest Date you can start work") &&
																		<Col
																			xs="12"
																			md="6"
																			className="position-relative"
																		>
																			<label>
																				What is the Earliest Date you can start
																				work 
																				<span style={{ color: "red" }}>*</span>
																			</label>

																			<Datetime
																				className={
																					this.state.dateofstartError
																						? "red-box"
																						: ""
																				}
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				required={true}
																				value={
																					this.state.availablestartdate ===
																						"" ||
																						String(
																							this.state.availablestartdate
																						) === String(undefined) ||
																						String(
																							this.state.availablestartdate
																						) === String(null) ||
																						String(
																							this.state.availablestartdate
																						) === String("Invalid date")
																						? ""
																						: moment(
																							this.state.availablestartdate
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																				}}
																				// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							availablestartdate: e,
																							dateofstartError: false,
																							isFormErrors: false,
																						});
																					} else if (!e) {
																						this.setState({
																							availablestartdate: null,
																							dateofstartError: true,
																						});
																					} else {
																						this.setState({
																							availablestartdate: null,
																							dateofstartError: true,
																						});
																					}
																				}}
																				onBlur={() => {
																					this.state.availablestartdate ===
																						"" ||
																						this.state.availablestartdate ===
																						null ||
																						this.state.availablestartdate ===
																						"null"
																						? this.setState({
																							dateofstartError: true,
																						})
																						: this.setState({
																							dateofstartError: false,
																						});
																				}}
																			/>
																			{this.state.dateofstartError ? (
																				<span className="custom-text-danger">
																					Required
																				</span>
																			) : null}
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("General Availability" ,"Would you be willing to work at short notice?") &&
																		<Col xs="12" md="6">
																			<AvRadioGroup
																				inline
																				name="shortnotice"
																				label={
																					"Would you be willing to work at short notice?"
																				}
																				value={this.state.shortnotice}
																			>
																				<AvRadio label="Yes" value="yes" />
																				<AvRadio label="No" value="no" />
																			</AvRadioGroup>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("General Availability" ,"Do you have any commitments that reduce your flexibility to work") &&
																		<Col xs="12" md="6">
																			<AvRadioGroup
																				inline
																				name="reduceworkflexibility"
																				label={
																					"Do you have any commitments that reduce your flexibility to work"
																				}
																				value={this.state.reduceworkflexibility}
																			>
																				<AvRadio label="Yes" value="yes" />
																				<AvRadio label="No" value="no" />
																			</AvRadioGroup>
																		</Col>
																		}

																		{
																			yourPersonalDetailsIsVisible("General Availability" ,"Please provide details:") &&
																		<Col
																			xs="12"
																			md="12"
																			className="position-relative"
																		>
																			<AvField
																				type="textarea"
																				label="Please provide details:"
																				name="workstate"
																				onChange={this.onChange}
																				value={this.state.workstate}
																			/>
																		</Col>
																		}

																		{
																			this.addtionalFieldsFilterByHeading("Your Personal Details" ,"General Availability").map((item)=>{
																				const TYPE = item && item.field_type && item.field_type.toUpperCase() || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				let field_value = (this.state.addtionalFieldsValue.find(fld => fld._id === item._id) || {}).field_value;
																				    field_value = item.field_value || field_value;
																					item.field_value = field_value;
																				// console.log({item})
																				return <Field key={item._id} {...item} onChange={this.handleOnlineFormChange} />
																			})
																		}




																	</Row>
																</div>
															</div>
															}

															{
															// yourPersonalDetailsIsVisible("ID & Right To Work") && 
															// console.log("ID & Right To Work" , this.state.docType_info , this.state.rightToWorkType_info ) ||
															((this.state.docType_info && this.state.docType_info.isvisible ) /* || ( this.state.rightToWorkType_info &&  this.state.rightToWorkType_info.isvisible) */ )  && 											
															<>
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		ID & Right to Work
																	</h4>
																	<p className="font-weight">
																		Provide details about your proof of right to
																		work in the UK.
																	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		{
																			this.state.docType_info.isvisible  && 
																		<>
																		<Col
																			xs="12"
																			md="5"
																			className="position-relative"
																		>
																			<AvField
																				type="select"
																				name="docType"
																				label="Identity Document"
																				onChange={this.docTypeChangeHandler}
																				value={this.state.docType}
																			>
																				<option value="">Please Select</option>
																				<option value="Passport">
																					Passport
																				</option>
																				<option value="Driving Licence">
																					Driving Licence
																				</option>
																				<option value="Identity Card">
																					Identity Card
																				</option>
																				<option value="Biometric Card">
																					Biometric Card
																				</option>
																				<option value="Birth Certificate">
																					Birth Certificate
																				</option>
																				<option value="Certificate of Registration">
																					Certificate of Registration
																				</option>
																				<option value="Travel Document">
																					Travel Document
																				</option>
																			</AvField>
																		</Col>

																		{this.state.docType !== "" ? (
																			<div className="card-body" style={{ marginLeft: "12px" }}>
																				<div className="row">
																					<Col
																						xs="12"
																						md="3"
																						className="position-relative"
																					>
																						<div className="form-group">
																							<label>Country of Issue</label>
																							<Select
																								name="countryOfIssue"
																								isClearable={true}
																								isSearchable={true}
																								options={countries}
																								value={
																									this.state.docType_info.country_issue_arr
																								}
																								onChange={
																									this.docCountryIssueHandler
																								}
																							/>
																						</div>
																					</Col>
																					<Col
																						xs="12"
																						md="3"
																						className="position-relative"
																					>
																						<div className="form-group">
																							<AvField
																								type="text"
																								label="Doc Number"
																								name="documentNumber"
																								placeholder="Enter Doc Number"
																								onChange={(e) => this.setState({ docType_info: { ...this.state.docType_info, doc_no: e.target.value } })}
																								value={this.state.docType_info.doc_no}
																							/>
																						</div>
																					</Col>
																					<Col
																						xs="12"
																						md="3"
																						className={`position-relative ${this.state.docType === "Birth Certificate" ? "expiry-date" : ""}`}
																					>
																						<div className="form-group">
																							<label>Expiry Date </label>

																							<Datetime
																								dateFormat="DD-MM-YYYY"
																								timeFormat={false}
																								closeOnSelect={true}
																								required={true}
																								value={
																									this.state.docType_info.expiry_date ===
																										"" ||
																										String(
																											this.state.docType_info.expiry_date
																										) === String(undefined) ||
																										String(
																											this.state.docType_info.expiry_date
																										) === String(null) ||
																										String(
																											this.state.docType_info.expiry_date
																										) === String("Invalid date")
																										? ""
																										: moment(
																											this.state.docType_info.expiry_date
																										).format("DD-MM-YYYY")
																								}
																								inputProps={{
																									placeholder: "Select Date",
																								}}
																								// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}

																								onChange={(e) => {
																									// console.log({ e });
																									if (e._isValid) {
																										this.setState({ docType_info: { ...this.state.docType_info, expiry_date: e } });
																									} else if (!e) {
																										this.setState({ docType_info: { ...this.state.docType_info, expiry_date: "" } });
																									} else {
																										this.setState({ docType_info: { ...this.state.docType_info, expiry_date: "" } })
																									}
																								}}
																							/>
																						</div>
																					</Col>
																					<Col xs="12"
																						md="3"
																						className="position-relative">
																						{this.state.docType_info && Array.isArray(this.state.docType_info.doc_url) && this.state.docType_info.doc_url.length > 0  ? 
																							this.state.docType_info.doc_url.map((url , i)=><p key={i} className="down-uploads">
																							<UncontrolledTooltip
																								placement="bottom"
																								target={`uploadeducation`}
																							>
																								View Document{" "}
																							</UncontrolledTooltip>
																							<img
																								src={pdf}
																								alt="pdf"
																								id={`uploadeducation`}
																								onClick={(e) => {
																									e.preventDefault();
																									this.FileView(url);
																								}}
																							/>
																							<button
																								type="button"
																								className="trash-bttn"
																								onClick={(e) => this.delete_DocType_doc(e, url)}
																							>
																								<i className="fa fa-trash-o" aria-hidden="true"></i>
																							</button>
																						</p>)

																						 : <></>
																						}
																							<span className="img-file">
																								<img src={uploadRecruitment} alt="uploadRecruitment" style={{ maxWidth: "26px", maxHeight: "26px", cursor: "pointer" }} />
																								<input
																									style={{ cursor: "pointer" }}
																									type="file"
																									name="upload_doc"
																									accept="application/pdf,.pdf,image/*"
																									onChange={(e) => this.uploadIDDoc(e)}
																								/>
																							</span>
																					</Col>
																				</div>
																			</div>
																		) : null}
																		</>
																		}


																		{this.state.docType_info.country_issue !== "United Kingdom"  ?
																			( this.state.rightToWorkType_info.isvisible &&
																			<Col
																				xs="12"
																				md="5"
																				className="position-relative"
																			>
																				<AvField
																					type="select"
																					name="rightToWorkType"
																					label="Proof of Right to Work"
																					onChange={this.docTypeChangeHandler2}
																					disabled={this.state.docType_info.country_issue === "United Kingdom"}
																					value={this.state.rightToWorkType}
																				>
																					<option value="">Please Select</option>
																					<option value="Visa">
																						Visa
																					</option>
																					<option value="Work Permit">
																						Work Permit
																					</option>
																					<option value="Residence Permit">
																						Residence Permit
																					</option>
																					<option value="Permanent Residence Card">
																						Permanent Residence Card
																					</option>
																					<option value="Biometric Card">
																						Biometric Card
																					</option>
																					<option value="Immigration Status Residence">
																						Immigration Status Residence
																					</option>
																					<option value="Certificate of Naturalisation">
																						Certificate of Naturalisation
																					</option>
																				</AvField>
																			</Col>
																			)
																			 : <></>}


																	</div>
																</div>
															</div>
															{this.state.rightToWorkType !== "" && this.state.docType_info.country_issue !== "United Kingdom" ? (
																( this.state.rightToWorkType_info.isvisible) &&
																<>
																	<div className="section-divder">
																		<div className="card-header">
																			<h4 className="card-title mb-0">
																				{this.state.rightToWorkType} Information
																			</h4>
																		</div>
																		<div className="card-body">
																			<div className="row">
																				<Col
																					xs="12"
																					md="3"
																					className="position-relative"
																				>
																					<AvField
																						type="text"
																						label="Doc Number/Ref"
																						name="Doc_Number"
																						placeholder="Enter Visa Number/Ref"
																						onChange={(e) => this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, doc_no: e.target.value } })}
																						value={this.state.rightToWorkType_info.doc_no}
																					/>
																				</Col>

																				<Col
																					xs="12"
																					md="3"
																					className="position-relative"
																				>
																					<label>Country of Issue</label>
																					<Select
																						name="CountryOfIssue"
																						isClearable={true}
																						isSearchable={true}
																						options={countries}
																						value={
																							this.state.rightToWorkType_info.country_issue_arr
																						}
																						onChange={
																							this.docCountryIssueHandler2
																						}
																					/>
																				</Col>

																				<Col
																					xs="12"
																					md="3"
																					className="position-relative"
																				>
																					<label>Doc Expiry Date </label>

																					<Datetime
																						dateFormat="DD-MM-YYYY"
																						timeFormat={false}
																						closeOnSelect={true}
																						required={true}
																						value={
																							this.state.rightToWorkType_info.expiry_date === "" ||
																								String(this.state.rightToWorkType_info.expiry_date) ===
																								String(undefined) ||
																								String(this.state.rightToWorkType_info.expiry_date) ===
																								String(null) ||
																								String(this.state.rightToWorkType_info.expiry_date) ===
																								String("Invalid date")
																								? ""
																								: moment(
																									this.state.rightToWorkType_info.expiry_date
																								).format("DD-MM-YYYY")
																						}
																						inputProps={{
																							placeholder: "Select Date",
																						}}
																						// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
																						onChange={(e) => {
																							if (e._isValid) {
																								this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, expiry_date: e } });
																							} else if (!e) {
																								this.setState(this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, expiry_date: "" } }));
																							} else {
																								this.setState(this.setState({ rightToWorkType_info: { ...this.state.rightToWorkType_info, expiry_date: "" } }));
																							}
																						}}
																					/>
																				</Col>
																				<Col xs="12"
																					md="3"
																					className="position-relative">
																					{CheckValue(this.state.rightToWorkType_info && this.state.rightToWorkType_info.doc_url && this.state.rightToWorkType_info.doc_url.length > 0) ? (
																						<p className="down-uploads">
																							<UncontrolledTooltip
																								placement="bottom"
																								target={`uploadeducation`}
																							>
																								View Document{" "}
																							</UncontrolledTooltip>
																							<img
																								src={pdf}
																								alt="pdf"
																								id={`uploadeducation`}
																								onClick={(e) => {
																									e.preventDefault();
																									this.FileView(this.state.rightToWorkType_info.doc_url);
																								}}
																							/>
																							<button
																								type="button"
																								className="trash-bttn"
																								onClick={(e) => this.delete_DocType_doc2(e, this.state.rightToWorkType_info.doc_url)}
																							>
																								<i className="fa fa-trash-o" aria-hidden="true"></i>
																							</button>
																						</p>
																					) : (
																						<span className="img-file">
																							<img src={uploadRecruitment} alt="uploadRecruitment" style={{ maxWidth: "26px", maxHeight: "26px", cursor: "pointer" }} />
																							<input
																								style={{ cursor: "pointer" }}
																								type="file"
																								name="upload_doc"
																								accept="application/pdf,.pdf,image/*"
																								onChange={(e) => this.uploadIDDoc2(e)}
																							/>
																						</span>)}
																				</Col>
																			</div>
																		</div>
																	</div>
																</>
															) : null}
															</>
															}

															{
															// yourPersonalDetailsIsVisible("Driving License Details") && 	
															this.state.drivinglicenceisVisible && 													
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		Driving License Details
																	</h4>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				name="drivinglicence"
																				label="Do you have a driving License?"
																				value={this.state.drivinglicence}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={() =>
																						this.drivelicenceyes("yes")
																					}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.drivelicenceyes}
																				/>
																			</AvRadioGroup>
																		</Col>
																		{this.state.drivinglicence === "yes" ? (
																			<>
																				<Col
																					xs="12"
																					md="4"
																					className="position-relative"
																				>
																					<AvField
																						type="text"
																						label="License Number"
																						name="drivinglicenceno"
																						placeholder="Enter License Number"
																						onChange={this.onChange}
																						value={this.state.drivinglicenceno}
																					/>
																				</Col>
																				<Col
																					xs="12"
																					md="4"
																					className="position-relative"
																				>
																					<div class="form-group">
																						<label>Country of Issue</label>
																						<Select
																							name="drivingCountryOfIssue"
																							isClearable={true}
																							isSearchable={true}
																							options={countries}
																							value={
																								this.state
																									.drivingCountryOfIssue_arr
																							}
																							onChange={
																								this.onSelectModule_Change
																							}
																						/>
																					</div>
																				</Col>
																				<Col
																					xs="12"
																					md="4"
																					className="position-relative"
																				>
																					<div class="form-group">
																						<label>
																							License Expiry Date{" "}
																							<span style={{ color: "red" }}>
																								*
																							</span>{" "}
																						</label>

																						<Datetime
																							dateFormat="DD-MM-YYYY"
																							timeFormat={false}
																							closeOnSelect={true}
																							required={true}
																							value={
																								this.state.licenceExpiry ===
																									"" ||
																									String(
																										this.state.licenceExpiry
																									) === String(undefined) ||
																									String(
																										this.state.licenceExpiry
																									) === String(null) ||
																									String(
																										this.state.licenceExpiry
																									) === String("Invalid date")
																									? ""
																									: moment(
																										this.state.licenceExpiry
																									).format("DD-MM-YYYY")
																							}
																							inputProps={{
																								placeholder: "Select Date",
																							}}
																							// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
																							onChange={(e) => {
																								if (e._isValid) {
																									this.setState({
																										licenceExpiry: e,
																									});
																								} else if (!e) {
																									this.setState({
																										licenceExpiry: null,
																									});
																								} else {
																									this.setState({
																										licenceExpiry: null,
																									});
																								}
																							}}
																						/>
																					</div>
																				</Col>

																				<Col
																					xs="12"
																					md="4"
																					className="position-relative"
																				>
																					<div class="form-group">
																						<AvField
																							type="text"
																							label="License Class"
																							name="licenceClass"
																							placeholder="Enter License Class"
																							onChange={this.onChange}
																							value={this.state.licenceClass}
																						/>
																					</div>
																				</Col>
																			</>
																		) : null}

																		{this.state.reduceworkflexibility ===
																			"yes" ? (
																			<>
																				<Col xs="12" md="4">
																					<AvRadioGroup
																						inline
																						name="caraccess"
																						label="Do you have access to a car that you can use for work?"
																						value={this.state.caraccess}
																					>
																						<AvRadio
																							label="Yes"
																							value="yes"
																							onClick={() =>
																								this.caraccessyes("yes")
																							}
																						/>
																						<AvRadio
																							label="No"
																							value="no"
																							onClick={this.caraccessyes}
																						/>
																					</AvRadioGroup>
																				</Col>

																				<Col xs="12" md="4">
																					<AvRadioGroup
																						inline
																						name="bannedfromdriving"
																						label="Have you been banned from driving. or do you have any current endorsements on you License?"
																						value={this.state.bannedfromdriving}
																					>
																						<AvRadio label="Yes" value="yes" />
																						<AvRadio label="No" value="no" />
																					</AvRadioGroup>
																				</Col>
																			</>
																		) : null}

																		{this.state.documentType === "" ||
																			this.state.documentType === "Passport" ||
																			this.state.documentType ===
																			"Residence Permit" ||
																			this.state.documentType ===
																			"Permanent Residence card" ||
																			this.state.documentType ===
																			"Biometric Card" ? null : (
																			<Col
																				xs="12"
																				md="4"
																				className="position-relative"
																			>
																				<AvField
																					type="select"
																					name="drivingPhotoID"
																					label="Photo ID"
																					value={this.state.drivingPhotoID}
																				>
																					<option>Please Select</option>
																					<option value="Driving Licence">
																						Driving License
																					</option>
																					<option value="public">
																						National ID{" "}
																					</option>
																					<option value="Travel Document">
																						Travel Document
																					</option>
																					<option value="other">Other</option>
																				</AvField>
																			</Col>
																		)}
																	</div>
																</div>
															</div>
															}


															{
															// yourPersonalDetailsIsVisible("LANGUAGE DETAILS") &&
																								
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		LANGUAGE DETAILS
																	</h4>
																</div>
																<div className="card-body">
																	<Row>
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				name="englishspoken"
																				label="English - Spoken"
																				value={this.state.englishspoken}
																				onChange={(e) => this.englishSpoken(e)}
																			>
																				<AvRadio
																					label="Fluent"
																					value="fluent"
																				/>
																				<AvRadio label="Good" value="good" />
																				<AvRadio label="Fair" value="fair" />
																			</AvRadioGroup>
																		</Col>
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				name="englishwritten"
																				label={"English - Written"}
																				value={this.state.englishwritten}
																				onChange={(e) => this.englishWritten(e)}
																			>
																				<AvRadio
																					label="Fluent"
																					value="fluent"
																				/>
																				<AvRadio label="Good" value="good" />
																				<AvRadio label="Fair" value="fair" />
																			</AvRadioGroup>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<label>Other Languages Spoken</label>
																			<Select
																				name="otherlanguage"
																				isClearable={true}
																				isSearchable={true}
																				options={languages}
																				value={this.state.otherlanguage}
																				isMulti
																				required
																				onChange={this.languages_change_arr}
																			/>
																		</Col>

																		{this.state.englishspoken === "fair" ||
																			this.state.englishwritten === "fair" ? (
																			<>
																				<Col xs="12" md="12">
																					<AvRadioGroup
																						inline
																						label={
																							"Have you passed each of the academic modules of the IELTS test?"
																						}
																						name="IELTStest"
																						value={this.state.IELTStest}
																					>
																						<AvRadio
																							label="Yes"
																							value="yes"
																							onClick={() =>
																								this.IELTStestyes("yes")
																							}
																						/>
																						<AvRadio
																							label="No"
																							value="no"
																							onClick={this.IELTStestyes}
																						/>
																					</AvRadioGroup>
																				</Col>
																				<Col xs="12" md="12">
																					<AvRadioGroup
																						inline
																						label={
																							"Have you passed each of the academic modules of the IELTS test?"
																						}
																						name="IELTStest"
																						value={this.state.IELTStest}
																					>
																						<AvRadio
																							label="Yes"
																							value="yes"
																							onClick={() =>
																								this.IELTStestyes("yes")
																							}
																						/>
																						<AvRadio
																							label="No"
																							value="no"
																							onClick={this.IELTStestyes}
																						/>
																					</AvRadioGroup>
																				</Col>
																				{this.state.IELTStestyes ? (
																					<Col xs="12" md="12">
																						<p className="pl-note">
																							<strong> Please note:</strong> you
																							have to provide copies of all
																							IELTS certificates held by you
																						</p>
																					</Col>
																				) : null}
																			</>
																		) : null}
																	</Row>
																</div>
															</div>
															}

															{
															// yourPersonalDetailsIsVisible("DBS DETAILS") &&
															this.state.dbsisVisible &&  														
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		DBS DETAILS
																	</h4>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				label={"Do you have a current DBS"}
																				name="currentDBS"
																				value={this.state.currentDBS}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onChange={(e) => {
																						this.onSelectChange(e);
																					}}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onChange={(e) => {
																						this.onSelectChange(e);
																					}}
																				/>
																			</AvRadioGroup>
																		</Col>
																		{this.state.currentDBS &&
																			String(this.state.currentDBS) === "yes" ? (
																			<>
																				<Col
																					xs="12"
																					md="4"
																					className="position-relative"
																				>
																					<AvField
																						type="text"
																						label="Certificate No"
																						name="dbsCertificateNo"
																						placeholder="Enter Certificate No"
																						onChange={this.onChange}
																						value={this.state.dbsCertificateNo}
																					/>
																				</Col>
																				<Col
																					xs="12"
																					md="4"
																					className="position-relative"
																				>
																					<label>
																						Issue Date{" "}
																						<span style={{ color: "red" }}>
																							*
																						</span>{" "}
																					</label>

																					<Datetime
																						dateFormat="DD-MM-YYYY"
																						timeFormat={false}
																						closeOnSelect={true}
																						required={true}
																						value={
																							this.state.dbsIssueDate === "" ||
																								String(
																									this.state.dbsIssueDate
																								) === String(undefined) ||
																								String(
																									this.state.dbsIssueDate
																								) === String(null) ||
																								String(
																									this.state.dbsIssueDate
																								) === String("Invalid date")
																								? ""
																								: moment(
																									this.state.dbsIssueDate
																								).format("DD-MM-YYYY")
																						}
																						inputProps={{
																							placeholder: "Select Date",
																						}}
																						// isValidDate={current => current.isBefore(moment(new Date()).subtract(18, "years"))}
																						onChange={(e) => {
																							if (e._isValid) {
																								this.setState({
																									dbsIssueDate: e,
																								});
																							} else if (!e) {
																								this.setState({
																									dbsIssueDate: null,
																								});
																							} else {
																								this.setState({
																									dbsIssueDate: null,
																								});
																							}
																						}}
																					/>
																				</Col>
																				<Col
																					xs="12"
																					md="4"
																					className="position-relative"
																				>
																					<div className="form-group">
																						<label>Expiry Date</label>
																						<Datetime
																							dateFormat="DD-MM-YYYY"
																							timeFormat={false}
																							closeOnSelect={true}
																							required={true}
																							value={
																								this.state.dbsExpirydate &&
																									CheckValue(
																										this.state.dbsExpirydate
																									)
																									? moment(
																										new Date(
																											this.state.dbsExpirydate
																										)
																									).format("DD-MM-YYYY")
																									: ""
																							}
																							inputProps={{
																								placeholder: "Select Date",
																							}}
																							onChange={(e) => {
																								if (e._isValid) {
																									this.setState({
																										dbsExpirydate: e,
																									});
																								} else if (!e) {
																									this.setState({
																										dbsExpirydate: null,
																									});
																								} else {
																									this.setState({
																										dbsExpirydate: null,
																									});
																								}
																							}}
																						/>
																					</div>
																				</Col>
																			</>
																		) : null}
																	</div>
																</div>
															</div>
															}

															{
															// yourPersonalDetailsIsVisible("NEXT OF KIN/EMERGENCY CONTACT") && 														
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		NEXT OF KIN/EMERGENCY CONTACT
																	</h4>
																</div>
																<div className="card-body">
																	<Row>
																		{/* <Col xs="12" md="3">
                                                                <AvField type="select" name="kinprefix" label="Prefix" placeholder="Select Prefix" value={kinprefix} >
                                                                    <option>Please Select</option>
                                                                    <option value="mr">Mr.</option>
                                                                    <option value="mrs">Mrs.</option>
                                                                    <option value="miss">Miss.</option>
                                                                    <option value="ms">Ms.</option>
                                                                    <option value="dr">Dr.</option>
                                                                    <option value="prof">Prof.</option>
                                                                    <option value="rev">Rev.</option>
                                                                </AvField>
                                                            </Col> */}
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="First Name"
																				name="kinfirstname"
																				placeholder="Enter First Name"
																				onChange={this.onChange}
																				value={this.state.kinfirstname}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Last Name"
																				name="kinlastname"
																				placeholder="Enter Last Name"
																				onChange={this.onChange}
																				value={this.state.kinlastname}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Relationship to you:"
																				name="kinrelationship"
																				placeholder="Enter Relationship to you:"
																				onChange={this.onChange}
																				value={this.state.kinrelationship}
																			/>
																		</Col>

																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="number"
																				label="Home/Work Phone"
																				name="kinhomephone"
																				placeholder="Enter Home/Work Phone"
																				onChange={this.onChange}
																				value={this.state.kinhomephone}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			{/* <AvField type="number" label="Mobile No" name="kinmobileno" placeholder="Enter Mobile Number" onChange={this.onChange} value={kinmobileno} required /> */}
																			<Label
																				className={
																					this.state.phoneerror1
																						? "error-color"
																						: null
																				}
																			>
																				Mobile No
																			</Label>
																			<IntlTelInput
																				placeholder=""
																				style={{ width: "100%" }}
																				defaultCountry={
																					this.state.kinmobileno.dailcountry
																				}
																				utilsScript={libphonenumber}
																				css={
																					this.state.phoneerror1
																						? [
																							"intl-tel-input",
																							"form-control",
																							"error-color",
																						]
																						: ["intl-tel-input", "form-control"]
																				}
																				onPhoneNumberChange={this.handler1}
																				// value={kinmobileno && kinmobileno.number}
																				value={this.state.kinmobileno.number}
																			/>
																			{this.state.phoneerror1 ? (
																				<div className={"error-color"}>
																					Enter Valid Phone Number!
																				</div>
																			) : null}
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="email"
																				label="Email Address"
																				name="kinemail"
																				placeholder="Enter Email Address"
																				onChange={this.onChange}
																				value={this.state.kinemail}
																			/>
																		</Col>
																		<Col xs="12" md="12">
																			<strong className="an-heading">
																				Address
																			</strong>
																		</Col>
																		<Col className="che-box">
																			<AvInput
																				type="checkbox"
																				name="save_as_my_current"
																				id="save_as_my_current"
																				checked={this.state.save_as_my_current}
																				value={this.state.save_as_my_current}
																				onChange={(e) =>
																					this.change_toggle(
																						e,
																						"save_as_my_current"
																					)
																				}
																			/>{" "}
																			Same as my current address
																		</Col>

																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<div className="form-group">
																				<Label>Street Address</Label>
																				<PlacesAutocomplete
																					value={this.state.kinstreetAddress}
																					onChange={this.handleChange_kin_addr}
																					onSelect={this.handleSelect_kin_addr}
																					onFocus={this.geolocate}
																				>
																					{({
																						getInputProps,
																						suggestions,
																						getSuggestionItemProps,
																					}) => (
																						<div>
																							<input
																								{...getInputProps({
																									placeholder: "Search Places",
																									className:
																										"form-control serach-place",
																								})}
																							/>
																							<div className="autocomplete-dropdown-container absolute">
																								{suggestions.map(
																									(suggestion) => {
																										const className =
																											suggestion.active
																												? "suggestion-item--active"
																												: "suggestion-item";
																										// inline style for demonstration purpose
																										const style =
																											suggestion.active
																												? {
																													backgroundColor:
																														"#fafafa",
																													cursor: "pointer",
																												}
																												: {
																													backgroundColor:
																														"#ffffff",
																													cursor: "pointer",
																												};
																										return (
																											<div
																												{...getSuggestionItemProps(
																													suggestion,
																													{
																														className,
																														style,
																													}
																												)}
																											>
																												<span>
																													{
																														suggestion.description
																													}
																												</span>
																											</div>
																										);
																									}
																								)}
																							</div>
																						</div>
																					)}
																				</PlacesAutocomplete>
																			</div>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Address Line 2"
																				name="kinaddressline2"
																				placeholder="Enter Address Line 2"
																				onChange={this.onChange}
																				value={this.state.kinaddressline2}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="City"
																				name="kincity"
																				placeholder="Enter City"
																				onChange={this.onChange}
																				value={this.state.kincity}
																			/>
																		</Col>

																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="State / Region"
																				name="kinstate"
																				placeholder="Enter State"
																				onChange={this.onChange}
																				value={this.state.kinstate}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="ZIP / Postal Code"
																				name="kinzip"
																				placeholder="Enter ZIP / Postal Code"
																				onChange={this.onChange}
																				value={this.state.kinzip}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Country"
																				name="kincountry"
																				placeholder="Enter Country"
																				onChange={this.onChange}
																				value={this.state.kincountry}
																			/>
																		</Col>
																	

																		{
																			this.addtionalFieldsFilterByHeading("Your Personal Details" ,"NEXT OF KIN/EMERGENCY CONTACT").map((item)=>{
																				const TYPE = item && item.field_type && item.field_type.toUpperCase() || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				let field_value = (this.state.addtionalFieldsValue.find(fld => fld._id === item._id) || {}).field_value;
																				    field_value = item.field_value || field_value;
																					item.field_value = field_value;
																				// console.log({item})
																				return <Field key={item._id} {...item} onChange={this.handleOnlineFormChange} />
																			})
																		}


																	</Row>
																</div>
															</div>
															}


															<div className="card-footer text-right">
																<button
																	className="btn btn-primary btn-save"
																	type="submit"
																	disabled={this.state.active_tab_1 }
																	onClick={() => {
																		this.update_1st_tab("update");
																	}}
																>
																	Save
																</button>{" "}
																<button
																	className="btn btn-primary"
																	type="submit"
																	disabled={this.state.active_tab_1}
																	onClick={() => {
																		this.update_1st_tab("next");
																	}}
																>
																	{"Continue"}
																</button>
															</div>



														</AvForm>
													</div>
												</TabPane>
												<TabPane tabId="2">
													<div className="col-lg-12 edit-list-box">
														<AvForm
															className="card"
															onSubmit={this.OnFormEmploymentEducation}
														>

															{
															employmentAndEducation("Qualifications") && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		Qualifications
																	</h4>
																	<p className="font-weight">
																		Please add and upload certificates of your
																		qualifications.
																	</p>
																</div>
																<div className="card-body">
																	<Col xs="12" md="12" className="mar-ops">
																		{this.state.education_qualification.length >
																			0 ? (
																			<div className="new-table hiding-calendar">
																				<table className="table">
																					<tr>
																						<th scope="col">Course</th>
																						<th scope="col">Level</th>
																						<th scope="col">Title</th>
																						<th scope="col">
																							Date of Qualification
																						</th>
																						{/* <th scope="col">Renewal (Tick if Yes)</th> */}
																						<th scope="col">
																							Renewal (Tick if Yes)
																						</th>
																						<th colspan="2">Upload</th>
																					</tr>
																					{this.createQualificationsUI()}
																				</table>
																			</div>
																		) : null}
																	</Col>
																	<Col xs="12" md="6">
																		<Button onClick={this.onAddFormEducation}>
																			+
																		</Button>
																	</Col>
																</div>
															</div>
															}


																			
															{/* Training & Other Courses (Mandatory Training) */}
															{
															employmentAndEducation("Training & Other Courses (Mandatory Training)") &&
															<>
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		Training & Other Courses (Mandatory
																		Training)
																	</h4>
																	<p className="font-weight">
																		Please add all the mandatory training that
																		you have completed within the last 12 months
																		You will be required to provide copies of
																		your training certificates
																	</p>
																</div>
																<div className="card-body">
																	<Col xs="12" md="12" className="mar-ops">
																		{this.state.other_courses.length > 0 ? (
																			<div className="new-table hiding-calendar">
																				<table className="table">
																					<tr>
																						<th scope="col">Course</th>
																						<th scope="col">Level</th>
																						<th scope="col">Title</th>
																						<th colspan="col">
																							Date of Qualification
																						</th>
																						<th scope="col">Expiry Date</th>
																						<th colspan="2">Upload</th>
																					</tr>
																					{this.createOtherCoursesUI()}
																				</table>
																			</div>
																		) : null}
																	</Col>
																	<Col xs="12" md="6">
																		<Button onClick={this.onAddOtherEducation}>
																			+
																		</Button>
																	</Col>
																</div>
															</div>
															<div className="section-divder">
																<div className="card-body">
																	<p className="font-weight">
																		If you cannot provide evidence for mandatory
																		training (if needed for the role) you will
																		have to complete the relevant training
																		before starting work.
																	</p>
																</div>
															</div>
															</>
															}

															{
															employmentAndEducation("Professional Body Memberships") && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		Professional Body Memberships
																	</h4>
																	<p className="font-weight">
																		Please add details of professional bodies
																		that you are affiliated with, eg NMC, SWE
																		etc.
																	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		{/* <Col
                                      xs="12"
                                      md="4"
                                      className="position-relative"
                                    >
                                      <AvField
                                        type="text"
                                        label="Body"
                                        name="professionalBody"
                                        placeholder="Enter Body"
                                        onChange={this.onChange}
                                        value={this.state.professionalBody}
                                      />
                                    </Col>
                                    <Col
                                      xs="12"
                                      md="4"
                                      className="position-relative"
                                    >
                                      <AvField
                                        type="text"
                                        label="PIN/REF"
                                        name="pinRef"
                                        placeholder="Enter PIN/REF"
                                        onChange={this.onChange}
                                        value={this.state.pinRef}
                                      />
                                    </Col>

                                    <Col
                                      xs="12"
                                      md="4"
                                      className="position-relative"
                                    >
                                      <label>Expiry Date</label>
                                      <Datetime
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        closeOnSelect={true}
                                        value={
                                          this.state.professionalBodyExpiry ===
                                            ""
                                            ? ""
                                            : moment(
                                              this.state
                                                .professionalBodyExpiry
                                            ).format("DD-MM-YYYY")
                                        }
                                        inputProps={{
                                          placeholder: "Pick Date",
                                        }}
                                        onChange={(e) => {
                                          if (e._isValid) {
                                            this.setState({
                                              professionalBodyExpiry: e,
                                            });
                                          } else if (!e) {
                                            this.setState({
                                              professionalBodyExpiry: null,
                                            });
                                          } else {
                                            this.setState({
                                              professionalBodyExpiry: null,
                                            });
                                          }
                                        }}
                                      />
                                    </Col> */}
																		<Col className="mar-ops" xs="12" md="12">
																			{this.state.professional_Body &&
																				this.state.professional_Body.length >
																				0 ? (
																				<div className="new-table hiding-calendar">
																					<table className="table">
																						<tr>
																							<th scope="col">
																								Body/Institution/Description
																							</th>
																							<th scope="col">PIN/REF </th>
																							<th scope="col">Expiry Date </th>
																							<th colspan="2"> Upload </th>
																						</tr>
																						{this.create_professional_body()}
																					</table>
																				</div>
																			) : null}
																		</Col>
																		<Col xs="12" md="6">
																			<Button
																				onClick={this.add_professional_body}
																			>
																				+
																			</Button>
																		</Col>
																	</div>
																</div>
															</div>
															}

															<div className="card-footer text-right">
																<button
																	className="btn btn-primary"
																	onClick={(e) => {
																		this.previous(e);
																	}}
																>{`< Previous`}</button>{" "}
																<button
																	className="btn btn-primary btn-save"
																	type="submit"
																	disabled={this.state.active_tab_2}
																	onClick={() => {
																		this.update_2_tab("update");
																	}}
																>
																	Save
																</button>{" "}
																<button
																	className="btn btn-primary"
																	type="submit"
																	disabled={this.state.active_tab_2}
																	onClick={() => {
																		this.update_2_tab("next");
																	}}
																>
																	{"Continue"}
																</button>
															</div>


														</AvForm>
													</div>
												</TabPane>

												<TabPane tabId="3">
													<div className="col-lg-12 edit-list-box">
														<AvForm
															className="card"
															onSubmit={this.OnFormSkills}
														>
															<div className="section-divder">
															
															{

															skillsAndWorkHistoryIsVisible("WORK HISTORY") && 
															<>
																<div className="card-header">
																	<h5 className="card-title mb-0">
																		WORK HISTORY
																	</h5>
																	<p className="font-weight">
																		Please ensure you complete this section.
																		Please ensure that you leave no gaps
																		unaccounted for and it covers full work
																		history including your education.<br></br>
																		1. Full work history including your
																		education
																		<br></br>
																		2. Dates to and from should be continual
																		with NO gaps<br></br>
																		3. Month and year should be sufficient if
																		exact date is not available , any date in
																		that month can be selected<br></br>
																		4. Where there have been gaps in work
																		history please state the reason for the gaps
																		<br></br>
																		5. Lists all relevant training undertaken in
																		the section below
																	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col xs="12" md="12">
																			{/* {this.state.work_experience.length > 0 ? ( */}
																			<div className="new-table hiding-calendar">
																				<table className="table">
																					<tr>
																						<th scope="col">Work Title</th>
																						<th scope="col">Employer</th>
																						<th scope="col">From Date</th>
																						<th scope="col">To Date</th>
																						<th> </th>
																					</tr>
																					{this.createWorkExperienceUI()}
																				</table>
																			</div>
																			{/* ) : null} */}
																		</Col>
																		<Col xs="12" md="4" className="mt-2 mb-3">
																			<Button
																				onClick={this.onAddWorkExperience}
																			>
																				+
																			</Button>
																		</Col>
																	</div>
																</div>
															</>
															}


															{
															skillsAndWorkHistoryIsVisible('PROVIDE DETAILS OF GAPS IF ANY') && 
																<div className="section-divder">
																<div className="card-header">
																	<h5 className="card-title mb-0">
																		Provide Details of gaps if any
																	</h5>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col xs="12" md="8">
																			<AvField
																				type="textarea"
																				label="Details"
																				name="skillProvideDetails"
																				placeholder="Provide Details"
																				onChange={this.onChange}
																				value={this.state.skillProvideDetails}
																			/>
																		</Col>
																	</div>
																</div>
																</div>
															}

															{
															skillsAndWorkHistoryIsVisible("Others") &&
																<div className="sens-infos pad-ext">
																	<Col xs="12" md="6">
																		<Label>Skills</Label>
																		<input
																			id="myInput_skill"
																			type="search"
																			placeholder="... start typing to search or Add New Skill"
																			name="skill_search"
																			autoComplete="nope"
																			value={this.state.skill_search}
																			onSelect={(record) => {
																				this.setState(
																					{ oninputselect_skill: true },
																					() => { }
																				);
																			}}
																			onFocus={() => {
																				this.setState({
																					oninputselect_skill: true,
																				});
																			}}
																			onChange={(e) => {
																				this.setState(
																					{ skill_search: e.target.value },
																					() => {
																						this.onSkillSearch();
																					}
																				);
																			}}
																		/>
																		<ul
																			className={`myULsearch_skill ${this.state.oninputselect_skill
																					? "none-display_skill"
																					: ""
																				}`}
																		>
																			{this.state.skill_search_data &&
																				this.state.skill_search_data.length >
																				0 &&
																				this.state.skill_search_data.map(
																					(item, i) => (
																						<li key={i}>
																							<a
																								onClick={(e) =>
																									this.onAddSkills(item, null)
																								}
																							>
																								{item.value}
																							</a>
																						</li>
																					)
																				)}
																			<li>
																				<a
																					onClick={this.addNewSkill}
																					className="add-new-grade"
																				>
																					+ Add New Skill
																				</a>
																			</li>
																		</ul>
																		<div className="uppend-divs mb-5">
																			{this.createSkillsUI()}
																		</div>
																	</Col>
																	<Col xs="12" md="6">
																		<Label>Languages</Label>
																		<input
																			id="myInput_skill"
																			type="search"
																			name="language_search"
																			placeholder="... start typing to search or Add New Language"
																			autoComplete="nope"
																			value={this.state.language_search}
																			onSelect={(record) => {
																				this.setState(
																					{ onlanguageselect: true },
																					() => { }
																				);
																			}}
																			onFocus={() => {
																				this.setState({
																					onlanguageselect: true,
																				});
																			}}
																			onChange={(e) => {
																				this.setState(
																					{ language_search: e.target.value },
																					() => {
																						this.onLanguageSearch();
																					}
																				);
																			}}
																		/>
																		<ul
																			className={`myULsearch_skill ${this.state.onlanguageselect
																					? "none-display_skill"
																					: ""
																				}`}
																		>
																			{this.state.language_search_data &&
																				this.state.language_search_data.length >
																				0 &&
																				this.state.language_search_data.map(
																					(item, i) => (
																						<li key={i}>
																							<a
																								onClick={(e) =>
																									this.onAddLanguages(
																										item,
																										null
																									)
																								}
																							>
																								{item.value}
																							</a>
																						</li>
																					)
																				)}
																			<li>
																				<a
																					onClick={this.addNewLanguage}
																					className="add-new-grade"
																				>
																					{" "}
																					+ Add New Language
																				</a>
																			</li>
																		</ul>
																		<div className="uppend-divs mb-5">
																			{this.createLanguagesUI()}
																		</div>
																	</Col>
																</div>
															}

															</div>

															{/* <div className="section-divder">
																<div className="card-header">
																	<h5 className="card-title mb-0">Emergency Contacts</h5>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col xs="12" md="12">
																			{this.createEmergencyContactsUI()}
																		</Col>
																		<Col xs="12" md="4" className="mb-3">
																			<Button onClick={this.onAddEmergencyContacts}>
																				+
																			</Button>
																		</Col>
																	</div>
																</div>
															</div> */}

															

															<div
																className="card-footer text-right"
																align="right"
															>
																<button
																	className="btn btn-primary"
																	onClick={(e) => {
																		this.previous(e);
																	}}
																>{`<  Previous`}</button>{" "}
																<button
																	className="btn btn-primary btn-save"
																	type="submit"
																	disabled={this.state.active_tab_3}
																	onClick={() => {
																		this.update_3_tab("update");
																	}}
																>
																	Save
																</button>{" "}
																<button
																	className="btn btn-primary"
																	type="submit"
																	disabled={this.state.active_tab_3}
																	onClick={() => {
																		this.update_3_tab("next");
																	}}
																>
																	{`Continue`}{" "}
																</button>
															</div>
															
														</AvForm>
													</div>
												</TabPane>

												<TabPane tabId="4">
													<div className="col-lg-12 edit-list-box">
														<AvForm
															className="card"
															onSubmit={this.OnFormDeclaration}
														>

															{/* iF the template has the DEFINITIONS is visible or not  */}
															{
															declarationAndTermIsVisible("DEFINITIONS") &&  
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		DEFINITIONS
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight"> <RenderHtml rawhtml={declarationAndTermIsVisible("DEFINITIONS").template && declarationAndTermIsVisible("DEFINITIONS").template.templateValue ||  declarationAndTermIsVisible("DEFINITIONS").field_name} /> 	</p>
																</div>
															</div>
															}



															{
															declarationAndTermIsVisible("WORKING TIME REGULATIONS") && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		WORKING TIME REGULATIONS{" "}
																		<span style={{ color: "red" }}>*</span>
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight"> <RenderHtml rawhtml={ declarationAndTermIsVisible("WORKING TIME REGULATIONS").template && declarationAndTermIsVisible("WORKING TIME REGULATIONS").template.templateValue ||  declarationAndTermIsVisible("WORKING TIME REGULATIONS").field_name} /> </p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Datetime
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				value={
																					this.state.workTimeDate === "" ||
																						String(this.state.workTimeDate) ===
																						String(undefined) ||
																						String(this.state.workTimeDate) ===
																						String(null) ||
																						String(this.state.workTimeDate) ===
																						String("Invalid date")
																						? moment().format("DD-MM-YYYY")
																						: moment(
																							this.state.workTimeDate
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																				}}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							workTimeDate: e,
																						});
																					} else if (!e) {
																						this.setState({
																							workTimeDate: null,
																						});
																					} else {
																						this.setState({
																							workTimeDate: null,
																						});
																					}
																				}}
																			/>
																		</Col>
																		<Col xs="12" md="12">
																			<button
																				className="btn btn-primary ma-spaces"
																				onClick={(e) => {
																					this.workingTimeSignatureModal(e);
																				}}
																			>
																				{this.state.workTimeSignature &&
																					this.state.workTimeSignature.length > 0
																					? "Replace Signature"
																					: "Click to Sign"}
																			</button>
																			{this.state.workTimeSignature.includes(
																				"/"
																			) &&
																				this.state.workTimeSignature.length >
																				0 ? (
																				<Col
																					xs="6"
																					md="6"
																					className="margin-ranges"
																				>
																					<img
																						src={`${NodeURL}/${this.state.workTimeSignature}`}
																						alt="workTimeSignature"
																					/>
																				</Col>
																			) : this.state.workTimeSignature &&
																				this.state.workTimeSignature.length >
																				0 ? (
																				<h3
																					style={{
																						fontFamily:
																							"Brush Script MT, cursive",
																						fontWeight: "500",
																						fontSize: "25px",
																					}}
																				>
																					{this.state.workTimeSignature}
																				</h3>
																			) : null}
																		</Col>
																	</div>
																</div>
															</div>
															}


															{
															declarationAndTermIsVisible("HEALTH DECLARATION") && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		HEALTH DECLARATION
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight"> <RenderHtml rawhtml={declarationAndTermIsVisible("HEALTH DECLARATION").template && declarationAndTermIsVisible("HEALTH DECLARATION").template.templateValue || declarationAndTermIsVisible("HEALTH DECLARATION").field_name} /> </p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Datetime
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				value={
																					this.state.HealthDeclarationDate ===
																						"" ||
																						String(
																							this.state.HealthDeclarationDate
																						) === String(undefined) ||
																						String(
																							this.state.HealthDeclarationDate
																						) === String(null) ||
																						String(
																							this.state.HealthDeclarationDate
																						) === String("Invalid date")
																						? moment().format("DD-MM-YYYY")
																						: moment(
																							this.state.HealthDeclarationDate
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																				}}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							HealthDeclarationDate: e,
																						});
																					} else if (!e) {
																						this.setState({
																							HealthDeclarationDate: null,
																						});
																					} else {
																						this.setState({
																							HealthDeclarationDate: null,
																						});
																					}
																				}}
																			/>
																		</Col>
																	</div>
																</div>
															</div>

															}


															{
															declarationAndTermIsVisible("PERSONAL DECLARATION") &&
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		PERSONAL DECLARATION
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight">	<RenderHtml rawhtml={declarationAndTermIsVisible("PERSONAL DECLARATION").template &&  declarationAndTermIsVisible("PERSONAL DECLARATION").template.templateValue || declarationAndTermIsVisible("PERSONAL DECLARATION").field_name} />	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Datetime
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				value={
																					this.state.PersonalDeclarationDate ===
																						"" ||
																						String(
																							this.state.PersonalDeclarationDate
																						) === String(undefined) ||
																						String(
																							this.state.PersonalDeclarationDate
																						) === String(null) ||
																						String(
																							this.state.PersonalDeclarationDate
																						) === String("Invalid date")
																						? moment().format("DD-MM-YYYY")
																						: moment(
																							this.state
																								.PersonalDeclarationDate
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																				}}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							PersonalDeclarationDate: e,
																						});
																					} else if (!e) {
																						this.setState({
																							PersonalDeclarationDate: null,
																						});
																					} else {
																						this.setState({
																							PersonalDeclarationDate: null,
																						});
																					}
																				}}
																			/>
																		</Col>
																	</div>
																</div>
															</div>

															}


															{
															declarationAndTermIsVisible("CONFIDENTIALITY") &&
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		CONFIDENTIALITY
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight">	<RenderHtml rawhtml={declarationAndTermIsVisible("CONFIDENTIALITY").template && declarationAndTermIsVisible("CONFIDENTIALITY").template.templateValue ||  declarationAndTermIsVisible("CONFIDENTIALITY").field_name} />	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Datetime
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				value={
																					this.state.ConfidentialityDate ===
																						"" ||
																						String(
																							this.state.ConfidentialityDate
																						) === String(undefined) ||
																						String(
																							this.state.ConfidentialityDate
																						) === String(null) ||
																						String(
																							this.state.ConfidentialityDate
																						) === String("Invalid date")
																						? moment().format("DD-MM-YYYY")
																						: moment(
																							this.state.ConfidentialityDate
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																				}}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							ConfidentialityDate: e,
																						});
																					} else if (!e) {
																						this.setState({
																							ConfidentialityDate: null,
																						});
																					} else {
																						this.setState({
																							ConfidentialityDate: null,
																						});
																					}
																				}}
																			/>
																		</Col>
																	</div>
																</div>
															</div>

															}


															{
															declarationAndTermIsVisible("REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS") &&
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		REHABILITATION OF OFFENDERS ACT 1974 {"&"} CRIMINAL RECORDS
																	</h4>
																	<p className="font-weight">
																	<RenderHtml rawhtml={declarationAndTermIsVisible("REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS").template && declarationAndTermIsVisible("REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS").template.templateValue ||  declarationAndTermIsVisible("REHABILITATION OF OFFENDERS ACT 1974 & CRIMINAL RECORDS").field_name} />
																	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				label={
																					"Have you been convicted of a criminal offence?"
																				}
																				name="criminaloffence"
																				value={this.state.criminaloffence}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				label={`Have you ever been cautioned or issued with a formal warning for a criminal
                                                                        offence?`}
																				name="criminalCautioned"
																				value={this.state.criminalCautioned}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				label={`Do you have any spent or unspent criminal convictions or cautions?`}
																				name="criminalConvictions"
																				value={this.state.criminalConvictions}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>

																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				label={`Have you ever been involved in court proceedings?`}
																				name="criminalCourt"
																				value={this.state.criminalCourt}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				inline
																				label={`Have you ever had disciplinary action taken against you?`}
																				name="criminalDisciplinaryAction"
																				value={
																					this.state.criminalDisciplinaryAction
																				}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		{String(
																			this.state.criminalDisciplinaryAction
																		) === "yes" ||
																			String(this.state.criminalCourt) ===
																			"yes" ||
																			String(this.state.criminalConvictions) ===
																			"yes" ||
																			String(this.state.criminalCautioned) ===
																			"yes" ||
																			String(this.state.criminaloffence) ===
																			"yes" ? (
																			<Col xs="12" md="12">
																				<AvField
																					type="textarea"
																					label="Please give any additional information
																			which you think may be relevant in
																			support of your application on below."
																					name="criminalAdditionalInformation"
																					placeholder="Provide details"
																					onChange={this.onChange}
																					value={
																						this.state
																							.criminalAdditionalInformation
																					}
																				/>
																			</Col>
																		) : null}
																	</div>
																</div>
															</div>
															}

															{
															declarationAndTermIsVisible("Disclosure Barring Service (DBS)") &&
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		Disclosure Barring Service (DBS)
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight"> <RenderHtml rawhtml={declarationAndTermIsVisible("Disclosure Barring Service (DBS)").template && declarationAndTermIsVisible("Disclosure Barring Service (DBS)").template.templateValue || declarationAndTermIsVisible("Disclosure Barring Service (DBS)").field_name} /> </p>

																	<div className="card-body">
																		<div className="row">
																			<Col
																					xs="12"
																				md="4"
																				className="position-relative"
																			>
																				<Datetime
																					dateFormat="DD-MM-YYYY"
																					timeFormat={false}
																					closeOnSelect={true}
																					value={
																						this.state.dbsAcceptDate === "" ||
																							String(this.state.dbsAcceptDate) ===
																							String(undefined) ||
																							String(this.state.dbsAcceptDate) ===
																							String(null) ||
																							String(this.state.dbsAcceptDate) ===
																							String("Invalid date")
																							? moment().format("DD-MM-YYYY")
																							: moment(
																								this.state.dbsAcceptDate
																							).format("DD-MM-YYYY")
																					}
																					inputProps={{
																						placeholder: "Select Date",
																					}}
																					onChange={(e) => {
																						if (e._isValid) {
																							this.setState({
																								dbsAcceptDate: e,
																							});
																						} else if (!e) {
																							this.setState({
																								dbsAcceptDate: null,
																							});
																						} else {
																							this.setState({
																								dbsAcceptDate: null,
																							});
																						}
																					}}
																				/>
																			</Col>
																		</div>
																	</div>
																</div>
															</div>
															}


															{
															// declarationAndTermIsVisible("HEALTH & SAFETY") && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		HEALTH {"&"} SAFETY
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight">
																		Each agency worker has a responsibility at
																		the start of their first shift to become
																		familiar with the Client’s general policies
																		including, without limitation, those
																		relating to Crash Call Procedures, the Hot
																		Spot Mechanism for alerting security staff
																		that an individual is in trouble, Fire
																		Policy and the Violent Episode Policy.
																	</p>
																</div>
															</div>
															}

															{
															declarationAndTermIsVisible("HEALTH & SAFETY") && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		ID {"&"} INDEMNITY VERIFICATION
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight"> <RenderHtml rawhtml={declarationAndTermIsVisible("HEALTH & SAFETY").field_name}/> </p>
																</div>
															</div>
															}

															{
															declarationAndTermIsVisible("DISABILITY & DISCRIMINATION ACT 1985") &&
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		DISABILITY & DISCRIMINATION ACT 1985
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight">
																		{this.state.company_name} offers a
																		guaranteed interview to any applicant who
																		considers him/herself disabled and who meets
																		the minimum essential requirements for the
																		post.
																	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col xs="12" md="6">
																			<AvRadioGroup
																				inline
																				label={"Are you registered disabled?:"}
																				name="registereddisabled"
																				value={this.state.registereddisabled}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		{this.state.registereddisabled === "yes" ? (
																			<Col xs="12" md="12">
																				<AvField
																					type="textarea"
																					label="Please give details"
																					name="disableRegisteredDetails"
																					placeholder="Provide details"
																					onChange={this.onChange}
																					value={
																						this.state.disableRegisteredDetails
																					}
																				/>
																			</Col>
																		) : null}

																		<Col xs="12" md="6">
																			<AvRadioGroup
																				inline
																				label={`Do you consider yourself to be disabled
                                                                        under the Disability and Discrimination
                                                                        Act?`}
																				name="disableAct"
																				value={this.state.disableAct}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		{this.state.disableAct === "yes" ? (
																			<Col xs="12" md="12">
																				<AvField
																					type="textarea"
																					label="Please give details"
																					name="disableActDetails"
																					placeholder="Provide details"
																					onChange={this.onChange}
																					value={this.state.disableActDetails}
																				/>
																			</Col>
																		) : null}

																		<Col xs="12" md="6">
																			<AvRadioGroup
																				inline
																				label={`Are there any adjustments that you think
                                                                            we would make to overcome a disability
                                                                            in relation to the essential requirements
                                                                            of this Job.`}
																				name="disableOverCome"
																				value={this.state.disableOverCome}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>
																		{this.state.disableOverCome === "yes" ? (
																			<Col xs="12" md="12">
																				<AvField
																					type="textarea"
																					label="Please give details"
																					name="disableOverComeDetails"
																					placeholder="Provide details"
																					onChange={this.onChange}
																					value={
																						this.state.disableOverComeDetails
																					}
																				/>
																			</Col>
																		) : null}
																	</div>
																</div>
															</div>
															}

															{
															declarationAndTermIsVisible("APPLICATION FORM DECLARATION") && 
															<div className="section-divder">
																<div className="card-header">
																	<h4 className="card-title mb-0">
																		APPLICATION FORM DECLARATION
																		<span style={{ color: "red" }}> *</span>
																	</h4>
																</div>
																<div className="card-body">
																	<p className="font-weight">
																		<RenderHtml  rawhtml={declarationAndTermIsVisible("APPLICATION FORM DECLARATION").field_name}/>
																		<input
																			style={{ margin: "20px" }}
																			type="checkbox"
																			name="declarationAccept"
																			checked={this.state.declarationAccept}
																			onChange={this.declarationAccept}
																		/>
																	</p>
																</div>
																<div className="card-body">
																	<div className="row">
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Datetime
																				dateFormat="DD-MM-YYYY"
																				timeFormat={false}
																				closeOnSelect={true}
																				value={
																					this.state.declarationAcceptDate ===
																						"" ||
																						String(
																							this.state.declarationAcceptDate
																						) === String(undefined) ||
																						String(
																							this.state.declarationAcceptDate
																						) === String(null) ||
																						String(
																							this.state.declarationAcceptDate
																						) === String("Invalid date")
																						? moment().format("DD-MM-YYYY")
																						: moment(
																							this.state.declarationAcceptDate
																						).format("DD-MM-YYYY")
																				}
																				inputProps={{
																					placeholder: "Select Date",
																				}}
																				onChange={(e) => {
																					if (e._isValid) {
																						this.setState({
																							declarationAcceptDate: e,
																						});
																					} else if (!e) {
																						this.setState({
																							declarationAcceptDate: null,
																						});
																					} else {
																						this.setState({
																							declarationAcceptDate: null,
																						});
																					}
																				}}
																			/>
																		</Col>
																	</div>
																</div>

																<div className="card-footer">
																	<div className="row">
																		<Col xs="12" md="4">
																			<button
																				className="btn btn-primary mb-3"
																				onClick={(e) => {
																					this.openModal(e);
																				}}
																			>
																				{this.state.signature.length > 0
																					? "Replace Signature"
																					: "Click to Sign"}
																			</button>
																			{this.state.signature.includes("/") &&
																				this.state.signature.length > 0 ? (
																				<Col xs="6" md="3">
																					<img
																						width="180px"
																						height="180px"
																						src={`${NodeURL}/${this.state.signature}`}
																						alt="Signature"
																					/>
																				</Col>
																			) : this.state.signature &&
																				this.state.signature.length > 0 ? (
																				<h3
																					style={{
																						fontFamily:
																							"Brush Script MT, cursive",
																						fontWeight: "500",
																						fontSize: "25px",
																					}}
																				>
																					{this.state.signature}
																				</h3>
																			) : null}
																		</Col>
																	</div>
																</div>
															</div>
															}

															<Modal
																isOpen={this.state.openWorkingTimeSignature}
																toggle={this.workingTimeSignatureModal}
																className="requs-pops"
																centered={true}
															>
																<ModalBody>
																	<div className="cus-senders">
																		<div className="row ">
																			<div className="col-sm-12 col-xs-12">
																				<Nav
																					tabs
																					className="nav-pills nav-info horz-tab"
																				>
																					<NavItem
																						className="nav nav-tabs"
																						id="myTab"
																						role="tablist"
																					>
																						<NavLink
																							className={
																								signatureTab === "1"
																									? "active"
																									: ""
																							}
																							onClick={() =>
																								this.signatureToggle("1")
																							}
																						>
																							Draw
																						</NavLink>
																					</NavItem>
																					<NavItem
																						className="nav nav-tabs"
																						id="myTab"
																						role="tablist"
																					>
																						<NavLink
																							className={
																								signatureTab === "2"
																									? "active"
																									: ""
																							}
																							onClick={() =>
																								this.signatureToggle("2")
																							}
																						>
																							Type
																						</NavLink>
																					</NavItem>
																				</Nav>
																			</div>
																			<Col xs="12" md="12">
																				<TabContent activeTab={signatureTab}>
																					<TabPane tabId="1">
																						<div className="popup adding_folder">
																							<div className="modal-dialog">
																								<div className="modal-content">
																									<div className="modal-header">
																										<h4
																											className="modal-title"
																											id="myModalLabel"
																										>
																											Signature Pad
																										</h4>
																									</div>
																									<div className="modal-body">
																										<div className="sig-container">
																											<div className="sigContainer">
																												<SignaturePad
																													canvasProps={{
																														width: 500,
																														height: 200,
																														className: "sigPad",
																													}}
																													ref={(ref) => {
																														this.sigPad = ref;
																													}}
																												/>
																											</div>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</TabPane>
																					<TabPane tabId="2">
																						<div className="popup adding_folder">
																							<div className="modal-dialog">
																								<div className="modal-content">
																									<div className="modal-header">
																										<h4
																											className="modal-title"
																											id="myModalLabel"
																										>
																											Type Your Signature
																										</h4>
																									</div>
																									<div className="modal-body">
																										<div className="sig-container">
																											<input
																												style={{
																													fontFamily:
																														"Brush Script MT, cursive",
																													fontWeight: "500",
																													fontSize: "25px",
																												}}
																												type="text"
																												name="workingTimeSignatureText"
																												value={
																													this.state
																														.workingTimeSignatureText
																												}
																												onChange={this.onChange}
																											/>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</TabPane>
																				</TabContent>
																			</Col>
																		</div>
																	</div>
																</ModalBody>
																<ModalFooter className="footer-model">
																	{signatureTab === "1" ? (
																		<button
																			type="button"
																			className="btn btn-secondary"
																			data-dismiss="modal"
																			onClick={this.clear}
																		>
																			Clear
																		</button>
																	) : null}

																	{signatureTab === "1" ? (
																		<button
																			type="button"
																			className="btn btn-primary"
																			onClick={this.saveWorkingTimeSignature}
																		>
																			Save
																		</button>
																	) : (
																		<button
																			type="button"
																			className="btn btn-primary"
																			onClick={this.saveWorkingTextSignature}
																		>
																			Save
																		</button>
																	)}

																	<Button
																		className="btn btn-secondary"
																		onClick={this.workingTimeSignatureModal}
																	>
																		Cancel
																	</Button>
																</ModalFooter>
															</Modal>

															<Modal
																isOpen={this.state.showModal}
																toggle={this.toggleModal}
																className="requs-pops"
																centered={true}
															>
																<ModalBody>
																	<div className="cus-senders">
																		<div className="row ">
																			<div className="col-sm-12 col-xs-12">
																				<Nav
																					tabs
																					className="nav-pills nav-info horz-tab"
																				>
																					<NavItem
																						className="nav nav-tabs"
																						id="myTab"
																						role="tablist"
																					>
																						<NavLink
																							className={
																								signatureTab === "1"
																									? "active"
																									: ""
																							}
																							onClick={() =>
																								this.signatureToggle("1")
																							}
																						>
																							Draw
																						</NavLink>
																					</NavItem>
																					<NavItem
																						className="nav nav-tabs"
																						id="myTab"
																						role="tablist"
																					>
																						<NavLink
																							className={
																								signatureTab === "2"
																									? "active"
																									: ""
																							}
																							onClick={() =>
																								this.signatureToggle("2")
																							}
																						>
																							Type
																						</NavLink>
																					</NavItem>
																				</Nav>
																			</div>
																			<Col xs="12" md="12">
																				<TabContent activeTab={signatureTab}>
																					<TabPane tabId="1">
																						<div className="popup adding_folder">
																							<div className="modal-dialog">
																								<div className="modal-content">
																									<div className="modal-header">
																										<h4
																											className="modal-title"
																											id="myModalLabel"
																										>
																											Signature Pad
																										</h4>
																									</div>
																									<div className="modal-body">
																										<div className="sig-container">
																											<div className="sigContainer">
																												<SignaturePad
																													canvasProps={{
																														width: 500,
																														height: 200,
																														className: "sigPad",
																													}}
																													ref={(ref) => {
																														this.sigPad = ref;
																													}}
																												/>
																											</div>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</TabPane>
																					<TabPane tabId="2">
																						<div className="popup adding_folder">
																							<div className="modal-dialog">
																								<div className="modal-content">
																									<div className="modal-header">
																										<h4
																											className="modal-title"
																											id="myModalLabel"
																										>
																											Type Your Signature
																										</h4>
																									</div>
																									<div className="modal-body">
																										<div className="sig-container">
																											<input
																												style={{
																													fontFamily:
																														"Brush Script MT, cursive",
																													fontWeight: "500",
																													fontSize: "25px",
																												}}
																												type="text"
																												name="signatureText"
																												value={
																													this.state
																														.signatureText
																												}
																												onChange={this.onChange}
																											/>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</TabPane>
																				</TabContent>
																			</Col>
																		</div>
																	</div>
																</ModalBody>
																<ModalFooter className="footer-model">
																	{signatureTab === "1" ? (
																		<button
																			type="button"
																			className="btn btn-default"
																			data-dismiss="modal"
																			onClick={this.clear}
																		>
																			Clear
																		</button>
																	) : null}

																	{signatureTab === "1" ? (
																		<button
																			type="button"
																			className="btn btn-primary"
																			onClick={this.trim}
																		>
																			Save
																		</button>
																	) : (
																		<button
																			type="button"
																			className="btn btn-primary"
																			onClick={this.saveTextSignature}
																		>
																			Save
																		</button>
																	)}

																	<Button
																		className="btn btn-default"
																		onClick={this.toggleModal}
																	>
																		Cancel
																	</Button>
																</ModalFooter>
															</Modal>

															<div className="card-footer text-right">
																<button
																	className="btn btn-primary"
																	onClick={(e) => {
																		this.previous(e);
																	}}
																>{`< Previous`}</button>{" "}
																<button
																	className="btn btn-primary btn-save"
																	type="submit"
																	disabled={this.state.active_tab_4}
																	onClick={() => {
																		this.update_4_tab("update");
																	}}
																>
																	Save
																</button>{" "}
																<button
																	className="btn btn-primary"
																	disabled={this.state.active_tab_4}
																	type="submit"
																	onClick={() => {
																		this.update_4_tab("next");
																	}}
																>{`Continue`}</button>
															</div>
														</AvForm>
													</div>
												</TabPane>
											</TabContent>
										</div>
									</TabPane>

									{/* Document Section */}
									<TabPane tabId="2">
										<div className="col-lg-12 edit-list-box">
											<AvForm
												className="card"
												onSubmit={(e) => {
													this.OnFormDocuments(e);
												}}
											>
												{/* {this.state.documentType === "Passport" ? (
                          <div className="section-divder">
                            <div className="card-header">
                              <h5 className="card-title mb-2">Passport</h5>
                            </div>
                            <div className="upload-section">
                              <table className="table">
                                {this.createPassportUploadUI()}
                              </table>
                            </div>
                            <div className="documentlist-main">
                              {this.state &&
                                this.state.passportdocs &&
                                this.state.passportdocs.length > 0 &&
                                this.state.passportdocs.map((list, i) => (
                                  <div
                                    className="documentlist"
                                    key={i}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <span>
                                      <button
                                        className="trash-bttn"
                                        onClick={(e) =>
                                          this.deleteDocs(
                                            e,
                                            list._id,
                                            list.path,
                                            "passport"
                                          )
                                        }
                                      >
                                        <span>
                                          <i
                                            className="fa fa-trash-o"
                                            style={{
                                              fontSize: 16,
                                              color: "#e4566e",
                                              cursor: "pointer",
                                            }}
                                            aria-hidden="true"
                                          />
                                        </span>
                                      </button>
                                    </span>
                                    <img
                                      src={pdf}
                                      alt="files"
                                      className="fileviewimg"
                                      onClick={() => this.FileView(list.path)}
                                    />
                                    <span className="documents-name">
                                      {list && list.name}{" "}
                                    </span>
                                  </div>
                                ))}
                            </div>
                          </div>
                        ) : null}

                        {this.state.documentType === "Passport" &&
                        this.state.nationality !== "United Kingdom" ? (
                          <div className="section-divder">
                            <div className="card-header">
                              <h5 className="card-title mb-2">Visa</h5>
                            </div>
                            <div className="upload-section">
                              <table className="table">
                                {this.createVisaUploadUI()}
                              </table>
                            </div>
                            <div className="documentlist-main">
                              {this.state &&
                                this.state.visadocs &&
                                this.state.visadocs.length > 0 &&
                                this.state.visadocs.map((list, i) => (
                                  <div
                                    className="documentlist"
                                    key={i}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <span>
                                      <button
                                        className="trash-bttn"
                                        onClick={(e) =>
                                          this.deleteDocs(
                                            e,
                                            list._id,
                                            list.path,
                                            "visa"
                                          )
                                        }
                                      >
                                        <span>
                                          <i
                                            style={{
                                              fontSize: 16,
                                              color: "#e4566e",
                                              cursor: "pointer",
                                            }}
                                            className="fa fa-trash-o"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      </button>
                                    </span>
                                    <img
                                      src={pdf}
                                      alt="files"
                                      className="fileviewimg"
                                      onClick={() => this.FileView(list.path)}
                                    />
                                    <span className="documents-name">
                                      {list && list.name}{" "}
                                    </span>
                                  </div>
                                ))}
                            </div>
                          </div>
                        ) : null} */}

												{this.state.drivinglicence === "yes" ? (
													<div className="section-divder">
														<div className="card-header">
															<h5 className="card-title mb-2">
																Driving License
															</h5>
														</div>
														<div className="card-body">
															<div className="row">
																<Col xs="12" md="12">
																	<div className="upload-section">
																		<table className="table">
																			{this.createDrivingUploadUI()}
																		</table>
																	</div>
																</Col>
																<div className="documentlist-main">
																	{this.state &&
																		this.state.drivingdocs &&
																		this.state.drivingdocs.length > 0 &&
																		this.state.drivingdocs.map((list, i) => (
																			<div
																				className="documentlist"
																				key={i}
																				style={{ cursor: "pointer" }}
																			>
																				<span>
																					<button
																						className="trash-bttn"
																						onClick={(e) =>
																							this.deleteDocs(
																								e,
																								list._id,
																								list.path,
																								"driving"
																							)
																						}
																					>
																						<span>
																							<i
																								style={{
																									fontSize: 16,
																									color: "#e4566e",
																									cursor: "pointer",
																								}}
																								className="fa fa-trash-o"
																								aria-hidden="true"
																							/>
																						</span>
																					</button>
																				</span>
																				<img
																					src={pdf}
																					alt="files"
																					className="fileviewimg"
																					onClick={() =>
																						this.FileView(list.path)
																					}
																				/>
																				<span className="documents-name">
																					{list && list.name}{" "}
																				</span>
																			</div>
																		))}
																</div>
															</div>
														</div>
													</div>
												) : null}
												{/* {console.log({a:this.state.DBSyes,b:this.state})} */}
												{this.state.currentDBS === "yes" ? 
													<div className="section-divder">
                                                        <div className="card-header">
															<h5 className="card-title mb-2">
																DBS
															</h5>
                                                            <div className="card-body">
                                                                <div className="row">
																	<Col xs="12" md="12">
																		<div className="upload-section">
																			<table className="table">
																				{this.createDBSUploadUI()}
																			</table>
																		</div>
																	</Col>
                                                                        {
																			<div className="documentlist-main">
																				{this.state &&
																				this.state.dbsdocs &&
																				this.state.dbsdocs.length > 0 &&
																				this.state.dbsdocs.map((list, i) => (
																					<div
																					className="documentlist"
																					key={i}
																					style={{ cursor: "pointer" }}
																					>
																					<span>
																					<button
																					className="trash-bttn"
																					onClick={(e) =>
																						this.deleteDocs(
																							e,
																							list._id,
																							list.path,
																							"dbs"
																						)
																					}
																					>
																						<span>
																							<i
																							style={{
																								fontSize: 16,
																								color: "#e4566e",
																								cursor: "pointer",
																							}}
																							className="fa fa-trash-o"
																							aria-hidden="true"
																							/>
																						</span>
																					</button>
																					</span>
																					<img
																					src={pdf}
																					alt="files"
																					className="fileviewimg"
																					onClick={() =>
																						this.FileView(list.path)
																					}
																					/>
																					<span className="documents-name">
																					{list && list.name}{" "}
																					</span>
																					</div>))
																				
                                                                            
																				}
                                                                    </div>
																	}
                                                                </div>
                                                            </div>
															</div>
                                                        </div>:<></>
														}

												{/* {this.state.education_qualification.length > 0 ? (
													<div className="section-divder">
														<div className="card-header">
															<h5 className="card-title mb-0">
																Qualifications
															</h5>
														</div>
														<div className="card-body">
															<div className="row">
																<Col xs="12" md="12">
																	<div className="new-table">
																		<table className="table">
																			<tr>
																				<th scope="col">Course</th>

																				<th scope="col">Upload</th>
																			</tr>
																			{this.createQualificationUploadUI()}
																		</table>
																	</div>
																</Col>
															</div>
														</div>
													</div>
												) : null} */}

												{/* {this.state.other_courses.length > 0 ? (
													<div className="section-divder">
														<div className="card-header">
															<h5 className="card-title mb-0">
																Other Qualifications
															</h5>
														</div>
														<div className="card-body">
															<div className="row">
																<Col xs="12" md="12">
																	<div className="new-table">
																		<table className="table">
																			<tr>
																				<th scope="col">Course</th>

																				<th scope="col">Upload</th>
																			</tr>
																			{this.createOtherQualificationUploadUI()}
																		</table>
																	</div>
																</Col>
															</div>
														</div>
													</div>
												) : null} */}
												<div className="section-divder">
													<div className="card-header">
														<h5 className="card-title mb-0">Other Documents</h5>
														<p className="font-weight">
															Please upload any other documents that are not
															listed above but are important to support your
															application.
														</p>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="12">
																{this.state.documents.length > 0 ? (
																	<div className="new-table doc-table-sec">
																		<table className="table">
																			{this.createDocumentsUI()}
																		</table>
																	</div>
																) : null}
															</Col>
															<Col xs="12" md="4">
																<Button onClick={this.onAddDocuments}>+</Button>
															</Col>
														</div>
													</div>
												</div>
												<div className="card-footer text-right" align="right">
													<button
														className="btn btn-primary"
														onClick={(e) => {
															this.previous(e);
														}}
													>{`< Previous`}</button>{" "}
													<button
														className="btn btn-primary btn-save"
														type="submit"
														disabled={this.state.mainactive_tab_2}
														onClick={() => {
															this.update_2_main_tab("update");
														}}
													>
														{" "}
														Save{" "}
													</button>{" "}
													<button
														className="btn btn-primary"
														type="submit"
														disabled={this.state.mainactive_tab_2}
														onClick={() => {
															this.update_2_main_tab("next");
														}}
													>{`Continue`}</button>
												</div>
											</AvForm>
										</div>
									</TabPane>

									<TabPane tabId="3">
										<div className="col-lg-12 edit-list-box">
											<AvForm
												className="card"
												onSubmit={(e) => {
													this.reference_submiit(e);
												}}
											>
												<div className="card-header">
													<h4 className="card-title mb-0">REFERENCES</h4>
													<p className="font-weight">
														Please supply us with two professional referees. One must be from your present or most recent
														employer and must be a senior grade to yourself and you must have worked for that person for a
														period of not less than three months duration. It is essential that you have had professional
														dealings with your references for at least 3 years. Please provide a minimum of 2 professional
														references, or 1 character reference and 1 professional reference.
													</p>
													<p style={{ color: "red" }}>
														* Must not be family, a friend or a relative
													</p>
												</div>
												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0"> Reference 1 </h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="Relationship"
																	name="firstrefrelationship"
																	placeholder="Enter Relationship "
																	onChange={this.onChange}
																	value={this.state.firstrefrelationship}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	First Name{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="text"
																	name="firstreffirstname"
																	placeholder="Enter First Name"
																	onChange={this.onChange}
																	value={this.state.firstreffirstname}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Last Name{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="text"
																	name="firstreflastname"
																	placeholder="Enter Last Name"
																	onChange={this.onChange}
																	value={this.state.firstreflastname}
																/>
															</Col>

															<Col xs="12" md="4" className="position-relative">
																<Label
																	className={
																		this.state.phoneerror2
																			? "error-color"
																			: null
																	}
																>
																	Mobile No
																</Label>
																<IntlTelInput
																	placeholder=""
																	style={{ width: "100%" }}
																	defaultCountry={
																		this.state.firstrefphone.dailcountry
																	}
																	utilsScript={libphonenumber}
																	css={
																		this.state.phoneerror2
																			? [
																				"intl-tel-input",
																				"form-control",
																				"error-color",
																			]
																			: ["intl-tel-input", "form-control"]
																	}
																	onPhoneNumberChange={this.handler2}
																	// value={firstrefphone && firstrefphone.number}
																	value={this.state.firstrefphone.number}
																/>
																{this.state.phoneerror2 ? (
																	<div className={"error-color"}>
																		Enter Valid Phone Number!
																	</div>
																) : null}
																{/* <AvField type="number" label="Phone" name="firstrefphone" placeholder="Enter  Phone" onChange={this.onChange} value={this.state.firstrefphone} required /> */}
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Email Address{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="email"
																	name="firstrefemail"
																	placeholder="Enter Email Address"
																	onChange={this.onChange}
																	value={this.state.firstrefemail}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Confirm Email Address{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="email"
																	name="firstrefconfirmemail"
																	placeholder="Enter Email Address"
																	onChange={this.onChange}
																	value={this.state.firstrefconfirmemail}
																	validate={{
																		match: { value: "firstrefemail" },
																	}}
																/>
															</Col>
															<Col xs="12" md="12">
																<strong className="an-heading">Address</strong>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<div className="form-group">
																	<Label>Street Address</Label>
																	<PlacesAutocomplete
																		value={
																			this.state.firstrefstreetAddress &&
																				this.state.firstrefstreetAddress !== ""
																				? this.state.firstrefstreetAddress
																				: ""
																		}
																		onChange={this.handleChange_ref_addr_1}
																		onSelect={this.handleSelect_ref_addr1}
																		onFocus={this.geolocate}
																	>
																		{({
																			getInputProps,
																			suggestions,
																			getSuggestionItemProps,
																		}) => (
																			<div>
																				<input
																					{...getInputProps({
																						placeholder: "Search Places",
																						className:
																							"form-control serach-place",
																					})}
																				/>
																				<div className="autocomplete-dropdown-container absolute">
																					{suggestions.map((suggestion) => {
																						const className = suggestion.active
																							? "suggestion-item--active"
																							: "suggestion-item";
																						// inline style for demonstration purpose
																						const style = suggestion.active
																							? {
																								backgroundColor: "#fafafa",
																								cursor: "pointer",
																							}
																							: {
																								backgroundColor: "#ffffff",
																								cursor: "pointer",
																							};
																						return (
																							<div
																								{...getSuggestionItemProps(
																									suggestion,
																									{
																										className,
																										style,
																									}
																								)}
																							>
																								<span>
																									{suggestion.description}
																								</span>
																							</div>
																						);
																					})}
																				</div>
																			</div>
																		)}
																	</PlacesAutocomplete>
																</div>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="City"
																	name="firstrefcity"
																	placeholder="Enter City.."
																	onChange={this.onChange}
																	value={this.state.firstrefcity}
																/>
															</Col>

															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="State / Region"
																	name="firstrefstate"
																	placeholder="Enter State.."
																	onChange={this.onChange}
																	value={this.state.firstrefstate}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="ZIP / Postal Code"
																	name="firstrefzip"
																	placeholder="Enter ZIP / Postal Code.."
																	onChange={this.onChange}
																	value={this.state.firstrefzip}
																/>
															</Col>
														</div>
													</div>
												</div>

												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0">Reference 2</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="Relationship"
																	name="secondrefrelationship"
																	placeholder="Enter Relationship .."
																	onChange={this.onChange}
																	value={this.state.secondrefrelationship}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	First Name{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="text"
																	name="secondreffirstname"
																	placeholder="Enter First Name.."
																	onChange={this.onChange}
																	value={this.state.secondreffirstname}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Last Name{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="text"
																	name="secondreflastname"
																	placeholder="Enter Last Name.."
																	onChange={this.onChange}
																	value={this.state.secondreflastname}
																/>
															</Col>

															<Col xs="12" md="4" className="position-relative">
																<Label
																	className={
																		this.state.phoneerror3
																			? "error-color"
																			: null
																	}
																>
																	Mobile No
																</Label>
																<IntlTelInput
																	placeholder=""
																	style={{ width: "100%" }}
																	defaultCountry={
																		this.state.secondrefphone.dailcountry
																	}
																	utilsScript={libphonenumber}
																	css={
																		this.state.phoneerror3
																			? [
																				"intl-tel-input",
																				"form-control",
																				"error-color",
																			]
																			: ["intl-tel-input", "form-control"]
																	}
																	onPhoneNumberChange={this.handler3}
																	// value={secondrefphone && secondrefphone.number}
																	value={this.state.secondrefphone.number}
																/>
																{this.state.phoneerror3 ? (
																	<div className={"error-color"}>
																		Enter Valid Phone Number!
																	</div>
																) : null}
																{/* <AvField type="number" label="Phone" name="secondrefphone" placeholder="Enter  Phone.." onChange={this.onChange} value={this.state.secondrefphone}  /> */}
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Email Address{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="email"
																	label="Email Address"
																	name="secondrefemail"
																	placeholder="Enter Email Address"
																	onChange={this.onChange}
																	value={this.state.secondrefemail}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Confirm Email Address{" "}
																	<span style={{ color: "red" }}>*</span>
																</label>
																<AvField
																	type="email"
																	name="secondrefconfirmemail"
																	placeholder="Enter Email Address"
																	onChange={this.onChange}
																	value={this.state.secondrefconfirmemail}
																	validate={{
																		match: { value: "secondrefemail" },
																	}}
																/>
															</Col>
															<Col xs="12" md="12">
																<strong className="an-heading">Address</strong>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																{/* <AvField
																	type="text"
																	label="Street Address"
																	name="secondrefstreetAddress"
																	placeholder="Enter Street Address.."
																	onChange={this.onChange}
																	value={this.state.secondrefstreetAddress}
																	
																	/> */}
																<div className="form-group">
																	<Label>Street Address</Label>
																	<PlacesAutocomplete
																		value={this.state.secondrefstreetAddress}
																		onChange={this.handleChange_ref_addr_2}
																		onSelect={this.handleSelect_ref_addr_2}
																		onFocus={this.geolocate}
																	>
																		{({
																			getInputProps,
																			suggestions,
																			getSuggestionItemProps,
																		}) => (
																			<div>
																				<input
																					{...getInputProps({
																						placeholder: "Search Places",
																						className:
																							"form-control serach-place",
																					})}
																				/>
																				<div className="autocomplete-dropdown-container absolute">
																					{suggestions.map((suggestion) => {
																						const className = suggestion.active
																							? "suggestion-item--active"
																							: "suggestion-item";
																						// inline style for demonstration purpose
																						const style = suggestion.active
																							? {
																								backgroundColor: "#fafafa",
																								cursor: "pointer",
																							}
																							: {
																								backgroundColor: "#ffffff",
																								cursor: "pointer",
																							};
																						return (
																							<div
																								{...getSuggestionItemProps(
																									suggestion,
																									{
																										className,
																										style,
																									}
																								)}
																							>
																								<span>
																									{suggestion.description}
																								</span>
																							</div>
																						);
																					})}
																				</div>
																			</div>
																		)}
																	</PlacesAutocomplete>
																</div>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="City"
																	name="secondrefcity"
																	placeholder="Enter City.."
																	onChange={this.onChange}
																	value={this.state.secondrefcity}
																/>
															</Col>

															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="State / Region"
																	name="secondrefstate"
																	placeholder="Enter State.."
																	onChange={this.onChange}
																	value={this.state.secondrefstate}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="ZIP / Postal Code"
																	name="secondrefzip"
																	placeholder="Enter ZIP / Postal Code.."
																	onChange={this.onChange}
																	value={this.state.secondrefzip}
																/>
															</Col>
														</div>
													</div>
												</div>
												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0">Reference 3</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="Relationship"
																	name="thirdrefrelationship"
																	placeholder="Enter Relationship .."
																	onChange={this.onChange}
																	value={this.state.thirdrefrelationship}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	First Name{" "}
																</label>
																<AvField
																	type="text"
																	name="thirdreffirstname"
																	placeholder="Enter First Name.."
																	onChange={this.onChange}
																	value={this.state.thirdreffirstname}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Last Name{" "}
																</label>
																<AvField
																	type="text"
																	name="thirdreflastname"
																	placeholder="Enter Last Name.."
																	onChange={this.onChange}
																	value={this.state.thirdreflastname}
																/>
															</Col>

															<Col xs="12" md="4" className="position-relative">
																<Label
																	className={
																		this.state.phoneerror4
																			? "error-color"
																			: null
																	}
																>
																	Mobile No
																</Label>
																<IntlTelInput
																	placeholder=""
																	style={{ width: "100%" }}
																	defaultCountry={
																		this.state.thirdrefphone.dailcountry
																	}
																	utilsScript={libphonenumber}
																	css={
																		this.state.phoneerror4
																			? [
																				"intl-tel-input",
																				"form-control",
																				"error-color",
																			]
																			: ["intl-tel-input", "form-control"]
																	}
																	onPhoneNumberChange={this.handler4}
																	// value={thirdrefphone && thirdrefphone.number}
																	value={this.state.thirdrefphone.number}
																/>
																{this.state.phoneerror4 ? (
																	<div className={"error-color"}>
																		Enter Valid Phone Number!
																	</div>
																) : null}
																{/* <AvField type="number" label="Phone" name="thirdrefphone" placeholder="Enter  Phone.." onChange={this.onChange} value={this.state.thirdrefphone}  /> */}
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Email Address{" "}
																</label>
																<AvField
																	type="email"
																	label="Email Address"
																	name="thirdrefemail"
																	placeholder="Enter Email Address"
																	onChange={this.onChange}
																	value={this.state.thirdrefemail}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>
																	Confirm Email Address{" "}
																</label>
																<AvField
																	type="email"
																	name="thirdrefconfirmemail"
																	placeholder="Enter Email Address"
																	onChange={this.onChange}
																	value={this.state.thirdrefconfirmemail}
																	validate={{
																		match: { value: "thirdrefemail" },
																	}}
																/>
															</Col>
															<Col xs="12" md="12">
																<strong className="an-heading">Address</strong>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																{/* <AvField
																	type="text"
																	label="Street Address"
																	name="thirdrefstreetAddress"
																	placeholder="Enter Street Address.."
																	onChange={this.onChange}
																	value={this.state.thirdrefstreetAddress}
																	
																	/> */}
																<div className="form-group">
																	<Label>Street Address</Label>
																	<PlacesAutocomplete
																		value={this.state.thirdrefstreetAddress}
																		onChange={this.handleChange_ref_addr_3}
																		onSelect={this.handleSelect_ref_addr_3}
																		onFocus={this.geolocate}
																	>
																		{({
																			getInputProps,
																			suggestions,
																			getSuggestionItemProps,
																		}) => (
																			<div>
																				<input
																					{...getInputProps({
																						placeholder: "Search Places",
																						className:
																							"form-control serach-place",
																					})}
																				/>
																				<div className="autocomplete-dropdown-container absolute">
																					{suggestions.map((suggestion) => {
																						const className = suggestion.active
																							? "suggestion-item--active"
																							: "suggestion-item";
																						// inline style for demonstration purpose
																						const style = suggestion.active
																							? {
																								backgroundColor: "#fafafa",
																								cursor: "pointer",
																							}
																							: {
																								backgroundColor: "#ffffff",
																								cursor: "pointer",
																							};
																						return (
																							<div
																								{...getSuggestionItemProps(
																									suggestion,
																									{
																										className,
																										style,
																									}
																								)}
																							>
																								<span>
																									{suggestion.description}
																								</span>
																							</div>
																						);
																					})}
																				</div>
																			</div>
																		)}
																	</PlacesAutocomplete>
																</div>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="City"
																	name="thirdrefcity"
																	placeholder="Enter City.."
																	onChange={this.onChange}
																	value={this.state.thirdrefcity}
																/>
															</Col>

															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="State / Region"
																	name="thirdrefstate"
																	placeholder="Enter State.."
																	onChange={this.onChange}
																	value={this.state.thirdrefstate}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="ZIP / Postal Code"
																	name="thirdrefzip"
																	placeholder="Enter ZIP / Postal Code.."
																	onChange={this.onChange}
																	value={this.state.thirdrefzip}
																/>
															</Col>
														</div>
													</div>
												</div>
												<div className="card-footer text-right" align="right">
													<button
														className="btn btn-primary"
														onClick={(e) => {
															this.previous(e);
														}}
													>{`< Previous`}</button>{" "}
													<button
														className="btn btn-primary btn-save"
														type="submit"
														disabled={this.state.mainactive_tab_3}
														onClick={() => {
															this.update_3_main_tab("update");
														}}
													>
														Save
													</button>{" "}
													<button
														className="btn btn-primary"
														type="submit"
														disabled={this.state.mainactive_tab_3}
														onClick={() => {
															this.update_3_main_tab("next");
														}}
													>{`Continue`}</button>
												</div>
											</AvForm>
										</div>
									</TabPane>

									<TabPane tabId="4">
										<div className="col-lg-12 edit-list-box">
											<AvForm
												className="card"
												onSubmit={this.onHealthDeclarationSubmit}
											>
												<div className="section-divder medical-his">
													<div className="card-header">
														<h4 className="card-title mb-0">
															Medical History 1
														</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Do you or have ever suffered from long term illness?:"
																	}
																	name="sufferedlongtermillness"
																	value={this.state.sufferedlongtermillness}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.sufferedlongtermillness &&
																String(this.state.sufferedlongtermillness) ===
																"yes" ? (
																<Col xs="12" md="4">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="sufferedlongtermillness_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state
																				.sufferedlongtermillness_notes &&
																				this.state.sufferedlongtermillness_notes
																					.length > 0 &&
																				String(
																					this.state.sufferedlongtermillness_notes
																				) !== String(undefined)
																				? this.state
																					.sufferedlongtermillness_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Have you ever required sick leave for a back or neck injury?:"
																	}
																	name="leaveforneckinjury"
																	value={this.state.leaveforneckinjury}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.leaveforneckinjury &&
																String(this.state.leaveforneckinjury) ===
																"yes" ? (
																<Col xs="12" md="4">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="leaveforneckinjury_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.leaveforneckinjury_notes &&
																				this.state.leaveforneckinjury_notes
																					.length > 0 &&
																				String(
																					this.state.leaveforneckinjury_notes
																				) !== String(undefined)
																				? this.state.leaveforneckinjury_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Do you suffer with any back or neck injuries?:"
																	}
																	name="neckinjuries"
																	value={this.state.neckinjuries}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.neckinjuries &&
																String(this.state.neckinjuries) === "yes" ? (
																<Col xs="12" md="4">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="neckinjuries_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.neckinjuries_notes &&
																				this.state.neckinjuries_notes.length >
																				0 &&
																				String(this.state.neckinjuries_notes) !==
																				String(undefined)
																				? this.state.neckinjuries_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Have you been in contact with anyone who is suffering from a contagious illness within the last six weeks?:"
																	}
																	name="sixweeksillness"
																	value={this.state.sixweeksillness}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.sixweeksillness &&
																String(this.state.sixweeksillness) === "yes" ? (
																<Col xs="12" md="4">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="sixweeksillness_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.sixweeksillness_notes &&
																				this.state.sixweeksillness_notes.length >
																				0 &&
																				String(
																					this.state.sixweeksillness_notes
																				) !== String(undefined)
																				? this.state.sixweeksillness_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Do you suffer with a communicable disease?:"
																	}
																	name="communicabledisease"
																	value={this.state.communicabledisease}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.communicabledisease &&
																String(this.state.communicabledisease) ===
																"yes" ? (
																<Col xs="12" md="4">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="communicabledisease_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.communicabledisease_notes &&
																				this.state.communicabledisease_notes
																					.length > 0 &&
																				String(
																					this.state.communicabledisease_notes
																				) !== String(undefined)
																				? this.state.communicabledisease_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Are you currently receiving active medical attention?:"
																	}
																	name="medicalattention"
																	value={this.state.medicalattention}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.medicalattention &&
																String(this.state.medicalattention) === "yes" ? (
																<Col xs="12" md="4">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="healthdeclarationdetails"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={this.state.healthdeclarationdetails}
																	/>
																</Col>
															) : null}
															{(this.state.sufferedlongtermillness &&
																String(this.state.sufferedlongtermillness) ===
																"yes") ||
																(this.state.leaveforneckinjury &&
																	String(this.state.leaveforneckinjury) ===
																	"yes") ||
																(this.state.neckinjuries &&
																	String(this.state.neckinjuries) === "yes") ||
																(this.state.sixweeksillness &&
																	String(this.state.sixweeksillness) === "yes") ||
																(this.state.communicabledisease &&
																	String(this.state.communicabledisease) ===
																	"yes") ||
																(this.state.medicalattention &&
																	String(this.state.medicalattention) ===
																	"yes") ? (
																<Col xs="12" md="6">
																	<AvField
																		type="number"
																		label="How many days have you been absent from work due to illness in the last 12 months?:"
																		name="absentfromwork"
																		placeholder="Enter Number of days"
																		onChange={this.onChange}
																		value={this.state.absentfromwork}
																	/>
																</Col>
															) : null}
														</div>
													</div>
												</div>

												<div className="section-divder medical-his">
													<div className="card-header">
														<h4 className="card-title mb-0">
															Medical History 2
														</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="6">
																<AvRadioGroup
																	inline
																	label={
																		"Do you have any illness/impairment/disability (physical or psychological) which may affect your work?"
																	}
																	name="medicalillness"
																	value={this.state.medicalillness}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.medicalillness &&
																String(this.state.medicalillness) === "yes" ? (
																<Col xs="12" md="6">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="medicalillness_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.medicalillness_notes &&
																				this.state.medicalillness_notes.length >
																				0 &&
																				String(
																					this.state.medicalillness_notes
																				) !== String(undefined)
																				? this.state.medicalillness_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="6">
																<AvRadioGroup
																	inline
																	label={
																		"Have you ever had any illness/impairment/disability which may have been caused or made worse by your work?"
																	}
																	name="medicalillnesscaused"
																	value={this.state.medicalillnesscaused}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.medicalillnesscaused &&
																String(this.state.medicalillnesscaused) ===
																"yes" ? (
																<Col xs="12" md="6">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="medicalillnesscaused_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.medicalillnesscaused_notes &&
																				this.state.medicalillnesscaused_notes
																					.length > 0 &&
																				String(
																					this.state.medicalillnesscaused_notes
																				) !== String(undefined)
																				? this.state.medicalillnesscaused_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="6">
																<AvRadioGroup
																	inline
																	label={
																		"Are you having, or waiting for treatment (including medication) or investigations at present? If your answer is yes, please provide further details of\n" +
																		"                              the condition, treatment and dates?"
																	}
																	name="treatment"
																	value={this.state.treatment}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.treatment &&
																String(this.state.treatment) === "yes" ? (
																<Col xs="12" md="6">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="treatment_notes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.treatment_notes &&
																				this.state.treatment_notes.length > 0 &&
																				String(this.state.treatment_notes) !==
																				String(undefined)
																				? this.state.treatment_notes
																				: ""
																		}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="6">
																<AvRadioGroup
																	inline
																	label={
																		"Do you think you may need any adjustments or assistance to help you to do the job?"
																	}
																	name="needanyadjustments"
																	value={this.state.needanyadjustments}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.needanyadjustmentsyes ||
																(this.state.needanyadjustments &&
																	String(this.state.needanyadjustments) ===
																	"yes") ? (
																<Col xs="12" md="6">
																	<AvField
																		type="textarea"
																		label="Please provide details:"
																		name="needanyadjustmentsnotes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={
																			this.state.needanyadjustmentsnotes || ""
																		}
																	/>
																</Col>
															) : null}
														</div>
													</div>
												</div>

												<div className="section-divder medical-his">
													<div className="card-header">
														<h4 className="card-title mb-0">TUBERCULOSIS</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Have you lived continuously in the UK for the last 5 years"
																	}
																	name="livedUK"
																	value={this.state.livedUK}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.livedUK}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={() => this.livedUK("no")}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															{this.state.livedUKyes ? (
																<Col xs="12" md="4">
																	<AvField
																		type="textarea"
																		label="Please list all the countries that you have lived in over the last 5 years"
																		name="livedUKnotes"
																		placeholder="Provide details"
																		onChange={this.onChange}
																		value={this.state.livedUKnotes || ""}
																	/>
																</Col>
															) : null}
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Have you had a BCG vaccination in relation to Tuberculosis?"
																	}
																	name="BCGvaccination"
																	value={this.state.BCGvaccination}
																>
																	<AvRadio
																		label="Yes"
																		onClick={() => this.BCGvaccination("yes")}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.BCGvaccination}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
														</div>
														<div className="card-header">
															<h4 className="card-title mb-0">
																Have you had any of the following?
															</h4>
														</div>
														<div className="row">
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"A cough which has lasted for more than 3 weeks"
																	}
																	name="cough"
																	value={this.state.cough}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>

															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Unexplained weight loss"}
																	name="weightloss"
																	value={this.state.weightloss}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																{" "}
																<AvRadioGroup
																	inline
																	label={"Unexplained fever"}
																	name="fever"
																	value={this.state.fever}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Have you had tuberculosis (TB) or been in recent contact with open TB"
																	}
																	name="TB"
																	value={this.state.TB}
																>
																	<AvRadio
																		label="Yes"
																		value="yes"
																		onClick={this.onRadioNameChanged}
																	/>
																	<AvRadio
																		label="No"
																		value="no"
																		onClick={this.onRadioNameChanged}
																	/>
																</AvRadioGroup>
															</Col>
														</div>
													</div>
												</div>

												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0">MEDICAL HISTORY</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="12">
																<h6>
																	Have you ever suffered from any of the
																	following:
																</h6>
															</Col>

															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Heart/Circulatory Illness/Hypertension"
																	}
																	name="heartCirculatory"
																	value={this.state.heartCirculatory}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>

															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Diabetes"}
																	name="diabetes"
																	value={this.state.diabetes}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>

															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Asthma/Hay fever"}
																	name="asthma"
																	value={this.state.asthma}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Bronchitis"}
																	name="bronchitis"
																	value={this.state.bronchitis}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Epilepsy"}
																	name="epilepsy"
																	value={this.state.epilepsy}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Headaches/Migraine"}
																	name="headaches"
																	value={this.state.headaches}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={
																		"Psychiatric Illness/Anxiety/Depression"
																	}
																	name="psychiatric"
																	value={this.state.psychiatric}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Dermatitis/Psoriasis/Eczema"}
																	name="dermatitis"
																	value={this.state.dermatitis}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Back problems"}
																	name="backProblems"
																	value={this.state.backProblems}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Recurrent infections"}
																	name="recurrentInfections"
																	value={this.state.recurrentInfections}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Hepatitis/Jaundice"}
																	name="hepatitis"
																	value={this.state.hepatitis}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Chicken pox or Shingles?"}
																	name="chickenpox"
																	value={this.state.chickenpox}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
														</div>
													</div>
												</div>

												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0">
															COVID vaccination History
														</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4" className="position-relative">
																<label>Are You Vaccinated?</label>
																<Select
																	name="covidVaccination"
																	isClearable={true}
																	isSearchable={true}
																	options={VaccinationList}
																	value={this.state.covidVaccination_arr}
																	onChange={this.vaccinationHistoryChange}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<label>Date Of Vaccination </label>
																<Datetime
																	dateFormat="DD-MM-YYYY"
																	timeFormat={false}
																	closeOnSelect={true}
																	required={true}
																	value={
																		CheckValue(this.state.covidVaccination_date)
																			? moment(
																				new Date(
																					this.state.covidVaccination_date
																				)
																			).format("DD-MM-YYYY")
																			: ""
																	}
																	inputProps={{ placeholder: "Select Date" }}
																	onChange={(e) => {
																		if (e._isValid) {
																			this.setState({
																				covidVaccination_date: e,
																			});
																		} else if (!e) {
																			this.setState({
																				covidVaccination_date: null,
																			});
																		} else {
																			this.setState({
																				covidVaccination_date: null,
																			});
																		}
																	}}
																/>
															</Col>
														</div>
													</div>
												</div>

												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0">
															Immunisation History
														</h4>
													</div>
													<div className="card-header">
														<h4 className="card-title mb-0">
															Have had any of the following immunisations?
														</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Varicella"}
																	name="varicella"
																	value={this.state.varicella}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>

															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Tuberculosis including BCG"}
																	name="tuberculosis"
																	value={this.state.tuberculosis}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>

															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Heaf, Mantoux or Tine"}
																	name="heaf"
																	value={this.state.heaf}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Rubella (German Measles)"}
																	name="rubella"
																	value={this.state.rubella}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Poliomyelitis"}
																	name="poliomyelitis"
																	value={this.state.poliomyelitis}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Hepatitis B"}
																	name="hepatitisB"
																	value={this.state.hepatitisB}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															{/* <Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"HIV"}
																	name="HIV"
																	value={this.state.HIV}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col> */}
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Tetanus"}
																	name="tetanus"
																	value={this.state.tetanus}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
															<Col xs="12" md="4">
																<AvRadioGroup
																	inline
																	label={"Typhoid"}
																	name="typhoid"
																	value={this.state.typhoid}
																>
																	<AvRadio
																		label="Yes"
																		onClick={this.onRadioNameChanged}
																		value="yes"
																	/>
																	<AvRadio
																		label="No"
																		onClick={this.onRadioNameChanged}
																		value="no"
																	/>
																</AvRadioGroup>
															</Col>
														</div>
													</div>
												</div>

												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0">GP’s Details</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="6" className="position-relative">
																<AvField
																	type="text"
																	label="GP Name"
																	name="GPname"
																	placeholder="Enter GP Name"
																	onChange={this.onChange}
																	value={this.state.GPname}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<div className="form-group">
																	<Label
																		className={
																			this.state.phoneerror44
																				? "error-color"
																				: null
																		}
																	>
																		Phone No
																	</Label>
																	<IntlTelInput
																		placeholder=""
																		style={{ width: "100%" }}
																		defaultCountry={
																			this.state.GPphone.dialcountry
																		}
																		utilsScript={libphonenumber}
																		css={
																			this.state.phoneerror44
																				? [
																					"intl-tel-input",
																					"form-control",
																					"error-color",
																				]
																				: ["intl-tel-input", "form-control"]
																		}
																		onPhoneNumberChange={this.handler3_gp}
																		value={this.state.GPphone.number}
																	/>
																	{this.state.phoneerror44 ? (
																		<div className={"error-color"}>
																			Enter Valid Phone Number!
																		</div>
																	) : null}
																</div>
															</Col>
															<Col xs="12" md="12">
																<strong className="an-heading">
																	GP Address:
																</strong>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																{/* <AvField
                                  type="text"
                                  label="Street Address"
                                  name="GPstreetAddress"
                                  placeholder="Enter Street Address"
                                  onChange={this.onChange}
                                  value={this.state.GPstreetAddress}
                                /> */}
																<div className="form-group">
																	<Label>Street Address</Label>
																	<PlacesAutocomplete
																		value={this.state.GPstreetAddress}
																		onChange={this.handleChange_gp_addr}
																		onSelect={this.handleSelect_gp_addr}
																		onFocus={this.geolocate}
																	>
																		{({
																			getInputProps,
																			suggestions,
																			getSuggestionItemProps,
																		}) => (
																			<div>
																				<input
																					{...getInputProps({
																						placeholder: "Search Places",
																						className:
																							"form-control serach-place",
																					})}
																				/>
																				<div className="autocomplete-dropdown-container absolute">
																					{suggestions.map((suggestion) => {
																						const className = suggestion.active
																							? "suggestion-item--active"
																							: "suggestion-item";
																						// inline style for demonstration purpose
																						const style = suggestion.active
																							? {
																								backgroundColor: "#fafafa",
																								cursor: "pointer",
																							}
																							: {
																								backgroundColor: "#ffffff",
																								cursor: "pointer",
																							};
																						return (
																							<div
																								{...getSuggestionItemProps(
																									suggestion,
																									{
																										className,
																										style,
																									}
																								)}
																							>
																								<span>
																									{suggestion.description}
																								</span>
																							</div>
																						);
																					})}
																				</div>
																			</div>
																		)}
																	</PlacesAutocomplete>
																</div>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="City"
																	name="GPcity"
																	placeholder="Enter City"
																	onChange={this.onChange}
																	value={this.state.GPcity}
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="State / Region"
																	name="GPstate"
																	placeholder="Enter State"
																	onChange={this.onChange}
																	value={this.state.GPstate}
																/>
															</Col>

															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="text"
																	label="ZIP / Postal Code"
																	name="GPzip"
																	placeholder="Enter ZIP / Postal Code"
																	onChange={this.onChange}
																	value={this.state.GPzip}
																/>
															</Col>
														</div>
													</div>
												</div>

												<div className="card-footer text-right">
													<button
														className="btn btn-primary"
														onClick={(e) => {
															this.previous(e);
														}}
													>{`< Previous`}</button>{" "}
													<button
														className="btn btn-primary btn-save"
														type="submit"
														disabled={this.state.mainactive_tab_4}
														onClick={() => {
															this.update_4_main_tab("update");
														}}
													>
														Save
													</button>{" "}
													<button
														className="btn btn-primary"
														disabled={this.state.mainactive_tab_4}
														onClick={() => {
															this.update_4_main_tab("next");
														}}
														type="submit"
													>{`Continue`}</button>
												</div>
											</AvForm>
										</div>
									</TabPane>
									<TabPane tabId="5">
										<div className="col-lg-12 edit-list-box">
											<AvForm className="card" onSubmit={this.OnBankFormSubmit}>
												<div className="section-divder">
													<div className="card-header">
														<h4 className="card-title mb-0">
															Your Payment Details
														</h4>
													</div>
													<div className="card-body">
														<div className="row">
															<Col xs="12" md="4" className="position-relative">
																<Label>
																	Name of Bank/Building Society{" "}
																	{/* <span style={{ color: "red" }}>*</span> */}
																</Label>
																<AvField
																	type="text"
																	// label="Name of Bank/Building Society"
																	name="bankName"
																	placeholder="Enter Bank Name"
																	onChange={this.onChange}
																	value={this.state.bankName}
																	// required
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<AvField
																	type="select"
																	name="accountType"
																	label="Account Type"
																	onChange={(e) => {
																		this.onSelectbank(e);
																	}}
																	value={this.state.accountType}
																>
																	<option>Please Select</option>
																	<option value="personal">Personal</option>
																	<option value="ltd">Limited Company</option>
																</AvField>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<Label>
																	Account Name{" "}
																	{/* <span style={{ color: "red" }}>*</span> */}
																</Label>
																<AvField
																	type="text"
																	// label="Account Name"
																	name="accountName"
																	placeholder="Enter Account Name"
																	onChange={this.onChange}
																	value={this.state.accountName}
																	// required
																/>
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<div className="group-control">
																	<Label>Sort Code</Label>
																	<NumberFormat
																		className="form-control"
																		format="##-##-##"
																		mask="_"
																		placeholder="Enter Sort Code"
																		onValueChange={(v) =>
																			this.setState({ bank_sort_code: v.value })
																		}
																		value={this.state.bank_sort_code}
																	/>
																</div>
																{/* {this.state.sortcodeerror ? <div style={{ color: "red" }}> Sort Code required!</div> : null} */}
															</Col>
															<Col xs="12" md="4" className="position-relative">
																<div className="group-control">
																	<Label>
																		Account Number{" "}
																		{/* <span style={{ color: "red" }}>*</span>{" "} */}
																	</Label>
																	<NumberFormat
																		className="form-control"
																		format="####-####"
																		mask="_"
																		placeholder="Enter Account Number"
																		onValueChange={(v) =>
																			this.setState({ bank_ac: v.value })
																		}
																		value={this.state.bank_ac}
																		// required
																	/>
																</div>
																{/* {this.state.accountnumerror ? <div style={{ color: "red" }}> Account Number required!</div> : null} */}
															</Col>
															{/* <Col xs="12" md="4" className="position-relative">
                                <div className="group-control">
                                  <AvField
                                    type="text"
                                    label="Post Code"
                                    name="postCode"
                                    placeholder="Enter Post Code"
                                    onChange={this.onChange}
                                    value={this.state.postCode}
                                  />
                                </div>
                              </Col>
                              <Col xs="12" md="4" className="position-relative">
                                <Label>Mobile No</Label>
                                <IntlTelInput
                                  placeholder=""
                                  style={{ width: "100%" }}
                                  defaultCountry={
                                    this.state.bankMobileNo.dialcountry
                                  }
                                  utilsScript={libphonenumber}
                                  css={
                                    this.state.bankPhoneError
                                      ? [
                                        "intl-tel-input",
                                        "form-control",
                                        "error-color",
                                      ]
                                      : ["intl-tel-input", "form-control"]
                                  }
                                  onPhoneNumberChange={this.bankPhoneHandler}
                                  value={this.state.bankMobileNo.number}
                                  required
                                />
                                {this.state.bankPhoneError ? (
                                  <div className={"error-color"}>
                                    Enter Valid Phone Number!
                                  </div>
                                ) : null}
                              </Col>
                              <Col xs="12" md="4" className="position-relative">
                                <AvField
                                  type="email"
                                  label="Email"
                                  name="bankEmail"
                                  placeholder="Enter Email"
                                  onChange={this.onChange}
                                  value={this.state.bankEmail}
                                />
                              </Col> */}
														</div>
													</div>
												</div>
												<div className="card-footer text-right">
													<button
														className="btn btn-primary"
														type="submit"
														disabled={this.state.mainactive_tab_5}
													>
														Submit
													</button>{" "}
													{/* <button
                            className="btn btn-primary"
                            onClick={(e) => {
                              this.previous(e);
                            }}
                          >{`< Previous`}</button> */}
												</div>
											</AvForm>
										</div>
									</TabPane>
								</TabContent>
							</div>
						</div>
					</div>

					<Modal
						isOpen={this.state.finalFormSubmitModal}
						toggle={() =>
							this.setState((prevState) => ({
								finalFormSubmitModal: !prevState.finalFormSubmitModal,
							}))
						}
						className="quick-pages"
					>
						<ModalHeader>
							<Button
								onClick={() =>
									this.setState((prevState) => ({
										finalFormSubmitModal: !prevState.finalFormSubmitModal,
									}))
								}
							>
								<i className="fa fa-times" aria-hidden="true"></i>
							</Button>
						</ModalHeader>
						<ModalBody>
							<div class="thanks-info">
								<p>
									Thank you, your profile/application has been submitted, we
									will be in touch soon.
								</p>
								<button
									type="button"
									className="btn update-btns"
									onClick={() => this.props.history.push("/dashboard/default")}
								>
									Ok
								</button>
							</div>
						</ModalBody>
					</Modal>

					<Modal
						isOpen={this.state.fileviewmodal}
						toggle={() => this.FileView("")}
						className="requs-pops"
					>
						<ModalHeader>
							<Button onClick={() => this.FileView("")}>
								<i className="fa fa-times" aria-hidden="true"></i>
							</Button>
						</ModalHeader>
						<ModalBody>
							<div className="img-views">
								{filepath && String(fileext) === String("pdf") ? (
									<embed src={filepath} width="100%" height="100%" />
								) : (
									<div style={{ width: "100%", height: "400px" }}>
										<img
											style={{ float: "left", width: "100%", height: "100%" }}
											alt="imgviewer"
											src={filepath}
										/>
									</div>
								)}
							</div>
						</ModalBody>
						{/* <ModalFooter>
              <Button color="secondary" onClick={() => this.FileView("")}>
                Close
              </Button>
            </ModalFooter> */}
					</Modal>
					<Modal
						isOpen={this.state.apply_to_all_pop}
						toggle={() => this.apply_pop_toggle("")}
					>
						<ModalBody>
							<p>Select other courses included in this certificate/document?</p>
							{this.state.apply_to_all_pop_yes ? this.question_popup() : null}
							{String(this.state.ask_qualifi_skip) === String(true)
								? this.skip_popup()
								: null}
						</ModalBody>
						<ModalFooter>
							{this.state.ask_qualifi_skip ? (
								<>
									<Button
										color="secondary"
										onClick={() => this.yes_skip_qualification("")}
									>
										{" "}
										Yes{" "}
									</Button>{" "}
									<Button
										color="secondary"
										onClick={(e) => this.apply_pop_toggle(e)}
									>
										{" "}
										No{" "}
									</Button>
								</>
							) : !this.state.apply_to_all_pop_yes ? (
								<>
									<Button
										color="secondary"
										onClick={() => this.yes_qualification("")}
									>
										{" "}
										Yes{" "}
									</Button>{" "}
									<Button
										color="secondary"
										onClick={(e) => this.no_qualification(e)}
									>
										{" "}
										No{" "}
									</Button>
								</>
							) : (
								<>
									<Button
										color="secondary"
										onClick={(e) => this.save_pop_qualification(e)}
									>
										{" "}
										Save{" "}
									</Button>{" "}
									<Button
										color="secondary"
										onClick={() => this.apply_pop_toggle("")}
									>
										{" "}
										Cancel{" "}
									</Button>
								</>
							)}
						</ModalFooter>
					</Modal>

					<Modal
						isOpen={this.state.apply_to_all_pop_other}
						toggle={() => this.apply_pop_toggle_other("")}
					>
						<ModalBody>
							<p>Select other courses included in this certificate/document?</p>
							{this.state.apply_to_all_pop_yes_other
								? this.question_popup_other()
								: null}
							{String(this.state.ask_qualifi_skip_other) === String(true)
								? this.skip_popup_other()
								: null}
						</ModalBody>
						<ModalFooter>
							{this.state.ask_qualifi_skip_other ? (
								<>
									<Button
										color="secondary"
										onClick={() => this.yes_skip_qualification_other("")}
									>
										{" "}
										Yes{" "}
									</Button>{" "}
									<Button
										color="secondary"
										onClick={(e) => this.apply_pop_toggle_other(e)}
									>
										{" "}
										No{" "}
									</Button>
								</>
							) : !this.state.apply_to_all_pop_yes_other ? (
								<>
									<Button
										color="secondary"
										onClick={() => this.yes_qualification_other("")}
									>
										{" "}
										Yes{" "}
									</Button>{" "}
									<Button
										color="secondary"
										onClick={(e) => this.no_qualification_other(e)}
									>
										{" "}
										No{" "}
									</Button>
								</>
							) : (
								<>
									<Button
										color="secondary"
										onClick={(e) => this.save_pop_qualification_other(e)}
									>
										{" "}
										Save{" "}
									</Button>{" "}
									<Button
										color="secondary"
										onClick={() => this.apply_pop_toggle_other("")}
									>
										{" "}
										Cancel{" "}
									</Button>
								</>
							)}
						</ModalFooter>
					</Modal>

					<Modal
						className= "submit-no-data"
						isOpen={this.state.review_ok_submit}
						toggle={(e) => this.review_ok_toggle(e, "")}
					>
						<ModalBody>
							<p>
								You have not fully completed your profile and this may cause
								delays in your recruitment process. Please review and complete
								your profile.
							</p>
							<p>On completion you will get a confirmation Email</p>
						</ModalBody>
						<ModalFooter>
							<Button
								color="secondary"
								onClick={(e) => this.review_ok_toggle(e, "")}
							>
								{" "}
								Review{" "}
							</Button>{" "}
							<Button
								color="secondary"
								onClick={(e) => this.review_ok_toggle(e, "settab")}
							>
								{" "}
								It’s ok I’ll Submit{" "}
							</Button>
						</ModalFooter>
					</Modal>
					{/* Rules for photo modal */}
					<Modal
						isOpen={this.state.showPhotoRules}
						toggle={() =>
							this.setState((prevState) => ({
								showPhotoRules: !prevState.showPhotoRules,
							}))
						}
						className="quick-pages emplyoess-views"
					>
						<ToastContainer
							position="top-right"
							autoClose={2500}
							closeOnClick
						/>
						<ModalHeader>
							{" "}
							Rules for photos
							<Button
								onClick={() =>
									this.setState((prevState) => ({
										showPhotoRules: !prevState.showPhotoRules,
									}))
								}
							>
								<i className="fa fa-times" aria-hidden="true"></i>
							</Button>
						</ModalHeader>
						<ModalBody>
							<div className="rules-modal">
								<h4> Your photo must be: </h4>
								<ul className="rules-lists">
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
										clear and in focus
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> in
										colour
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
										unaltered by computer software ( DO NOT use filters)
									</li>
								</ul>
								<h4> Your photo must show:</h4>
								<ul className="rules-lists">
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
										contain no other objects or people
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> be
										taken against a plain light-coloured background
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> be
										in clear contrast to the background
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> not
										have 'red eye'
									</li>
								</ul>
								<h4>In your photo you must:</h4>
								<ul className="rules-lists">
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> be
										facing forward and looking straight at the camera
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
										have a plain expression and your mouth closed
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i>{" "}
										have your eyes open and visible
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> not
										have hair in front of your eyes
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> not
										have a head covering (unless it's for religious or medical
										reasons)
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> not
										have anything covering your face
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> not
										have any shadows on your face or behind you
									</li>
									<li>
										<i className="fa fa-caret-right" aria-hidden="true"></i> Do
										not wear glasses in your photo unless you have to do so. If
										you must wear glasses, they cannot be sunglasses or tinted
										glasses, and you must make sure your eyes are not covered by
										the frames or any glare, reflection or shadow.
									</li>
								</ul>
								<img src={photoRules} alt="" />
							</div>
						</ModalBody>
						{/* <ModalFooter>
							<button className="deatils-saves subs-cancel" type="button" onClick={() => this.setState(prevState => ({showPhotoRules: !prevState.showPhotoRules}))}> Cancel </button>
						</ModalFooter> */}
					</Modal>
				</Fragment>
			</div>
		);
	}
}


const MyProfile = () =>(
	<Profileprovider initailState={initailState} reducer={profilereducer}>
		<EditProfile />
	</Profileprovider>
)  


const TernaryComponent = ({ condition = false ,  IFTRUE = <></>, IFFALSE = <></> }) => condition ? IFTRUE : IFFALSE ;


const RenderHtml = ({rawhtml}) => React.createElement('span' ,{dangerouslySetInnerHTML:{ __html:rawhtml }});













export default MyProfile;








/*




																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="select"
																				name="title"
																				label="Title"
																				placeholder="Select Title"
																				onChange={this.onChange}
																				value={this.state.title}
																			>
																				<option>Please Select</option>
																				<option value="mr">Mr.</option>
																				<option value="mrs">Mrs.</option>
																				<option value="miss">Miss.</option>
																				<option value="ms">Ms.</option>
																				<option value="dr">Dr.</option>
																				<option value="prof">Prof.</option>
																				<option value="rev">Rev.</option>
																			</AvField>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label>
																				First Name{" "}
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<AvField
																				type="text"
																				// label="First Name"
																				name="firstname"
																				placeholder="Enter First Name"
																				onChange={this.onChange}
																				value={this.state.firstname}
																				errorMessage="Required"
																				required
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Preferred Name"
																				name="prefferedName"
																				placeholder="Enter Preferred Name"
																				onChange={this.onChange}
																				value={this.state.prefferedName}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Middle Name"
																				name="middlename"
																				placeholder="Enter Middle Name"
																				onChange={this.onChange}
																				value={this.state.middlename}
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<Label>
																				Last Name{" "}
																				<span style={{ color: "red" }}>*</span>
																			</Label>
																			<AvField
																				type="text"
																				// label="Last Name"
																				name="lastname"
																				placeholder="Enter Last Name"
																				onChange={this.onChange}
																				value={this.state.lastname}
																				errorMessage="Required"
																				required
																			/>
																		</Col>
																		<Col
																			xs="12"
																			md="4"
																			className="position-relative"
																		>
																			<AvField
																				type="text"
																				label="Maiden Name"
																				name="maidenName"
																				placeholder="Enter Maiden Name"
																				onChange={this.onChange}
																				value={this.state.maidenName}
																			/>
																		</Col>
																		<Col xs="12" md="4">
																			<AvRadioGroup
																				label="Have you ever changed your name?"
																				name="isNameChanged"
																				value={this.state.isNameChanged}
																			>
																				<AvRadio
																					label="Yes"
																					value="yes"
																					onClick={this.onRadioNameChanged}
																				/>
																				<AvRadio
																					label="No"
																					value="no"
																					onClick={this.onRadioNameChanged}
																				/>
																			</AvRadioGroup>
																		</Col>




																		
																		{
																			 templateFields.filter(({field_heading})=>field_heading.name === "Personal Details 1").map((item)=>{
																				const TYPE = item && item.field_type && item.field_type.toUpperCase() || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				// console.log({item})
																				return <Field key={item._id} {...item} onChange={this.handleOnlineFormChange} />
																			})
																		}


																		
																		{
																			dummyFields.filter(({field_heading})=>field_heading.name === "Personal Details 2").map((item)=>{
																				const TYPE = item && item.field_type && item.field_type.toUpperCase() || "";
																				let Field = CustomField.hasOwnProperty(TYPE) ? CustomField[TYPE] : TernaryComponent;
																				console.log({TYPE})
																				return <Field {...item} onChange={(e)=>this.onChange(e)} />
																			})

																		}









*/